(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("keymirror"), require("lwr-client"), require("react"), require("map-portlet/js/map-portlet"), require("leaflet"), require("prop-types"), require("react-bootstrap"), require("datefns"), require("react-datepicker"), require("change-record-portlet/js/change-record-portlet"), require("user-state-history-portlet/js/user-state-history-portlet"), require("pub-sub-portlet/js/pub-sub-portlet"), require("./react"), require("react-dropzone"), require("react-datepicker-css"), require("react-dom"), require("json!named-props"), require("json!group-schemas"), require("json!initial-named-lists"));
	else if(typeof define === 'function' && define.amd)
		define(["liferay-widgets-react-web/js/liferay-widgets-react-web", "keymirror", "lwr-client", "react", "map-portlet/js/map-portlet", "leaflet", "prop-types", "react-bootstrap", "datefns", "react-datepicker", "change-record-portlet/js/change-record-portlet", "user-state-history-portlet/js/user-state-history-portlet", "pub-sub-portlet/js/pub-sub-portlet", "react", "react-dropzone", "react-datepicker-css", "react-dom", "json!named-props", "json!group-schemas", "json!initial-named-lists"], factory);
	else if(typeof exports === 'object')
		exports["base-portlet"] = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("keymirror"), require("lwr-client"), require("react"), require("map-portlet/js/map-portlet"), require("leaflet"), require("prop-types"), require("react-bootstrap"), require("datefns"), require("react-datepicker"), require("change-record-portlet/js/change-record-portlet"), require("user-state-history-portlet/js/user-state-history-portlet"), require("pub-sub-portlet/js/pub-sub-portlet"), require("./react"), require("react-dropzone"), require("react-datepicker-css"), require("react-dom"), require("json!named-props"), require("json!group-schemas"), require("json!initial-named-lists"));
	else
		root["base-portlet"] = factory(root["liferay-widgets-react-web/js/liferay-widgets-react-web"], root["keymirror"], root["lwr-client"], root["react"], root["map-portlet/js/map-portlet"], root["leaflet"], root["prop-types"], root["react-bootstrap"], root["datefns"], root["react-datepicker"], root["change-record-portlet/js/change-record-portlet"], root["user-state-history-portlet/js/user-state-history-portlet"], root["pub-sub-portlet/js/pub-sub-portlet"], root["react"], root["react-dropzone"], root["react-datepicker-css"], root["react-dom"], root["json!named-props"], root["json!group-schemas"], root["json!initial-named-lists"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_27__, __WEBPACK_EXTERNAL_MODULE_34__, __WEBPACK_EXTERNAL_MODULE_35__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_39__, __WEBPACK_EXTERNAL_MODULE_60__, __WEBPACK_EXTERNAL_MODULE_61__, __WEBPACK_EXTERNAL_MODULE_62__, __WEBPACK_EXTERNAL_MODULE_81__, __WEBPACK_EXTERNAL_MODULE_83__, __WEBPACK_EXTERNAL_MODULE_97__, __WEBPACK_EXTERNAL_MODULE_114__, __WEBPACK_EXTERNAL_MODULE_159__, __WEBPACK_EXTERNAL_MODULE_161__, __WEBPACK_EXTERNAL_MODULE_162__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 13.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	exports.FormValidationUtil = exports.DateFormat = exports.BomListWidget = exports.NamedListMasterDetailsWidget = exports.FliwasMapWidget = exports.DetailsWidget = exports.WebCamWidget = exports.hasEditPermissionAndGroup = exports.METRIC_TYPE = exports.formatMeasurements = exports.timeseriesUtil = exports.uploadFile = exports.getGroupSchemaProperties = exports.assetLink = exports.Accordion = exports.HtmlTextRenderer = exports.ChangeRecordSiteTeamRenderer = exports.ChangeRecordBusinessObjectRenderer = exports.ChangeRecordGeometryRenderer = exports.ChangeRecordDescriptionRenderer = exports.ChangeRecordBooleanRenderer = exports.DefaultTimeLineItemMessageHeader = exports.DefaultChangeRecordTable = exports.ChangeRecordDateRenderer = exports.ChangeRecordTextRenderer = exports.DefaultChangeRecordListItem = exports.JournalAddEntryButton = exports.FliwasActionButtons = exports.FliwasDetailsBox = exports.SelectObjectErrorMessage = exports.FliwasObjectMasterDetailPosition = exports.FliwasObjectMasterDetailList = exports.InlinePositionFormControl = exports.InlineDescriptionFormControl = exports.SituationStatusIcons = exports.PDFExportButton = exports.JournalEntryAddForm = exports.BusinessObjectMultiSelect = exports.AttachedDocumentsByTagForm = exports.AttachedFileListItem = exports.AttachedObjectList = exports.AttachedDocumentList = exports.ItemDescription = exports.AssetLinkChooser = exports.BusinessObjectSelect = exports.ImageDisplay = exports.DateRangePicker = exports.DateTimePicker = exports.C3TimeSeriesPlugin = exports.HCTimeSeriesPlugin = exports.HighChartsChart = exports.Upload = exports.Icon = exports.MultilineText = exports.BusinessObjectLink = exports.ObjectDates = exports.NamedProp = exports.TimeLineItemMessageHeader = exports.TimeLineItem = exports.ActiveFilterBar = exports.BaseToolbar = exports.FilterDropdown = exports.NumberSelect = exports.DateTimeDisplay = exports.ReferenceValueSelect = exports.GroupSchemaActions = exports.FliwasPermissionActions = exports.ReferenceValueActions = exports.ModalActions = exports.WmsLayerRefreshController = exports.BaseRemoteVectorLayerController = exports.BaseRemoteDataLayerController = exports.JournalRenderer_Webcam = exports.ChangeRecordRenderer_GeoFeature = exports.ChangeRecordRenderer_AssetLink = exports.ChangeRecordRenderer_DLFileEntry = exports.Group = exports.DLFileEntry = exports.AssetTag = exports.AssetLink = exports.FliwasPermissionWebApi = exports.UploadWebApi = exports.BomListWebApi = exports.NamedListWebApi = exports.GroupSchemaWebApi = exports.ReferenceValueWebApi = exports.NamedPropWebApi = exports.FliwasFileEntryWebApi = exports.AssetTagWebApi = exports.UNITS = exports.EVENT_TYPE_UPDATE = exports.EVENT_TYPE_DELETE = exports.EVENT_TYPE_CREATE = exports.STORE_KEY_GROUP_SCHEMAS = exports.ElementTypes = exports.ClassNames = undefined;
	
	var _StoreFactory = __webpack_require__(2);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _timeserieseventUtil = __webpack_require__(21);
	
	Object.keys(_timeserieseventUtil).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _timeserieseventUtil[key];
	        }
	    });
	});
	
	var _TableElems = __webpack_require__(22);
	
	Object.keys(_TableElems).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _TableElems[key];
	        }
	    });
	});
	
	var _BaseRemoteDataLayerController = __webpack_require__(24);
	
	Object.defineProperty(exports, 'BaseRemoteDataLayerController', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_BaseRemoteDataLayerController).default;
	    }
	});
	
	var _BaseRemoteVectorLayerController = __webpack_require__(28);
	
	Object.defineProperty(exports, 'BaseRemoteVectorLayerController', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_BaseRemoteVectorLayerController).default;
	    }
	});
	
	var _WmsLayerRefreshController = __webpack_require__(29);
	
	Object.defineProperty(exports, 'WmsLayerRefreshController', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_WmsLayerRefreshController).default;
	    }
	});
	
	var _ModalActions = __webpack_require__(26);
	
	Object.defineProperty(exports, 'ModalActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ModalActions).default;
	    }
	});
	
	var _ReferenceValueActions = __webpack_require__(30);
	
	Object.defineProperty(exports, 'ReferenceValueActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ReferenceValueActions).default;
	    }
	});
	
	var _FliwasPermissionActions = __webpack_require__(32);
	
	Object.defineProperty(exports, 'FliwasPermissionActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasPermissionActions).default;
	    }
	});
	
	var _ReferenceValueSelect = __webpack_require__(33);
	
	Object.defineProperty(exports, 'ReferenceValueSelect', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ReferenceValueSelect).default;
	    }
	});
	
	var _DateTimeDisplay = __webpack_require__(36);
	
	Object.defineProperty(exports, 'DateTimeDisplay', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DateTimeDisplay).default;
	    }
	});
	
	var _NumberSelect = __webpack_require__(40);
	
	Object.defineProperty(exports, 'NumberSelect', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_NumberSelect).default;
	    }
	});
	
	var _FilterDropdown = __webpack_require__(41);
	
	Object.defineProperty(exports, 'FilterDropdown', {
	    enumerable: true,
	    get: function get() {
	        return _FilterDropdown.FilterDropdown;
	    }
	});
	
	var _BaseToolbar = __webpack_require__(42);
	
	Object.defineProperty(exports, 'BaseToolbar', {
	    enumerable: true,
	    get: function get() {
	        return _BaseToolbar.BaseToolbar;
	    }
	});
	
	var _ActiveFilterBar = __webpack_require__(43);
	
	Object.defineProperty(exports, 'ActiveFilterBar', {
	    enumerable: true,
	    get: function get() {
	        return _ActiveFilterBar.ActiveFilterBar;
	    }
	});
	
	var _TimeLineItem = __webpack_require__(44);
	
	Object.defineProperty(exports, 'TimeLineItem', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_TimeLineItem).default;
	    }
	});
	
	var _TimeLineItemMessageHeader = __webpack_require__(45);
	
	Object.defineProperty(exports, 'TimeLineItemMessageHeader', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_TimeLineItemMessageHeader).default;
	    }
	});
	
	var _NamedProp = __webpack_require__(49);
	
	Object.defineProperty(exports, 'NamedProp', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_NamedProp).default;
	    }
	});
	
	var _ObjectDates = __webpack_require__(50);
	
	Object.defineProperty(exports, 'ObjectDates', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ObjectDates).default;
	    }
	});
	
	var _BusinessObjectLink = __webpack_require__(51);
	
	Object.defineProperty(exports, 'BusinessObjectLink', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_BusinessObjectLink).default;
	    }
	});
	
	var _MiniWidgetComponents = __webpack_require__(53);
	
	Object.keys(_MiniWidgetComponents).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _MiniWidgetComponents[key];
	        }
	    });
	});
	
	var _DetailsRenderer = __webpack_require__(59);
	
	Object.keys(_DetailsRenderer).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _DetailsRenderer[key];
	        }
	    });
	});
	
	var _DetailsListItemComponents = __webpack_require__(77);
	
	Object.keys(_DetailsListItemComponents).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _DetailsListItemComponents[key];
	        }
	    });
	});
	
	var _MultilineText = __webpack_require__(74);
	
	Object.defineProperty(exports, 'MultilineText', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_MultilineText).default;
	    }
	});
	
	var _Icon = __webpack_require__(58);
	
	Object.defineProperty(exports, 'Icon', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Icon).default;
	    }
	});
	
	var _Upload = __webpack_require__(82);
	
	Object.defineProperty(exports, 'Upload', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Upload).default;
	    }
	});
	
	var _HighChartsChart = __webpack_require__(88);
	
	Object.defineProperty(exports, 'HighChartsChart', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_HighChartsChart).default;
	    }
	});
	
	var _HCTimeSeriesPlugin = __webpack_require__(93);
	
	Object.defineProperty(exports, 'HCTimeSeriesPlugin', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_HCTimeSeriesPlugin).default;
	    }
	});
	
	var _TimeSeriesPlugin = __webpack_require__(95);
	
	Object.defineProperty(exports, 'C3TimeSeriesPlugin', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_TimeSeriesPlugin).default;
	    }
	});
	
	var _DateTimePicker = __webpack_require__(96);
	
	Object.defineProperty(exports, 'DateTimePicker', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DateTimePicker).default;
	    }
	});
	
	var _DateRangePicker = __webpack_require__(98);
	
	Object.defineProperty(exports, 'DateRangePicker', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DateRangePicker).default;
	    }
	});
	
	var _ImageDisplay = __webpack_require__(65);
	
	Object.defineProperty(exports, 'ImageDisplay', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ImageDisplay).default;
	    }
	});
	
	var _BusinessObjectSelect = __webpack_require__(101);
	
	Object.defineProperty(exports, 'BusinessObjectSelect', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_BusinessObjectSelect).default;
	    }
	});
	
	var _AssetLinkChooser = __webpack_require__(102);
	
	Object.defineProperty(exports, 'AssetLinkChooser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_AssetLinkChooser).default;
	    }
	});
	
	var _ItemDescription = __webpack_require__(71);
	
	Object.defineProperty(exports, 'ItemDescription', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ItemDescription).default;
	    }
	});
	
	var _AttachedDocumentList = __webpack_require__(63);
	
	Object.defineProperty(exports, 'AttachedDocumentList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_AttachedDocumentList).default;
	    }
	});
	
	var _AttachedObjectList = __webpack_require__(75);
	
	Object.defineProperty(exports, 'AttachedObjectList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_AttachedObjectList).default;
	    }
	});
	Object.defineProperty(exports, 'AttachedFileListItem', {
	    enumerable: true,
	    get: function get() {
	        return _AttachedDocumentList.AttachedFileListItem;
	    }
	});
	
	var _AttachedDocumentsByTagForm = __webpack_require__(103);
	
	Object.defineProperty(exports, 'AttachedDocumentsByTagForm', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_AttachedDocumentsByTagForm).default;
	    }
	});
	
	var _BusinessObjectMultiSelect = __webpack_require__(108);
	
	Object.defineProperty(exports, 'BusinessObjectMultiSelect', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_BusinessObjectMultiSelect).default;
	    }
	});
	
	var _JournalEntryAddForm = __webpack_require__(91);
	
	Object.defineProperty(exports, 'JournalEntryAddForm', {
	    enumerable: true,
	    get: function get() {
	        return _JournalEntryAddForm.JournalEntryAddForm;
	    }
	});
	
	var _PDFExportButton = __webpack_require__(109);
	
	Object.defineProperty(exports, 'PDFExportButton', {
	    enumerable: true,
	    get: function get() {
	        return _PDFExportButton.PDFExportButton;
	    }
	});
	
	var _SituationStatusIcons = __webpack_require__(110);
	
	Object.defineProperty(exports, 'SituationStatusIcons', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_SituationStatusIcons).default;
	    }
	});
	
	var _BasicFormComponents = __webpack_require__(70);
	
	Object.keys(_BasicFormComponents).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _BasicFormComponents[key];
	        }
	    });
	});
	
	var _InlineFormControl = __webpack_require__(113);
	
	Object.keys(_InlineFormControl).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _InlineFormControl[key];
	        }
	    });
	});
	
	var _InlineDescriptionFormControl = __webpack_require__(115);
	
	Object.defineProperty(exports, 'InlineDescriptionFormControl', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_InlineDescriptionFormControl).default;
	    }
	});
	
	var _InlinePositionFormControl = __webpack_require__(116);
	
	Object.defineProperty(exports, 'InlinePositionFormControl', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_InlinePositionFormControl).default;
	    }
	});
	
	var _FliwasObjectMasterDetailList = __webpack_require__(117);
	
	Object.defineProperty(exports, 'FliwasObjectMasterDetailList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasObjectMasterDetailList).default;
	    }
	});
	
	var _FliwasObjectMasterDetailPosition = __webpack_require__(118);
	
	Object.defineProperty(exports, 'FliwasObjectMasterDetailPosition', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasObjectMasterDetailPosition).default;
	    }
	});
	
	var _SelectObjectErrorMessage = __webpack_require__(119);
	
	Object.defineProperty(exports, 'SelectObjectErrorMessage', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_SelectObjectErrorMessage).default;
	    }
	});
	
	var _FliwasDetailsBox = __webpack_require__(120);
	
	Object.defineProperty(exports, 'FliwasDetailsBox', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasDetailsBox).default;
	    }
	});
	
	var _FliwasActionButtons = __webpack_require__(121);
	
	Object.defineProperty(exports, 'FliwasActionButtons', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasActionButtons).default;
	    }
	});
	
	var _JournalAddEntryButton = __webpack_require__(122);
	
	Object.defineProperty(exports, 'JournalAddEntryButton', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_JournalAddEntryButton).default;
	    }
	});
	
	var _DefaultChangeRecordListItem = __webpack_require__(123);
	
	Object.defineProperty(exports, 'DefaultChangeRecordListItem', {
	    enumerable: true,
	    get: function get() {
	        return _DefaultChangeRecordListItem.DefaultChangeRecordListItem;
	    }
	});
	
	var _ChangeRecordTextRenderer = __webpack_require__(127);
	
	Object.defineProperty(exports, 'ChangeRecordTextRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _ChangeRecordTextRenderer.ChangeRecordTextRenderer;
	    }
	});
	
	var _ChangeRecordDateRenderer = __webpack_require__(128);
	
	Object.defineProperty(exports, 'ChangeRecordDateRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _ChangeRecordDateRenderer.ChangeRecordDateRenderer;
	    }
	});
	
	var _DefaultChangeRecordTable = __webpack_require__(126);
	
	Object.defineProperty(exports, 'DefaultChangeRecordTable', {
	    enumerable: true,
	    get: function get() {
	        return _DefaultChangeRecordTable.DefaultChangeRecordTable;
	    }
	});
	
	var _DefaultTimeLineItemMessageHeader = __webpack_require__(124);
	
	Object.defineProperty(exports, 'DefaultTimeLineItemMessageHeader', {
	    enumerable: true,
	    get: function get() {
	        return _DefaultTimeLineItemMessageHeader.DefaultTimeLineItemMessageHeader;
	    }
	});
	
	var _ChangeRecordBooleanRenderer = __webpack_require__(129);
	
	Object.defineProperty(exports, 'ChangeRecordBooleanRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _ChangeRecordBooleanRenderer.ChangeRecordBooleanRenderer;
	    }
	});
	
	var _ChangeRecordDescriptionRenderer = __webpack_require__(130);
	
	Object.defineProperty(exports, 'ChangeRecordDescriptionRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _ChangeRecordDescriptionRenderer.ChangeRecordDescriptionRenderer;
	    }
	});
	
	var _ChangeRecordGeometryRenderer = __webpack_require__(132);
	
	Object.defineProperty(exports, 'ChangeRecordGeometryRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _ChangeRecordGeometryRenderer.ChangeRecordGeometryRenderer;
	    }
	});
	
	var _ChangeRecordBusinessObjectRenderer = __webpack_require__(133);
	
	Object.defineProperty(exports, 'ChangeRecordBusinessObjectRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _ChangeRecordBusinessObjectRenderer.ChangeRecordBusinessObjectRenderer;
	    }
	});
	
	var _ChangeRecordSiteTeamRenderer = __webpack_require__(134);
	
	Object.defineProperty(exports, 'ChangeRecordSiteTeamRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _ChangeRecordSiteTeamRenderer.ChangeRecordSiteTeamRenderer;
	    }
	});
	
	var _HtmlTextRenderer = __webpack_require__(131);
	
	Object.defineProperty(exports, 'HtmlTextRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _HtmlTextRenderer.HtmlTextRenderer;
	    }
	});
	
	var _Accordion = __webpack_require__(135);
	
	Object.defineProperty(exports, 'Accordion', {
	    enumerable: true,
	    get: function get() {
	        return _Accordion.Accordion;
	    }
	});
	
	var _assetLink = __webpack_require__(64);
	
	Object.defineProperty(exports, 'assetLink', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_assetLink).default;
	    }
	});
	
	var _groupSchemaUtil = __webpack_require__(137);
	
	Object.defineProperty(exports, 'getGroupSchemaProperties', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_groupSchemaUtil).default;
	    }
	});
	
	var _uploadFile = __webpack_require__(138);
	
	Object.defineProperty(exports, 'uploadFile', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_uploadFile).default;
	    }
	});
	
	var _timeseriesUtil = __webpack_require__(94);
	
	Object.defineProperty(exports, 'timeseriesUtil', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_timeseriesUtil).default;
	    }
	});
	
	var _formatingUtil = __webpack_require__(76);
	
	Object.defineProperty(exports, 'formatMeasurements', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_formatingUtil).default;
	    }
	});
	Object.defineProperty(exports, 'METRIC_TYPE', {
	    enumerable: true,
	    get: function get() {
	        return _timeseriesUtil.METRIC_TYPE;
	    }
	});
	
	var _eventTypeUtil = __webpack_require__(125);
	
	Object.keys(_eventTypeUtil).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _eventTypeUtil[key];
	        }
	    });
	});
	
	var _editPermissionUtil = __webpack_require__(139);
	
	Object.defineProperty(exports, 'hasEditPermissionAndGroup', {
	    enumerable: true,
	    get: function get() {
	        return _editPermissionUtil.hasEditPermissionAndGroup;
	    }
	});
	
	var _WebCamWidget = __webpack_require__(140);
	
	Object.defineProperty(exports, 'WebCamWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_WebCamWidget).default;
	    }
	});
	
	var _DetailsWidget = __webpack_require__(142);
	
	Object.defineProperty(exports, 'DetailsWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DetailsWidget).default;
	    }
	});
	
	var _FliwasMapWidget = __webpack_require__(143);
	
	Object.defineProperty(exports, 'FliwasMapWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasMapWidget).default;
	    }
	});
	
	var _NamedListMasterDetailsWidget = __webpack_require__(144);
	
	Object.defineProperty(exports, 'NamedListMasterDetailsWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_NamedListMasterDetailsWidget).default;
	    }
	});
	
	var _BomListWidget = __webpack_require__(151);
	
	Object.defineProperty(exports, 'BomListWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_BomListWidget).default;
	    }
	});
	
	var _reactDom = __webpack_require__(114);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _NamedPropsActions = __webpack_require__(153);
	
	var _NamedPropsActions2 = _interopRequireDefault(_NamedPropsActions);
	
	var _GroupSchemaActions = __webpack_require__(154);
	
	var _GroupSchemaActions2 = _interopRequireDefault(_GroupSchemaActions);
	
	var _NamedListActions = __webpack_require__(148);
	
	var _NamedListActions2 = _interopRequireDefault(_NamedListActions);
	
	var _AssetLinkChangeRecordRenderer = __webpack_require__(156);
	
	var _AssetLinkChangeRecordRenderer2 = _interopRequireDefault(_AssetLinkChangeRecordRenderer);
	
	var _GeoFeatureChangeRecordRenderer = __webpack_require__(157);
	
	var _GeoFeatureChangeRecordRenderer2 = _interopRequireDefault(_GeoFeatureChangeRecordRenderer);
	
	var _Constants = __webpack_require__(5);
	
	var _FliwasFileEntryWebApi = __webpack_require__(107);
	
	var _FliwasFileEntryWebApi2 = _interopRequireDefault(_FliwasFileEntryWebApi);
	
	var _NamedPropWebApi = __webpack_require__(158);
	
	var _NamedPropWebApi2 = _interopRequireDefault(_NamedPropWebApi);
	
	var _AssetTagWebApi = __webpack_require__(105);
	
	var _AssetTagWebApi2 = _interopRequireDefault(_AssetTagWebApi);
	
	var _UploadWebApi = __webpack_require__(84);
	
	var _UploadWebApi2 = _interopRequireDefault(_UploadWebApi);
	
	var _ReferenceValueWebApi = __webpack_require__(31);
	
	var _ReferenceValueWebApi2 = _interopRequireDefault(_ReferenceValueWebApi);
	
	var _GroupSchemaWebApi = __webpack_require__(155);
	
	var _GroupSchemaWebApi2 = _interopRequireDefault(_GroupSchemaWebApi);
	
	var _NamedListWebApi = __webpack_require__(69);
	
	var _NamedListWebApi2 = _interopRequireDefault(_NamedListWebApi);
	
	var _BomListWebApi = __webpack_require__(150);
	
	var _BomListWebApi2 = _interopRequireDefault(_BomListWebApi);
	
	var _FliwasPermissionWebApi = __webpack_require__(19);
	
	var _FliwasPermissionWebApi2 = _interopRequireDefault(_FliwasPermissionWebApi);
	
	var _jsonNamedProps = __webpack_require__(159);
	
	var _jsonNamedProps2 = _interopRequireDefault(_jsonNamedProps);
	
	var _ModalRenderer = __webpack_require__(160);
	
	var _ModalRenderer2 = _interopRequireDefault(_ModalRenderer);
	
	var _dateFormat = __webpack_require__(37);
	
	var DateFormat = _interopRequireWildcard(_dateFormat);
	
	var _formValidationUtil = __webpack_require__(92);
	
	var FormValidationUtil = _interopRequireWildcard(_formValidationUtil);
	
	var _jsonGroupSchemas = __webpack_require__(161);
	
	var _jsonGroupSchemas2 = _interopRequireDefault(_jsonGroupSchemas);
	
	var _jsonInitialNamedLists = __webpack_require__(162);
	
	var _jsonInitialNamedLists2 = _interopRequireDefault(_jsonInitialNamedLists);
	
	var _WebcamJournalRenderer = __webpack_require__(163);
	
	var _WebcamJournalRenderer2 = _interopRequireDefault(_WebcamJournalRenderer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Utils
	exports.ClassNames = _Constants.ClassNames;
	exports.ElementTypes = _Constants.ElementTypes;
	exports.STORE_KEY_GROUP_SCHEMAS = _Constants.STORE_KEY_GROUP_SCHEMAS;
	exports.EVENT_TYPE_CREATE = _Constants.EVENT_TYPE_CREATE;
	exports.EVENT_TYPE_DELETE = _Constants.EVENT_TYPE_DELETE;
	exports.EVENT_TYPE_UPDATE = _Constants.EVENT_TYPE_UPDATE;
	exports.UNITS = _Constants.UNITS;
	// WebApi
	
	exports.AssetTagWebApi = _AssetTagWebApi2.default;
	exports.FliwasFileEntryWebApi = _FliwasFileEntryWebApi2.default;
	exports.NamedPropWebApi = _NamedPropWebApi2.default;
	exports.ReferenceValueWebApi = _ReferenceValueWebApi2.default;
	exports.GroupSchemaWebApi = _GroupSchemaWebApi2.default;
	exports.NamedListWebApi = _NamedListWebApi2.default;
	exports.BomListWebApi = _BomListWebApi2.default;
	exports.UploadWebApi = _UploadWebApi2.default;
	exports.FliwasPermissionWebApi = _FliwasPermissionWebApi2.default;
	
	
	_liferayWidgetsReactWeb.AppContext.registerBundle({
	    webApis: {
	        AssetTagWebApi: _AssetTagWebApi2.default,
	        FliwasFileEntryWebApi: _FliwasFileEntryWebApi2.default,
	        NamedPropWebApi: _NamedPropWebApi2.default,
	        NamedListWebApi: _NamedListWebApi2.default,
	        BomListWebApi: _BomListWebApi2.default,
	        ReferenceValueWebApi: _ReferenceValueWebApi2.default,
	        GroupSchemaWebApi: _GroupSchemaWebApi2.default,
	        UploadWebApi: _UploadWebApi2.default,
	        FliwasPermissionWebApi: _FliwasPermissionWebApi2.default
	    },
	    detailsRenderer: {}
	});
	
	var AssetLink = exports.AssetLink = undefined;
	var AssetTag = exports.AssetTag = undefined;
	var DLFileEntry = exports.DLFileEntry = undefined;
	var Group = exports.Group = undefined;
	var ChangeRecordRenderer_DLFileEntry = exports.ChangeRecordRenderer_DLFileEntry = _AssetLinkChangeRecordRenderer2.default;
	var ChangeRecordRenderer_AssetLink = exports.ChangeRecordRenderer_AssetLink = _AssetLinkChangeRecordRenderer2.default;
	var ChangeRecordRenderer_GeoFeature = exports.ChangeRecordRenderer_GeoFeature = _GeoFeatureChangeRecordRenderer2.default;
	var JournalRenderer_Webcam = exports.JournalRenderer_Webcam = _WebcamJournalRenderer2.default;
	
	exports.GroupSchemaActions = _GroupSchemaActions2.default;
	
	//Components
	
	exports.DateFormat = DateFormat;
	exports.FormValidationUtil = FormValidationUtil;
	
	
	window.waitForElementById('fliwas-modal-container',
	// eslint-disable-next-line react/no-render-return-value
	function (e) {
	    return _reactDom2.default.render(_react2.default.createElement(_ModalRenderer2.default, { hasConfig: false }), e);
	});
	
	var NamedPropStore = (0, _StoreFactory.getNamedPropStore)(_liferayWidgetsReactWeb.AppContext);
	_NamedPropsActions2.default.list(_jsonNamedProps2.default); //early load
	if (!NamedPropStore.getProps()) console.error('Props not initialized');
	
	var GroupSchemaStore = (0, _StoreFactory.getGroupSchemaStore)(_liferayWidgetsReactWeb.AppContext);
	_GroupSchemaActions2.default.listDefaultGroupSchemas(_jsonGroupSchemas2.default); //early load
	if (!GroupSchemaStore.getProps()) console.error('GroupSchemas not initialized');
	
	var NamedListStore = (0, _StoreFactory.getNamedListStore)(_liferayWidgetsReactWeb.AppContext);
	_NamedListActions2.default.initialNamedLists(_jsonInitialNamedLists2.default); //early load
	if (!NamedListStore.getRemoteData(_Constants.GROUP_NAMED_LISTS)) console.error('NamedLists not initialized');
	
	Liferay.Util.Session.get('com.liferay.product.navigation.product.menu.web_productMenuState').then(function (v) {
	    Liferay.Util.Session.set('com.liferay.product.navigation.product.menu.web_productMenuState', 'closed');
	});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getNamedPropStore = getNamedPropStore;
	exports.getPageSelectedStore = getPageSelectedStore;
	exports.getDLFileEntryStore = getDLFileEntryStore;
	exports.getAssetLinkStore = getAssetLinkStore;
	exports.getAssetTagStore = getAssetTagStore;
	exports.getModalStore = getModalStore;
	exports.getTitleStore = getTitleStore;
	exports.getReferenceValueStore = getReferenceValueStore;
	exports.getGroupSchemaStore = getGroupSchemaStore;
	exports.getBomListStore = getBomListStore;
	exports.getNamedListStore = getNamedListStore;
	exports.getFliwasPermissionStore = getFliwasPermissionStore;
	
	var _NamedPropStore = __webpack_require__(3);
	
	var _NamedPropStore2 = _interopRequireDefault(_NamedPropStore);
	
	var _PageSelectedStore = __webpack_require__(7);
	
	var _PageSelectedStore2 = _interopRequireDefault(_PageSelectedStore);
	
	var _DlFileEntryStore = __webpack_require__(8);
	
	var _DlFileEntryStore2 = _interopRequireDefault(_DlFileEntryStore);
	
	var _AssetLinkStore = __webpack_require__(9);
	
	var _AssetLinkStore2 = _interopRequireDefault(_AssetLinkStore);
	
	var _AssetTagStore = __webpack_require__(10);
	
	var _AssetTagStore2 = _interopRequireDefault(_AssetTagStore);
	
	var _ModalStore = __webpack_require__(11);
	
	var _ModalStore2 = _interopRequireDefault(_ModalStore);
	
	var _TitleStore = __webpack_require__(13);
	
	var _TitleStore2 = _interopRequireDefault(_TitleStore);
	
	var _ReferenceValueStore = __webpack_require__(14);
	
	var _ReferenceValueStore2 = _interopRequireDefault(_ReferenceValueStore);
	
	var _GroupSchemaStore = __webpack_require__(15);
	
	var _GroupSchemaStore2 = _interopRequireDefault(_GroupSchemaStore);
	
	var _BomListStore = __webpack_require__(16);
	
	var _BomListStore2 = _interopRequireDefault(_BomListStore);
	
	var _NamedListStore = __webpack_require__(17);
	
	var _NamedListStore2 = _interopRequireDefault(_NamedListStore);
	
	var _FliwasPermissionStore = __webpack_require__(18);
	
	var _FliwasPermissionStore2 = _interopRequireDefault(_FliwasPermissionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 28.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	var namedPropStoreInstance = void 0;
	
	function getNamedPropStore(AppContext) {
	    return namedPropStoreInstance || (namedPropStoreInstance = AppContext.createStore(_NamedPropStore2.default));
	}
	
	var pageSelectedStoreInstance = void 0;
	
	function getPageSelectedStore(AppContext) {
	    return pageSelectedStoreInstance || (pageSelectedStoreInstance = AppContext.createStore(_PageSelectedStore2.default));
	}
	
	var dlFileEntryStoreInstance = void 0;
	
	function getDLFileEntryStore(AppContext) {
	    return dlFileEntryStoreInstance || (dlFileEntryStoreInstance = AppContext.createStore(_DlFileEntryStore2.default));
	}
	
	var assetLinkStoreInstance = void 0;
	
	function getAssetLinkStore(AppContext) {
	    return assetLinkStoreInstance || (assetLinkStoreInstance = AppContext.createStore(_AssetLinkStore2.default));
	}
	
	var assetTagStoreInstance = void 0;
	
	function getAssetTagStore(AppContext) {
	    return assetTagStoreInstance || (assetTagStoreInstance = AppContext.createStore(_AssetTagStore2.default));
	}
	
	var modalStoreInstance = void 0;
	
	function getModalStore(AppContext) {
	    return modalStoreInstance || (modalStoreInstance = AppContext.createStore(_ModalStore2.default));
	}
	
	var titleStoreInstance = void 0;
	
	function getTitleStore(AppContext) {
	    return titleStoreInstance || (titleStoreInstance = AppContext.createStore(_TitleStore2.default));
	}
	
	var referenceValueInstance = void 0;
	
	function getReferenceValueStore(AppContext) {
	    return referenceValueInstance || (referenceValueInstance = AppContext.createStore(_ReferenceValueStore2.default));
	}
	
	var groupSchemaStoreInstance = void 0;
	
	function getGroupSchemaStore(AppContext) {
	    return groupSchemaStoreInstance || (groupSchemaStoreInstance = AppContext.createStore(_GroupSchemaStore2.default));
	}
	
	var bomListStoreInstance = void 0;
	
	function getBomListStore(AppContext) {
	    return bomListStoreInstance || (bomListStoreInstance = AppContext.createStore(_BomListStore2.default));
	}
	
	var namedListStoreInstance = void 0;
	
	function getNamedListStore(AppContext) {
	    return namedListStoreInstance || (namedListStoreInstance = AppContext.createStore(_NamedListStore2.default));
	}
	
	var fliwasPermissionStoreInstance = void 0;
	
	function getFliwasPermissionStore(AppContext) {
	    return fliwasPermissionStoreInstance || (fliwasPermissionStoreInstance = AppContext.createStore(_FliwasPermissionStore2.default));
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 22.10.2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var propsByType = null;
	var propsByTypeKey = null;
	var cacheKey = null;
	
	var buildCache = function buildCache(list) {
	    cacheKey = list;
	    propsByType = {};
	    propsByTypeKey = {};
	    list.forEach(function (p) {
	        var type = p.type,
	            key = p.key;
	
	        var pByType = propsByType[type];
	
	        pByType = pByType && Array.isArray(pByType) ? pByType.concat(p) : [p];
	        propsByType[type] = pByType;
	
	        propsByTypeKey[type + '___' + key] = p;
	    });
	};
	
	var NamedPropStore = function (_ClassRemoteDataStore) {
	    _inherits(NamedPropStore, _ClassRemoteDataStore);
	
	    function NamedPropStore() {
	        _classCallCheck(this, NamedPropStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, _liferayWidgetsReactWeb.AppContext.getDispatcher(), _Constants.ClassNames.NamedProp));
	    }
	
	    NamedPropStore.prototype.getProps = function getProps() {
	        return this.getRemoteData('namedprops').item;
	    };
	
	    NamedPropStore.prototype.getPropByType = function getPropByType(type) {
	        if (cacheKey != this.getProps()) {
	            buildCache(this.getProps());
	        }
	        return propsByType[type] || [];
	    };
	
	    NamedPropStore.prototype.getPropByTypeKey = function getPropByTypeKey(type, key) {
	        if (cacheKey != this.getProps()) {
	            buildCache(this.getProps());
	        }
	        return propsByTypeKey[type + '___' + key];
	    };
	
	    return NamedPropStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = NamedPropStore;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.UNITS = exports.EVENT_TYPE_UPDATE = exports.EVENT_TYPE_DELETE = exports.EVENT_TYPE_CREATE = exports.STORE_KEY_GROUP_SCHEMAS = exports.ElementTypes = exports.GROUP_NAMED_LISTS = exports.JournalTypeNames = exports.ClassNames = exports.ActionTypes = undefined;
	
	var _keymirror = __webpack_require__(6);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = {
	    NamedProps: {},
	    TITLES_REQUEST: "TITLES_REQUEST",
	    TITLES_UPDATE: "TITLES_UPDATE",
	    SELECTED_FLIWAS_PERMISSION_NAMESPACE: "SELECTED_FLIWAS_PERMISSION_NAMESPACE"
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 22.10.2015
	    * Copyright: xdot GmbH 2015
	    */
	
	var ClassNames = exports.ClassNames = (0, _keymirror2.default)({
	    GroupSchema: null,
	    ReferenceValue: null,
	    AssetCategory: null,
	    NamedProp: null,
	    DLFileEntry: null,
	    AssetLink: null,
	    AssetTag: null,
	    GeoFeature: null,
	    User: null,
	    Team: null,
	    Group: null,
	    FliwasPermission: null
	});
	
	var JournalTypeNames = exports.JournalTypeNames = (0, _keymirror2.default)({
	    Webcam: null
	});
	
	var GROUP_NAMED_LISTS = exports.GROUP_NAMED_LISTS = 'groupNamedLists';
	
	var ElementTypes = exports.ElementTypes = (0, _keymirror2.default)({
	    StatusBox: null,
	    PropertyBox: null,
	    StatusPropertyBox: null,
	    DynamicContentBox: null
	});
	
	var STORE_KEY_GROUP_SCHEMAS = exports.STORE_KEY_GROUP_SCHEMAS = 'groupSchemas';
	
	var EVENT_TYPE_CREATE = exports.EVENT_TYPE_CREATE = 'CREATE';
	var EVENT_TYPE_DELETE = exports.EVENT_TYPE_DELETE = 'DELETE';
	var EVENT_TYPE_UPDATE = exports.EVENT_TYPE_UPDATE = 'UPDATE';
	
	var UNITS = exports.UNITS = {
	    CM: 'cm',
	    CBMS: 'm³/s',
	    CBM: 'm³',
	    PERCENT: '%',
	    MM: 'mm',
	    MM_5MIN: 'mm/5 min'
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var PageSelectedStore = function (_ReduceStore) {
	    _inherits(PageSelectedStore, _ReduceStore);
	
	    function PageSelectedStore() {
	        _classCallCheck(this, PageSelectedStore);
	
	        return _possibleConstructorReturn(this, _ReduceStore.call(this, _liferayWidgetsReactWeb.AppContext.getDispatcher()));
	    }
	
	    PageSelectedStore.prototype.getInitialState = function getInitialState() {
	        return { selected: null };
	    };
	
	    PageSelectedStore.prototype.getRemoteData = function getRemoteData(name) {
	        return this.getPageSelected();
	    };
	
	    PageSelectedStore.prototype.getPageSelected = function getPageSelected() {
	        return this.getState().selected;
	    };
	
	    PageSelectedStore.prototype.getRemotePageSelected = function getRemotePageSelected(state) {
	        var _this2 = this;
	
	        var remoteDataStores = _liferayWidgetsReactWeb.AppContext.getStores().filter(function (s) {
	            return s.getRemoteData && s !== _this2;
	        });
	        this.getDispatcher().waitFor(remoteDataStores.map(function (s) {
	            return s.getDispatchToken();
	        }));
	        var selected = remoteDataStores.reduce(function (a, store) {
	            var s = store.getRemoteData(_liferayWidgetsReactWeb.ActionTypesCommon.PAGE_SELECTED);
	            return s ? a.concat(s) : a;
	        }, []);
	        state = {
	            selected: selected
	        };
	        return state;
	    };
	
	    PageSelectedStore.prototype.reduce = function reduce(state, action) {
	
	        switch (action.type) {
	
	            case _liferayWidgetsReactWeb.ActionTypesCommon.PAGE_SELECTED:
	                //this implementation is multi value ready
	                state = this.getRemotePageSelected(state);
	                break;
	
	            case _liferayWidgetsReactWeb.ActionTypesCommon.DATA_ASYNC:
	                if (action.meta.name == _liferayWidgetsReactWeb.ActionTypesCommon.PAGE_SELECTED) {
	                    switch (action.meta.asyncState) {
	                        case _liferayWidgetsReactWeb.AsyncState.SUCCESS:
	                            state = this.getRemotePageSelected(state);
	                    }
	                }
	            //no default
	
	        }
	
	        return state;
	    };
	
	    return PageSelectedStore;
	}(_liferayWidgetsReactWeb.ReduceStore);
	
	exports.default = PageSelectedStore;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DLFileEntryStore = function (_ClassRemoteDataStore) {
	    _inherits(DLFileEntryStore, _ClassRemoteDataStore);
	
	    function DLFileEntryStore(Dispatcher) {
	        _classCallCheck(this, DLFileEntryStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.DLFileEntry, undefined, undefined));
	    }
	
	    DLFileEntryStore.prototype.reduce = function reduce(state, action) {
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    return DLFileEntryStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = DLFileEntryStore;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var AssetLinkStore = function (_ClassRemoteDataStore) {
	    _inherits(AssetLinkStore, _ClassRemoteDataStore);
	
	    function AssetLinkStore(Dispatcher) {
	        _classCallCheck(this, AssetLinkStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.AssetLink, undefined, undefined));
	    }
	
	    AssetLinkStore.prototype.reduce = function reduce(state, action) {
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    return AssetLinkStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = AssetLinkStore;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var AssetTagStore = function (_ClassRemoteDataStore) {
	    _inherits(AssetTagStore, _ClassRemoteDataStore);
	
	    function AssetTagStore(Dispatcher) {
	        _classCallCheck(this, AssetTagStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.AssetTag, undefined, undefined));
	    }
	
	    AssetTagStore.prototype.reduce = function reduce(state, action) {
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    return AssetTagStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = AssetTagStore;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ActionsTypesModal = __webpack_require__(12);
	
	var _ActionsTypesModal2 = _interopRequireDefault(_ActionsTypesModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalStore = function (_ReduceStore) {
	    _inherits(ModalStore, _ReduceStore);
	
	    function ModalStore() {
	        _classCallCheck(this, ModalStore);
	
	        return _possibleConstructorReturn(this, _ReduceStore.call(this, _liferayWidgetsReactWeb.AppContext.getDispatcher()));
	    }
	
	    ModalStore.prototype.getInitialState = function getInitialState() {
	        return {
	            modals: []
	        };
	    };
	
	    ModalStore.prototype.getModals = function getModals() {
	        return this._state.modals;
	    };
	
	    ModalStore.prototype.createModal = function createModal(state, key, dataName, className, store, props, context) {
	        var newModals = state.modals.slice();
	        newModals.push({
	            key: key,
	            className: className,
	            dataName: dataName,
	            store: store,
	            props: props,
	            context: context
	        });
	
	        return _extends({}, state, {
	            modals: newModals
	        });
	    };
	
	    ModalStore.prototype.removeModal = function removeModal(state, key) {
	        var newModals = state.modals.filter(function (modal) {
	            return modal.key != key;
	        });
	
	        return _extends({}, state, {
	            modals: newModals
	        });
	    };
	
	    ModalStore.prototype.getModalByKey = function getModalByKey(state, key) {
	        var m = undefined;
	        if (state.modals && Array.isArray(state.modals)) {
	            state.modals.forEach(function (modal) {
	                if (modal.key == key) {
	                    m = modal;
	                }
	            });
	        }
	        return m;
	    };
	
	    ModalStore.prototype.getStore = function getStore(dataName, className) {
	        var _this2 = this;
	
	        var remoteDataStores = _liferayWidgetsReactWeb.AppContext.getStores().filter(function (s) {
	            return s.getRemoteData && s !== _this2;
	        }).filter(function (s) {
	            return s.containsRemoteData && s.containsRemoteData(dataName, className);
	        });
	
	        if (remoteDataStores.length > 0) {
	            if (remoteDataStores.length > 1) {
	                console.error('More than one store for dataName: ' + dataName + ' className: ' + className + ' found!');
	            }
	            return remoteDataStores[0];
	        } else {
	            console.error("No Store found for className: ", className);
	        }
	    };
	
	    ModalStore.prototype.reduce = function reduce(state, action) {
	
	        switch (action.type) {
	
	            case _ActionsTypesModal2.default.SHOW_MODAL:
	                {
	                    var _action$payload = action.payload,
	                        dataName = _action$payload.dataName,
	                        className = _action$payload.className,
	                        props = _action$payload.props,
	                        context = _action$payload.context,
	                        key = className + dataName,
	                        store = this.getStore(dataName, className);
	
	
	                    this.getDispatcher().waitFor([store.getDispatchToken()]);
	
	                    if (!this.getModalByKey(state, key)) {
	                        state = this.createModal(state, key, dataName, className, store, props, context);
	                    }
	
	                    break;
	                }
	            case _ActionsTypesModal2.default.HIDE_MODAL:
	                {
	                    state = this.removeModal(state, action.payload.className + action.payload.dataName);
	                    break;
	                }
	        }
	
	        return state;
	    };
	
	    return ModalStore;
	}(_liferayWidgetsReactWeb.ReduceStore);
	
	exports.default = ModalStore;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _keymirror = __webpack_require__(6);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _keymirror2.default)({
	  SHOW_MODAL: null,
	  HIDE_MODAL: null
	}); /**
	     * Created by Carsten Bühler
	     * User: c.buehler on 17.08.2016
	     * Copyright: xdot GmbH 2015
	     */

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Constants = __webpack_require__(5);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 23.10.2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var TitleStore = function (_ReduceStore) {
	    _inherits(TitleStore, _ReduceStore);
	
	    function TitleStore(dispatcher) {
	        _classCallCheck(this, TitleStore);
	
	        return _possibleConstructorReturn(this, _ReduceStore.call(this, dispatcher));
	    }
	
	    TitleStore.prototype.getInitialState = function getInitialState() {
	        return {
	            requested: {},
	            titles: {}
	        };
	    };
	
	    TitleStore.prototype.filterNotRequested = function filterNotRequested(keys) {
	        var _this2 = this;
	
	        return keys.filter(function (key) {
	            return !_this2.isRequested(key);
	        });
	    };
	
	    TitleStore.prototype.getTitleFromKey = function getTitleFromKey(key) {
	        var titles = this.getState().titles;
	        return titles[key];
	    };
	
	    TitleStore.prototype.isRequested = function isRequested(key) {
	        var requested = this.getState().requested;
	        return requested[key] !== undefined;
	    };
	
	    TitleStore.prototype.reduce = function reduce(state, action) {
	        var newState = state;
	        if (action.type === _Constants.ActionTypes.TITLES_REQUEST) {
	            newState = _extends({}, state);
	
	            action.payload.keys.forEach(function (key) {
	                newState.requested[key] = action.payload.xhr;
	            });
	
	            return newState;
	        }
	        if (action.type === _Constants.ActionTypes.TITLES_UPDATE) {
	            for (var property in action.payload.lookUpResult) {
	                if (action.payload.lookUpResult.hasOwnProperty(property)) {
	                    var storeTitle = state.titles[property];
	                    var requestedTitle = action.payload.lookUpResult[property];
	                    if (storeTitle !== requestedTitle) {
	                        var _extends2;
	
	                        newState = {
	                            titles: _extends({}, newState.titles, (_extends2 = {}, _extends2[property] = requestedTitle, _extends2)),
	                            requested: newState.requested
	                        };
	                        delete newState.requested[property];
	                    }
	                }
	            }
	
	            if (newState !== state) {
	                return newState;
	            }
	        }
	        return state;
	    };
	
	    return TitleStore;
	}(_liferayWidgetsReactWeb.ReduceStore);
	
	exports.default = TitleStore;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ReferenceValueStore = function (_ClassRemoteDataStore) {
	    _inherits(ReferenceValueStore, _ClassRemoteDataStore);
	
	    function ReferenceValueStore(Dispatcher) {
	        _classCallCheck(this, ReferenceValueStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.ReferenceValue, undefined, undefined));
	    }
	
	    ReferenceValueStore.prototype.reduce = function reduce(state, action) {
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    return ReferenceValueStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = ReferenceValueStore;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 22.10.2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var schemasByGroup = null;
	var cacheKey = null;
	
	var buildCache = function buildCache(list) {
	    cacheKey = list;
	    schemasByGroup = {};
	    list.forEach(function (schema) {
	        var groupId = schema.groupId;
	        //className = schema.className,
	        //subType = schema.subType;
	
	        schemasByGroup[groupId] = schema;
	    });
	};
	
	var GroupSchemaStore = function (_ClassRemoteDataStore) {
	    _inherits(GroupSchemaStore, _ClassRemoteDataStore);
	
	    function GroupSchemaStore() {
	        _classCallCheck(this, GroupSchemaStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, _liferayWidgetsReactWeb.AppContext.getDispatcher(), _Constants.ClassNames.GroupSchema));
	    }
	
	    GroupSchemaStore.prototype.getProps = function getProps() {
	        return this.getRemoteData('group-schemas').item;
	    };
	
	    GroupSchemaStore.prototype.getByGroupId = function getByGroupId(groupId) {
	        if (cacheKey != this.getProps()) {
	            buildCache(this.getProps());
	        }
	        return schemasByGroup[groupId];
	    };
	
	    GroupSchemaStore.prototype.reduce = function reduce(state, action) {
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    return GroupSchemaStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = GroupSchemaStore;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var BomListStore = function (_ComputedQueryParamsD) {
	    _inherits(BomListStore, _ComputedQueryParamsD);
	
	    function BomListStore(Dispatcher) {
	        _classCallCheck(this, BomListStore);
	
	        return _possibleConstructorReturn(this, _ComputedQueryParamsD.call(this, Dispatcher, undefined, undefined, undefined));
	    }
	
	    BomListStore.prototype.getDataClassNames = function getDataClassNames(d) {
	        if (d && d.item && Array.isArray(d.item)) {
	            return d.item.reduce(function (acc, curr, idx) {
	                var className = curr.__type;
	                if (acc.lastIndexOf(className) >= 0) {
	                    acc.push(className);
	                }
	                return acc;
	            }, []);
	        } else {
	            if (d && d.item) {
	                return [d.item.__type];
	            }
	        }
	        return [];
	    };
	
	    BomListStore.prototype.extendedWebsocketModelUpdate = function extendedWebsocketModelUpdate(remote, wsUpdate) {
	
	        var newRemote = void 0;
	
	        newRemote = this.handleObjectUpdates(wsUpdate, remote, newRemote);
	        newRemote = this.handleTimeSeriesUpdates(wsUpdate, remote, newRemote);
	
	        return newRemote || remote;
	    };
	
	    BomListStore.prototype.handleObjectUpdates = function handleObjectUpdates(wsUpdate, remote, newRemote) {
	        if (!wsUpdate.labels) {
	            var storeRemoteEntries = _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote);
	            if (storeRemoteEntries && storeRemoteEntries.length > 0) {
	                storeRemoteEntries.forEach(function (remoteEntry) {
	                    if (remoteEntry && remoteEntry.item && Array.isArray(remoteEntry.item)) {
	                        return remoteEntry.item.map(function (bomItem) {
	                            var bomClassName = bomItem.__type;
	
	                            //Is same type or attached to the same type? AND is the updatedObject or attached to it?
	                            if (bomClassName === wsUpdate.type || wsUpdate.metadata && bomClassName === wsUpdate.metadata.attachedClassName) {
	                                if (bomItem.id === wsUpdate.id || wsUpdate.metadata && bomItem.id === wsUpdate.metadata.attachedClassPK) {
	                                    var newItem = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                                    if (!newRemote) {
	                                        newRemote = newRemote || (newRemote = _extends({}, remote));
	                                    }
	                                    newRemote[remoteEntry.name] = newItem;
	                                }
	                            }
	                        });
	                    }
	                });
	            }
	
	            return newRemote;
	        }
	    };
	
	    BomListStore.prototype.handleTimeSeriesUpdates = function handleTimeSeriesUpdates(wsUpdate, remote, newRemote) {
	        if (wsUpdate.labels) {
	            if (wsUpdate.labels.gaugingStationId > 0 || wsUpdate.labels.frbId > 0 || wsUpdate.labels.precipitationStationId > 0) {
	                var storeRemoteEntries = _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote);
	                if (storeRemoteEntries && storeRemoteEntries.length > 0) {
	                    storeRemoteEntries.forEach(function (remoteEntry) {
	                        if (remoteEntry.item) {
	                            if (Array.isArray(remoteEntry.item)) {
	                                remoteEntry.item.forEach(function (fliwasBom) {
	                                    if (fliwasBom.id == (wsUpdate.labels.gaugingStationId || wsUpdate.labels.frbId || wsUpdate.labels.precipitationStationId)) {
	                                        var newItem = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                                        if (!newRemote) {
	                                            newRemote = newRemote || (newRemote = _extends({}, remote));
	                                        }
	                                        newRemote[remoteEntry.name] = newItem;
	                                    }
	                                });
	                                //Dont refresh list, only because a measurement of an item has changed
	                            } else {
	                                if (remoteEntry.item.id == (wsUpdate.labels.gaugingStationId || wsUpdate.labels.frbId || wsUpdate.labels.precipitationStationId)) {
	                                    var newItem = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                                    if (!newRemote) {
	                                        newRemote = newRemote || (newRemote = _extends({}, remote));
	                                    }
	                                    newRemote[remoteEntry.name] = newItem;
	                                }
	                            }
	                        }
	                    });
	                }
	            }
	        }
	        return newRemote;
	    };
	
	    BomListStore.prototype.reduce = function reduce(state, action) {
	
	        if (!action.meta || !action.meta.className) {
	
	            switch (action.type) {
	                case _liferayWidgetsReactWeb.ActionTypesCommon.DATA_LIST_INIT:
	                    return this.initList(state, action.meta.name, action.payload, this.defaultListData);
	
	                case _liferayWidgetsReactWeb.ActionTypesCommon.DATA_ITEM_INIT:
	                    return this.initItem(state, action.meta.name, action.payload, this.defaultItemData);
	
	                case _liferayWidgetsReactWeb.ActionTypesCommon.DATA_REMOVE:
	                    return this.removeRemoteData(state, action.meta.name);
	            }
	        }
	
	        return _ComputedQueryParamsD.prototype.reduce.call(this, state, action);
	    };
	
	    return BomListStore;
	}(_liferayWidgetsReactWeb.ComputedQueryParamsDataStore);
	
	exports.default = BomListStore;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 23.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var NamedListStore = function (_ClassRemoteDataStore) {
	    _inherits(NamedListStore, _ClassRemoteDataStore);
	
	    function NamedListStore(Dispatcher) {
	        _classCallCheck(this, NamedListStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.AssetCategory, undefined, undefined));
	    }
	
	    NamedListStore.prototype.reduce = function reduce(state, action) {
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    return NamedListStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = NamedListStore;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _FliwasPermissionWebApi = __webpack_require__(19);
	
	var _FliwasPermissionWebApi2 = _interopRequireDefault(_FliwasPermissionWebApi);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Marius Runde
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 21.04.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FliwasPermissionStore = function (_ClassRemoteDataStore) {
	    _inherits(FliwasPermissionStore, _ClassRemoteDataStore);
	
	    function FliwasPermissionStore(Dispatcher) {
	        _classCallCheck(this, FliwasPermissionStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.FliwasPermission, _FliwasPermissionWebApi2.default.listAllNamespaces, _FliwasPermissionWebApi2.default.getPermissionStatesByRoleId));
	    }
	
	    FliwasPermissionStore.prototype.getSelectedNamespace = function getSelectedNamespace() {
	        return this._state._selectedNamespace || undefined;
	    };
	
	    FliwasPermissionStore.prototype.reduce = function reduce(state, action) {
	
	        if (action.type === _Constants.ActionTypes.SELECTED_FLIWAS_PERMISSION_NAMESPACE) {
	            return _extends({}, state, {
	                _selectedNamespace: action.payload
	            });
	        }
	
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    return FliwasPermissionStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = FliwasPermissionStore;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _lwrClient = __webpack_require__(20);
	
	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	var administrationService = function administrationService(m, o) {
	    return _lwrClient.Client.invoke('/administration.fliwaspermissionapi/' + m, o);
	};
	var administrationServiceWithContext = function administrationServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/administration.fliwaspermissionapi/' + m, o, c);
	};
	//const roleService = (m, o) => Client.invoke('/role/' + m, o);
	
	var api = {
	    getPermissionStatesByRoleId: function getPermissionStatesByRoleId(dataItem) {
	        return administrationService('get-fliwas-permission-states.1', {
	            teamId: dataItem.id
	        });
	    },
	    getPermissionState: function getPermissionState(query) {
	        return administrationServiceWithContext('get-fliwas-permission-state.3', {
	            nameSpace: query.nameSpace,
	            fliwasPermission: query.fliwasPermission
	        }, {});
	    },
	    listAllNamespaces: function listAllNamespaces(query) {
	        return administrationServiceWithContext('list-all-name-spaces.1', {}, {});
	    },
	    getUserRoles: function getUserRoles(query) {
	        return administrationService('get-user-roles.1', {
	            userId: query.userId
	        });
	    },
	    setFiliwasPermissions: function setFiliwasPermissions(item) {
	        return administrationServiceWithContext('set-fliwas-permissions.3', {
	            teamId: item.id,
	            nameSpace: item.nameSpace
	        }, { fliwasPermissions: item.fliwasPermissions });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('FliwasPermissionWebApi', api);
	
	exports.default = api;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                   * User: c.buehler on 13.09.2017
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                   */
	
	exports.defaultExtendedWebsocketModelUpdate = defaultExtendedWebsocketModelUpdate;
	exports.defaultBatchedExtendedWebsocketModelUpdate = defaultBatchedExtendedWebsocketModelUpdate;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function defaultExtendedWebsocketModelUpdate(remote, wsUpdate, stationLabelName) {
	    var newRemote = void 0;
	
	    if (wsUpdate.labels) {
	        if (wsUpdate.labels[stationLabelName] > 0) {
	            var storeRemoteEntries = _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote);
	            if (storeRemoteEntries && storeRemoteEntries.length > 0) {
	                storeRemoteEntries.forEach(function (remoteEntry) {
	                    if (remoteEntry.item) {
	                        if (Array.isArray(remoteEntry.item)) {
	                            var newList = void 0;
	                            if (remoteEntry.query && remoteEntry.query.byId) {
	                                if (remoteEntry.query.byId == wsUpdate.labels[stationLabelName]) {
	                                    newList = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                                }
	                            } else {
	                                newList = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                            }
	                            if (newList) {
	                                if (!newRemote) {
	                                    newRemote = newRemote || (newRemote = _extends({}, remote));
	                                }
	                                newRemote[remoteEntry.name] = newList;
	                            }
	                        } else {
	                            console.warn("Single Entries should not occure in store, only timeseries. Please check the implementation.");
	                        }
	                    }
	                });
	            }
	        }
	    }
	
	    return newRemote || remote;
	}
	
	function defaultBatchedExtendedWebsocketModelUpdate(remote, wsUpdate, stationLabelName) {
	    var newRemote = void 0;
	
	    if (Array.isArray(wsUpdate)) {
	
	        var processedListNames = [];
	
	        wsUpdate.forEach(function (incomingEvent) {
	            var wsEvent = void 0;
	            if (incomingEvent instanceof String) {
	                wsEvent = JSON.parse(incomingEvent);
	            } else {
	                wsEvent = incomingEvent;
	            }
	            if (wsEvent.labels) {
	                if (wsEvent.labels[stationLabelName] > 0) {
	                    var storeRemoteEntries = _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote);
	                    if (storeRemoteEntries && storeRemoteEntries.length > 0) {
	                        storeRemoteEntries.forEach(function (remoteEntry) {
	                            if (remoteEntry.item) {
	                                var wasProcessed = processedListNames.indexOf(remoteEntry.name) >= 0;
	                                if (!wasProcessed) {
	                                    if (Array.isArray(remoteEntry.item)) {
	                                        var newList = void 0;
	                                        if (remoteEntry.query && remoteEntry.query.byId) {
	                                            if (remoteEntry.query.byId == wsEvent.labels[stationLabelName]) {
	                                                newList = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                                            }
	                                        } else {
	                                            newList = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                                        }
	                                        if (newList) {
	                                            if (!newRemote) {
	                                                newRemote = newRemote || (newRemote = _extends({}, remote));
	                                            }
	                                            newRemote[remoteEntry.name] = newList;
	                                            processedListNames.push(remoteEntry.name);
	                                        }
	                                    } else {
	                                        var newItem = void 0;
	                                        if (remoteEntry.item.id == wsEvent.labels[stationLabelName]) {
	                                            newItem = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                                        }
	                                        if (newItem) {
	                                            if (!newRemote) {
	                                                newRemote = newRemote || (newRemote = _extends({}, remote));
	                                            }
	                                            newRemote[remoteEntry.name] = newItem;
	                                            processedListNames.push(remoteEntry.name);
	                                        }
	                                    }
	                                }
	                            }
	                        });
	                    }
	                }
	            }
	        });
	    } else {
	        return defaultExtendedWebsocketModelUpdate(remote, wsUpdate, stationLabelName);
	    }
	
	    return newRemote || remote;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NewValueTd = exports.OldValueTd = exports.PropertyTd = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PropertyTd = exports.PropertyTd = function PropertyTd(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "td",
	    { className: "change-records-table__first-col" },
	    children
	  );
	};
	var OldValueTd = exports.OldValueTd = function OldValueTd(_ref2) {
	  var children = _ref2.children;
	  return _react2.default.createElement(
	    "td",
	    { className: "change-records-table__old-value" },
	    children
	  );
	};
	var NewValueTd = exports.NewValueTd = function NewValueTd(_ref3) {
	  var children = _ref3.children;
	  return _react2.default.createElement(
	    "td",
	    { className: "change-records-table__new-value" },
	    children
	  );
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_23__;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _mapPortlet = __webpack_require__(25);
	
	var _ModalActions = __webpack_require__(26);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _leaflet = __webpack_require__(27);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Created by Carsten Hibbeler on 27.03.2019.
	                                                                                                                                                           */
	
	
	var toMap = function toMap(array, idFtkn) {
	    return array.reduce(function (obj, item) {
	        obj[idFtkn(item)] = item;
	        return obj;
	    }, {});
	};
	
	var clone = function clone(s) {
	    var t = {};
	    for (var k in s) {
	        if (Object.prototype.hasOwnProperty.call(s, k)) {
	            t[k] = s[k];
	        }
	    }
	    return t;
	};
	
	var diff = function diff(oldFeaturesMap, newFeatures, oldFeatureProps, newFeatureProps) {
	    var t0 = performance.now();
	    oldFeaturesMap = clone(oldFeaturesMap);
	    var diff = {
	        added: [],
	        removed: [],
	        changed: []
	    };
	    newFeatures.forEach(function (nF) {
	        var id = (0, _mapPortlet.getFeatureId)(nF),
	            oF = oldFeaturesMap[id];
	        if (!oF) {
	            diff.added.push(nF);
	        } else {
	            if (!(0, _liferayWidgetsReactWeb.deepEqual)(nF, oF) || !(0, _liferayWidgetsReactWeb.deepEqual)(oldFeatureProps[id], newFeatureProps[id])) {
	                diff.changed.push(nF);
	            }
	            delete oldFeaturesMap[id];
	        }
	    });
	    for (var k in oldFeaturesMap) {
	        if (Object.prototype.hasOwnProperty.call(oldFeaturesMap, k)) {
	            diff.removed.push(oldFeaturesMap[k]);
	        }
	    }
	    var dt = performance.now() - t0;
	    if (dt > 3) {
	        console.log('Diff took ' + dt + ' milliseconds.');
	    }
	    return diff;
	};
	
	var geoJsonStore = (0, _mapPortlet.getGeoJsonStore)(_liferayWidgetsReactWeb.AppContext);
	
	var serviceToClass = {
	    '/critical-object-portlet.criticalobject/': 'CriticalObject',
	    '/frb-portlet.floodretentionbasin/': 'FloodRetentionBasin',
	    '/fliwas-structure-portlet.fliwasorganizationapi/': 'Group',
	    '/news-portlet.newsmessage/': 'NewsMessage',
	    '/precipitation-portlet.precipitationstation/': 'PrecipitationStation',
	    '/flood-protection-object-portlet.floodprotectionobjectline/': 'FloodProtectionObjectLine',
	    '/flood-protection-object-portlet.floodprotectionobjectpoint/': 'FloodProtectionObjectPoint',
	    '/twodfm-portlet.dikebreak/': 'DikeBreak'
	};
	
	//TODO UGLY
	var MissingRendererException = {};
	
	var BaseRemoteDataLayerController = function () {
	    function BaseRemoteDataLayerController() {
	        _classCallCheck(this, BaseRemoteDataLayerController);
	    }
	
	    /**
	     * Use this to mutate layer config used for layer creation.
	     *
	     * @param {object} layerConfig - options
	     * @return {object} layerConfig - options
	     */
	    BaseRemoteDataLayerController.prototype.layerConfig = function layerConfig(_layerConfig) {
	        if (_layerConfig.servicePath) {
	            /* Old style config */
	            _layerConfig = _extends({}, _layerConfig, {
	                params: [serviceToClass[_layerConfig.servicePath]]
	            });
	            delete _layerConfig['servicePath'];
	            delete _layerConfig['method'];
	        }
	
	        return _layerConfig;
	    };
	
	    /**
	     * Invoked once after layer init.
	     *
	     * @param {Map} map - leaflet map
	     * @param {object} o - global options for the map
	     * @param {Layer} layer - leaflet Layer
	     * @param {object} layerConfig - config of the layer
	     */
	
	
	    BaseRemoteDataLayerController.prototype.init = function init(map, o, layer, layerConfig, context) {
	        var _this = this;
	
	        this.map = map;
	        this.o = o;
	        this.layer = layer || layer && layer.getInternalLayer && layer.getInternalLayer();
	        this.context = context;
	        //    this.onEachFeature.bind(this);
	        this.featureLayerProps = {};
	        this.update = this.update.bind(this);
	        this.getOptions = this.getOptions.bind(this);
	        this.onZoomeEnd = this.onZoomeEnd.bind(this);
	
	        map.on('zoomend', this.onZoomeEnd);
	
	        this.dataName = layer.id; //config.servicePath + config.method;
	        this.removeListener = geoJsonStore.addListener(function () {
	            return _this.forceUpdate();
	        });
	        _mapPortlet.GeoJsonActions.geoJson(this.dataName, layerConfig.params);
	
	        this._features = {};
	        this._featureLayers = {};
	        this._featureProps = {};
	    };
	
	    BaseRemoteDataLayerController.prototype.forceUpdate = function forceUpdate() {
	        this.update(this.map, this.getOptions());
	    };
	
	    BaseRemoteDataLayerController.prototype.onZoomeEnd = function onZoomeEnd() {
	        this.forceUpdate();
	    };
	
	    BaseRemoteDataLayerController.prototype.getOptions = function getOptions() {
	        return this.o;
	    };
	
	    /**
	     * Config phase.
	     * Use this to mutate options pre <code>update</code>.
	     * Do not use the options for third party component updates.
	     *
	     * @param {object} o - options
	     * @return {object} o - options
	     */
	
	
	    BaseRemoteDataLayerController.prototype.options = function options(o) {
	        //TODO This seems wrong because the selected layers may not exists at this moment.
	        var layer = this.getLayer(),
	            selectedItems = o.selectedItems;
	
	
	        if (selectedItems && layer.eachLayer) {
	            var selectedIds = toMap(selectedItems, function (i) {
	                return i.className + (i.item || i).id;
	            }),
	                selectedLayers = o.selectedLayers ? o.selectedLayers.slice() : [];
	
	            layer.eachLayer(function (featureLayer) {
	                if (selectedIds[(0, _mapPortlet.getFeatureId)(featureLayer.feature)]) {
	                    selectedLayers.push(featureLayer);
	                }
	            });
	
	            if (selectedLayers.length !== selectedItems.length) {
	                console.warn('Missing ' + (selectedItems.length - selectedLayers.length) + ' selected layers');
	            }
	
	            if (selectedLayers.length > 0) {
	                o.selectedLayers = selectedLayers;
	            }
	        }
	        return o;
	    };
	
	    /**
	     * Update phase.
	     * Use this to update based on the global map options.
	     * Not invoked after first init.
	     *
	     * @param {Map} map - leaflet map
	     * @param {object} o - options
	     */
	
	
	    BaseRemoteDataLayerController.prototype.update = function update(map, o) {
	        var _this2 = this;
	
	        console.log('BaseRemoteDataLayerController update()', { map: map, o: o });
	        this.o = o;
	
	        var remoteData = geoJsonStore.getRemoteData(this.dataName),
	            features = remoteData && remoteData.item && remoteData.item.features || [],
	            selectedIds = o.selectedItems && toMap(o.selectedItems, function (i) {
	            return i.className + (i.item || i).id;
	        }) || {};
	
	        var featureProps = features.reduce(function (props, feature) {
	            var id = (0, _mapPortlet.getFeatureId)(feature),
	                selected = selectedIds[id],
	                zoomThreshold = _this2.getZoomThreshold(feature);
	
	            if (zoomThreshold || selected) {
	                props[id] = {
	                    highlight: selected,
	                    zoomThreshold: zoomThreshold,
	                    collapsed: typeof zoomThreshold === 'number' && _this2.map.getZoom() <= zoomThreshold
	                };
	            }
	            return props;
	        }, {});
	
	        this.updateFeatures(features, featureProps);
	    };
	
	    BaseRemoteDataLayerController.prototype.updateFeatures = function updateFeatures(features, featureProps) {
	        var _this3 = this;
	
	        var layer = this.getLayer(),
	            addedLayers = [],
	            removedLayers = [],
	            _diff = diff(this._features, features, this._featureProps, featureProps),
	            added = _diff.added,
	            changed = _diff.changed,
	            removed = _diff.removed;
	
	
	        if (added.length + changed.length + removed.length === 0) {
	            return;
	        }
	
	        //Remove missing features
	        removed.forEach(function (feature) {
	            var fId = (0, _mapPortlet.getFeatureId)(feature);
	            removedLayers.push(_this3._featureLayers[fId]);
	            delete _this3._featureLayers[fId];
	            delete _this3._features[fId];
	            delete _this3._featureProps[fId];
	        });
	
	        var addFeature = function addFeature(feature) {
	            var fId = (0, _mapPortlet.getFeatureId)(feature),
	                props = featureProps[fId],
	                l = _mapPortlet.FeatureManager.createFeatureLayer(feature, props, true);
	
	            if (l.then) {
	                l.then(function () {
	                    return _this3.forceUpdate();
	                });
	                throw MissingRendererException; //Early stop layer update to prevent massive updates
	            } else {
	                if (props && props.highlight) {
	                    l.preventCluster = true;
	                }
	                _this3.prepareLayerControls(feature, l);
	                addedLayers.push(l);
	                _this3._featureLayers[fId] = l;
	                _this3._features[fId] = feature;
	                if (props) {
	                    _this3._featureProps[fId] = props;
	                } else {
	                    delete _this3._featureProps[fId];
	                }
	            }
	        };
	
	        try {
	            //Remove old and add new features
	            changed.forEach(function (feature) {
	                removedLayers.push(_this3._featureLayers[(0, _mapPortlet.getFeatureId)(feature)]);
	                addFeature(feature);
	            });
	
	            //Add new features
	            added.forEach(addFeature);
	        } catch (e) {
	            if (e !== MissingRendererException) {
	                throw e;
	            } else {
	                console.warn('Missing renderer');
	            }
	        }
	
	        layer.removeLayers(removedLayers);
	        layer.addLayers(addedLayers);
	    };
	
	    BaseRemoteDataLayerController.prototype.remove = function remove(map) {
	        map.off('zoomend', this.onZoomeEnd);
	        if (this.removeListener) {
	            this.removeListener.remove();
	        }
	    };
	
	    BaseRemoteDataLayerController.prototype.getLayer = function getLayer() {
	        if (this.layer.getInternalLayer && this.layer.getInternalLayer()) {
	            this.layer = this.layer.getInternalLayer();
	        }
	        return this.layer;
	    };
	
	    BaseRemoteDataLayerController.prototype.prepareLayerControls = function prepareLayerControls(feature, featureLayer) {
	        if (!this.onMouseOver) {
	            //Create only one function for all layers
	            this.onMouseOver = function (e) {
	                return e && e.target && e.target.openTooltip && e.target.openTooltip();
	            };
	            this.onMouseOut = function (e) {
	                return e && e.target && e.target.closeTooltip && e.target.closeTooltip();
	            };
	        }
	        featureLayer.bindTooltip(feature.properties.title, {
	            autoPan: false,
	            keepInView: true,
	            closeOnClick: false,
	            direction: 'top',
	            offset: [0, -40]
	        });
	        featureLayer.on('mouseover', this.onMouseOver);
	        featureLayer.on('mouseout', this.onMouseOut);
	        featureLayer.on('click', this.onFeatureClick.bind(this, feature));
	    };
	
	    BaseRemoteDataLayerController.prototype.getZoomThreshold = function getZoomThreshold(feature) {
	        var minSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	        if (feature.geometry.type === 'Point') {
	            return null;
	        }
	        var id = (0, _mapPortlet.getFeatureId)(feature),
	            currentProps = this._featureProps[id];
	
	        //Reuse zoomThreshold if the geometry is the same
	        var zoomThreshold = void 0;
	        if (currentProps && currentProps.zoomThreshold >= 0 && (0, _liferayWidgetsReactWeb.deepEqual)(this._features[id].geometry, feature.geometry)) {
	            zoomThreshold = currentProps.zoomThreshold;
	        } else {
	            var layer = _leaflet2.default.GeoJSON.geometryToLayer(feature);
	            if (layer instanceof _leaflet2.default.Circle) {
	                //https://github.com/oliverroick/Leaflet.Deflate/blob/master/src/L.Deflate.js
	                throw new Error('Circle is not supported');
	            }
	            zoomThreshold = DeflateUtil.getZoomThreshold(layer.getBounds(), this.map, minSize);
	        }
	        return zoomThreshold;
	    };
	
	    BaseRemoteDataLayerController.prototype.onFeatureClick = function onFeatureClick(feature) {
	        this.onItemClick(feature.properties.type, feature.properties.id, feature.properties.title, feature.properties.typeKey);
	    };
	
	    BaseRemoteDataLayerController.prototype.onItemClick = function onItemClick(className, id) {
	        _liferayWidgetsReactWeb.RemoteDataActions.pageSelected(className, { id: id });
	        _ModalActions2.default.showModal(className, { id: id }, false, undefined, { contextId: this.context && this.context.contextId });
	    };
	
	    return BaseRemoteDataLayerController;
	}();
	
	exports.default = BaseRemoteDataLayerController;
	
	
	var DeflateUtil = {
	
	    getZoomThreshold: function getZoomThreshold(bounds, map, minSize) {
	        var zoomThreshold = null;
	        var zoom = map.getZoom();
	
	        if (this.isCollapsed(bounds, map, zoom, minSize)) {
	            while (!zoomThreshold) {
	                zoom += 1;
	                if (!this.isCollapsed(bounds, map, zoom, minSize)) {
	                    zoomThreshold = zoom - 1;
	                }
	            }
	        } else {
	            while (!zoomThreshold) {
	                zoom -= 1;
	                if (this.isCollapsed(bounds, map, zoom, minSize)) {
	                    zoomThreshold = zoom;
	                }
	            }
	        }
	        return zoomThreshold;
	    },
	
	    /**
	     * Check if a path is displayed smaller than minSize (in pixels)
	     */
	    isCollapsed: function isCollapsed(bounds, map, zoom) {
	        var minSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 50;
	
	        var ne_px = map.project(bounds.getNorthEast(), zoom);
	        var sw_px = map.project(bounds.getSouthWest(), zoom);
	
	        var width = ne_px.x - sw_px.x;
	        var height = sw_px.y - ne_px.y;
	        return height < minSize || width < minSize;
	    }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ActionsTypesModal = __webpack_require__(12);
	
	var _ActionsTypesModal2 = _interopRequireDefault(_ActionsTypesModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    showModal: function showModal(className, query) {
	        var isList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	        var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	        var context = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
	        var api = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
	        var dataName = arguments[6];
	
	
	        //Load Module ASYNC if not exists
	        (0, _liferayWidgetsReactWeb.loadModuleByClassName)(className, function () {
	            dataName = dataName || _liferayWidgetsReactWeb.UidUtil.generateId('modal_data') + '_data';
	            if (isList) {
	                _liferayWidgetsReactWeb.RemoteDataActions.list(dataName, className, query, api);
	            } else {
	                _liferayWidgetsReactWeb.RemoteDataActions.item(dataName, className, query, api);
	            }
	            _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	                type: _ActionsTypesModal2.default.SHOW_MODAL,
	                payload: {
	                    dataName: dataName,
	                    className: className,
	                    props: props,
	                    context: context
	                },
	                error: {},
	                meta: {}
	            });
	        });
	    },
	
	    hideModal: function hideModal(className, dataName) {
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	            type: _ActionsTypesModal2.default.HIDE_MODAL,
	            payload: {
	                dataName: dataName,
	                className: className
	            },
	            error: {},
	            meta: {}
	        });
	    }
	
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 22.10.2015
	    * Copyright: xdot GmbH 2015
	    */

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_27__;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _mapPortlet = __webpack_require__(25);
	
	var _ModalActions = __webpack_require__(26);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _leaflet = __webpack_require__(27);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Created by Carsten Hibbeler on 14.02.2016.
	                                                                                                                                                           */
	
	var BaseRemoteVectorLayerController = function () {
	    function BaseRemoteVectorLayerController() {
	        _classCallCheck(this, BaseRemoteVectorLayerController);
	    }
	
	    /**
	     * Use this to mutate layer config used for layer creation.
	     *
	     * @param {object} layerConfig - options
	     * @return {object} layerConfig - options
	     */
	    BaseRemoteVectorLayerController.prototype.layerConfig = function layerConfig(_layerConfig) {
	        return _extends({}, _layerConfig, {
	            onClick: this.onFeatureClick.bind(this),
	            onMouseOver: this.onMouseOver.bind(this)
	        });
	    };
	
	    /**
	     * Invoked once after layer init.
	     *
	     * @param {Map} map - leaflet map
	     * @param {object} o - global options for the map
	     * @param {Layer} layer - leaflet Layer
	     * @param {object} layerConfig - config of the layer
	     */
	
	
	    BaseRemoteVectorLayerController.prototype.init = function init(map, o, layer, layerConfig, context) {
	        var _this = this;
	
	        this.map = map;
	        this.layer = layer || layer && layer.getInternalLayer && layer.getInternalLayer();
	        this.context = context;
	        this.lastSelected = [];
	        this.originalSelected = o.selectedItems || [];
	        this.disabledItems = o.disabledItems || [];
	        this.lastSelected = [];
	
	        this.forceUpdate = (0, _liferayWidgetsReactWeb.debounce)(this.forceUpdate.bind(this), 300);
	
	        if (layerConfig.className && layerConfig.api) {
	            this.className = layerConfig.className;
	            this.DATA_NAME = 'VectorLayerData_' + layerConfig.className;
	            var webApi = _liferayWidgetsReactWeb.AppContext.getWebApis()[layerConfig.api];
	            var allStores = _liferayWidgetsReactWeb.AppContext.getStores();
	            var store = allStores.find(function (s) {
	                return s.className === layerConfig.className;
	            });
	            this.removeListener = store && store.addListener(function () {
	                console.info('STORE UPDATE', layerConfig.filter.type);
	                _this.forceUpdate();
	            });
	
	            _liferayWidgetsReactWeb.RemoteDataActions.list(this.DATA_NAME, layerConfig.className, {
	                start: 0,
	                end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	            }, webApi.list);
	        }
	    };
	
	    BaseRemoteVectorLayerController.prototype.forceUpdate = function forceUpdate() {
	        var layer = this.getLayer();
	        layer.redraw();
	    };
	
	    /**
	     * Config phase.
	     * Use this to mutate options pre <code>update</code>.
	     * Do not use the options for third party component updates.
	     *
	     * @param {object} o - options
	     * @return {object} o - options
	     */
	
	
	    BaseRemoteVectorLayerController.prototype.options = function options(o) {
	        var _this2 = this;
	
	        var layer = this.getLayer(),
	            selectedItems = o.selectedItems;
	
	
	        if (selectedItems) {
	            var selectedLayers = o.selectedLayers || [];
	
	            layer.eachLayer && layer.eachLayer(function (featureLayer) {
	                var feature = featureLayer.feature;
	
	                if (_this2.isSelected(selectedItems, feature)) {
	                    selectedLayers = [].concat(selectedLayers, [featureLayer.original || featureLayer]);
	                }
	            });
	
	            if (selectedLayers.length > 0) {
	                o.selectedLayers = selectedLayers;
	            }
	        }
	
	        return o;
	    };
	
	    /**
	     * Update phase.
	     * Use this to update based on the global map options.
	     * Not invoked after first init.
	     *
	     * @param {Map} map - leaflet map
	     * @param {object} o - options
	     */
	
	
	    BaseRemoteVectorLayerController.prototype.update = function update(map, o) {
	        var layer = this.getLayer();
	        var _o$selectedItems = o.selectedItems,
	            selectedItems = _o$selectedItems === undefined ? [] : _o$selectedItems,
	            _o$disabledItems = o.disabledItems,
	            disabledItems = _o$disabledItems === undefined ? [] : _o$disabledItems;
	
	        this.lastSelected.forEach(function (s) {
	            return layer.resetFeatureStyle(s.className + '_' + s.id);
	        });
	
	        disabledItems.forEach(function (s) {
	            layer.setFeatureStyle(s.className + '_' + s.id, {
	                weight: 3,
	                fillColor: '#b3b3b3',
	                color: '#b3b3b3',
	                fillOpacity: 0.5,
	                fill: true
	            });
	        });
	
	        selectedItems && selectedItems.forEach(function (s) {
	            return layer.setFeatureStyle(s.className + '_' + s.id, {
	                weight: 3,
	                fillColor: '#FF5733',
	                color: '#FF5733',
	                fillOpacity: 0.5,
	                fill: true
	            });
	        });
	
	        this.disabledItems = disabledItems || [];
	        this.lastSelected = selectedItems || [];
	    };
	
	    BaseRemoteVectorLayerController.prototype.updateDeselected = function updateDeselected(map, layer, featureLayer, o) {
	        var originalLayer = featureLayer.originalLayer;
	
	        delete featureLayer.originalLayer;
	        map.removeLayer(featureLayer);
	        originalLayer.addLayer(featureLayer);
	        this.lastSelected = this.lastSelected.filter(function (ls) {
	            return ls.feature.properties.id !== featureLayer.feature.properties.id;
	        });
	    };
	
	    BaseRemoteVectorLayerController.prototype.updateSelected = function updateSelected(map, layer, featureLayer, o) {
	        layer.removeLayer(featureLayer);
	        if (featureLayer.original) {
	            layer.removeLayer(featureLayer.original);
	            featureLayer = featureLayer.original;
	        }
	        featureLayer.originalLayer = layer;
	        map.addLayer(featureLayer);
	        this.lastSelected = [].concat(this.lastSelected, [featureLayer]);
	    };
	
	    BaseRemoteVectorLayerController.prototype.remove = function remove(map) {
	        if (this.lastSelected) {
	            this.lastSelected.forEach(function (layer) {
	                if (layer instanceof _leaflet2.default.Layer) {
	                    map.removeLayer(layer);
	                }
	            });
	            this.lastSelected = [];
	        }
	        if (this.removeListener) {
	            this.removeListener.remove();
	            _liferayWidgetsReactWeb.RemoteDataActions.remove(this.DATA_NAME, this.className);
	        }
	    };
	
	    BaseRemoteVectorLayerController.prototype.getLayer = function getLayer() {
	        if (this.layer.getInternalLayer && this.layer.getInternalLayer()) {
	            this.layer = this.layer.getInternalLayer();
	        }
	        return this.layer;
	    };
	
	    BaseRemoteVectorLayerController.prototype.getProps = function getProps(map, feature, featureLayer, selectedItems) {
	        var props = {};
	
	        if (_mapPortlet.featureUtils.notMarker(featureLayer)) {
	
	            if (this.isCollapsed(map, featureLayer)) {
	                props.renderAsMarker = true;
	                featureLayer.marker = featureLayer.marker || this.markerForPolygon(feature, featureLayer);
	            }
	        } else {
	            if (featureLayer.original && this.isCollapsed(map, featureLayer.original)) {
	                props.renderAsMarker = true;
	            }
	        }
	
	        props.selected = this.isSelected(selectedItems, feature);
	
	        return props;
	    };
	
	    BaseRemoteVectorLayerController.prototype.isSelected = function isSelected(selectedItems, feature) {
	        var _feature$properties = feature.properties,
	            featureId = _feature$properties.id,
	            featureType = _feature$properties.type;
	
	        return !!(selectedItems && selectedItems.findIndex(function (item) {
	            return (item.item || item).id === featureId && item.className === featureType;
	        }) >= 0);
	    };
	
	    /**
	     * Check if a path is displayed smaller than minSize (in pixels)
	     * @param map
	     * @param path
	     * @param minSize
	     * @returns {boolean}
	     */
	
	
	    BaseRemoteVectorLayerController.prototype.isCollapsed = function isCollapsed(map, path) {
	        var minSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	
	        var zoom = map.getZoom();
	        var bounds = path.getBounds();
	
	        var ne_px = map.project(bounds.getNorthEast(), zoom);
	        var sw_px = map.project(bounds.getSouthWest(), zoom);
	
	        var width = ne_px.x - sw_px.x;
	        var height = sw_px.y - ne_px.y;
	        return height < minSize || width < minSize;
	    };
	
	    BaseRemoteVectorLayerController.prototype.onMouseOver = function onMouseOver(e) {
	        _leaflet2.default.popup().setContent(e.layer.properties.name || e.layer.properties.type).setLatLng(e.latlng);
	        //.openOn(map);
	
	        _leaflet2.default.DomEvent.stop(e);
	    };
	
	    BaseRemoteVectorLayerController.prototype.onFeatureClick = function onFeatureClick(e) {
	        //e.originalEvent.preventDefault();
	        var layer = e.layer;
	
	        var allowClick = this.originalSelected.find(function (item) {
	            return parseInt(item.id) === parseInt(layer.properties.id);
	        }) || !this.disabledItems.find(function (item) {
	            return parseInt(item.id) === parseInt(layer.properties.id);
	        });
	        if (allowClick) {
	            this.onItemClick(layer.properties.type, layer.properties.id, layer.properties.title);
	        }
	    };
	
	    BaseRemoteVectorLayerController.prototype.onItemClick = function onItemClick(className, id) {
	        _liferayWidgetsReactWeb.RemoteDataActions.pageSelected(className, { id: id });
	        _ModalActions2.default.showModal(className, { id: id }, false, undefined, { contextId: this.context && this.context.contextId });
	    };
	
	    return BaseRemoteVectorLayerController;
	}();
	
	exports.default = BaseRemoteVectorLayerController;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WmsLayerRefreshController = function () {
	    function WmsLayerRefreshController() {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$refreshInterval = _ref.refreshInterval,
	            refreshInterval = _ref$refreshInterval === undefined ? 1000 * 60 : _ref$refreshInterval;
	
	        _classCallCheck(this, WmsLayerRefreshController);
	
	        this.refreshInterval = refreshInterval;
	        this.refresh = this.refresh.bind(this);
	    }
	
	    WmsLayerRefreshController.prototype.layerConfig = function layerConfig(_layerConfig) {
	        return _layerConfig;
	    };
	
	    WmsLayerRefreshController.prototype.init = function init(map, o, layer, layerConfig, context) {
	        this.o = o;
	        this.layer = layer || layer && layer.getInternalLayer && layer.getInternalLayer();
	
	        this.interval = setInterval(this.refresh, this.refreshInterval);
	    };
	
	    WmsLayerRefreshController.prototype.options = function options(o) {
	        return o;
	    };
	
	    WmsLayerRefreshController.prototype.update = function update(map, o) {
	        console.debug('WmsLayerRefreshController update()', { map: map, o: o });
	        this.o = o;
	    };
	
	    WmsLayerRefreshController.prototype.remove = function remove(map) {
	        this.layer = null;
	        clearInterval(this.interval);
	    };
	
	    WmsLayerRefreshController.prototype.refresh = function refresh() {
	        // Merges an object with the new parameters and re-requests tiles on the current screen (unless noRedraw was set to true).
	        this.layer.setParams({
	            timestamp: Date.now()
	        }, false);
	    };
	
	    return WmsLayerRefreshController;
	}();
	
	exports.default = WmsLayerRefreshController;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ReferenceValueWebApi = __webpack_require__(31);
	
	var _ReferenceValueWebApi2 = _interopRequireDefault(_ReferenceValueWebApi);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.ReferenceValue; /**
	                                                       * Created by Carsten Bühler
	                                                       * User: c.buehler on 01.09.2016
	                                                       * Copyright: xdot GmbH 2015
	                                                       */
	
	exports.default = {
	  getReferenceValuesByDataTypeNotExpired: function getReferenceValuesByDataTypeNotExpired(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _ReferenceValueWebApi2.default.getReferenceValuesByDataTypeNotExpired);
	  },
	  remove: function remove(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.remove(name, className);
	  }
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(20);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 09.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var baseService = function baseService(m, o) {
	    return _lwrClient.Client.invoke('/base.referencevalue/' + m, o);
	};
	//const baseServiceWithContext = (m, o, c) => Client.invokeWithContext('/base.namedprop/' + m, o, c);
	
	var api = {
	    getReferenceValuesByDataTypeNotExpired: function getReferenceValuesByDataTypeNotExpired(query) {
	        return baseService('get-reference-values-by-data-type-not-expired.3', {
	            className: query.className,
	            classPK: query.classPK,
	            dataType: query.dataType
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('ReferenceValueWebApi', api);
	
	exports.default = api;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _FliwasPermissionWebApi = __webpack_require__(19);
	
	var _FliwasPermissionWebApi2 = _interopRequireDefault(_FliwasPermissionWebApi);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.FliwasPermission;
	
	exports.default = {
	
	    selectedNamespace: function selectedNamespace(namespace) {
	        return _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	            type: _Constants.ActionTypes.SELECTED_FLIWAS_PERMISSION_NAMESPACE,
	            payload: _extends({}, namespace)
	        });
	    },
	    getPermissionStatesByRoleId: function getPermissionStatesByRoleId(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasPermissionWebApi2.default.getPermissionStatesByRoleId);
	    },
	    getPermissionState: function getPermissionState(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query, _FliwasPermissionWebApi2.default.getPermissionState);
	    },
	
	    listAllNamespaces: function listAllNamespaces(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasPermissionWebApi2.default.listAllNamespaces);
	    },
	    getUserRoles: function getUserRoles(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query, _FliwasPermissionWebApi2.default.getUserRoles);
	    },
	
	    setPermission: function setPermission(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_FliwasPermissionWebApi2.default.setFiliwasPermissions, item, formId, closeForm);
	    }
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ReferenceValueActions = __webpack_require__(30);
	
	var _ReferenceValueActions2 = _interopRequireDefault(_ReferenceValueActions);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 11.03.2019
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2019
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ReferenceValueStore = (0, _StoreFactory.getReferenceValueStore)(_liferayWidgetsReactWeb.AppContext);
	
	var ReferenceValueSelect = function (_React$Component) {
	    _inherits(ReferenceValueSelect, _React$Component);
	
	    function ReferenceValueSelect(props) {
	        _classCallCheck(this, ReferenceValueSelect);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            REFERENCE_VALUES: 'RefValues'
	        };
	
	        _this.onSelect = _this.onSelect.bind(_this);
	        return _this;
	    }
	
	    ReferenceValueSelect.getStores = function getStores() {
	        return [ReferenceValueStore];
	    };
	
	    ReferenceValueSelect.calculateState = function calculateState(prevState, undefined, DATA) {
	        return {
	            referenceValues: ReferenceValueStore.getRemoteData(DATA.REFERENCE_VALUES)
	        };
	    };
	
	    ReferenceValueSelect.prototype.componentDidMount = function componentDidMount() {
	        if (this.props.id > 0) {
	            _ReferenceValueActions2.default.getReferenceValuesByDataTypeNotExpired(this.DATA.REFERENCE_VALUES, {
	                className: this.props.className,
	                classPK: this.props.id,
	                dataType: this.props.dataType
	            });
	        }
	    };
	
	    ReferenceValueSelect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        if (this.props.id !== prevProps.id || this.props.className !== prevProps.className || this.props.dataType !== prevProps.dataType) {
	            if (this.props.id === -1) {
	                _ReferenceValueActions2.default.remove();
	            } else {
	                _ReferenceValueActions2.default.getReferenceValuesByDataTypeNotExpired(this.DATA.REFERENCE_VALUES, {
	                    className: this.props.className,
	                    classPK: this.props.id,
	                    dataType: this.props.dataType
	                });
	            }
	        }
	    };
	
	    ReferenceValueSelect.prototype.onSelect = function onSelect(e) {
	        var referenceValue = undefined;
	        if (e.target.value.indexOf('-') > 0) {
	            var refKey = e.target.value.split('-');
	            referenceValue = _liferayWidgetsReactWeb.DataUtil.asArray(this.state.referenceValues).find(function (refVal) {
	                return refVal.key === refKey[0] && refVal.unit === refKey[1] && refVal.dataType === refKey[2];
	            });
	        }
	
	        this.props.onChange(referenceValue);
	    };
	
	    ReferenceValueSelect.prototype.render = function render() {
	        var _this2 = this;
	
	        var refKeyOptions = [];
	        var referenceValues = _liferayWidgetsReactWeb.DataUtil.asArray(this.state.referenceValues);
	        if (referenceValues && referenceValues.length > 0) {
	            refKeyOptions = [_react2.default.createElement(
	                'option',
	                { key: -1, value: "--" },
	                'Bitte ausw\xE4hlen'
	            )];
	            if (this.props.filterFn) {
	                refKeyOptions = refKeyOptions.concat(referenceValues.filter(this.props.filterFn).map(function (refValue) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: refValue.id, value: refValue.key + '-' + refValue.unit + '-' + refValue.dataType },
	                        _this2.refLabel(refValue)
	                    );
	                }));
	            } else {
	                refKeyOptions = refKeyOptions.concat(referenceValues.map(function (refValue) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: refValue.id, value: refValue.key + '-' + refValue.unit + '-' + refValue.dataType },
	                        _this2.refLabel(refValue)
	                    );
	                }));
	            }
	        } else {
	            refKeyOptions = [_react2.default.createElement(
	                'option',
	                { key: -1, value: null },
	                'Keine Kennwerte vorhanden!'
	            )];
	        }
	
	        var refKey = this.props.refKey + '-' + this.props.unit + '-' + this.props.dataType;
	
	        return _react2.default.createElement(
	            _reactBootstrap.FormControl,
	            { as: 'select',
	                label: 'Kennwert',
	                value: refKey,
	                onChange: this.onSelect },
	            refKeyOptions
	        );
	    };
	
	    ReferenceValueSelect.prototype.refLabel = function refLabel(refValue) {
	        return refValue.title + ' (' + refValue.value + ' ' + refValue.unit.replace("m3/s", "m³/s") + ')';
	    };
	
	    return ReferenceValueSelect;
	}(_react2.default.Component);
	
	ReferenceValueSelect.propTypes = {
	    onChange: _propTypes2.default.func.isRequired,
	
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.number,
	    dataType: _propTypes2.default.string,
	    refKey: _propTypes2.default.string,
	    unit: _propTypes2.default.string,
	    filterFn: _propTypes2.default.func
	};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(ReferenceValueSelect);

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_34__;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_35__;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateFormat = __webpack_require__(37);
	
	var DateFormat = _interopRequireWildcard(_dateFormat);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateTimeDisplay = function DateTimeDisplay(_ref) {
	    var timestamp = _ref.timestamp,
	        dateFormat = _ref.dateFormat,
	        classNames = _ref.classNames,
	        onClick = _ref.onClick;
	
	
	    if (!(timestamp && dateFormat)) {
	        return _react2.default.createElement(
	            'span',
	            { className: '' + (classNames || ''), onClick: onClick && onClick.bind(undefined) },
	            '---'
	        );
	    }
	
	    return _react2.default.createElement(
	        'span',
	        { className: '' + (classNames || ''),
	            onClick: onClick && onClick.bind(undefined) },
	        dateFormat(timestamp)
	    );
	}; /**
	    * Created by Carsten Bühler
	    * User: c.buehler on 14.09.2016
	    * Copyright: xdot GmbH 2015
	    */
	
	DateTimeDisplay.propTypes = {
	    timestamp: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    classNames: _propTypes2.default.string,
	    dateFormat: _propTypes2.default.func,
	    onClick: _propTypes2.default.func
	};
	
	DateTimeDisplay.defaultProps = {
	    dateFormat: DateFormat.formatDateTimeNoSeconds
	};
	
	exports.default = DateTimeDisplay;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_TIME_FORMAT = exports.DEFAULT_DATE_FORMAT = exports.DEFAULT_DATETIME_FORMAT_NO_YEAR = exports.DEFAULT_DATETIME_FORMAT = undefined;
	exports.format = format;
	exports.formatDateTimeNoSeconds = formatDateTimeNoSeconds;
	exports.formatDateTimeNoYear = formatDateTimeNoYear;
	exports.formatDate = formatDate;
	exports.formatTimeNoSeconds = formatTimeNoSeconds;
	
	var _datefns = __webpack_require__(38);
	
	var _datefns2 = _interopRequireDefault(_datefns);
	
	var _reactDatepicker = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 23.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	(0, _reactDatepicker.registerLocale)('de', _datefns2.default.locale);
	(0, _reactDatepicker.setDefaultLocale)('de');
	
	var DEFAULT_DATETIME_FORMAT = exports.DEFAULT_DATETIME_FORMAT = 'dd.MM.yy HH:mm';
	var DEFAULT_DATETIME_FORMAT_NO_YEAR = exports.DEFAULT_DATETIME_FORMAT_NO_YEAR = 'dd.MM. HH:mm';
	var DEFAULT_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = 'dd.MM.yy';
	var DEFAULT_TIME_FORMAT = exports.DEFAULT_TIME_FORMAT = 'HH:mm';
	
	function format(v, format) {
	    try {
	        return _datefns2.default.format(new Date(v), format);
	    } catch (e) {
	        return '---';
	    }
	}
	
	function formatDateTimeNoSeconds(v) {
	    return format(v, DEFAULT_DATETIME_FORMAT);
	}
	
	function formatDateTimeNoYear(v) {
	    return _datefns2.default.format(new Date(v), DEFAULT_DATETIME_FORMAT_NO_YEAR);
	}
	
	function formatDate(v) {
	    return format(v, DEFAULT_DATE_FORMAT);
	}
	
	function formatTimeNoSeconds(v) {
	    return format(v, DEFAULT_TIME_FORMAT);
	}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler ##Test
	 * User: CBuehler on 29.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NumberSelect = function (_React$Component) {
	  _inherits(NumberSelect, _React$Component);
	
	  function NumberSelect(props) {
	    _classCallCheck(this, NumberSelect);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onItemChange = _this.onItemChange.bind(_this);
	    return _this;
	  }
	
	  NumberSelect.prototype.onItemChange = function onItemChange(e) {
	    if (this.props.multiple) {
	      var data = [];
	
	      for (var i = 0; i < e.target.options.length; i++) {
	        if (e.target.options[i].selected) {
	          data.push(parseInt(e.target.options[i].value));
	        }
	      }
	      this.props.onChange(data);
	    } else {
	      this.props.onChange(parseInt(e.target.value));
	    }
	  };
	
	  NumberSelect.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        list = _props.list,
	        currentValue = _props.currentValue,
	        _props$currentKeys = _props.currentKeys,
	        currentKeys = _props$currentKeys === undefined ? [] : _props$currentKeys,
	        _props$defaultOption = _props.defaultOption,
	        defaultOption = _props$defaultOption === undefined ? _react2.default.createElement(
	      'option',
	      { key: 'option_-1', value: -1 },
	      'Bitte wählen!'
	    ) : _props$defaultOption,
	        _props$multiple = _props.multiple,
	        multiple = _props$multiple === undefined ? false : _props$multiple;
	
	    var selectedElement = this.props.multiple ? [] : -1;
	    var options = defaultOption ? [defaultOption] : [];
	    var createOption = function createOption(item, selected) {
	      if (selected) {
	        options.push(_react2.default.createElement(
	          'option',
	          { key: 'option_' + item.label + '_' + item.value,
	            value: item.value },
	          item.label
	        ));
	        _this2.props.multiple ? selectedElement.push(item.value) : selectedElement = item.value;
	      } else {
	        options.push(_react2.default.createElement(
	          'option',
	          { key: 'option_' + item.label + '_' + item.value,
	            value: item.value },
	          item.label
	        ));
	      }
	    };
	
	    if (list && list.length > 0) {
	      list.forEach(function (item) {
	        if (multiple) {
	          var contained = [];
	          contained = currentKeys && currentKeys.filter(function (k) {
	            return k === item.value;
	          });
	          var found = contained.length > 0;
	          createOption(item, found);
	        } else {
	          createOption(item, currentValue === item.value);
	        }
	      });
	    } else {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '---'
	      );
	    }
	
	    return _react2.default.createElement(
	      _reactBootstrap.FormControl,
	      {
	        as: 'select',
	        multiple: multiple,
	        value: selectedElement,
	        className: className,
	        onChange: this.onItemChange },
	      options
	    );
	  };
	
	  return NumberSelect;
	}(_react2.default.Component);
	
	NumberSelect.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  list: _propTypes2.default.array.isRequired,
	  multiple: _propTypes2.default.bool,
	  defaultOption: _propTypes2.default.object,
	  currentValue: _propTypes2.default.number,
	  currentKeys: _propTypes2.default.array,
	  className: _propTypes2.default.string
	};
	
	exports.default = NumberSelect;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FilterDropdown = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterDropdown = exports.FilterDropdown = function FilterDropdown(_ref) {
	  var count = _ref.count,
	      children = _ref.children,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Filter auswählen' : _ref$title,
	      _ref$iconClassName = _ref.iconClassName,
	      iconClassName = _ref$iconClassName === undefined ? 'fa fa-filter' : _ref$iconClassName,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var _useState = (0, _react.useState)(false),
	      isOpen = _useState[0],
	      setIsOpen = _useState[1];
	
	  var onToggle = function onToggle(show, e, metadata) {
	    // prevent from closing when clicking an item
	    if (metadata.source !== 'select') {
	      setIsOpen(show);
	    }
	  };
	
	  return _react2.default.createElement(
	    _reactBootstrap.Dropdown,
	    {
	      show: isOpen,
	      className: 'filter-dropdown ' + className,
	      onToggle: onToggle
	    },
	    _react2.default.createElement(
	      _reactBootstrap.Dropdown.Toggle,
	      { id: 'filter-toggle' },
	      _react2.default.createElement(
	        'div',
	        { className: 'd-flex flex-row align-items-center' },
	        _react2.default.createElement('i', { className: iconClassName, 'aria-hidden': 'true' }),
	        title,
	        count > 0 && _react2.default.createElement(
	          _reactBootstrap.Badge,
	          { pill: true, variant: 'primary' },
	          count
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Dropdown.Menu,
	      null,
	      children
	    )
	  );
	}; /**
	    * User: Nikolai Gorte * Date: 23.11.23 * Time: 09:31
	    */
	
	
	FilterDropdown.propTypes = {
	  title: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  iconClassName: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  count: _propTypes2.default.number
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BaseToolbar = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User: Nikolai Gorte * Date: 17.11.23 * Time: 16:09
	 */
	var BaseToolbar = exports.BaseToolbar = function BaseToolbar(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'base-toolbar ' + className },
	    children
	  );
	};
	
	BaseToolbar.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActiveFilterBar = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActiveFilterBar = exports.ActiveFilterBar = function ActiveFilterBar(_ref) {
	  var onFilterRemove = _ref.onFilterRemove,
	      onFilterReset = _ref.onFilterReset,
	      activeFilters = _ref.activeFilters,
	      className = _ref.className;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'active-filter-bar ' + className },
	    activeFilters.map(function (f) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          key: f.type + f.value,
	          variant: 'outline-primary',
	          onClick: function onClick() {
	            return onFilterRemove(f);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'd-flex flex-row align-items-center' },
	          _react2.default.createElement(
	            'span',
	            { className: 'mx-3' },
	            f.altLabel || f.label
	          ),
	          _react2.default.createElement('i', { className: 'icon icon-fliwas-x', 'aria-hidden': 'true' })
	        )
	      );
	    }),
	    activeFilters.length > 1 && _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        variant: 'outline-danger',
	        className: 'btn-reset',
	        onClick: onFilterReset
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'd-flex flex-row align-items-center' },
	        _react2.default.createElement(
	          'span',
	          { className: 'mx-3' },
	          'Alle Filter l\xF6schen'
	        ),
	        _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' })
	      )
	    )
	  );
	}; /**
	    * User: Nikolai Gorte * Date: 17.11.23 * Time: 16:09
	    */
	
	
	ActiveFilterBar.propTypes = {
	  activeFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    type: _propTypes2.default.string,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    label: _propTypes2.default.string.isRequired,
	    altLabel: _propTypes2.default.string
	  })),
	  onFilterRemove: _propTypes2.default.func,
	  onFilterReset: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 15.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateFormat = __webpack_require__(37);
	
	var DateFormat = _interopRequireWildcard(_dateFormat);
	
	var _DateTimeDisplay = __webpack_require__(36);
	
	var _DateTimeDisplay2 = _interopRequireDefault(_DateTimeDisplay);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeLineItem = function TimeLineItem(_ref) {
	    var timestamp = _ref.timestamp,
	        userMeta = _ref.userMeta,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'journal-timeline-item' },
	        _react2.default.createElement(
	            'div',
	            { className: 'date' },
	            _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: timestamp, dateFormat: DateFormat.formatDate }),
	            _react2.default.createElement(
	                'small',
	                { className: 'text-navy' },
	                _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: timestamp, dateFormat: DateFormat.formatTimeNoSeconds })
	            ),
	            userMeta && _react2.default.createElement(
	                'small',
	                null,
	                userMeta.userName + (userMeta.teamName ? ' (' + userMeta.teamName + ')' : '')
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            children
	        )
	    );
	};
	
	TimeLineItem.propTypes = {
	    timestamp: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	    userMeta: _propTypes2.default.object,
	    iconClassName: _propTypes2.default.string,
	    children: _propTypes2.default.node
	};
	
	exports.default = TimeLineItem;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 15.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeLineItemMessageHeader = function TimeLineItemMessageHeader(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'm-b-xs' },
	    props.children
	  );
	};
	
	TimeLineItemMessageHeader.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = TimeLineItemMessageHeader;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(47)();
	}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(48);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 27.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	var NamedPropStore = (0, _StoreFactory.getNamedPropStore)(_liferayWidgetsReactWeb.AppContext);
	
	var NamedProp = function NamedProp(_ref) {
	    var type = _ref.type,
	        typeKey = _ref.typeKey;
	
	    var prop = NamedPropStore.getPropByTypeKey(type, typeKey);
	    if (!prop) {
	        console.warn('Prop not found', type, typeKey);
	    }
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        prop && prop.title ? prop.title : '---'
	    );
	};
	
	NamedProp.propTypes = {
	    type: _propTypes2.default.string,
	    typeKey: _propTypes2.default.string
	};
	
	exports.default = NamedProp;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateFormat = __webpack_require__(37);
	
	var DateFormat = _interopRequireWildcard(_dateFormat);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _DateTimeDisplay = __webpack_require__(36);
	
	var _DateTimeDisplay2 = _interopRequireDefault(_DateTimeDisplay);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ObjectDates = function ObjectDates(_ref) {
	    var dataItem = _ref.dataItem;
	
	    var item = dataItem;
	    return _react2.default.createElement(
	        'div',
	        { className: 'padding-box-v' },
	        _react2.default.createElement(
	            'h4',
	            null,
	            'Daten'
	        ),
	        item && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 4, md: 4, sm: 4, xs: 4 },
	                    'Erstellt:'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 8, md: 8, sm: 8, xs: 8 },
	                    _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: item.createDate, dateFormat: DateFormat.formatDateTimeNoSeconds })
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 4, md: 4, sm: 4, xs: 4 },
	                    'Ge\xE4ndert:'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 8, md: 8, sm: 8, xs: 8 },
	                    _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: item.modifiedDate, dateFormat: DateFormat.formatDateTimeNoSeconds })
	                )
	            )
	        )
	    );
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 25.09.2015
	    * Copyright: xdot GmbH 2015
	    */
	
	ObjectDates.propTypes = {
	    dataItem: _propTypes2.default.object
	};
	
	exports.default = ObjectDates;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ModalActions = __webpack_require__(26);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _TitleActions = __webpack_require__(52);
	
	var _TitleActions2 = _interopRequireDefault(_TitleActions);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 11.02.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TitleStore = (0, _StoreFactory.getTitleStore)(_liferayWidgetsReactWeb.AppContext);
	
	var BusinessObjectLink = function (_React$Component) {
	    _inherits(BusinessObjectLink, _React$Component);
	
	    function BusinessObjectLink(props) {
	        _classCallCheck(this, BusinessObjectLink);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {};
	        _this.state.title = _this.props.title || TitleStore.getTitleFromKey(_this.props.className + '-' + _this.props.classPK);
	        _this.state.isActive = _this.props.isActive !== undefined ? _this.props.isActive : true;
	        _this.state.isVisible = _this.props.isVisible !== undefined ? _this.props.isVisible : true;
	        return _this;
	    }
	
	    BusinessObjectLink.prototype.componentDidMount = function componentDidMount() {
	        this.removeListener = TitleStore.addListener(this.titlesChanged.bind(this));
	        //Fetch the title, if no customtitle was set via props.
	        if (!this.state.title) {
	            this.requestTitle();
	        }
	    };
	
	    BusinessObjectLink.prototype.requestTitle = function requestTitle() {
	        var titleKey = this.props.className + '-' + this.props.classPK;
	        _TitleActions2.default.missingTitles([titleKey]);
	    };
	
	    BusinessObjectLink.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	        if (!(prevProps.className === this.props.className && prevProps.classPK === this.props.classPK)) {
	            var titleFromStore = TitleStore.getTitleFromKey(this.props.className + '-' + this.props.classPK);
	            if (!titleFromStore) {
	                this.requestTitle();
	            } else {
	                this.setState({ title: titleFromStore });
	            }
	        }
	    };
	
	    BusinessObjectLink.prototype.titlesChanged = function titlesChanged() {
	        var newTitle = this.props.title || TitleStore.getTitleFromKey(this.props.className + '-' + this.props.classPK);
	        if (this.state.title !== newTitle) {
	            this.setState({
	                title: newTitle
	            });
	        }
	    };
	
	    BusinessObjectLink.prototype.openDetailsModal = function openDetailsModal(className, classPK, e) {
	        _ModalActions2.default.showModal(className, {
	            id: classPK
	        }, false, undefined, { contextId: this.context && this.context.contextId });
	        e.preventDefault();
	        e.stopPropagation();
	    };
	
	    BusinessObjectLink.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.removeListener) {
	            this.removeListener.remove();
	        }
	    };
	
	    BusinessObjectLink.prototype.render = function render() {
	        var _props = this.props,
	            _props$buttonProps = _props.buttonProps,
	            buttonProps = _props$buttonProps === undefined ? {} : _props$buttonProps,
	            _props$inline = _props.inline,
	            inline = _props$inline === undefined ? true : _props$inline;
	
	        return _react2.default.createElement(
	            'a',
	            _extends({
	                className: 'btn btn-outline-primary btn-sm business-object-link ' + (inline ? 'business-object-link--inline' : '') + ' ' + (!this.state.isActive ? 'business-object-link-error' : '') + '  ' + (!this.state.isVisible ? 'business-object-link-not-visible' : '') + ' ',
	                title: this.state.title,
	                onClick: this.openDetailsModal.bind(this, this.props.className, this.props.classPK),
	                'data-object-type': this.props.className
	            }, buttonProps),
	            this.state.title ? this.state.title : '#' + this.props.className + '-' + this.props.classPK
	        );
	    };
	
	    return BusinessObjectLink;
	}(_react2.default.Component);
	
	BusinessObjectLink.propTypes = {
	    className: _propTypes2.default.string.isRequired,
	    classPK: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	    title: _propTypes2.default.string,
	    /* indicates if object "exists", false = deleted(=deactivated))*/
	    isActive: _propTypes2.default.bool,
	    /* indicates if object is visible because either it is shared or it is in same site */
	    isVisible: _propTypes2.default.bool,
	    buttonProps: _propTypes2.default.object,
	    inline: _propTypes2.default.bool
	};
	
	BusinessObjectLink.contextTypes = {
	    contextId: _propTypes2.default.string
	};
	
	exports.default = BusinessObjectLink;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _StoreFactory = __webpack_require__(2);
	
	var TitleStore = (0, _StoreFactory.getTitleStore)(_liferayWidgetsReactWeb.AppContext); /**
	                                                                                        * Created by Carsten Bühler
	                                                                                        * User: c.buehler on 23.10.2018
	                                                                                        * Copyright: xdot GmbH 2018
	                                                                                        */
	
	var fetchMissingTitles = function fetchMissingTitles() {
	    var keys = TitleStore.filterNotRequested(Object.keys(_missingTitles));
	    _missingTitles = null;
	    if (keys.length > 0) {
	
	        var l = 0;
	        var idx = keys.findIndex(function (k) {
	            l += k.length + 1;
	            return l > 1024;
	        });
	
	        if (idx >= 0) {
	            _missingTitles = keys.slice(idx).reduce(function (accum, key) {
	                accum[key] = true;
	                return accum;
	            }, {});
	            keys = keys.slice(0, idx);
	            setTimeout(fetchMissingTitles, 0);
	        }
	
	        //Do XHR with Key http://localhost:8080/delegate/title-lookup?keys=GaugingStation-5,GaugingStation-3,Group-23418
	        //On Result send them to the store => Component should render.
	        var xhr = new XMLHttpRequest();
	        xhr.onreadystatechange = function () {
	            if (xhr.readyState === 4 && xhr.status === 200) {
	                // Typical action to be performed when the document is ready:
	                if (xhr.responseText) {
	                    _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	                        type: _Constants.ActionTypes.TITLES_UPDATE,
	                        payload: {
	                            xhr: xhr,
	                            lookUpResult: JSON.parse(xhr.responseText)
	                        }
	                    });
	                }
	            }
	        };
	        xhr.open("GET", "/o/title/lookup?keys=" + keys.join(','), true);
	        xhr.send();
	
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	            type: _Constants.ActionTypes.TITLES_REQUEST,
	            payload: {
	                keys: keys,
	                xhr: xhr
	            }
	        });
	    }
	};
	
	var _missingTitles = null;
	exports.default = {
	    missingTitles: function missingTitles(keys) {
	        if (_missingTitles == null) {
	            _missingTitles = {};
	            setTimeout(fetchMissingTitles, 0);
	        }
	        for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var key = _ref;
	
	            _missingTitles[key] = true;
	        }
	    }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 29.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.MiniWidgetLineWrapper = exports.MiniWidgetLine = exports.MiniWidgetHeader = exports.MiniWidgetContent = exports.MiniWidgetWrapper = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	__webpack_require__(54);
	
	var _ModalActions = __webpack_require__(26);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DateTimeDisplay = __webpack_require__(36);
	
	var _DateTimeDisplay2 = _interopRequireDefault(_DateTimeDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//ToDo FLIWAS-1713: @t.wahl Remove the inline scss and set correct classes or inline-style
	
	var getOverallStateClassName = function getOverallStateClassName(item, className) {
	    if (!className) {
	        var i = _liferayWidgetsReactWeb.DataUtil.asItem(item);
	        return i && i.overallState && i.overallState.state.style || 'lightgrey';
	    }
	    return className;
	};
	var MiniWidgetWrapper = function MiniWidgetWrapper(_ref) {
	    var item = _ref.item,
	        children = _ref.children,
	        className = _ref.className;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'mini-widget inner ' + getOverallStateClassName(item, className) },
	        _react2.default.createElement(
	            'div',
	            { className: 'mini-widget-header' },
	            ' '
	        ),
	        _react2.default.createElement(
	            _liferayWidgetsReactWeb.FlagComponent,
	            { item: item },
	            children
	        )
	    );
	};
	
	var MiniWidgetContent = function MiniWidgetContent(_ref2) {
	    var item = _ref2.item,
	        children = _ref2.children,
	        className = _ref2.className;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'content ' + getOverallStateClassName(item, className) },
	        children
	    );
	};
	
	// eslint-disable-next-line react/prop-types
	var MiniWidgetLineWrapper = function MiniWidgetLineWrapper(_ref3) {
	    var onClick = _ref3.onClick,
	        children = _ref3.children,
	        _ref3$className = _ref3.className,
	        className = _ref3$className === undefined ? "" : _ref3$className;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'line ' + className, onClick: onClick },
	        children
	    );
	};
	
	// eslint-disable-next-line react/prop-types
	var MiniWidgetLine = function MiniWidgetLine(_ref4) {
	    var iconClass = _ref4.iconClass,
	        value = _ref4.value,
	        unit = _ref4.unit,
	        timestamp = _ref4.timestamp,
	        onClick = _ref4.onClick,
	        fastEditFunc = _ref4.fastEditFunc;
	
	
	    var _onClickEdit = function _onClickEdit(e) {
	        e.stopPropagation();
	        fastEditFunc();
	    };
	
	    return _react2.default.createElement(
	        MiniWidgetLineWrapper,
	        { onClick: onClick, className: 'w-100' },
	        _react2.default.createElement(
	            'div',
	            { className: 'line-inner' },
	            _react2.default.createElement(
	                'div',
	                { className: 'edit-button-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'd-flex align-items-center' },
	                    iconClass && _react2.default.createElement(_Icon2.default, { name: iconClass }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'value' },
	                        value
	                    ),
	                    unit && _react2.default.createElement(
	                        'span',
	                        { className: 'unit' },
	                        unit
	                    )
	                ),
	                fastEditFunc && _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        variant: 'outline-primary',
	                        className: 'mini-widget-edit-button',
	                        title: 'Bearbeiten',
	                        onClick: _onClickEdit
	                    },
	                    _react2.default.createElement(_Icon2.default, { name: 'pencil', className: 'mini-widget-edit-icon', title: 'Bearbeiten' })
	                )
	            )
	        ),
	        timestamp && _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: timestamp, classNames: 'time' })
	    );
	};
	
	var MiniWidgetHeader = function (_React$Component) {
	    _inherits(MiniWidgetHeader, _React$Component);
	
	    function MiniWidgetHeader() {
	        _classCallCheck(this, MiniWidgetHeader);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    MiniWidgetHeader.prototype.openHistory = function openHistory() {
	        var item = _liferayWidgetsReactWeb.DataUtil.asItem(this.props.item);
	
	        _ModalActions2.default.showModal(this.props.className, {
	            id: item[this.props.idAttribute || 'id']
	        }, false, this.props.props, {
	            contextId: this.context && this.context.contextId
	        });
	    };
	
	    MiniWidgetHeader.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'header', onClick: this.openHistory.bind(this), title: 'Details anzeigen' },
	            _react2.default.createElement(
	                'div',
	                { className: 'header-icon' },
	                _react2.default.createElement(_Icon2.default, { name: this.props.iconClass })
	            ),
	            _react2.default.createElement(
	                'h2',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    this.props.customTitle || this.props.item && this.props.item.title
	                )
	            )
	        );
	    };
	
	    return MiniWidgetHeader;
	}(_react2.default.Component);
	
	MiniWidgetHeader.propTypes = {
	    item: _propTypes2.default.object,
	    idAttribute: _propTypes2.default.string,
	    customTitle: _propTypes2.default.string,
	    iconClass: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    contextId: _propTypes2.default.string,
	    props: _propTypes2.default.object
	};
	
	MiniWidgetHeader.contextTypes = {
	    contextId: _propTypes2.default.string
	};
	
	MiniWidgetWrapper.propTypes = {
	    item: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string
	};
	
	MiniWidgetContent.propTypes = {
	    item: _propTypes2.default.object,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	    className: _propTypes2.default.string
	};
	
	exports.MiniWidgetWrapper = MiniWidgetWrapper;
	exports.MiniWidgetContent = MiniWidgetContent;
	exports.MiniWidgetHeader = MiniWidgetHeader;
	exports.MiniWidgetLine = MiniWidgetLine;
	exports.MiniWidgetLineWrapper = MiniWidgetLineWrapper;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(55);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_miniwidgets.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_miniwidgets.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".mini-widget-dropzone>.portlet-column-content{display:flex;justify-content:space-around;flex-flow:row wrap;margin-left:-10px;margin-right:-10px}.mini-widget-dropzone>.portlet-column-content>.portlet-boundary{margin:10px}.mini-widgets{overflow:hidden}.mini-widgets-wrapper{padding-top:15px}.mini-widgets-wrapper section.portlet.portlet-container{display:inline-block;float:left}.mini-widget{box-sizing:border-box;font-size:6vw;overflow:hidden;display:inline-block;background-color:#f7f7f8;border:1px solid #eaeaea;box-shadow:0 0 14px -4px hsla(240,1%,45%,.7);width:13em;margin-bottom:10px}.mini-widget__journal_entry_button{position:absolute;left:8px;bottom:12px}@media (min-width:321px){.mini-widget{width:13em;font-size:3.325vw;float:left}.mini-widget:nth-child(odd){clear:both}.mini-widget:nth-child(2n){float:right}}@media (min-width:640px){.mini-widget{width:20vw;font-size:1.6vw}.mini-widget:nth-child(odd){float:right}.mini-widget:nth-child(2n){float:left}.mini-navbar .mini-widget{width:20vw;font-size:1.6vw}.mini-navbar .mini-widget:nth-child(odd){clear:none;float:left}.mini-navbar .mini-widget:nth-child(2n){float:left;margin-left:1.5vw}.mini-navbar .mini-widget:nth-child(3n){float:right;margin-left:0;margin-right:0}.mini-navbar .mini-widget:nth-child(3n+1){clear:both;margin-left:0}.mini-navbar .mini-widget:nth-child(3n+2){clear:none;margin-left:1.5vw}}@media (min-width:1024px){.mini-navbar .mini-widget,.mini-widget{width:14vw;font-size:1.12vw}}@media (min-width:1680px){.mini-navbar .mini-widget,.mini-widget{width:11vw;font-size:.88vw}}.mini-widget .mini-widget-header{height:1.5em;border-bottom:1px solid #eaeaea;background-color:#f7f7f8}.mini-widget .inner{box-sizing:border-box;margin:0;height:100%}.mini-widget .header,.mini-widget .inner{background-color:#fff;overflow:hidden;width:100%}.mini-widget .header{height:4em;position:relative}.mini-widget .header .header-icon{color:#a5a5a5;padding:.1em 0;font-size:2.5em;height:100%;width:20%;float:left;display:flex;align-items:center;justify-content:center}.mini-widget .header h2{width:80%;float:left;height:100%;margin:0;padding:0;display:inline-block;text-overflow:ellipsis;text-align:left;font-weight:800;font-size:.9em;position:relative}.mini-widget .header h2 span{padding-left:3%;padding-top:6%;display:inline-block;width:100%;overflow:hidden;max-height:3.9em;min-height:65px}.mini-widget .alert{padding:.5em}.mini-widget .alert h3{font-size:1em;margin-bottom:.5em;text-align:center}.mini-widget .alert p{margin:.5em 0;font-size:.8em}.mini-widget .content{clear:both;font-size:1.2em;line-height:100%;padding:.5em 0;height:8.2em;position:relative;background-color:#f7f7f8}.mini-widget .content .detail{display:inline-block}.mini-widget .content .icon{display:inline-block;margin-right:.3em;background-color:#fff;border-radius:5px;padding:.25em;border:1px solid #eaeaea}.mini-widget .content .mini-widget-edit-button{margin-top:.125rem}.mini-widget .content .mini-widget-edit-icon{border:none;background-color:transparent}.mini-widget .content .detail,.mini-widget .content .icon{vertical-align:top;float:left}.mini-widget .content .unit{font-size:.6em;padding-left:.25em;padding-top:.7em}.mini-widget .content .line{text-align:left;display:inline-block;cursor:pointer;line-height:100%;padding:0 15px;position:relative;word-break:break-all;max-width:100%;height:2.25em}.mini-widget .content .line .line-inner{display:table;width:100%}.mini-widget .content .line .line-inner>*{display:table-cell;vertical-align:middle}.mini-widget .content .line .line-inner .edit-button-wrapper{display:flex;align-items:center;justify-content:space-between}.mini-widget .content .line .label{text-overflow:ellipsis;overflow:hidden}.mini-widget .content .line>.detail,.mini-widget .content .line>.icon{text-align:left}.mini-widget .content .line .detail .value>span{line-height:130%;display:inline-block;word-break:break-all}.mini-widget .content .line .detail .value.nobreak,.mini-widget .content .line .detail .value.nobreak>span{white-space:nowrap;text-overflow:ellipsis;width:82%;overflow:hidden;display:inline-block}.mini-widget .content .line+.line{margin-top:.3em}.mini-widget .content .status-line{cursor:help}.mini-widget .content .status-line .edit-button-wrapper{display:flex;align-items:center;justify-content:space-between}.mini-widget .content .time{display:block;font-size:.4em;clear:both;line-height:110%;margin:0;padding:0;width:100%}.mini-widget .content .date{color:#f1f1f1;font-size:.8em}.mini-widget .level-container{padding:.5em;margin-top:.5em}.mini-widget .levels{list-style:none;margin:0;padding:0;clear:both;display:inline-block;text-align:center;width:30%}.mini-widget .levels .level{display:inline-block;display:flex;justify-content:space-between;text-align:center;list-style:none}.mini-widget .levels .level>span{position:relative;padding:4px;display:flex;align-items:center;justify-content:center}.mini-widget .levels .level>span:before{content:\"\";box-shadow:0 0 2px #aaa;position:absolute;width:100%;height:100%;top:0;left:0;transition:opacity 1s;border-radius:3px}.mini-widget .levels .level>span:hover:before{opacity:.3;transition:opacity 1s}.mini-widget .levels .level>span:last-child{margin-left:4px;padding:4px 5px}.mini-widget .levels .level .icon{font-size:1.2em}.mini-widget .levels .level .bullet{display:inline-block;height:1em;width:1em;background-color:#cecece}.mini-widget .levels .level .bullet.state-green{background-color:#79e14b}.mini-widget .levels .level .bullet.state-yellow{background-color:#ffe700}.mini-widget .levels .level .bullet.state-orange{background-color:#ffad00}.mini-widget .levels .level .bullet.state-red{background-color:#f00000}@media (min-width:1680px){.mini-navbar .mini-widget{width:12vw!important}}", ""]);
	
	// exports


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 17.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(_ref) {
	    var name = _ref.name,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? '' : _ref$title,
	        onClick = _ref.onClick,
	        _ref$className = _ref.className,
	        className = _ref$className === undefined ? '' : _ref$className;
	    return _react2.default.createElement('span', {
	        className: 'icon icon-fliwas-' + name + ' ' + className,
	        onClick: onClick,
	        title: title
	    });
	};
	
	Icon.propTypes = {
	    name: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = Icon;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Nikolai Gorte
	 * User: n.gorte on 10.08.2016
	 * Copyright: xdot GmbH 2016
	 */
	
	'use strict';
	
	exports.__esModule = true;
	exports.InstructionPropertyRenderer = exports.ReferenceValuePropertyRenderer = exports.ExternalIdsPropertyRenderer = exports.TimeValuePairPropertyRenderer = exports.BooleanPropertyRenderer = exports.TextPropertyRenderer = exports.DynamicContentBox = exports.StatusBox = exports.PropertyBox = exports.DetailsBox = exports.DetailsBoxPropertyLine = exports.DetailsBoxAttachedDocuments = exports.DetailsBoxSingleProperty = exports.DetailsRenderer = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _changeRecordPortlet = __webpack_require__(60);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _userStateHistoryPortlet = __webpack_require__(61);
	
	var _mapPortlet = __webpack_require__(25);
	
	var _pubSubPortlet = __webpack_require__(62);
	
	var _ModalActions = __webpack_require__(26);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _FliwasPermissionActions = __webpack_require__(32);
	
	var _FliwasPermissionActions2 = _interopRequireDefault(_FliwasPermissionActions);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Constants = __webpack_require__(5);
	
	var _AttachedDocumentList = __webpack_require__(63);
	
	var _AttachedDocumentList2 = _interopRequireDefault(_AttachedDocumentList);
	
	var _SaveToNamedListDropdown = __webpack_require__(68);
	
	var _SaveToNamedListDropdown2 = _interopRequireDefault(_SaveToNamedListDropdown);
	
	var _DateTimeDisplay = __webpack_require__(36);
	
	var _DateTimeDisplay2 = _interopRequireDefault(_DateTimeDisplay);
	
	var _ImageDisplay = __webpack_require__(65);
	
	var _ImageDisplay2 = _interopRequireDefault(_ImageDisplay);
	
	var _ItemDescription = __webpack_require__(71);
	
	var _ItemDescription2 = _interopRequireDefault(_ItemDescription);
	
	var _MultilineText = __webpack_require__(74);
	
	var _MultilineText2 = _interopRequireDefault(_MultilineText);
	
	var _AttachedObjectList = __webpack_require__(75);
	
	var _AttachedObjectList2 = _interopRequireDefault(_AttachedObjectList);
	
	var _formatingUtil = __webpack_require__(76);
	
	var _formatingUtil2 = _interopRequireDefault(_formatingUtil);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _dateFormat = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalConfigStore = (0, _liferayWidgetsReactWeb.getLocalConfigStore)(_liferayWidgetsReactWeb.AppContext);
	var NamedListStore = (0, _StoreFactory.getNamedListStore)(_liferayWidgetsReactWeb.AppContext);
	var FLiwasPermissionStore = (0, _StoreFactory.getFliwasPermissionStore)(_liferayWidgetsReactWeb.AppContext);
	
	var DetailsBox = function (_React$Component) {
	    _inherits(DetailsBox, _React$Component);
	
	    function DetailsBox(props) {
	        _classCallCheck(this, DetailsBox);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        var expanded = undefined;
	        _this.key = 'DetailsBox_' + _this.props.className + '_' + _this.props.title;
	        var localState = LocalConfigStore.getLocalConfig(_this.key);
	        if (localState) {
	            expanded = localState.properties;
	        }
	
	        _this.state = {
	            expanded: expanded !== undefined ? expanded : _this.props.defaultExpanded || true
	        };
	
	        _this.onToggle = _this.onToggle.bind(_this);
	        return _this;
	    }
	
	    DetailsBox.prototype.onToggle = function onToggle(eventKey) {
	        var newExpanded = !this.state.expanded;
	        if (this.props.toggle && eventKey !== 'journalEntry') {
	            _liferayWidgetsReactWeb.ConfigActions.updateLocalConfig(this.key, newExpanded);
	            this.setState({ expanded: newExpanded });
	        }
	    };
	
	    DetailsBox.prototype.render = function render() {
	        var _props = this.props,
	            title = _props.title,
	            titleIcon = _props.titleIcon,
	            onTitleIconClick = _props.onTitleIconClick,
	            children = _props.children,
	            subscription = _props.subscription,
	            _props$toggle = _props.toggle,
	            toggle = _props$toggle === undefined ? false : _props$toggle,
	            fastEditFunc = _props.fastEditFunc;
	        var expanded = this.state.expanded;
	
	        var defaultActiveKey = toggle ? expanded ? 'accordionToggle' : '' : 'accordionToggle';
	
	        return _react2.default.createElement(
	            _reactBootstrap.Accordion,
	            {
	                activeKey: defaultActiveKey,
	                onSelect: this.onToggle
	            },
	            _react2.default.createElement(
	                _reactBootstrap.Card,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Accordion.Toggle,
	                    { as: _reactBootstrap.Card.Header, eventKey: 'accordionToggle' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Card.Title,
	                        null,
	                        title,
	                        ' ',
	                        titleIcon && _react2.default.createElement(_Icon2.default, { name: titleIcon, onClick: onTitleIconClick }),
	                        subscription && _react2.default.createElement(_pubSubPortlet.UserMultiSubscriptionButton, subscription),
	                        fastEditFunc && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                variant: 'outline-primary',
	                                className: 'pull-right details-renderer-fast-edit-button',
	                                title: 'Bearbeiten',
	                                onClick: fastEditFunc
	                            },
	                            _react2.default.createElement(_Icon2.default, { name: 'pencil', title: 'Bearbeiten' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Accordion.Collapse,
	                    { eventKey: 'accordionToggle' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Card.Body,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'details-box' },
	                            expanded && children
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DetailsBox;
	}(_react2.default.Component);
	
	var DetailsBoxPropertyLine = function DetailsBoxPropertyLine(props) {
	    var stateStyle = props.stateStyle,
	        value = props.value,
	        userMeta = props.userMeta,
	        timestamp = props.timestamp,
	        icon = props.icon,
	        onClick = props.onClick,
	        _props$single = props.single,
	        single = _props$single === undefined ? false : _props$single;
	
	
	    var iconElement = void 0;
	    if (icon) {
	        iconElement = typeof icon === 'string' ? _react2.default.createElement(_Icon2.default, { name: icon }) : icon;
	    }
	
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { onClick: onClick ? onClick : undefined, className: 'clickable' },
	        iconElement && _react2.default.createElement(
	            _reactBootstrap.Col,
	            { lg: 2, md: 3, sm: 3, xs: 4,
	                className: 'details-box-icons ' + (single ? ' single' : '') },
	            iconElement
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            {
	                lg: iconElement ? 10 : 12,
	                md: iconElement ? 9 : 12,
	                sm: iconElement ? 9 : 12,
	                xs: iconElement ? 8 : 12,
	                className: 'details-box-content ' + (single ? ' single' : '')
	            },
	            stateStyle && _react2.default.createElement(
	                _reactBootstrap.Badge,
	                { className: 'description ' + stateStyle },
	                value
	            ),
	            !stateStyle && _react2.default.createElement(
	                'span',
	                { className: 'description' },
	                value
	            ),
	            !userMeta && timestamp && _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: timestamp, classNames: 'date' }),
	            userMeta && _react2.default.createElement(_userStateHistoryPortlet.UserHistoryEntry, { userMeta: userMeta, timestamp: timestamp })
	        )
	    );
	};
	
	var DetailsBoxSingleProperty = function DetailsBoxSingleProperty(props) {
	    return _react2.default.createElement(
	        DetailsBox,
	        props,
	        _react2.default.createElement(DetailsBoxPropertyLine, _extends({}, props, { single: true }))
	    );
	};
	
	var DetailsBoxAttachedDocuments = function DetailsBoxAttachedDocuments(_ref) {
	    var title = _ref.title,
	        item = _ref.item,
	        className = _ref.className;
	
	    return _react2.default.createElement(
	        DetailsBox,
	        { title: title, toggle: true, className: className },
	        _react2.default.createElement(_AttachedDocumentList2.default, { list: item })
	    );
	};
	
	var DetailsBoxAttachedObjects = function DetailsBoxAttachedObjects(_ref2) {
	    var title = _ref2.title,
	        item = _ref2.item,
	        className = _ref2.className;
	
	    return _react2.default.createElement(
	        DetailsBox,
	        { title: title, toggle: true, className: className },
	        _react2.default.createElement(_AttachedObjectList2.default, { list: item, size: 180 })
	    );
	};
	
	// eslint-disable-next-line react/prop-types
	var TextPropertyRenderer = function TextPropertyRenderer(_ref3) {
	    var value = _ref3.value,
	        transformFn = _ref3.transformFn,
	        prefix = _ref3.prefix,
	        suffix = _ref3.suffix,
	        _ref3$multiline = _ref3.multiline,
	        multiline = _ref3$multiline === undefined ? false : _ref3$multiline;
	
	    var returnVal = value ? value : '---';
	    if (transformFn) {
	        returnVal = transformFn(value);
	    }
	
	    if (prefix) {
	        returnVal += prefix + ' ';
	    }
	
	    if (suffix) {
	        returnVal += ' ' + suffix;
	    }
	
	    if (multiline) {
	        return _react2.default.createElement(
	            _MultilineText2.default,
	            null,
	            ' ',
	            value,
	            ' '
	        );
	    }
	
	    return returnVal;
	};
	
	var BooleanPropertyRenderer = function BooleanPropertyRenderer(_ref4) {
	    var value = _ref4.value;
	
	    return value ? 'Ja' : 'Nein';
	};
	
	var TimeValuePairPropertyRenderer = function TimeValuePairPropertyRenderer(_ref5) {
	    var measurement = _ref5.measurement;
	
	    return measurement && (measurement.value || measurement.value === 0) ? '' + (0, _formatingUtil2.default)(measurement.value) + (measurement.unit ? ' ' + measurement.unit + ' (' + (0, _dateFormat.formatDateTimeNoSeconds)(measurement.timestamp) + ')' : '') : '---';
	};
	
	var ExternalIdsPropertyRenderer = function ExternalIdsPropertyRenderer(_ref6) {
	    var externalIds = _ref6.externalIds;
	
	    if (externalIds && externalIds.length > 0) {
	        return externalIds.map(function (extId, idx) {
	            return _react2.default.createElement(
	                'div',
	                { key: idx },
	                extId.externalId + ' (' + extId.source + ')',
	                ' '
	            );
	        });
	    } else {
	        return '---';
	    }
	};
	
	var ReferenceValuePropertyRenderer = function ReferenceValuePropertyRenderer(_ref7) {
	    var referenceValues = _ref7.referenceValues;
	
	    if (referenceValues && referenceValues.length > 0) {
	        return referenceValues.map(function (refVal, idx) {
	            return _react2.default.createElement(
	                'div',
	                {
	                    key: idx },
	                refVal.description + ' (' + (0, _formatingUtil2.default)(refVal.value) + ' ' + refVal.unit + ')',
	                ' '
	            );
	        });
	    } else {
	        return '---';
	    }
	};
	
	var InstructionPropertyRenderer = function InstructionPropertyRenderer(_ref8) {
	    var instructions = _ref8.instructions;
	
	    if (instructions && instructions.length > 0) {
	        return instructions.map(function (instr, idx) {
	            return _react2.default.createElement(
	                'div',
	                { key: idx },
	                instr.title + (instr.responsible ? ' (' + instr.responsible + ')' : '')
	            );
	        });
	    } else {
	        return '---';
	    }
	};
	
	var InlineTableProperties = function InlineTableProperties(_ref9) {
	    var _ref9$title = _ref9.title,
	        title = _ref9$title === undefined ? 'Eigenschaften' : _ref9$title,
	        children = _ref9.children,
	        className = _ref9.className,
	        onClick = _ref9.onClick;
	
	    return _react2.default.createElement(
	        DetailsBox,
	        { className: className, title: title, onClick: onClick, toggle: true },
	        _react2.default.createElement(
	            _reactBootstrap.Table,
	            { responsive: true, className: 'noborder' },
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	var PropertyBox = function (_React$Component2) {
	    _inherits(PropertyBox, _React$Component2);
	
	    function PropertyBox() {
	        _classCallCheck(this, PropertyBox);
	
	        return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	    }
	
	    PropertyBox.prototype.render = function render() {
	        // eslint-disable-next-line react/prop-types
	        var _props2 = this.props,
	            _props2$inline = _props2.inline,
	            inline = _props2$inline === undefined ? false : _props2$inline,
	            title = _props2.title,
	            _props2$boxGridSize = _props2.boxGridSize,
	            boxGridSize = _props2$boxGridSize === undefined ? 4 : _props2$boxGridSize,
	            children = _props2.children;
	
	        if (inline) {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        title,
	                        ':'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        children
	                    )
	                )
	            );
	        } else {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: boxGridSize, md: boxGridSize, sm: boxGridSize, xs: boxGridSize },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        title,
	                        ':'
	                    ),
	                    children
	                )
	            );
	        }
	    };
	
	    return PropertyBox;
	}(_react2.default.Component);
	
	var StatusBox = function (_React$Component3) {
	    _inherits(StatusBox, _React$Component3);
	
	    function StatusBox() {
	        _classCallCheck(this, StatusBox);
	
	        return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	    }
	
	    StatusBox.prototype.render = function render() {
	        return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { lg: 4, md: 4, sm: 6, xs: 12,
	                className: 'details-container' },
	            this.props.children
	        );
	    };
	
	    return StatusBox;
	}(_react2.default.Component);
	
	var DynamicContentBox = function (_React$Component4) {
	    _inherits(DynamicContentBox, _React$Component4);
	
	    function DynamicContentBox() {
	        _classCallCheck(this, DynamicContentBox);
	
	        return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
	    }
	
	    DynamicContentBox.prototype.render = function render() {
	        return _react2.default.createElement(
	            DetailsBox,
	            { className: this.props.className, title: this.props.title, toggle: true },
	            this.props.children
	        );
	    };
	
	    return DynamicContentBox;
	}(_react2.default.Component);
	
	var DetailsDescriptionRow = function DetailsDescriptionRow(props) {
	    var dataItem = props.item,
	        item = _liferayWidgetsReactWeb.DataUtil.asItem(dataItem);
	
	
	    if (!item) {
	        return null;
	    }
	
	    var imageUrl = undefined,
	        geometry = undefined;
	    if (item && item.topImage) {
	        imageUrl = item.topImage && item.topImage.previewUrl ? item.topImage.previewUrl : '/o/fliwas-theme/images/file_system/large/document.png';
	    }
	    if (item && item.imageUrl) {
	        imageUrl = item.imageUrl;
	    }
	    if (item && item.geometry) {
	        geometry = item.geometry;
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        (imageUrl || item.description) && _react2.default.createElement(
	            DetailsBox,
	            { className: props.className, title: 'Beschreibung' + (imageUrl ? ' mit Titelbild' : ''),
	                toggle: true },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: imageUrl ? 6 : 12, className: 'nomargin' },
	                    _react2.default.createElement(_ItemDescription2.default, { item: item })
	                ),
	                imageUrl && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 6, className: 'nomargin' },
	                    _react2.default.createElement(_ImageDisplay2.default, {
	                        previewUrl: imageUrl,
	                        className: 'preview-image'
	                    })
	                )
	            )
	        ),
	        geometry && _react2.default.createElement(
	            DetailsBox,
	            { className: props.className, title: 'Karte', toggle: true },
	            _react2.default.createElement(_mapPortlet.Map, {
	                plugins: [_mapPortlet.FeatureDisplayPlugin, _mapPortlet.PrintPlugin],
	                defaultFallbackMapConfigType: 'static',
	                features: (0, _mapPortlet.transformGeometryToFeatures)(dataItem),
	                style: { height: '400px', cursor: 'pointer' },
	                zoom: 12
	            })
	        )
	    );
	};
	
	var DetailsBoxAttachedDocumentsHOC = (0, _liferayWidgetsReactWeb.flagHOC)(DetailsBoxAttachedDocuments, ['item']);
	var DetailsBoxAttachedObjectsHOC = (0, _liferayWidgetsReactWeb.flagHOC)(DetailsBoxAttachedObjects, ['item']);
	
	// eslint-disable-next-line react/prop-types
	var AttachedDocs = function AttachedDocs(_ref10) {
	    var documentLinks = _ref10.documentLinks,
	        className = _ref10.className;
	
	    var hasLinkedDocuments = documentLinks && _liferayWidgetsReactWeb.DataUtil.asArray(documentLinks) && _liferayWidgetsReactWeb.DataUtil.asArray(documentLinks).length > 0;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        hasLinkedDocuments && _react2.default.createElement(DetailsBoxAttachedDocumentsHOC, { item: documentLinks, className: className })
	    );
	};
	// eslint-disable-next-line react/prop-types
	var AttachedObjs = function AttachedObjs(_ref11) {
	    var objectLinks = _ref11.objectLinks,
	        className = _ref11.className;
	
	    var hasLinkedObjects = objectLinks && _liferayWidgetsReactWeb.DataUtil.asArray(objectLinks) && _liferayWidgetsReactWeb.DataUtil.asArray(objectLinks).length > 0;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        hasLinkedObjects && _react2.default.createElement(DetailsBoxAttachedObjectsHOC, { item: objectLinks, className: className })
	    );
	};
	
	var AttachedDocsCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(AttachedDocs, ['documentLinks', 'objectLinks'], (0, _StoreFactory.getAssetLinkStore)(_liferayWidgetsReactWeb.AppContext));
	var AttachedObjsCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(AttachedObjs, ['documentLinks', 'objectLinks'], (0, _StoreFactory.getAssetLinkStore)(_liferayWidgetsReactWeb.AppContext));
	
	var DetailsRenderer = function (_React$Component5) {
	    _inherits(DetailsRenderer, _React$Component5);
	
	    function DetailsRenderer(props) {
	        _classCallCheck(this, DetailsRenderer);
	
	        var _this5 = _possibleConstructorReturn(this, _React$Component5.call(this, props));
	
	        _this5.DATA = {
	            NAMED_LIST_PERMISSNIOM: 'NamedListPermission'
	        };
	
	        _this5.state = {
	            namedListPermission: undefined
	        };
	
	        _this5.SaveToNamedListDropdownCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(_SaveToNamedListDropdown2.default, 'namedLists', NamedListStore);
	
	        return _this5;
	    }
	
	    DetailsRenderer.prototype.componentDidMount = function componentDidMount() {
	        _FliwasPermissionActions2.default.getPermissionState(this.DATA.NAMED_LIST_PERMISSNIOM, {
	            nameSpace: 'named-lists',
	            fliwasPermission: 'manage-named-lists'
	        });
	        this.removeListener = FLiwasPermissionStore.addListener(this.onChange.bind(this));
	    };
	
	    DetailsRenderer.prototype.openChangeRecordDetails = function openChangeRecordDetails() {
	        var item = _liferayWidgetsReactWeb.DataUtil.asItem(this.props.item);
	
	        _ModalActions2.default.showModal(_changeRecordPortlet.ClassNames.ChangeRecord, {
	            byClassName: this.props.className,
	            byId: item.id,
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	        }, true);
	    };
	
	    DetailsRenderer.prototype.onChange = function onChange() {
	        this.setState({ namedListPermission: FLiwasPermissionStore.getRemoteData(this.DATA.NAMED_LIST_PERMISSNIOM) });
	    };
	
	    DetailsRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.removeListener) {
	            this.removeListener.remove();
	        }
	    };
	
	    DetailsRenderer.prototype.render = function render() {
	        var _props3 = this.props,
	            dataItem = _props3.item,
	            documentLinks = _props3.documentLinks,
	            objectLinks = _props3.objectLinks,
	            children = _props3.children,
	            _props3$canAddToList = _props3.canAddToList,
	            canAddToList = _props3$canAddToList === undefined ? false : _props3$canAddToList,
	            item = _liferayWidgetsReactWeb.DataUtil.asItem(dataItem);
	
	        var namedListPermission = this.state.namedListPermission,
	            hasNameListPermission = namedListPermission && _liferayWidgetsReactWeb.DataUtil.asItem(namedListPermission) && _liferayWidgetsReactWeb.DataUtil.asItem(namedListPermission).state && _liferayWidgetsReactWeb.DataUtil.asItem(namedListPermission).state.toLowerCase() === 'set';
	
	        var propertyBoxes = _react2.default.Children.map(this.props.children, function (child) {
	            if (child && child.props && child.props.elementType === _Constants.ElementTypes.PropertyBox) {
	                return child;
	            }
	        });
	
	        var statusBoxes = _react2.default.Children.map(children, function (child) {
	            if (child && child.props && child.props.elementType === _Constants.ElementTypes.StatusBox) {
	                return child;
	            }
	        });
	
	        var dynamicContentBoxes = _react2.default.Children.map(children, function (child) {
	            if (child && child.props && child.props.elementType === _Constants.ElementTypes.DynamicContentBox) {
	                return child;
	            }
	        });
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'details-widget' },
	            _react2.default.createElement(
	                _liferayWidgetsReactWeb.FlagComponent,
	                { item: dataItem },
	                _react2.default.createElement(_liferayWidgetsReactWeb.Title, {
	                    title: this.props.itemTitle || item && item.title,
	                    icon: item && _react2.default.createElement(_Icon2.default, { name: this.props.iconClassName || this.props.className }),
	                    listAdd: canAddToList && hasNameListPermission && _react2.default.createElement(this.SaveToNamedListDropdownCHOC, {
	                        namedLists: _Constants.GROUP_NAMED_LISTS,
	                        namedListPermission: this.DATA.NAMED_LIST_PERMISSNIOM,
	                        dataItem: dataItem
	                    })
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'details-widget__content padding-box' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        statusBoxes
	                    ),
	                    dynamicContentBoxes && dynamicContentBoxes.length > 0 && _react2.default.createElement(
	                        'div',
	                        { className: 'nomargin' },
	                        dynamicContentBoxes
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'nomargin' },
	                        _react2.default.createElement(DetailsDescriptionRow, { item: dataItem, className: dataItem.className })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'nomargin' },
	                        propertyBoxes && propertyBoxes.length > 0 && _react2.default.createElement(
	                            InlineTableProperties,
	                            { onClick: this.openChangeRecordDetails.bind(this),
	                                className: dataItem.className },
	                            propertyBoxes
	                        ),
	                        documentLinks && typeof documentLinks === 'string' && _react2.default.createElement(AttachedDocsCHOC, { documentLinks: documentLinks, className: this.props.className }),
	                        documentLinks && (typeof documentLinks === 'undefined' ? 'undefined' : _typeof(documentLinks)) === 'object' && _react2.default.createElement(AttachedDocs, { documentLinks: documentLinks, className: this.props.className }),
	                        objectLinks && typeof objectLinks === 'string' && _react2.default.createElement(AttachedObjsCHOC, { objectLinks: objectLinks, className: this.props.className }),
	                        objectLinks && (typeof objectLinks === 'undefined' ? 'undefined' : _typeof(objectLinks)) === 'object' && _react2.default.createElement(AttachedObjs, { objectLinks: objectLinks, className: this.props.className })
	                    )
	                ),
	                _react2.default.createElement('br', null)
	            )
	        );
	    };
	
	    return DetailsRenderer;
	}(_react2.default.Component);
	
	DetailsDescriptionRow.propTypes = {
	    item: _propTypes2.default.object.isRequired,
	    className: _propTypes2.default.string.isRequired
	};
	
	DetailsBoxPropertyLine.propTypes = {
	    icon: _propTypes2.default.node,
	    stateStyle: _propTypes2.default.object,
	    value: _propTypes2.default.node,
	    userMeta: _propTypes2.default.object,
	    timestamp: _propTypes2.default.number,
	    titleContainerRef: _propTypes2.default.object,
	    className: _propTypes2.default.string.isRequired
	};
	
	DetailsBoxSingleProperty.propTypes = _extends({}, DetailsBoxPropertyLine.propTypes, {
	    icon: _propTypes2.default.node
	});
	
	InlineTableProperties.propTypes = {
	    title: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    propertyDescriptions: _propTypes2.default.object,
	    onClick: _propTypes2.default.func,
	    className: _propTypes2.default.string.isRequired
	};
	
	DetailsBoxAttachedDocuments.propTypes = {
	    title: _propTypes2.default.string,
	    item: _propTypes2.default.object,
	    className: _propTypes2.default.string.isRequired
	};
	DetailsBoxAttachedObjects.propTypes = {
	    title: _propTypes2.default.string,
	    item: _propTypes2.default.object,
	    className: _propTypes2.default.string.isRequired
	};
	DynamicContentBox.propTypes = {
	    title: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string.isRequired
	};
	StatusBox.propTypes = {
	    children: _propTypes2.default.node
	};
	
	DetailsBoxAttachedDocuments.defaultProps = {
	    title: 'Dokumente'
	};
	
	DetailsBoxAttachedObjects.defaultProps = {
	    title: 'Verknüpfte Objekte'
	};
	
	PropertyBox.defaultProps = {
	    elementType: _Constants.ElementTypes.PropertyBox
	};
	
	StatusBox.defaultProps = {
	    elementType: _Constants.ElementTypes.StatusBox
	};
	
	DynamicContentBox.defaultProps = {
	    elementType: _Constants.ElementTypes.DynamicContentBox
	};
	
	DetailsBox.propTypes = {
	    children: _propTypes2.default.node,
	    title: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    titleIcon: _propTypes2.default.string,
	    onTitleIconClick: _propTypes2.default.func,
	    subscription: _propTypes2.default.object,
	    toggle: _propTypes2.default.bool,
	    defaultExpanded: _propTypes2.default.bool,
	    className: _propTypes2.default.string.isRequired,
	    fastEditFunc: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool])
	};
	
	DetailsRenderer.propTypes = {
	    className: _propTypes2.default.string.isRequired,
	    children: _propTypes2.default.node,
	    iconClassName: _propTypes2.default.string,
	    item: _propTypes2.default.object,
	    itemTitle: _propTypes2.default.string,
	    documentLinks: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	    objectLinks: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	    propertyDescriptions: _propTypes2.default.object,
	    canAddToList: _propTypes2.default.bool
	};
	
	exports.DetailsRenderer = DetailsRenderer;
	exports.DetailsBoxSingleProperty = DetailsBoxSingleProperty;
	exports.DetailsBoxAttachedDocuments = DetailsBoxAttachedDocuments;
	exports.DetailsBoxPropertyLine = DetailsBoxPropertyLine;
	exports.DetailsBox = DetailsBox;
	exports.PropertyBox = PropertyBox;
	exports.StatusBox = StatusBox;
	exports.DynamicContentBox = DynamicContentBox;
	exports.TextPropertyRenderer = TextPropertyRenderer;
	exports.BooleanPropertyRenderer = BooleanPropertyRenderer;
	exports.TimeValuePairPropertyRenderer = TimeValuePairPropertyRenderer;
	exports.ExternalIdsPropertyRenderer = ExternalIdsPropertyRenderer;
	exports.ReferenceValuePropertyRenderer = ReferenceValuePropertyRenderer;
	exports.InstructionPropertyRenderer = InstructionPropertyRenderer;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_60__;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_61__;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_62__;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _assetLink = __webpack_require__(64);
	
	var _assetLink2 = _interopRequireDefault(_assetLink);
	
	var _ImageDisplay = __webpack_require__(65);
	
	var _ImageDisplay2 = _interopRequireDefault(_ImageDisplay);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RENDER_STYLE = {
	    FOLDER_TREE: 'folderTree',
	    FLAT: 'flat'
	};
	
	// eslint-disable-next-line react/prop-types
	var AttachedListItemImage = function AttachedListItemImage(_ref) {
	    var item = _ref.item,
	        children = _ref.children;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'attached-file-item__image' },
	        children
	    );
	};
	
	// eslint-disable-next-line react/prop-types
	var AttachedListItemFileImage = function AttachedListItemFileImage(_ref2) {
	    var item = _ref2.item,
	        _ref2$defaultPreviewU = _ref2.defaultPreviewUrl,
	        defaultPreviewUrl = _ref2$defaultPreviewU === undefined ? '/o/fliwas-theme/images/file_system/large/document.png' : _ref2$defaultPreviewU,
	        _ref2$defaultThumbnai = _ref2.defaultThumbnailUrl,
	        defaultThumbnailUrl = _ref2$defaultThumbnai === undefined ? '/o/fliwas-theme/images/file_system/large/document.png' : _ref2$defaultThumbnai;
	
	    return _react2.default.createElement(_ImageDisplay2.default, {
	        thumbnailUrl: item.thumbnailUrl || defaultThumbnailUrl,
	        previewUrl: item.previewUrl || defaultPreviewUrl,
	        className: 'preview-image img-polaroid'
	    });
	};
	
	// eslint-disable-next-line react/prop-types
	var AttachedListItemFolderImage = function AttachedListItemFolderImage(_ref3) {
	    var onFolderClick = _ref3.onFolderClick;
	
	    return _react2.default.createElement(_ImageDisplay2.default, {
	        thumbnailUrl: '/o/fliwas-theme/images/file_system/large/folder_full_document.png',
	        className: 'preview-image img-polaroid',
	        onClick: onFolderClick
	    });
	};
	
	// eslint-disable-next-line react/prop-types
	var AttachedListItemDetails = function AttachedListItemDetails(_ref4) {
	    var title = _ref4.title,
	        onClick = _ref4.onClick;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'attached-file-item__details', onClick: onClick },
	        _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            title
	        )
	    );
	};
	
	// eslint-disable-next-line react/prop-types
	var AttachedListItemButtons = function AttachedListItemButtons(_ref5) {
	    var item = _ref5.item,
	        onDeleteAttachedAsset = _ref5.onDeleteAttachedAsset;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'button-box-nopadding' },
	        _react2.default.createElement(
	            _reactBootstrap.Button,
	            { variant: 'default',
	                title: '\xD6ffnen',
	                onClick: function onClick() {
	                    return _assetLink2.default.openDocumentDetailsDialog(item.id, item.groupId);
	                } },
	            '\xD6ffnen'
	        ),
	        onDeleteAttachedAsset && _react2.default.createElement(
	            _reactBootstrap.Button,
	            { variant: 'primary', onClick: function onClick() {
	                    return onDeleteAttachedAsset(item);
	                } },
	            _react2.default.createElement(_Icon2.default, { name: 'x' }),
	            'Trennen'
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	                variant: 'outline-primary',
	                className: 'ml-2',
	                href: item.downloadUrl + '&download=true',
	                title: 'Herunterladen',
	                download: true
	            },
	            _react2.default.createElement(_Icon2.default, { name: 'download', title: 'Herunterladen' })
	        )
	    );
	};
	
	// eslint-disable-next-line react/prop-types
	var AttachedFileListItem = function AttachedFileListItem(_ref6) {
	    var item = _ref6.item,
	        onDeleteAttachedAsset = _ref6.onDeleteAttachedAsset;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'attached-file-item' },
	        _react2.default.createElement(
	            AttachedListItemImage,
	            null,
	            _react2.default.createElement(AttachedListItemFileImage, { item: item })
	        ),
	        _react2.default.createElement(AttachedListItemDetails, { title: item.title }),
	        _react2.default.createElement(AttachedListItemButtons, { item: item, onDeleteAttachedAsset: onDeleteAttachedAsset })
	    );
	};
	
	var AttachedFolderListItem = function (_React$Component) {
	    _inherits(AttachedFolderListItem, _React$Component);
	
	    function AttachedFolderListItem(props) {
	        _classCallCheck(this, AttachedFolderListItem);
	
	        // eslint-disable-next-line react/prop-types
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onFolderClick = props.onFolderClick.bind(_this, props.title);
	        return _this;
	    }
	
	    AttachedFolderListItem.prototype.render = function render() {
	        var title = this.props.title;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'attached-file-item' },
	            _react2.default.createElement(
	                AttachedListItemImage,
	                null,
	                _react2.default.createElement(AttachedListItemFolderImage, { onFolderClick: this.onFolderClick })
	            ),
	            _react2.default.createElement(AttachedListItemDetails, {
	                title: title.toLowerCase() === 'topimage' ? 'Titelbild' : title,
	                onClick: this.onFolderClick
	            })
	        );
	    };
	
	    return AttachedFolderListItem;
	}(_react2.default.Component);
	
	var FolderNavTitle = function (_React$Component2) {
	    _inherits(FolderNavTitle, _React$Component2);
	
	    function FolderNavTitle(props) {
	        _classCallCheck(this, FolderNavTitle);
	
	        // eslint-disable-next-line react/prop-types
	        var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
	        _this2.onFolderClick = props.onFolderClick.bind(_this2, undefined);
	        return _this2;
	    }
	
	    FolderNavTitle.prototype.render = function render() {
	        // eslint-disable-next-line react/prop-types
	        var _props = this.props,
	            currentFolderName = _props.currentFolderName,
	            folderFiles = _props.folderFiles,
	            onFolderFilesDownload = _props.onFolderFilesDownload;
	
	        return _react2.default.createElement(
	            'h3',
	            { className: '' },
	            currentFolderName.toLowerCase() === 'topimage' ? 'Titelbild' : currentFolderName,
	            onFolderFilesDownload && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'outline-primary',
	                    className: 'ml-3',
	                    onClick: onFolderFilesDownload.bind(this, currentFolderName, folderFiles),
	                    title: 'Alles herunterladen'
	                },
	                _react2.default.createElement(_Icon2.default, { name: 'download', title: 'Alles herunterladen' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'primary',
	                    className: 'pull-right',
	                    onClick: this.onFolderClick,
	                    title: 'Ordner hoch'
	                },
	                _react2.default.createElement(_liferayWidgetsReactWeb.FaIcon, { name: 'level-up' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'ml-2' },
	                    'Ordner hoch'
	                )
	            )
	        );
	    };
	
	    return FolderNavTitle;
	}(_react2.default.Component);
	
	// eslint-disable-next-line react/prop-types
	
	
	var AttachedDocList = function AttachedDocList(_ref7) {
	    var list = _ref7.list,
	        currentFolderName = _ref7.currentFolderName,
	        onFolderClick = _ref7.onFolderClick,
	        onFolderFilesDownload = _ref7.onFolderFilesDownload,
	        renderStyle = _ref7.renderStyle,
	        otherProps = _objectWithoutProperties(_ref7, ['list', 'currentFolderName', 'onFolderClick', 'onFolderFilesDownload', 'renderStyle']);
	
	    var items = _liferayWidgetsReactWeb.DataUtil.asArray(list);
	    if (!items || !items.length) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'error-message' },
	            'Keine verbundenen Dokumente!'
	        );
	    }
	
	    if (renderStyle === RENDER_STYLE.FOLDER_TREE) {
	        if (currentFolderName) {
	            //filter all files with tag, that is the currentFolder
	            var files = items.slice().filter(function (item) {
	                return item.tags && item.tags.find(function (tag) {
	                    return tag.name === currentFolderName;
	                });
	            }).sort(function (a, b) {
	                return a.title.localeCompare(b.title);
	            });
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(FolderNavTitle, {
	                    currentFolderName: currentFolderName,
	                    onFolderClick: onFolderClick,
	                    onFolderFilesDownload: onFolderFilesDownload,
	                    folderFiles: files
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'attached-file-list flex-box' },
	                    files.map(function (item, i) {
	                        return _react2.default.createElement(AttachedFileListItem, _extends({}, otherProps, { key: 'file' + item.id + '_' + i, item: item }));
	                    })
	                )
	            );
	        } else {
	            //filter all tags and put them (as virtual folderNames) in an object (as keys) named folderNames
	            var folderNames = items.reduce(function (folderNames, file) {
	                file.tags && file.tags.forEach(function (tag) {
	                    return folderNames[tag.name] = tag.name;
	                });
	                return folderNames;
	            }, {});
	            folderNames = Object.keys(folderNames).reduce(function (result, file) {
	                result.push(file);
	                return result;
	            }, []).sort(function (a, b) {
	                return a.localeCompare(b);
	            });
	
	            //filter all files without tags, therefore are the folders, in which the virtually lie
	            var _files = items.slice().filter(function (item) {
	                return !item.tags || item.tags && item.tags.length === 0;
	            }).sort(function (a, b) {
	                return a.title.localeCompare(b.title);
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: 'attached-file-list flex-box' },
	                folderNames && folderNames.length > 0 && folderNames.map(function (folderName, i) {
	                    return _react2.default.createElement(AttachedFolderListItem, _extends({}, otherProps, { key: 'folderName' + folderName + i, title: folderName,
	                        onFolderClick: onFolderClick }));
	                }),
	                _files.map(function (item, i) {
	                    return _react2.default.createElement(AttachedFileListItem, _extends({}, otherProps, { key: 'file-' + item.id + '_' + i, item: item }));
	                })
	            );
	        }
	    }
	
	    //RENDER_STYLE = FLAT
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        items.map(function (item, i) {
	            return _react2.default.createElement(AttachedFileListItem, _extends({}, otherProps, { key: 'file-' + item.id + '_' + i, item: item }));
	        })
	    );
	};
	
	var LinkedAttachedDocList = _liferayWidgetsReactWeb.DataLinkContainer.link(AttachedDocList, 'list', (0, _StoreFactory.getAssetLinkStore)(_liferayWidgetsReactWeb.AppContext));
	
	var AttachedDocumentList = function (_React$Component3) {
	    _inherits(AttachedDocumentList, _React$Component3);
	
	    function AttachedDocumentList(props) {
	        _classCallCheck(this, AttachedDocumentList);
	
	        var _this3 = _possibleConstructorReturn(this, _React$Component3.call(this, props));
	
	        _this3.onFolderClick = _this3.onFolderClick.bind(_this3);
	        _this3.onFolderFilesDownload = _this3.onFolderFilesDownload.bind(_this3);
	        _this3.state = {
	            currentFolderName: undefined
	        };
	        return _this3;
	    }
	
	    AttachedDocumentList.prototype.onFolderClick = function onFolderClick(title) {
	        this.setState({
	            currentFolderName: title
	        });
	    };
	
	    AttachedDocumentList.prototype.onFolderFilesDownload = function onFolderFilesDownload(folderTag, folderFiles) {
	        var url = '/o/multiDocumentDownload?p_auth=' + Liferay.authToken;
	        if (folderFiles && folderFiles.length > 0) {
	            var fileList = folderFiles.reduce(function (list, file) {
	                list.push(file.id);
	                return list;
	            }, []);
	            url += '&fileIds=' + fileList.join(',');
	        }
	        url += '&folderTag=' + folderTag;
	
	        var HWRMwindow = window.open(window.location.protocol + '//' + window.location.host + url, '_blank');
	        HWRMwindow.focus();
	    };
	
	    AttachedDocumentList.prototype.render = function render() {
	        var _props2 = this.props,
	            list = _props2.list,
	            moreAttachedEntities = _props2.moreAttachedEntities,
	            _props2$renderStyle = _props2.renderStyle,
	            renderStyle = _props2$renderStyle === undefined ? RENDER_STYLE.FOLDER_TREE : _props2$renderStyle,
	            otherProps = _objectWithoutProperties(_props2, ['list', 'moreAttachedEntities', 'renderStyle']);
	
	        var List = AttachedDocList;
	
	        if (typeof list === 'string') {
	            List = LinkedAttachedDocList;
	        }
	
	        return _react2.default.createElement(List, _extends({}, otherProps, {
	            list: list,
	            renderStyle: renderStyle,
	            ListItem: AttachedFileListItem,
	            currentFolderName: this.state.currentFolderName,
	            onFolderClick: this.onFolderClick,
	            onFolderFilesDownload: this.onFolderFilesDownload,
	            className: 'feed-activity-list modal-list',
	            onClickMore: moreAttachedEntities }));
	    };
	
	    return AttachedDocumentList;
	}(_react2.default.Component);
	
	AttachedDocumentList.propTypes = {
	    list: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.array]).isRequired,
	    moreAttachedEntities: _propTypes2.default.func,
	    renderStyle: _propTypes2.default.string
	};
	
	AttachedDocumentList.RENDER_STYLE = RENDER_STYLE;
	
	exports.default = AttachedDocumentList;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 01.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	exports.default = {
	    openDocumentAssetDialog: openDocumentAssetDialog,
	    openDocumentDetailsDialog: openDocumentDetailsDialog
	};
	
	
	function openDocumentAssetDialog(relatedAssetEntryId, className, callback) {
	    AUI().use('aui-base', 'escape', 'liferay-search-container', 'liferay-portlet-url', function (A) {
	
	        var renderURL = Liferay.PortletURL.createURL(location.pathname),
	            eventName = 'RelatedAssetEvent_' + new Date().getTime();
	
	        renderURL.setWindowState('pop_up');
	        renderURL.setPortletMode('view');
	        renderURL.setParameter('eventName', eventName);
	
	        //ToDo Set as Attribute, but how?
	        //renderURL.setAttribute('liferay-ui:input-asset-links:assetEntryId', relatedAssetEntryId);
	        //renderURL.setAttribute('liferay-ui:input-asset-links:className', 'com.liferay.portlet.documentlibrary.model.DLFileEntry');
	
	        renderURL.setParameter('refererAssetEntryId', relatedAssetEntryId);
	        renderURL.setParameter('struts_action', '/asset_browser/view');
	        renderURL.setParameter('fliwasCommand', 'BusinessObjectUpload');
	        renderURL.setParameter('showAddButton', 'true');
	        renderURL.setParameter('groupId', Liferay.ThemeDisplay.getScopeGroupId());
	        renderURL.setParameter('selectedGroupIds', Liferay.ThemeDisplay.getCompanyGroupId() + ',' + Liferay.ThemeDisplay.getScopeGroupId());
	        renderURL.setParameter('typeSelection', 'com.liferay.document.library.kernel.model.DLFileEntry');
	        renderURL.setPortletId('com_liferay_asset_browser_web_portlet_AssetBrowserPortlet');
	
	        var url = renderURL.toString();
	
	        Liferay.Util.selectEntity({
	            dialog: {
	                constrain: true,
	                modal: true
	            },
	            eventName: eventName,
	            id: new Date().getTime(),
	            title: 'Dokument verknüpfen',
	            uri: url
	        }, function (event) {
	            var searchContainerName = '_172_assetEntriesSearchContainerSearchContainer';
	
	            var searchContainer = Liferay.SearchContainer.get(searchContainerName);
	
	            // let entryLink = '<a class="modify-link" data-rowId="' + event.assetentryid + '" href="javascript:;">Entfernen</a>';
	
	            //searchContainer.addRow([ event.assettype, A.Escape.html(event.assettitle), A.Escape.html(event.groupdescriptivename), entryLink ], event.assetentryid);
	
	            searchContainer.updateDataStore();
	
	            callback({
	                relatedAssetEntryId: relatedAssetEntryId,
	                relatedAssetClassName: className,
	
	                id: parseInt(event.entityid),
	                className: event.assetclassname,
	                title: event.assetentrytitle,
	                type: event.assetentrytype,
	                groupDescriptiveName: event.groupdescriptivename
	            });
	        });
	    }.bind(this));
	}
	
	function openDocumentDetailsDialog(fileEntryId, groupId) {
	    AUI().use('aui-base', 'escape', 'liferay-search-container', 'liferay-portlet-url', function (A) {
	        var themeDisplay = window.Liferay.ThemeDisplay;
	
	        //com.liferay.app.builder.web-1.0.45.jar!\META-INF\resources\js\pages\entry\FieldPreview.es.js
	        var createFileEntryPreviewURL = function createFileEntryPreviewURL(groupId, fileEntryId) {
	            var portletURL = Liferay.PortletURL.createURL(themeDisplay.getLayoutRelativeControlPanelURL());
	            portletURL.setParameter('doAsGroupId', groupId);
	            portletURL.setParameter('fileEntryId', fileEntryId);
	            portletURL.setParameter('mvcRenderCommandName', '/document_library/view_file_entry');
	            portletURL.setParameter('p_p_auth', Liferay.authToken);
	            portletURL.setParameter('refererGroupId', themeDisplay.getScopeGroupId());
	            portletURL.setPortletId(Liferay.PortletKeys.DOCUMENT_LIBRARY);
	            portletURL.setPortletMode('view');
	            portletURL.setWindowState('pop_up');
	            return portletURL.toString();
	        };
	
	        var uri = createFileEntryPreviewURL(groupId, fileEntryId);
	
	        Liferay.Util.openWindow({
	            dialog: {
	                constrain: true,
	                modal: true
	            },
	            id: new Date().getTime(),
	            title: 'Dokumentenansicht',
	            uri: uri
	        }, function (event) {});
	    }.bind(this));
	}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 11.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cacheBusting = {};
	
	var ImageDisplay = _react2.default.forwardRef(function (_ref, ref) {
	    var _ref$className = _ref.className,
	        className = _ref$className === undefined ? '' : _ref$className,
	        onClick = _ref.onClick,
	        previewUrl = _ref.previewUrl,
	        thumbnailUrl = _ref.thumbnailUrl;
	
	    var _useState = (0, _react.useState)(false),
	        openedImageModal = _useState[0],
	        setOpenedImageModal = _useState[1];
	
	    var openImageModal = function openImageModal() {
	        return setOpenedImageModal(true);
	    };
	
	    var closeImageModal = function closeImageModal() {
	        return setOpenedImageModal(false);
	    };
	
	    if (!ref) {
	        ref = _react2.default.createRef();
	    }
	
	    var onError = function onError(e) {
	        if (!cacheBusting[e.currentTarget.src]) {
	            console.log('Img load error ' + e.currentTarget.src + ' try cache busting');
	            cacheBusting[e.currentTarget.src] = true;
	            fetch(e.currentTarget.src, { cache: 'reload', mode: 'no-cors' }).then(function () {
	                console.info('cache busted!');
	                if (ref.current && ref.current.src.indexOf('#1') === -1) {
	                    ref.current.src = ref.current.src + '#1';
	                }
	            });
	        } else {
	            console.error('Img load error ' + e.currentTarget.src + ' cache already busted');
	        }
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'image-display ' + className },
	        _react2.default.createElement(
	            _reactBootstrap.Button,
	            { variant: 'link', onClick: onClick || previewUrl && openImageModal },
	            _react2.default.createElement('img', {
	                onError: onError,
	                ref: ref,
	                src: thumbnailUrl || previewUrl,
	                title: 'Vergr\xF6\xDFern',
	                loading: 'lazy'
	            })
	        ),
	        _react2.default.createElement(
	            _liferayWidgetsReactWeb.CustomModal,
	            {
	                show: openedImageModal,
	                onHide: closeImageModal,
	                size: 'xl'
	            },
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Vorschau' }),
	            _react2.default.createElement(
	                _liferayWidgetsReactWeb.CustomModalBody,
	                null,
	                _react2.default.createElement('img', { src: previewUrl, className: 'w-100', loading: 'lazy' })
	            )
	        )
	    );
	});
	ImageDisplay.displayName = 'ImageDisplay';
	
	ImageDisplay.propTypes = {
	    thumbnailUrl: _propTypes2.default.string,
	    previewUrl: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = ImageDisplay;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(67);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_imagedisplay.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_imagedisplay.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".WebCamWidget .portlet-body,.widgetRoot[id*=ImageWidget] .center{text-align:center}.image-display button,.image-display button img{width:100%}", ""]);
	
	// exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _NamedListWebApi = __webpack_require__(69);
	
	var _NamedListWebApi2 = _interopRequireDefault(_NamedListWebApi);
	
	var _BasicFormComponents = __webpack_require__(70);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 11.03.2019
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2019
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var SaveToNamedListDropdown = function (_React$Component) {
	    _inherits(SaveToNamedListDropdown, _React$Component);
	
	    function SaveToNamedListDropdown(props) {
	        _classCallCheck(this, SaveToNamedListDropdown);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    SaveToNamedListDropdown.prototype.isInList = function isInList(item, list) {
	        var i = _liferayWidgetsReactWeb.DataUtil.asItem(item);
	        return item && i && list.entries.filter(function (entry) {
	            return item.className === entry.className && i.id === entry.classPK;
	        }).length > 0;
	    };
	
	    SaveToNamedListDropdown.prototype.onItemClick = function onItemClick(dataItem, list) {
	        if (this.isInList(dataItem, list)) {
	            var entries = list.entries.filter(function (entry) {
	                return !(entry.className === dataItem.className && entry.classPK === _liferayWidgetsReactWeb.DataUtil.asItem(dataItem).id);
	            });
	            _NamedListWebApi2.default.update(_extends({}, list, { entries: entries }));
	        } else {
	            var _entries = [].concat(list.entries);
	            _entries.push({ className: dataItem.className, classPK: _liferayWidgetsReactWeb.DataUtil.asItem(dataItem).id });
	            _NamedListWebApi2.default.update(_extends({}, list, { entries: _entries }));
	        }
	    };
	
	    SaveToNamedListDropdown.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            namedLists = _props.namedLists,
	            dataItem = _props.dataItem;
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.Dropdown,
	            { variant: 'default', className: 'position-static pull-right' },
	            _react2.default.createElement(
	                _reactBootstrap.Dropdown.Toggle,
	                { variant: 'default' },
	                _react2.default.createElement(_Icon2.default, { name: 'playlist-plus' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Dropdown.Menu,
	                { className: "pull-right" },
	                _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Header,
	                    null,
	                    'Zu Liste hinzuf\xFCgen'
	                ),
	                _react2.default.createElement(_reactBootstrap.Dropdown.Divider, null),
	
	                /*
	                https://inovum-dev.de/jira/browse/FLIWASTPA-883
	                don't set checkbox to readonly
	                 */
	                _liferayWidgetsReactWeb.DataUtil.asArray(namedLists).map(function (namedList, index) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Item,
	                        {
	                            key: "namedList" + index,
	                            onSelect: _this2.onItemClick.bind(_this2, dataItem, namedList)
	                        },
	                        _react2.default.createElement(_BasicFormComponents.FliwasCheckbox, {
	                            name: "namedListCheck" + index,
	                            label: namedList.title,
	                            checked: _this2.isInList(dataItem, namedList),
	                            onChange: _this2.onItemClick.bind(_this2, dataItem, namedList)
	                        })
	                    );
	                })
	            )
	        );
	    };
	
	    return SaveToNamedListDropdown;
	}(_react2.default.Component);
	
	SaveToNamedListDropdown.propTypes = {
	    dataItem: _propTypes2.default.object.isRequired,
	    namedLists: _propTypes2.default.object.isRequired
	};
	
	exports.default = SaveToNamedListDropdown;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(20);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 09.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var namedListService = function namedListService(m, o) {
	    return _lwrClient.Client.invoke('/administration.namedlist/' + m, o);
	};
	var nameListServiceWithContext = function nameListServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/administration.namedlist/' + m, o, c);
	};
	
	var api = {
	    listViewableByGroupScope: function listViewableByGroupScope(query) {
	        return nameListServiceWithContext('list-viewable-by-group-scope.1', {}, {});
	    },
	    get: function get(item) {
	        return nameListServiceWithContext('get.2', {
	            id: item.id
	        }, {});
	    },
	    add: function add(item) {
	        return nameListServiceWithContext('add.1', {
	            'title': item.title,
	            'entries': item.entries || []
	        });
	    },
	    update: function update(item) {
	        return nameListServiceWithContext('update.2', {
	            id: item.id
	        }, {
	            'title': item.title,
	            'entries': item.entries
	        });
	    },
	    delete: function _delete(query) {
	        return namedListService('delete.1', {
	            id: query.id
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('NamedListWebApi', api);
	
	exports.default = api;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FliwasFormHeading = exports.FliwasFormGroup = exports.FliwasCheckbox = exports.FliwasSelect = exports.FliwasFormGrid = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                   * User: CBuehler on 28.04.2016
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FliwasFormGrid = function FliwasFormGrid(_ref) {
	    var _ref$className = _ref.className,
	        className = _ref$className === undefined ? 'py-3' : _ref$className,
	        children = _ref.children;
	
	    return _react2.default.createElement(
	        _reactBootstrap.Container,
	        { className: className },
	        children
	    );
	};
	
	FliwasFormGrid.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string
	};
	
	var FliwasFormHeading = function FliwasFormHeading(_ref2) {
	    var title = _ref2.title;
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { className: 'row-2-col nomargin' },
	        _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: title })
	    );
	};
	
	FliwasFormHeading.propTypes = {
	    title: _propTypes2.default.string
	};
	
	var FliwasFormGroup = function FliwasFormGroup(_ref3) {
	    var title = _ref3.title,
	        formValidation = _ref3.formValidation,
	        propName = _ref3.propName,
	        formComponent = _ref3.formComponent,
	        _ref3$required = _ref3.required,
	        required = _ref3$required === undefined ? false : _ref3$required,
	        children = _ref3.children;
	    return _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        { className: formValidation && formValidation[propName] ? 'has-error' : '' },
	        title && _react2.default.createElement(
	            _reactBootstrap.FormLabel,
	            null,
	            title + (required ? ' *' : '')
	        ),
	        children,
	        formValidation && _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: propName })
	    );
	};
	
	FliwasFormGroup.propTypes = {
	    title: _propTypes2.default.string,
	    formComponent: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    propName: _propTypes2.default.string,
	    required: _propTypes2.default.bool,
	    children: _propTypes2.default.node
	};
	
	var FliwasCheckbox = function FliwasCheckbox(_ref4) {
	    var name = _ref4.name,
	        onChange = _ref4.onChange,
	        label = _ref4.label,
	        checked = _ref4.checked,
	        _ref4$readOnly = _ref4.readOnly,
	        readOnly = _ref4$readOnly === undefined ? false : _ref4$readOnly;
	
	    var cbProps = {};
	    cbProps.checked = !!checked;
	    return _react2.default.createElement(_reactBootstrap.FormCheck, _extends({
	        type: 'checkbox',
	        name: name
	    }, cbProps, {
	        onChange: onChange,
	        readOnly: readOnly,
	        label: label
	    }));
	};
	
	FliwasCheckbox.propTypes = {
	    name: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    label: _propTypes2.default.string,
	    checked: _propTypes2.default.bool,
	    readOnly: _propTypes2.default.bool
	};
	
	var FliwasSelect = function FliwasSelect(_ref5) {
	    var list = _ref5.list,
	        currentValue = _ref5.currentValue,
	        onChange = _ref5.onChange,
	        disabled = _ref5.disabled,
	        _ref5$hideDefaultOpti = _ref5.hideDefaultOption,
	        hideDefaultOption = _ref5$hideDefaultOpti === undefined ? false : _ref5$hideDefaultOpti,
	        _ref5$defaultOption = _ref5.defaultOption,
	        defaultOption = _ref5$defaultOption === undefined ? _react2.default.createElement(
	        'option',
	        { key: 'option_', value: '' },
	        'Bitte wählen!'
	    ) : _ref5$defaultOption;
	
	
	    if (list.length === 0) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            '---'
	        );
	    }
	
	    return _react2.default.createElement(
	        _reactBootstrap.FormControl,
	        {
	            as: 'select',
	            value: currentValue,
	            onChange: onChange,
	            disabled: disabled
	        },
	        !hideDefaultOption && defaultOption,
	        list.map(function (_ref6) {
	            var value = _ref6.value,
	                label = _ref6.label;
	            return _react2.default.createElement(
	                'option',
	                {
	                    key: 'option_' + label + '_' + value,
	                    value: value
	                },
	                label
	            );
	        })
	    );
	};
	
	FliwasSelect.propTypes = {
	    list: _propTypes2.default.array,
	    currentValue: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    disabled: _propTypes2.default.bool,
	    hideDefaultOption: _propTypes2.default.bool,
	    defaultOption: _propTypes2.default.node
	};
	
	exports.FliwasFormGrid = FliwasFormGrid;
	exports.FliwasSelect = FliwasSelect;
	exports.FliwasCheckbox = FliwasCheckbox;
	exports.FliwasFormGroup = FliwasFormGroup;
	exports.FliwasFormHeading = FliwasFormHeading;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemDescription = function ItemDescription(_ref) {
	    var item = _ref.item;
	    var description = item.description;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        description && _react2.default.createElement('span', { className: 'item-description', dangerouslySetInnerHTML: { __html: description } }),
	        !description && '---'
	    );
	};
	
	ItemDescription.propTypes = {
	    item: _propTypes2.default.object.isRequired
	};
	
	exports.default = ItemDescription;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(73);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./item-description.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./item-description.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".item-description h4{padding:.5em 15px;margin:0 0 .75em;box-shadow:0 0 3px rgba(86,96,117,.7);text-decoration:underline}", ""]);
	
	// exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler
	 * User: CBuehler on 12.03.2018
	 * Copyright: xdot GmbH 2018
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MultilineText = function MultilineText(_ref) {
	    var children = _ref.children,
	        onClick = _ref.onClick;
	    return _react2.default.createElement(
	        'div',
	        { onClick: onClick ? onClick : undefined },
	        children && children.split('\n').map(function (item, i) {
	            return _react2.default.createElement(
	                'p',
	                { key: i },
	                item
	            );
	        })
	    );
	};
	
	MultilineText.propTypes = {
	    children: _propTypes2.default.string,
	    onClick: _propTypes2.default.func
	};
	
	exports.default = MultilineText;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _BusinessObjectLink = __webpack_require__(51);
	
	var _BusinessObjectLink2 = _interopRequireDefault(_BusinessObjectLink);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-next-line react/prop-types
	var BusinessObjectListItem = function BusinessObjectListItem(_ref) {
	  var item = _ref.item,
	      onDeleteAttachedAsset = _ref.onDeleteAttachedAsset;
	
	  return _react2.default.createElement(
	    _reactBootstrap.ListGroupItem,
	    null,
	    _liferayWidgetsReactWeb.translation.trans(item.className) + ': ',
	    _react2.default.createElement(_BusinessObjectLink2.default, {
	      className: item.className,
	      classPK: item.classPK
	    }),
	    onDeleteAttachedAsset && _react2.default.createElement(
	      _reactBootstrap.OverlayTrigger,
	      {
	        placement: 'top',
	        overlay: _react2.default.createElement(
	          _reactBootstrap.Tooltip,
	          null,
	          'L\xF6schen'
	        )
	      },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          variant: 'outline-primary',
	          className: 'pull-right delete-button',
	          onClick: onDeleteAttachedAsset.bind(null, item),
	          title: 'L\xF6schen'
	        },
	        _react2.default.createElement(_Icon2.default, { name: 'x' })
	      )
	    )
	  );
	};
	
	var LinkedAttachedDocList = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataListRV, 'list', (0, _StoreFactory.getAssetLinkStore)(_liferayWidgetsReactWeb.AppContext));
	
	var AttachedObjectList = function (_React$Component) {
	  _inherits(AttachedObjectList, _React$Component);
	
	  function AttachedObjectList(props) {
	    _classCallCheck(this, AttachedObjectList);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  AttachedObjectList.prototype.render = function render() {
	    var _props = this.props,
	        list = _props.list,
	        moreAttachedEntities = _props.moreAttachedEntities,
	        onDeleteAttachedAsset = _props.onDeleteAttachedAsset,
	        _props$size = _props.size,
	        size = _props$size === undefined ? 350 : _props$size,
	        otherProps = _objectWithoutProperties(_props, ['list', 'moreAttachedEntities', 'onDeleteAttachedAsset', 'size']);
	
	    var List = _liferayWidgetsReactWeb.ScrollableDataListRV;
	
	    if (typeof list === 'string') {
	      List = LinkedAttachedDocList;
	    }
	
	    return _react2.default.createElement(List, _extends({
	      list: list,
	      size: size,
	      onDeleteAttachedAsset: onDeleteAttachedAsset,
	      ListItem: BusinessObjectListItem,
	      onClickMore: moreAttachedEntities
	    }, otherProps));
	  };
	
	  return AttachedObjectList;
	}(_react2.default.Component);
	
	AttachedObjectList.propTypes = {
	  list: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.array]).isRequired,
	  onDeleteAttachedAsset: _propTypes2.default.func,
	  moreAttachedEntities: _propTypes2.default.func,
	  size: _propTypes2.default.number
	};
	
	exports.default = AttachedObjectList;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = formatMeasurements;
	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 12.07.2021
	 * Copyright: xdot GmbH 2021
	 */
	
	function formatMeasurements(doubleValue) {
	    if (doubleValue > 1000) {
	        return doubleValue.toFixed(0);
	    } else if (doubleValue > 100) {
	        return doubleValue.toFixed(1);
	    } else {
	        return doubleValue.toFixed(2);
	    }
	}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 23.04.2019
	 * Copyright: xdot GmbH 2019
	 */
	
	'use strict';
	
	exports.__esModule = true;
	exports.DetailsListItemMeasurementBox = exports.DetailsListItemEditBox = exports.DetailsListItemStatusBox = exports.DetailsListItemTitle = exports.DetailsListItemNameBox = exports.DetailsListItem = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _NamedListWebApi = __webpack_require__(69);
	
	var _NamedListWebApi2 = _interopRequireDefault(_NamedListWebApi);
	
	var _reactLinesEllipsis = __webpack_require__(80);
	
	var _reactLinesEllipsis2 = _interopRequireDefault(_reactLinesEllipsis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailsListItem = _react2.default.forwardRef(function (_ref, ref) {
	    var item = _ref.item,
	        list = _ref.list,
	        children = _ref.children,
	        onClickDelete = _ref.onClickDelete;
	
	    var FORM_DELETE_OBJECT = (0, _react.useRef)('DeleteObject_' + item.__type + '_' + item.id);
	
	    var _onClickDelete = function _onClickDelete(formData) {
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(FORM_DELETE_OBJECT.current);
	        var entries = list.entries.filter(function (entry) {
	            return !(entry.className === formData.className && formData.classPK === entry.classPK);
	        });
	        _NamedListWebApi2.default.update(_extends({}, list, { entries: entries }));
	    };
	
	    var openDeleteForm = function openDeleteForm() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(FORM_DELETE_OBJECT.current, {
	            className: item.__type,
	            classPK: item.id
	        });
	    };
	
	    return _react2.default.createElement(
	        _reactBootstrap.ListGroupItem,
	        { className: 'details-list-item', ref: ref },
	        children,
	        onClickDelete && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, {
	                formId: FORM_DELETE_OBJECT.current,
	                title: 'L\xF6schen',
	                Content: function Content(_ref2) {
	                    var formData = _ref2.formData;
	                    return 'Wollen Sie das Objekt wirklich aus der Liste entfernen?';
	                },
	                editRequired: false,
	                onFormSubmit: _onClickDelete
	            }),
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'link',
	                    size: 'sm',
	                    title: 'L\xF6schen',
	                    onClick: openDeleteForm
	                },
	                _react2.default.createElement(_Icon2.default, { name: 'x' }),
	                _liferayWidgetsReactWeb.translation.trans('delete')
	            )
	        )
	    );
	});
	
	DetailsListItem.propTypes = {
	    item: _propTypes2.default.object,
	    list: _propTypes2.default.object,
	    onClickDelete: _propTypes2.default.bool,
	    children: _propTypes2.default.any
	};
	
	var DetailsListItemNameBox = function DetailsListItemNameBox(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'name-box', onClick: props.onClick },
	        props.children
	    );
	};
	var DetailsListItemTitle = function DetailsListItemTitle(props) {
	    return _react2.default.createElement(_reactLinesEllipsis2.default, {
	        text: props.children,
	        maxLine: '3',
	        ellipsis: '...',
	        trimRight: true,
	        basedOn: 'letters'
	    });
	};
	var DetailsListItemStatusBox = function DetailsListItemStatusBox(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'status-box' },
	        props.children
	    );
	};
	var DetailsListItemMeasurementBox = function DetailsListItemMeasurementBox(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'measurements-box' },
	        props.children
	    );
	};
	
	var DetailsListItemEditBox = function DetailsListItemEditBox(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'edit-box' },
	        props.children
	    );
	};
	
	exports.DetailsListItem = DetailsListItem;
	exports.DetailsListItemNameBox = DetailsListItemNameBox;
	exports.DetailsListItemTitle = DetailsListItemTitle;
	exports.DetailsListItemStatusBox = DetailsListItemStatusBox;
	exports.DetailsListItemEditBox = DetailsListItemEditBox;
	exports.DetailsListItemMeasurementBox = DetailsListItemMeasurementBox;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(79);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_details-list-item.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_details-list-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".list-group-item.details-list-item{display:flex;align-items:center;padding:10px!important;height:80px}.list-group-item.details-list-item>*{flex:0 1 220px}.list-group-item.details-list-item .name-box{display:flex;cursor:pointer;flex:1;flex-basis:180px;max-width:180px;height:100%;overflow:hidden}.list-group-item.details-list-item .name-box .object-icon{display:flex;flex-direction:column}.list-group-item.details-list-item .name-box .object-icon .icon{font-size:40px;display:block}.list-group-item.details-list-item .name-box .object-icon .label{display:block;cursor:pointer}.list-group-item.details-list-item .name-box .details-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.list-group-item.details-list-item .status-box{flex:1;flex-basis:140px}.list-group-item.details-list-item .status-box .label{display:inline-block;text-overflow:ellipsis;white-space:nowrap;max-width:160px;margin-right:5px;cursor:pointer}.list-group-item.details-list-item .status-box .date{font-size:6pt}.list-group-item.details-list-item .status-box .list-item-state-wrapper{display:flex;flex-direction:column}.list-group-item.details-list-item .status-box .list-item-state-wrapper span{text-overflow:ellipsis;white-space:nowrap;width:100px;overflow:hidden}.list-group-item.details-list-item .measurements-box{max-width:290px;flex:1;flex-basis:290px}.list-group-item.details-list-item .measurements-box .clickable .date{font-size:6pt}.list-group-item.details-list-item .measurements-box .details-box-content{display:flex;flex-direction:column}.list-group-item.details-list-item .edit-box{display:flex;flex:1;justify-content:flex-end;min-width:30px}", ""]);
	
	// exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(81);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	
	function _extends() {
	  _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	var canvasStyle = {
	  position: 'absolute',
	  bottom: 0,
	  left: 0,
	  height: 0,
	  overflow: 'hidden',
	  'padding-top': 0,
	  'padding-bottom': 0,
	  border: 'none'
	};
	var mirrorProps = ['box-sizing', 'width', 'font-size', 'font-weight', 'font-family', 'font-style', 'letter-spacing', 'text-indent', 'white-space', 'word-break', 'overflow-wrap', 'padding-left', 'padding-right'];
	
	function omit(obj, omittedKeys) {
	  if (!obj || typeof obj !== 'object') {
	    return obj;
	  }
	
	  var ret = {};
	  Object.keys(obj).forEach(function (key) {
	    if (omittedKeys.indexOf(key) > -1) {
	      return;
	    }
	
	    ret[key] = obj[key];
	  });
	  return ret;
	}
	
	var _excluded = ["component", "ellipsis", "trimRight", "className"];
	
	function prevSibling(node, count) {
	  while (node && count--) {
	    node = node.previousElementSibling;
	  }
	
	  return node;
	}
	
	var defaultProps = {
	  basedOn: undefined,
	  className: '',
	  component: 'div',
	  ellipsis: '…',
	  // &hellip;
	  maxLine: 1,
	  onReflow: function onReflow() {},
	  text: '',
	  trimRight: true,
	  winWidth: undefined // for the HOC
	
	};
	var usedProps = Object.keys(defaultProps);
	/**
	 * props.text {String} the text you want to clamp
	 * props.maxLine {Number|String} max lines allowed
	 * props.ellipsis {String} the ellipsis indicator
	 * props.trimRight {Boolean} should we trimRight the clamped text?
	 * props.basedOn {String} letters|words
	 * props.className {String}
	 */
	
	var LinesEllipsis = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(LinesEllipsis, _React$Component);
	
	  function LinesEllipsis(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      text: props.text,
	      clamped: false
	    };
	    _this.units = [];
	    _this.maxLine = 0;
	    _this.canvas = null;
	    return _this;
	  }
	
	  var _proto = LinesEllipsis.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.initCanvas();
	    this.reflow(this.props);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.winWidth !== this.props.winWidth) {
	      this.copyStyleToCanvas();
	    }
	
	    if (this.props !== prevProps) {
	      this.reflow(this.props);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.canvas.parentNode.removeChild(this.canvas);
	    this.canvas = null;
	  };
	
	  _proto.setState = function setState(state, callback) {
	    if (typeof state.clamped !== 'undefined') {
	      this.clamped = state.clamped;
	    }
	
	    return _React$Component.prototype.setState.call(this, state, callback);
	  };
	
	  _proto.initCanvas = function initCanvas() {
	    if (this.canvas) return;
	    var canvas = this.canvas = document.createElement('div');
	    canvas.className = "LinesEllipsis-canvas " + this.props.className;
	    canvas.setAttribute('aria-hidden', 'true');
	    this.copyStyleToCanvas();
	    Object.keys(canvasStyle).forEach(function (key) {
	      canvas.style[key] = canvasStyle[key];
	    });
	    document.body.appendChild(canvas);
	  };
	
	  _proto.copyStyleToCanvas = function copyStyleToCanvas() {
	    var _this2 = this;
	
	    var targetStyle = window.getComputedStyle(this.target);
	    mirrorProps.forEach(function (key) {
	      _this2.canvas.style[key] = targetStyle[key];
	    });
	  };
	
	  _proto.reflow = function reflow(props) {
	    /* eslint-disable no-control-regex */
	    var basedOn = props.basedOn || (/^[\x00-\x7F]+$/.test(props.text) ? 'words' : 'letters');
	
	    switch (basedOn) {
	      case 'words':
	        this.units = props.text.split(/\b|(?=\W)/);
	        break;
	
	      case 'letters':
	        this.units = Array.from(props.text);
	        break;
	
	      default:
	        throw new Error("Unsupported options basedOn: " + basedOn);
	    }
	
	    this.maxLine = +props.maxLine || 1;
	    this.canvas.innerHTML = this.units.map(function (c) {
	      return "<span class='LinesEllipsis-unit'>" + c + "</span>";
	    }).join('');
	    var ellipsisIndex = this.putEllipsis(this.calcIndexes());
	    var clamped = ellipsisIndex > -1;
	    var newState = {
	      clamped: clamped,
	      text: clamped ? this.units.slice(0, ellipsisIndex).join('') : props.text
	    };
	    this.setState(newState, props.onReflow.bind(this, newState));
	  };
	
	  _proto.calcIndexes = function calcIndexes() {
	    var indexes = [0];
	    var elt = this.canvas.firstElementChild;
	    if (!elt) return indexes;
	    var index = 0;
	    var line = 1;
	    var offsetTop = elt.offsetTop;
	
	    while (elt = elt.nextElementSibling) {
	      if (elt.offsetTop > offsetTop) {
	        line++;
	        indexes.push(index);
	        offsetTop = elt.offsetTop;
	      }
	
	      index++;
	
	      if (line > this.maxLine) {
	        break;
	      }
	    }
	
	    return indexes;
	  };
	
	  _proto.putEllipsis = function putEllipsis(indexes) {
	    if (indexes.length <= this.maxLine) return -1;
	    var lastIndex = indexes[this.maxLine];
	    var units = this.units.slice(0, lastIndex);
	    var maxOffsetTop = this.canvas.children[lastIndex].offsetTop;
	    this.canvas.innerHTML = units.map(function (c, i) {
	      return "<span class='LinesEllipsis-unit'>" + c + "</span>";
	    }).join('') + ("<wbr><span class='LinesEllipsis-ellipsis'>" + this.props.ellipsis + "</span>");
	    var ndEllipsis = this.canvas.lastElementChild;
	    var ndPrevUnit = prevSibling(ndEllipsis, 2);
	
	    while (ndPrevUnit && (ndEllipsis.offsetTop > maxOffsetTop || // IE & Edge: doesn't support <wbr>
	    ndEllipsis.offsetHeight > ndPrevUnit.offsetHeight || ndEllipsis.offsetTop > ndPrevUnit.offsetTop)) {
	      this.canvas.removeChild(ndPrevUnit);
	      ndPrevUnit = prevSibling(ndEllipsis, 2);
	      units.pop();
	    }
	
	    return units.length;
	  } // expose
	  ;
	
	  _proto.isClamped = function isClamped() {
	    return this.clamped; // do not use state.clamped. #27
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$state = this.state,
	        text = _this$state.text,
	        clamped = _this$state.clamped;
	
	    var _this$props = this.props,
	        Component = _this$props.component,
	        ellipsis = _this$props.ellipsis,
	        trimRight = _this$props.trimRight,
	        className = _this$props.className,
	        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
	
	    return /*#__PURE__*/React__default["default"].createElement(Component, _extends({
	      className: "LinesEllipsis " + (clamped ? 'LinesEllipsis--clamped' : '') + " " + className,
	      ref: function ref(node) {
	        return _this3.target = node;
	      }
	    }, omit(rest, usedProps)), clamped && trimRight ? text.replace(/[\s\uFEFF\xA0]+$/, '') : text, /*#__PURE__*/React__default["default"].createElement("wbr", null), clamped && /*#__PURE__*/React__default["default"].createElement("span", {
	      className: "LinesEllipsis-ellipsis"
	    }, ellipsis));
	  };
	
	  return LinesEllipsis;
	}(React__default["default"].Component);
	
	LinesEllipsis.defaultProps = defaultProps;
	
	module.exports = LinesEllipsis;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_81__;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDropzone = __webpack_require__(83);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _UploadWebApi = __webpack_require__(84);
	
	var _UploadWebApi2 = _interopRequireDefault(_UploadWebApi);
	
	var _ProgressBar = __webpack_require__(85);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	__webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 16.12.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// eslint-disable-next-line react/prop-types
	var UploadMediaEntry = function UploadMediaEntry(_ref) {
	    var entry = _ref.entry,
	        onClickDelete = _ref.onClickDelete;
	
	    var title = entry.file.src.name;
	
	    if (entry.state.status === 'fail') {
	        return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { lg: 3, md: 4, sm: 6, xs: 12 },
	            _react2.default.createElement(
	                'div',
	                null,
	                'Upload fehlgeschlagen'
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { lg: 4, md: 4, sm: 6, xs: 12 },
	        _react2.default.createElement(
	            _reactBootstrap.Card,
	            { className: 'upload-preview-card' },
	            _react2.default.createElement(
	                _reactBootstrap.Card.Header,
	                { className: 'd-flex justify-content-end p-1' },
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        variant: 'outline-danger',
	                        onClick: onClickDelete,
	                        size: 'sm',
	                        pullRight: true
	                    },
	                    'X'
	                )
	            ),
	            _react2.default.createElement(_reactBootstrap.Card.Img, {
	                variant: 'top',
	                as: (0, _liferayWidgetsReactWeb.detectIE)() ? 'img' : 'object',
	                data: entry.file.src.preview,
	                src: entry.file.src.preview,
	                type: entry.file.src.type,
	                title: title,
	                alt: title
	            }),
	            _react2.default.createElement(
	                _reactBootstrap.Card.Body,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Card.Text,
	                    null,
	                    title
	                )
	            )
	        )
	    );
	};
	
	var Upload = function (_React$Component) {
	    _inherits(Upload, _React$Component);
	
	    function Upload(props) {
	        _classCallCheck(this, Upload);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            tmpEntries: []
	        };
	        return _this;
	    }
	
	    Upload.prototype.componentWillUnmount = function componentWillUnmount() {
	        var _this2 = this;
	
	        var tmpEntries = this.state.tmpEntries || [];
	
	        tmpEntries.forEach(function (e) {
	            _this2.onClickDelete(e, false);
	        });
	    };
	
	    Upload.prototype.onDrop = function onDrop(acceptedFiles) {
	        var _this3 = this;
	
	        //const { uploadStatus } = this.props;
	        var uplds = []; // upload promises
	        var uploads = []; // valid URIs for upload
	
	        acceptedFiles.forEach(function (f, i) {
	            _this3.addUpload(f, i, uploads);
	        });
	
	        if (this.props.uploadObserver) {
	            if (uploads.length > 0) {
	                this.props.uploadObserver(true);
	            }
	        }
	
	        uploads.forEach(function (file) {
	            uplds.push(_UploadWebApi2.default.uploadTemp(file.src, { onProgress: _this3.onProgress.bind(_this3, file.k) }).then(function (fileEntry) {
	                _this3.appendToState(file, file.src.name, fileEntry.fileName, { status: 'success', error: null });
	                _this3.props.uploadObserver && _this3.props.uploadObserver(false);
	            }, function (error) {
	                _this3.appendToState(file, file.src.name, undefined, { status: 'fail', error: error });
	                _this3.props.uploadObserver && _this3.props.uploadObserver(false);
	            }));
	        });
	    };
	
	    Upload.prototype.onProgress = function onProgress(upload, progress) {
	        var p = progress.loaded / progress.total * 100;
	
	        var uploads = this.state.uploads || [];
	        uploads.forEach(function (u) {
	            if (u.k == upload) {
	                u.progress = p;
	            }
	        });
	
	        this.setState({
	            uploads: uploads
	        });
	    };
	
	    Upload.prototype.addUpload = function addUpload(f, i, uploads) {
	        if (f instanceof File || this.isLocalURI(f)) {
	            uploads.push({ k: i, src: f });
	            this.setState({
	                uploads: uploads
	            });
	        } else if (!f) {
	            console.debug('No value for file: ' + i);
	        } else {
	            console.warn('No local uri! File ' + i + ' : ' + f);
	        }
	    };
	
	    Upload.prototype.isLocalURI = function isLocalURI(uri) {
	        return uri && uri.indexOf && (uri.indexOf('file:/') > -1 || uri.indexOf('/') === 0 || uri.indexOf('blob:') === 0 || uri.indexOf('moz-filedata:') === 0 || uri.indexOf('content://') > -1 || uri.indexOf('///') > -1);
	    };
	
	    Upload.prototype.appendToState = function appendToState(file, fileName, tmpFileName, state) {
	        var _this4 = this;
	
	        var tmpEntries = this.state.tmpEntries || [];
	        var uploads = this.state.uploads || [];
	
	        var found = false;
	        tmpEntries = tmpEntries.map(function (entry) {
	            if (entry.fileName === fileName) {
	                found = true;
	                _this4.onClickDelete(entry);
	                return {
	                    fileName: fileName,
	                    tmpFileName: tmpFileName,
	                    file: file,
	                    state: state
	                };
	            } else {
	                return entry;
	            }
	        });
	
	        if (!found) {
	            tmpEntries.push({
	                fileName: fileName,
	                tmpFileName: tmpFileName,
	                file: file,
	                state: state
	            });
	        }
	
	        this.onChange(tmpEntries);
	
	        this.setState({
	            tmpEntries: tmpEntries,
	            uploads: uploads.filter(function (u) {
	                return u != file;
	            })
	        });
	    };
	
	    Upload.prototype.onChange = function onChange(tmpEntries) {
	        this.props.onChange(JSON.stringify(tmpEntries.map(function (e) {
	            var newE = _extends({}, e);
	            delete newE.file;
	
	            return newE;
	        })));
	    };
	
	    Upload.prototype.onClickDelete = function onClickDelete(entry) {
	        var propagateError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        this.deleteEntry(entry.tmpFileName, entry, propagateError);
	    };
	
	    Upload.prototype.deleteEntry = function deleteEntry(tmpFileName, entry, propagateError) {
	        var _this5 = this;
	
	        var options = {
	            afterSuccess: function afterSuccess(a) {
	                var tmpEntries = _this5.state.tmpEntries || [];
	                var newTmpEntries = tmpEntries.filter(function (e) {
	                    return e.tmpFileName != tmpFileName;
	                });
	                _this5.onChange(newTmpEntries);
	                _this5.setState({
	                    tmpEntries: newTmpEntries
	                });
	            }
	        };
	
	        if (propagateError) {
	            options = _extends({}, options, {
	                afterError: function afterError(e) {
	                    console.error('Error delete Entry', e);
	                    _this5.appendToState(entry, entry.file.src.name, undefined, { status: 'fail', error: e });
	                }
	            });
	        }
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatchAsyncOperation('DELETE_TEMP_FILE', _UploadWebApi2.default.deleteTemp, { tmpFileName: tmpFileName }, options);
	    };
	
	    Upload.prototype.render = function render() {
	        var _this6 = this;
	
	        var _props = this.props,
	            InputElement = _props.InputElement,
	            required = _props.required,
	            _props$accept = _props.accept,
	            accept = _props$accept === undefined ? 'image/*' : _props$accept,
	            acceptedImages = _props.acceptedImages,
	            acceptedVideos = _props.acceptedVideos,
	            acceptedDocuments = _props.acceptedDocuments;
	
	        var uploads = this.state.uploads || [];
	        //      const progress = this.state.progress;
	        //      const isUploading = uploads && uploads.length > 0;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'form-group row py-4' },
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 3 },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    'Dateien',
	                    required ? '*' : ''
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 9 },
	                InputElement && _react2.default.createElement('input', { name: 'tmpEntries',
	                    type: 'hidden',
	                    onChange: this.props.onChange.bind(this),
	                    value: JSON.stringify(this.state.tmpEntries.map(function (e) {
	                        var newE = _extends({}, e);
	                        delete newE.file;
	
	                        return newE;
	                    })) }),
	                _react2.default.createElement(
	                    _reactDropzone2.default,
	                    {
	                        ref: function ref(node) {
	                            _this6.dropzone = node;
	                        },
	                        onDrop: this.onDrop.bind(this),
	                        accept: accept,
	                        className: 'upload-dropzone',
	                        multiple: true
	                    },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Bitte ziehen Sie eine oder mehrere Dateien in die Fl\xE4che. Oder klicken Sie auf die Fl\xE4che und w\xE4hlen eine oder mehrere Dateien im Dialog aus.'
	                    ),
	                    (acceptedImages || acceptedVideos || acceptedDocuments) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            { className: 'w-100 pt-2' },
	                            'Folgende Dateitypen werden akzeptiert:'
	                        ),
	                        acceptedImages && _react2.default.createElement(
	                            'div',
	                            { className: 'w-100' },
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Bilder'
	                            ),
	                            ' (',
	                            acceptedImages,
	                            ')'
	                        ),
	                        acceptedVideos && _react2.default.createElement(
	                            'div',
	                            { className: 'w-100' },
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Videos'
	                            ),
	                            ' (',
	                            acceptedVideos,
	                            ')'
	                        ),
	                        acceptedDocuments && _react2.default.createElement(
	                            'div',
	                            { className: 'w-100' },
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Dokumente'
	                            ),
	                            ' (',
	                            acceptedDocuments,
	                            ')'
	                        )
	                    )
	                ),
	                uploads && uploads.length > 0 && uploads.map(function (upload) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: upload.src.name },
	                        'Upload (',
	                        upload.src.name,
	                        '):\xA0',
	                        _react2.default.createElement(_ProgressBar2.default, { percentage: upload.progress })
	                    );
	                }),
	                _react2.default.createElement('br', null),
	                this.state.tmpEntries.length > 0 && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.state.tmpEntries.map(function (entry) {
	                        return _react2.default.createElement(UploadMediaEntry, {
	                            key: entry.file.src.name,
	                            entry: entry,
	                            onClickDelete: _this6.onClickDelete.bind(_this6, entry)
	                        });
	                    })
	                )
	            )
	        );
	    };
	
	    return Upload;
	}(_react2.default.Component);
	
	Upload.propTypes = {
	    onChange: _propTypes2.default.func,
	    onClickDelete: _propTypes2.default.func,
	    entry: _propTypes2.default.object,
	    InputElement: _propTypes2.default.func,
	    required: _propTypes2.default.object,
	    accept: _propTypes2.default.string,
	    acceptedImages: _propTypes2.default.string,
	    acceptedVideos: _propTypes2.default.string,
	    acceptedDocuments: _propTypes2.default.string,
	    uploadObserver: _propTypes2.default.func
	};
	
	exports.default = Upload;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _lwrClient = __webpack_require__(20);
	
	//const uploadService = (m, o) => Client.invoke('/base.uploadapi/' + m, o);
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 09.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var uploadServiceWithContext = function uploadServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/base.uploadapi/' + m, o, c);
	};
	var uploader = new _lwrClient.FileUploader(_lwrClient.Client, '/base.uploadapi/upload-temp.3');
	
	var api = {
	    uploadTemp: function uploadTemp(file, _ref) {
	        var onProgress = _ref.onProgress;
	
	        var options = {};
	        var serviceContext = {
	            scopeGroupId: _liferayWidgetsReactWeb.AppContext.getScopeGroupId()
	        };
	
	        var params = {
	            serviceContext: JSON.stringify(serviceContext),
	            fileName: file.name
	        };
	
	        var opts = {
	            options: options, params: params, onProgress: onProgress
	        };
	        return uploader.upload(file, opts);
	    },
	    deleteTemp: function deleteTemp(query) {
	        return uploadServiceWithContext('delete-temp.2', {
	            fileName: query.tmpFileName
	        }, {});
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('UploadWebApi', api);
	
	exports.default = api;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Nikolai Gorte
	 * User: n.gorte on 15.09.2016
	 * Copyright: xdot GmbH 2016
	 */
	
	var ProgressBar = function ProgressBar(_ref) {
	    var _ref$height = _ref.height,
	        height = _ref$height === undefined ? 10 : _ref$height,
	        _ref$color = _ref.color,
	        color = _ref$color === undefined ? '#66d9ff' : _ref$color,
	        percentage = _ref.percentage,
	        children = _ref.children;
	
	    if (isNaN(percentage) || percentage <= 0) {
	        percentage = 0;
	    } else if (percentage >= 100) {
	        percentage = 100;
	    }
	
	    var style = {
	        backgroundColor: color,
	        width: percentage + '%',
	        transition: "width 200ms",
	        height: height
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'progressbar-container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'progressbar', style: style },
	            children
	        )
	    );
	};
	
	ProgressBar.propTypes = {
	    children: _propTypes2.default.node,
	    height: _propTypes2.default.number,
	    color: _propTypes2.default.string,
	    percentage: _propTypes2.default.number
	};
	
	exports.default = ProgressBar;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(87);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./upload.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./upload.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".upload-dropzone{width:100%;height:150px;border:2px dashed #666;border-radius:5px;box-sizing:border-box;padding:15px;font-style:italic;display:flex;flex-flow:wrap;align-items:center}.upload-preview-card .card-img-top{height:180px;object-fit:cover}", ""]);
	
	// exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler on 07.02.2016.
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	__webpack_require__(89);
	
	var _JournalEntryAddForm = __webpack_require__(91);
	
	var _basePortlet = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JournalEntryAddFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_JournalEntryAddForm.JournalEntryAddForm);
	var dependencies = ['highcharts', 'highcharts-export', 'highcharts-offline-export', 'highcharts-map', 'highcharts-more', 'highcharts-boost', 'highcharts-no-data'];
	
	var HC_OPTIONS = {
	    global: {
	        useUTC: true,
	        timezoneOffset: new Date().getTimezoneOffset()
	    },
	    lang: {
	        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
	        shortMonths: ['Jan', 'Feb', 'März', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
	        weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
	        rangeSelectorFrom: 'Von',
	        rangeSelectorTo: 'Bis',
	        loading: 'Laden...',
	        resetZoom: 'Zurücksetzen',
	        downloadJPEG: 'JPEG herunterladen',
	        downloadPDF: 'PDF herunterladen',
	        downloadPNG: 'PNG herunterladen',
	        downloadSVG: 'SVG herunterladen',
	        printChart: 'Drucken'
	    }
	
	};
	
	var _printChart = function _printChart(chartKey, title) {
	    var prtContent = document.getElementById(chartKey);
	    var WinPrint = window.open('', title || '');
	
	    var html = '\n            <body>\n                ' + prtContent.innerHTML + '\n                <footer class="p-3">\n                    ' + _basePortlet.DateFormat.formatDateTimeNoSeconds(Date.now()) + ' Uhr, ' + window.themeDisplay.getUserName() + '\n                </footer>\n                <script>\n                    window.onload = function() {\n                        window.print();\n                    };\n                </script>\n            </body>\n        ';
	    WinPrint.document.write(html);
	    WinPrint.document.close();
	    WinPrint.focus();
	
	    WinPrint.onafterprint = function (event) {
	        WinPrint.close();
	    };
	    WinPrint.print();
	};
	
	var exportPDF = function exportPDF(chart, title) {
	    chart && chart.exportChart({
	        filename: title || 'chart',
	        type: 'application/pdf',
	        scale: 1
	    }, {
	        title: { text: title || '' },
	        chart: {
	            height: 600,
	            width: 1200,
	            spacing: [10, 25, 15, 10]
	        }
	    });
	};
	
	var getExportData = function getExportData(chart, hc, title) {
	    return new Promise(function (resolve, reject) {
	        if (chart) {
	            //const { chartWidth, chartHeight } = chart;
	            var chartWidth = 700;
	            var chartHeight = 400;
	
	            var chartOptions = {
	                title: false,
	                chart: {
	                    height: chartHeight,
	                    width: chartWidth,
	                    spacing: [10, 25, 15, 10]
	                }
	            };
	            var exportingOptions = {
	                filename: title || 'chart',
	                type: 'image/svg+xml',
	                sourceWidth: chartWidth,
	                sourceHeight: chartHeight
	            };
	            exportingOptions = hc.merge(chart.options.exporting, exportingOptions);
	            var svg = chart.getSVGForExport(exportingOptions, chartOptions);
	
	            var canvas = document.createElement('canvas');
	            canvas.width = chartWidth;
	            canvas.height = chartHeight;
	            var ctx = canvas.getContext('2d');
	            var image = new Image(chartWidth, chartHeight);
	            image.onload = function () {
	                var mimetype = 'image/jpeg';
	                ctx.drawImage(image, 0, 0);
	                canvas.toBlob(function (blob) {
	                    resolve({
	                        filename: exportingOptions.filename || 'chart',
	                        type: mimetype,
	                        width: chartWidth,
	                        height: chartHeight,
	                        blob: blob
	                    });
	                }, mimetype, 0.95);
	            };
	
	            image.onerror = function (e) {
	                console.error('ERROR converting chart to blob', e);
	                reject(e);
	            };
	
	            image.src = 'data:image/svg+xml,' + encodeURIComponent(svg);
	        } else {
	            reject('No chart');
	        }
	    });
	};
	
	var exportImage = function exportImage(chart, title, type) {
	    chart && chart.exportChartLocal({
	        filename: title || 'chart',
	        type: 'image/' + type,
	        scale: 1
	    }, {
	        title: { text: title || '' },
	        chart: {
	            height: 600,
	            width: 1200,
	            spacing: [10, 25, 15, 10]
	        }
	    });
	};
	
	var HighChart = function (_PluginComponent) {
	    _inherits(HighChart, _PluginComponent);
	
	    function HighChart(props) {
	        _classCallCheck(this, HighChart);
	
	        var _this = _possibleConstructorReturn(this, _PluginComponent.call(this, props, props.plugins, dependencies));
	
	        _this.state = _extends({}, _this.state, {
	            chartKey: props.chartKey || _liferayWidgetsReactWeb.UidUtil.generateId('chart'),
	            chartLoaded: false
	        });
	
	        _this.DATA = {
	            FORM_ADD_JOURNAL_ENTRY: _liferayWidgetsReactWeb.UidUtil.generateId('FormAddJournalEntry')
	        };
	
	        _this.scrollOverlay = null;
	        _this.focusDiv = _this.focusDiv.bind(_this);
	        _this.onTouchStart = _this.onTouchStart.bind(_this);
	        _this.enable = _this.enable.bind(_this);
	        _this.disable = _this.disable.bind(_this);
	        _this.onSelect = _this.onSelect.bind(_this);
	        _this.onJournalEntryAddFormSubmit = _this.onJournalEntryAddFormSubmit.bind(_this);
	        return _this;
	    }
	
	    HighChart.prototype.componentDidMount = function componentDidMount() {
	        _PluginComponent.prototype.componentDidMount.call(this);
	        this.disable();
	    };
	
	    HighChart.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.chart) {
	            this.chart.destroy();
	        } else {
	            console.error('Chart componentWillUnmount without existing chart!');
	        }
	        _PluginComponent.prototype.componentWillUnmount.call(this);
	    };
	
	    HighChart.prototype.initWithPlugins = function initWithPlugins(o) {
	        var _this2 = this;
	
	        console.log('Init chart! options: ', o, ' plugins: ', this.plugins());
	        var d = this.state.dependencies;
	        var hc = d.highcharts;
	
	        hc.seriesTypes.area.prototype.drawLegendSymbol = hc.seriesTypes.line.prototype.drawLegendSymbol;
	        d['highcharts-export'](hc);
	        d['highcharts-offline-export'](hc);
	        d['highcharts-map'](hc);
	        d['highcharts-more'](hc);
	        d['highcharts-boost'](hc);
	        d['highcharts-no-data'](hc);
	
	        hc.setOptions(HC_OPTIONS);
	
	        hc.PlotLineOrBand.prototype.update = function (newOptions) {
	            var plotBand = this;
	            hc.extend(plotBand.options, newOptions);
	            if (plotBand.svgElem) {
	                plotBand.svgElem.destroy();
	                plotBand.svgElem = undefined;
	                plotBand.render();
	            }
	        };
	        this.hc = hc;
	        this.chart = hc.chart(this.refChart, _extends({
	            exporting: {
	                enabled: false
	            }
	        }, o, {
	            chart: _extends({}, o.chart, {
	                events: _extends({}, o.chart.events, {
	                    load: function load() {
	                        _this2.setState({
	                            chartLoaded: true
	                        });
	                    }
	                })
	            })
	        }));
	
	        Array.prototype.forEach.call(document.getElementsByClassName('modal-body'), function (elem) {
	            if (elem.contains(_this2.scrollOverlay)) {
	                _this2.modal = elem;
	                _this2.modalScrollable = elem.scrollHeight > elem.clientHeight;
	                if (!_this2.modalScrollable) {
	                    _this2.scrollOverlay && _this2.scrollOverlay.classList.remove('enter');
	                }
	            }
	        });
	
	        this.updateChart(this.chart, o);
	        this.callPluginsInit(this.chart, o);
	    };
	
	    HighChart.prototype.reinitWithPlugins = function reinitWithPlugins(o) {
	        console.log('Reinit chart! options: ', o, ' plugins: ', this.plugins());
	        if (this.chart) {
	            this.chart.destroy();
	        }
	        this.initWithPlugins(o);
	    };
	
	    HighChart.prototype.updateWithPlugins = function updateWithPlugins(o) {
	        this.updateChart(this.chart, o);
	        this.callPluginsUpdate(this.chart, o);
	    };
	
	    HighChart.prototype.updateChart = function updateChart(chart, o) {
	        var height = o.height;
	
	        if (height && height !== chart.container.currentHeight) {
	            chart.setSize(null, height);
	        }
	    };
	
	    HighChart.prototype.enable = function enable(e) {
	        if (e.ctrlKey) {
	            this.scrollOverlay && this.scrollOverlay.classList.remove('enter');
	        }
	    };
	
	    HighChart.prototype.disable = function disable(e) {
	        if (!this.modal || this.modalScrollable) {
	            this.scrollOverlay && this.scrollOverlay.classList.add('enter');
	        }
	    };
	
	    HighChart.prototype.onTouchStart = function onTouchStart() {
	        this.scrollOverlay && this.scrollOverlay.classList.remove('enter');
	    };
	
	    HighChart.prototype.focusDiv = function focusDiv(e) {
	        if (this.scrollOverlay) {
	            this.scrollOverlay.focus();
	        }
	    };
	
	    HighChart.prototype.onSelect = function onSelect(eventKey, e) {
	        var _props = this.props,
	            title = _props.title,
	            printChart = _props.printChart;
	        var chartKey = this.state.chartKey;
	
	        if (eventKey === 'print') {
	            printChart ? printChart(chartKey, title) : _printChart(chartKey, title);
	        } else if (eventKey === 'pdf') {
	            exportPDF(this.chart, title);
	        } else if (eventKey === 'journalEntry') {
	            _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_ADD_JOURNAL_ENTRY, { title: title });
	        } else {
	            exportImage(this.chart, title, eventKey);
	        }
	    };
	
	    HighChart.prototype.onJournalEntryAddFormSubmit = function onJournalEntryAddFormSubmit(formData) {
	        var _this3 = this;
	
	        var getNewJournalEntryData = this.props.getNewJournalEntryData;
	
	        getExportData(this.chart, this.hc, formData.title).then(function (exportData) {
	            var entryData = getNewJournalEntryData && getNewJournalEntryData() || {};
	            if (exportData.blob) {
	                entryData.attachments = { chart: exportData.blob };
	                delete exportData.blob;
	            }
	            entryData.message = _extends({
	                chart: exportData
	            }, formData, entryData.message);
	            entryData.groupId = Liferay.ThemeDisplay.getScopeGroupId();
	            console.info(entryData);
	            (0, _liferayWidgetsReactWeb.amdRequire)(['journal-portlet/js/journal-portlet'], function (J) {
	                J.JournalActions.addEntry(entryData, _this3.DATA.FORM_ADD_JOURNAL_ENTRY, true);
	            });
	        }).catch(function (e) {
	            //todo
	            console.error(e);
	        });
	    };
	
	    HighChart.prototype.render = function render() {
	        var _this4 = this;
	
	        var editJournalTitle = this.props.editJournalTitle;
	        var chartLoaded = this.state.chartLoaded;
	
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            chartLoaded && _react2.default.createElement(
	                _reactBootstrap.Dropdown,
	                {
	                    variant: 'default',
	                    className: 'highcharts-export-button',
	                    onSelect: this.onSelect
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Toggle,
	                    { variant: 'outline-primary', size: 'lg' },
	                    _react2.default.createElement('i', { className: 'fa fa-bars' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Menu,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Item,
	                        { eventKey: 'print' },
	                        'Drucken'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Item,
	                        { eventKey: 'journalEntry' },
	                        'Journaleintrag erstellen'
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Dropdown.Divider, null),
	                    _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Item,
	                        { eventKey: 'png' },
	                        'PNG herunterladen'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Item,
	                        { eventKey: 'jpeg' },
	                        'JPG herunterladen'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Item,
	                        { eventKey: 'pdf' },
	                        'PDF herunterladen'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Item,
	                        { eventKey: 'svg+xml' },
	                        'SVG herunterladen'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: 'delayed-chart-scroll-overlay',
	                    ref: function ref(div) {
	                        return _this4.scrollOverlay = div;
	                    },
	                    tabIndex: '0',
	                    onMouseEnter: this.focusDiv,
	                    onTouchStart: this.onTouchStart,
	                    onKeyDown: this.enable,
	                    onKeyUp: this.disable,
	                    onBlur: this.disable
	                },
	                _react2.default.createElement(JournalEntryAddFormHoc, {
	                    formId: this.DATA.FORM_ADD_JOURNAL_ENTRY,
	                    showReset: true,
	                    onFormSubmit: this.onJournalEntryAddFormSubmit,
	                    modalProps: {
	                        aboveLiferayDialog: true,
	                        size: 'md'
	                    },
	                    editTitle: editJournalTitle
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(c) {
	                            return _this4.refChart = c;
	                        }, id: this.state.chartKey, style: this.props.style,
	                        className: this.props.className },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Chart wird geladen...'
	                    ),
	                    _react2.default.createElement('br', null),
	                    this.state.loadPlugins && _react2.default.createElement(
	                        'span',
	                        null,
	                        'Plugins werden geladen'
	                    )
	                )
	            )
	        );
	    };
	
	    return HighChart;
	}(_liferayWidgetsReactWeb.PluginComponent);
	
	HighChart.propTypes = {
	    style: _propTypes2.default.object,
	    plugins: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])),
	    config: _propTypes2.default.object,
	    item: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	    getNewJournalEntryData: _propTypes2.default.func,
	    editJournalTitle: _propTypes2.default.bool,
	    printChart: _propTypes2.default.func
	};
	
	exports.default = HighChart;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(90);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_delayedScroll.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./_delayedScroll.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:768px){.delayed-chart-scroll-overlay{position:relative}.delayed-chart-scroll-overlay:focus{outline:none}.delayed-chart-scroll-overlay:before{position:absolute;top:0;right:0;left:0;bottom:0;background-color:rgba(0,0,0,.05);z-index:10;content:\"\";cursor:pointer;display:none}.delayed-chart-scroll-overlay:after{content:\"Verwenden Sie Strg + Scrollen zum Zoomen im Diagramm\";position:absolute;font-size:2em;z-index:11;top:50%;left:50%;transform:translate(-50%,-50%);color:grey;text-align:center;display:none}.delayed-chart-scroll-overlay.enter:after,.delayed-chart-scroll-overlay.enter:before{display:block}}", ""]);
	
	// exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.JournalEntryAddForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * User: n.gorte
	                                                                                                                                                                                                                                                                   * Date: 13.10.2020
	                                                                                                                                                                                                                                                                   * Time: 14:21
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _BasicFormComponents = __webpack_require__(70);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _formValidationUtil = __webpack_require__(92);
	
	var FormValidationUtil = _interopRequireWildcard(_formValidationUtil);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(formData) {
	    var titleValid = FormValidationUtil.validateStringMinLengthMaxLength(formData.title, 1, 140, 'Titel');
	    var descriptionValid = FormValidationUtil.validateStringMinLengthMaxLength(formData.description, 1, 3999, 'Kommentar');
	    return {
	        title: titleValid,
	        description: descriptionValid
	    };
	};
	
	var JournalEntryAddForm = exports.JournalEntryAddForm = function JournalEntryAddForm(_ref) {
	    var formData = _ref.formData,
	        formValidation = _ref.formValidation,
	        onChange = _ref.onChange,
	        _ref$editTitle = _ref.editTitle,
	        editTitle = _ref$editTitle === undefined ? false : _ref$editTitle;
	
	    (0, _react.useEffect)(function () {
	        onChange(formData, validate(formData));
	    }, []);
	
	    var change = function change(field) {
	        return function (value) {
	            var _extends2;
	
	            var item = formData.item || formData;
	            var newData = _extends({}, item, (_extends2 = {}, _extends2[field] = value, _extends2));
	            onChange(newData, validate(newData));
	        };
	    };
	    var titleChange = function titleChange(e) {
	        var item = formData.item || formData;
	        var newData = _extends({}, item, {
	            title: e.target.value
	        });
	        onChange(newData, validate(newData));
	    };
	
	    return _react2.default.createElement(
	        _BasicFormComponents.FliwasFormGrid,
	        null,
	        _react2.default.createElement(_BasicFormComponents.FliwasFormHeading, { title: 'Journaleintrag erstellen' }),
	        editTitle && _react2.default.createElement(
	            _BasicFormComponents.FliwasFormGroup,
	            {
	                title: _liferayWidgetsReactWeb.translation.trans('title'),
	                formValidation: formValidation,
	                propName: 'title',
	                required: true
	            },
	            _react2.default.createElement(_reactBootstrap.FormControl, {
	                type: 'text',
	                required: true,
	                placeholder: _liferayWidgetsReactWeb.translation.trans('title'),
	                value: formData && formData.title ? formData.title : '',
	                onChange: titleChange
	            })
	        ),
	        _react2.default.createElement(
	            _BasicFormComponents.FliwasFormGroup,
	            {
	                title: _liferayWidgetsReactWeb.translation.trans('comment'),
	                formValidation: formValidation,
	                propName: 'description',
	                required: true
	            },
	            _react2.default.createElement(_liferayWidgetsReactWeb.WYSIWYGEditor, {
	                placeholder: _liferayWidgetsReactWeb.translation.trans('comment'),
	                value: formData.description || '',
	                onChange: change('description')
	            })
	        )
	    );
	};
	
	JournalEntryAddForm.propTypes = {
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    onChange: _propTypes2.default.func,
	    title: _propTypes2.default.string,
	    editTitle: _propTypes2.default.bool
	};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.validateStringMinLengthMaxLength = validateStringMinLengthMaxLength;
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 23.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var validate = exports.validate = function validate(formData, fields) {
	    return Object.keys(fields).reduce(function (result, prop) {
	        var f = fields[prop];
	        result[prop] = f.validFn(f.label, formData[prop]);
	        return result;
	    }, {});
	};
	
	var isFormValid = exports.isFormValid = function isFormValid(formValidation) {
	    var formValid = true;
	    if (formValidation) {
	        Object.keys(formValidation).forEach(function (propName) {
	            if (formValidation[propName]) {
	                formValid = false;
	            }
	        });
	    }
	    return formValid;
	};
	
	var onChangeHandler = exports.onChangeHandler = function onChangeHandler(getProps, validate) {
	    var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    return function (propName) {
	        return handler[propName] || (handler[propName] = function (e) {
	            var _extends2;
	
	            var props = getProps(),
	                newData = _extends({}, props.formData, (_extends2 = {}, _extends2[propName] = e && e.target ? e.target.value : e, _extends2));
	            props.onChange(newData, validate ? validate(newData) : undefined);
	        });
	    };
	};
	
	function validateStringMinLengthMaxLength(value, minLength, maxLength, fieldLabel) {
	    var valid = void 0;
	
	    if (minLength <= 0) {
	        if (value) {
	            if (!(value.length <= maxLength)) {
	                valid = fieldLabel + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
	            }
	        }
	    } else {
	        if (!(value && value.length >= minLength)) {
	            valid = 'Bitte ' + fieldLabel + ' eingeben!';
	        }
	
	        if (value && value.length >= minLength && !/\S/.test(value)) {
	            valid = fieldLabel + ' darf nicht mit einem Leerzeichen starten!';
	        }
	
	        if (value && value.length >= minLength && !(value.length <= maxLength)) {
	            valid = fieldLabel + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
	        }
	    }
	
	    return valid;
	}
	
	var minMax = exports.minMax = function minMax(minLength, maxLength) {
	    return function (label, value) {
	        var valid = void 0;
	
	        if (minLength <= 0) {
	            if (value) {
	                if (!(value.length <= maxLength)) {
	                    valid = label + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
	                }
	            }
	        } else {
	            if (!(value && value.length >= minLength)) {
	                valid = 'Bitte ' + label + ' eingeben!';
	            }
	
	            if (value && value.length >= minLength && !/\S/.test(value)) {
	                valid = label + ' darf nicht mit einem Leerzeichen starten!';
	            }
	
	            if (value && value.length >= minLength && !(value.length <= maxLength)) {
	                valid = label + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
	            }
	        }
	        return valid;
	    };
	};
	
	var minMax_0_75 = exports.minMax_0_75 = minMax(0, 75);
	var minMax_1_75 = exports.minMax_1_75 = minMax(1, 75);
	var minMax_0_500 = exports.minMax_0_500 = minMax(0, 500);
	
	var isFiniteNumber = exports.isFiniteNumber = function isFiniteNumber(label, v) {
	    return !isFinite(v) ? label + ' muss eine Zahl sein!' : undefined;
	};
	
	var isPositiveFiniteNumber = exports.isPositiveFiniteNumber = function isPositiveFiniteNumber(label, v) {
	    return !isFinite(v) || v < 0 ? label + ' muss eine positive Zahl sein!' : undefined;
	};
	
	var exists = exports.exists = function exists(label, v) {
	    return typeof v === 'undefined' || v === '' || v === null || v === "null" ? 'Bitte ' + label + ' eingeben!' : undefined;
	};
	
	var selected = exports.selected = function selected(label, v) {
	    return typeof v === 'undefined' || v === '' || v === null || v === "null" ? 'Bitte ' + label + ' auswählen!' : undefined;
	};
	
	var min_2_Selected = exports.min_2_Selected = function min_2_Selected(label, v) {
	    return !v || !v.length || v.length < 2 ? 'Bitte mindestens ' + 2 + ' ' + label + ' ausw\xE4hlen!' : undefined;
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 07.04.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _timeseriesUtil = __webpack_require__(94);
	
	var _timeseriesUtil2 = _interopRequireDefault(_timeseriesUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HCTimeSeriesPlugin = function () {
	    function HCTimeSeriesPlugin() {
	        _classCallCheck(this, HCTimeSeriesPlugin);
	    }
	
	    HCTimeSeriesPlugin.prototype.initOptions = function initOptions(o) {
	        return this.options(o);
	    };
	
	    HCTimeSeriesPlugin.prototype.options = function options(o) {
	        o = _extends({
	            title: {
	                text: ' '
	            },
	            chart: {
	                animation: false,
	                alignTicks: true,
	                zoomType: 'xy',
	                resetZoomButton: {
	                    position: {
	                        align: 'left',
	                        x: 5,
	                        y: 5
	                    }
	                }
	            },
	            credits: {
	                text: '',
	                href: '',
	                style: { 'fontSize': '12px' }
	            },
	            tooltip: {
	                xDateFormat: '%d.%m.%Y %H:%M:%S',
	                valueDecimals: 2,
	                shared: true
	            },
	            plotOptions: {
	                series: {
	                    animation: false
	                },
	                scatter: {
	                    marker: {
	                        radius: 2
	                    }
	                }
	            },
	            rangeSelector: {
	                selected: 1,
	                inputEditDateFormat: '%d-%m-%Y',
	                inputDateFormat: '%d %b %Y',
	                buttons: [{
	                    type: 'month',
	                    count: 1,
	                    text: '1M'
	                }, {
	                    type: 'week',
	                    count: 1,
	                    text: '1W'
	                }, {
	                    type: 'day',
	                    count: 3,
	                    text: '3T'
	                }, {
	                    type: 'day',
	                    count: 1,
	                    text: '1T'
	                }, {
	                    type: 'hour',
	                    count: 12,
	                    text: '12H'
	                }, {
	                    type: 'all',
	                    text: 'Alle'
	                }]
	            },
	            legend: {
	                enabled: false
	            },
	            mapNavigation: {
	                enabled: true,
	                enableButtons: false
	            },
	            xAxis: {
	                type: 'datetime',
	                dateTimeLabelFormats: { // don't display the dummy year
	                    month: '%e. %b',
	                    year: '%b'
	                },
	                title: {
	                    text: 'Datum'
	                },
	                tickInterval: 24 * 3600 * 1000, // 1 day
	                minorTickInterval: 1 * 3600 * 1000, // 1 hour
	                minRange: 3 * 3600 * 1000, // 3 hours
	                minorTickLength: 5,
	                minorTickWidth: 1,
	                minorGridLineWidth: 0
	            },
	            yAxis: {
	                min: 0,
	                floor: -1.0,
	                startOnTick: false,
	                lineWidth: 1,
	                opposite: false,
	                title: {
	                    useHTML: true
	                }
	            },
	            lang: {
	                noData: 'Es liegen keine aktuellen Daten vor'
	            },
	            noData: {
	                style: {
	                    fontWeight: 'bold',
	                    color: '#999999'
	                }
	            }
	        }, o);
	        return o;
	    };
	
	    HCTimeSeriesPlugin.prototype.init = function init(chart, o) {
	        this.chart = chart;
	    };
	
	    HCTimeSeriesPlugin.prototype.update = function update(chart, o) {
	        var item = o.item;
	
	        var series = _liferayWidgetsReactWeb.DataUtil.asArray(item);
	        if (this.lastSeries != item && series && series.length > 0) {
	            this.updateSeries(chart, series);
	        } else if (series && series.length === 0) {
	            chart.series.forEach(function (s) {
	                return s.remove();
	            });
	            chart.redraw();
	        }
	
	        this.lastSeries = item;
	    };
	
	    HCTimeSeriesPlugin.prototype.updateSeries = function updateSeries(chart, seriesArray) {
	        seriesArray = seriesArray.filter(function (series) {
	            return series.times.length > 0;
	        });
	
	        if (seriesArray.length == 0) {
	            return;
	        }
	
	        var _preprocessSeriesArra = this.preprocessSeriesArray(chart, seriesArray),
	            referenceValueSeriesArray = _preprocessSeriesArra.referenceValueSeriesArray,
	            updates = _preprocessSeriesArra.updates;
	
	        var toRemove = this.toRemove(chart, updates);
	
	        if (toRemove) {
	            toRemove.forEach(function (id) {
	                chart.get(id).remove(false); // no redraw here
	            });
	            chart.redraw();
	        }
	
	        this.plotSeries(chart, updates);
	        this.updateAxis(chart);
	        this.updateGrid(referenceValueSeriesArray);
	        this.updateCredits(chart);
	    };
	
	    HCTimeSeriesPlugin.prototype.preprocessSeriesArray = function preprocessSeriesArray(chart, seriesArray) {
	        var _this = this;
	
	        var referenceValueSeriesArray = seriesArray.filter(function (series) {
	            return series.type === _timeseriesUtil.METRIC_TYPE.REFERENCE_VALUES;
	        });
	        if (referenceValueSeriesArray.length > 0) {
	            seriesArray = seriesArray.filter(function (series) {
	                return series.type !== _timeseriesUtil.METRIC_TYPE.REFERENCE_VALUES;
	            });
	        }
	
	        var updates = seriesArray.map(function (series) {
	            var seriesId = (0, _timeseriesUtil2.default)(series);
	            var updateType = _this.checkUpdateType(chart, seriesId, series);
	            return {
	                seriesId: seriesId,
	                updateType: updateType,
	                series: series
	            };
	        });
	
	        return { referenceValueSeriesArray: referenceValueSeriesArray, updates: updates };
	    };
	
	    HCTimeSeriesPlugin.prototype.toRemove = function toRemove(chart, updates) {
	        var toRemove = null;
	        chart.series.forEach(function (data) {
	            var found = false;
	            updates.forEach(function (update) {
	                if (data.options && data.options.id == update.seriesId) {
	                    found = true;
	                }
	            });
	            if (!found) {
	                toRemove = toRemove || [];
	                toRemove.push(data.options.id);
	            }
	        });
	        return toRemove;
	    };
	
	    HCTimeSeriesPlugin.prototype.plotSeries = function plotSeries(chart, data, o) {
	        var _this2 = this;
	
	        if (!data) return;
	
	        data.forEach(function (s) {
	            var series = s.series,
	                seriesId = s.seriesId,
	                updateType = s.updateType;
	            var times = series.times,
	                values = series.values;
	
	            var newData = times.map(function (t, i) {
	                return [Number.parseInt(t), values[i]];
	            });
	            var name = _this2.getName(series, false);
	            var type = _this2.getTypeOfChart(series);
	
	            var unit = ' ' + series.labels.unit;
	            var axisTitle = _this2.getClassName(series) + ' [' + unit + ']';
	            if (chart.yAxis[0] && chart.yAxis[0].options.title.text !== axisTitle) {
	                chart.yAxis[0].setTitle({ text: axisTitle });
	            }
	
	            var seriesOptions = _extends({
	                id: seriesId,
	                name: name,
	                data: newData,
	                color: _this2.getColor(series),
	                type: type === 'line' ? 'spline' : type
	            }, o);
	
	            seriesOptions.tooltip = _extends({}, seriesOptions.tooltip, {
	                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
	                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}' + unit + '</b><br/>'
	            });
	
	            _this2.doUpdate(chart, seriesId, newData, seriesOptions, updateType);
	        });
	    };
	
	    HCTimeSeriesPlugin.prototype.doUpdate = function doUpdate(chart, seriesId, newData, options, updateType) {
	        var chartSeries = chart.get(seriesId);
	        if (chartSeries) {
	            chartSeries.setData(newData);
	        } else if (!chartSeries && updateType === -1) {
	            chart.addSeries(options);
	        }
	    };
	
	    HCTimeSeriesPlugin.prototype.updateCredits = function updateCredits(chart) {
	        var xAxis = chart.xAxis[0],
	            oldCredits = chart.credits,
	            extremes = xAxis.getExtremes(),
	            dataMax = extremes.dataMax,
	            dataMin = extremes.dataMin;
	
	
	        var text = 'Zeitbereich vom ' + new Date(dataMin).toLocaleDateString() + ' bis ' + new Date(dataMax).toLocaleDateString() + ' ROHDATEN ohne Gewähr';
	
	        if (text !== oldCredits.textStr) {
	            chart.credits.update({
	                text: text
	            });
	        }
	    };
	
	    HCTimeSeriesPlugin.prototype.updateAxis = function updateAxis(chart) {
	        var yAxis = chart.yAxis[0],
	            extremes = yAxis.getExtremes(),
	            max = Math.ceil(extremes.dataMax),
	            min = extremes.dataMin;
	
	        if (max !== yAxis.max) {
	            yAxis.update({
	                max: max + 1,
	                min: min
	            });
	        }
	    };
	
	    //See: https://inovum-dev.de/jira/browse/FLIWAS-788
	
	
	    HCTimeSeriesPlugin.prototype.updateGrid = function updateGrid(referenceValueSeriesArray /*, yAxisRange*/) {
	
	        var yAxis = this.chart.yAxis[0],
	            plotLinesAndBands = this.chart.yAxis[0].plotLinesAndBands;
	
	        referenceValueSeriesArray.forEach(function (rvS) {
	            var value = rvS.values[rvS.values.length - 1],
	                title = rvS.meta.title,
	                color = rvS.meta.color || '#000000';
	
	            var o = {
	                id: title,
	                label: {
	                    align: 'right',
	                    text: title,
	                    style: {
	                        color: 'black',
	                        padding: 2
	                    }
	                },
	                value: value,
	                color: color,
	                width: 1,
	                zIndex: 3
	            };
	
	            var idx = plotLinesAndBands.findIndex(function (l) {
	                return l.id === title;
	            });
	
	            if (idx === -1) {
	                yAxis.addPlotLine(o);
	            } else {
	                var plotLine = plotLinesAndBands[idx],
	                    options = plotLinesAndBands[idx].options;
	
	                if (options.label.text !== title || options.value !== value || options.color !== color) {
	                    plotLine.update(o);
	                }
	            }
	        });
	    };
	
	    /**
	     *  Check type of the series update, returns:
	     *      -1  a 'full' update needed
	     *      0  no update data is equal
	     *      n number of values that needs to be appended
	     */
	
	
	    HCTimeSeriesPlugin.prototype.checkUpdateType = function checkUpdateType(chart, seriesId, newSeries) {
	        var series = chart.get(seriesId),
	            newLen = newSeries.values.length;
	
	        var data = series && series.options && series.options.data;
	
	        if (!data || newLen < data.length) {
	            return -1;
	        }
	
	        if (this.endsWith(data, newSeries)) {
	
	            if (data.length == newLen) {
	                return 0;
	            }
	
	            if (data[data.length - 1][0] > newSeries.times[newSeries.times.length - 1]) {
	                console.error('Invalid update found! ', data, newSeries);
	                return -1;
	            }
	
	            return newLen - data.length;
	        }
	
	        return -1;
	    };
	
	    HCTimeSeriesPlugin.prototype.endsWith = function endsWith(cvalues, _ref) {
	        var values = _ref.values,
	            times = _ref.times;
	
	        if (cvalues.length > values.length) {
	            return false;
	        }
	
	        for (var i = cvalues.length - 1, v, t; i >= 0; i--) {
	            t = cvalues[i][0];
	            v = cvalues[i][1];
	            if (v !== values[i] || t !== times[i]) {
	                return false;
	            }
	        }
	        return true;
	    };
	
	    HCTimeSeriesPlugin.prototype.getTypeOfChart = function getTypeOfChart(series) {
	        switch (series.type) {
	            case _timeseriesUtil.METRIC_TYPE.DATA_POINTS:
	                return 'scatter';
	            case _timeseriesUtil.METRIC_TYPE.SERIES:
	                return 'line';
	            default:
	                console.warn('Unknown series type: ' + series.type);
	                return 'line';
	        }
	    };
	
	    HCTimeSeriesPlugin.prototype.getName = function getName(series) {
	        return series.metric;
	    };
	
	    HCTimeSeriesPlugin.prototype.getColor = function getColor(series) {};
	
	    //TODO CURRENTLY UNUSED
	
	
	    HCTimeSeriesPlugin.prototype.getRegionFromSet = function getRegionFromSet(seriesArray) {};
	
	    return HCTimeSeriesPlugin;
	}();
	
	exports.default = HCTimeSeriesPlugin;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = uniqueId;
	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Hibbeler
	 * Date: 31.08.2016
	 */
	
	var METRIC_TYPE = exports.METRIC_TYPE = {
	    SERIES: 'series',
	    DATA_POINTS: 'datapoints',
	    REFERENCE_VALUES: 'reference_values'
	};
	
	/**
	 * https://prometheus.io/docs/concepts/data_model/
	 *
	 *  Notation
	 *  Given a metric name and a set of labels, time series are frequently identified using this notation:
	 *
	 *  <metric name>{<label name>=<label value>, ...}
	 *  For example, a time series with the metric name api_http_requests_total and the labels method="POST" and handler="/messages" could be written like this:
	 *
	 *  api_http_requests_total{method="POST", handler="/messages"}
	 *  This is the same notation that OpenTSDB uses.
	 *
	 */
	function uniqueId(series) {
	    return series.metric + '{' + Object.keys(series.labels).map(function (label) {
	        return label + '=' + series.labels[label];
	    }).join(',') + '}';
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 07.04.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	/**
	 * @deprecated use HCTimeSeriesPlugin.js instead
	 * User: Valeria Nazarova on 14.02.2023
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _timeseriesUtil = __webpack_require__(94);
	
	var _timeseriesUtil2 = _interopRequireDefault(_timeseriesUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var equalArray = function equalArray(a, b, equal) {
	    if (a && b) {
	        if (a.length === b.length) {
	            return a.findIndex(function (ae, i) {
	                return !equal(ae, b[i]);
	            }) >= 0;
	        }
	        return false;
	    }
	    return !a && !b;
	};
	
	var TimeSeriesPlugin = function () {
	    function TimeSeriesPlugin() {
	        _classCallCheck(this, TimeSeriesPlugin);
	    }
	
	    TimeSeriesPlugin.prototype.initOptions = function initOptions(o) {
	        return this.options(o);
	    };
	
	    TimeSeriesPlugin.prototype.options = function options(o) {
	        var _this = this;
	
	        o = _extends({}, o, {
	            data: _extends({}, o.data, {
	                columns: [],
	                empty: {
	                    label: {
	                        text: 'Daten nicht geladen'
	                    }
	                }
	            }),
	            tooltip: {
	                grouped: false,
	                format: {
	                    value: function value(_value, ratio, id) {
	                        return _value.toFixed(2);
	                    }
	                }
	            },
	            axis: {
	                x: {
	                    type: 'timeseries',
	                    padding: {
	                        right: 1000 * 60 * 60 * 8
	                    },
	                    tick: {
	                        rotate: 45,
	                        format: '%d-%m %H:%M', //d3.time.format('%d-%m %H:%M')
	                        fit: true,
	                        count: function count() {
	                            return _this.chart && _this.chart.data().length > 0 ? 25 : 0;
	                        }
	                    }
	                },
	                y: {
	                    min: 0,
	                    max: 100
	                }
	            }
	        });
	        return o;
	    };
	
	    TimeSeriesPlugin.prototype.init = function init(chart, o) {
	        this.chart = chart;
	        chart.zoom.enable(true);
	    };
	
	    TimeSeriesPlugin.prototype.update = function update(chart, o) {
	        if (o && o.item && this.lastSeries != o.item) {
	            this.updateSeries(chart, _liferayWidgetsReactWeb.DataUtil.asArray(o.item));
	        }
	        this.lastSeries = o.item;
	    };
	
	    TimeSeriesPlugin.prototype.updateSeries = function updateSeries(chart, seriesArray) {
	        var _this2 = this;
	
	        seriesArray = seriesArray.filter(function (series) {
	            return series.times.length > 0;
	        });
	
	        if (seriesArray.length == 0) {
	            return;
	        }
	
	        var referenceValueSeriesArray = seriesArray.filter(function (series) {
	            return series.type == _timeseriesUtil.METRIC_TYPE.REFERENCE_VALUES;
	        });
	        if (referenceValueSeriesArray.length > 0) {
	            seriesArray = seriesArray.filter(function (series) {
	                return series.type != _timeseriesUtil.METRIC_TYPE.REFERENCE_VALUES;
	            });
	        }
	
	        var updateType = 0,
	            anyDataUpdate = false;
	        var updates = seriesArray.map(function (series) {
	            var seriesId = (0, _timeseriesUtil2.default)(series);
	            updateType = updateType == -1 ? -1 : _this2.checkUpdateType(chart, seriesId, series);
	            anyDataUpdate = anyDataUpdate || updateType != 0;
	            return {
	                seriesId: seriesId,
	                updateType: updateType,
	                series: series
	            };
	        });
	
	        //Check for removed Data
	        //If removed Data found, do full repaint
	        chart.data().forEach(function (data) {
	            var found = false;
	            updates.forEach(function (update) {
	                if (data.id == update.seriesId) {
	                    found = true;
	                }
	            });
	            if (!found) {
	                updateType = -1;
	            }
	        });
	
	        if (anyDataUpdate) {
	            this.updateRegions(chart, seriesArray);
	            //See: https://inovum-dev.de/jira/browse/FLIWAS-788
	            /*let yAxisRange = */
	            this.updateAxis(seriesArray);
	        }
	
	        this.updateGrid(referenceValueSeriesArray /*, yAxisRange*/);
	
	        if (updateType == -1) {
	            this.fullUpdate(chart, updates);
	        } else {
	            this.appendOnlyUpdate(chart, updates);
	        }
	
	        //ToDo:
	        //Currently not supported for splines
	        //http://c3js.org/reference.html#data-regions
	        //chartData.regions[ 'data_' + name ] = this.getRegionFromSet(series);
	    };
	
	    TimeSeriesPlugin.prototype.appendOnlyUpdate = function appendOnlyUpdate(chart, updates) {
	        var chartData = {
	            columns: [],
	            length: 0
	        };
	
	        updates.forEach(function (update) {
	            var series = update.series,
	                seriesId = update.seriesId,
	                updateType = update.updateType,
	                axisName = 'x_' + seriesId;
	
	            if (updateType > 0) {
	
	                chartData.columns.push([seriesId].concat(series.values.slice(series.values.length - updateType)));
	                chartData.columns.push([axisName].concat(series.times.slice(series.times.length - updateType)));
	            }
	        });
	
	        if (chartData.columns.length > 0) {
	            chart.flow(chartData);
	        }
	    };
	
	    TimeSeriesPlugin.prototype.fullUpdate = function fullUpdate(chart, updates) {
	        var _this3 = this;
	
	        //http://c3js.org/reference.html#api-load
	        var chartData = {
	            xs: this.chart.xs(),
	            columns: [],
	            types: {},
	            names: {},
	            colors: {},
	            regions: {},
	            unload: true
	        };
	
	        updates.forEach(function (update) {
	            var series = update.series,
	                seriesId = update.seriesId,
	                axisName = 'x_' + seriesId;
	
	            chartData.xs[seriesId] = axisName;
	            chartData.columns.push([seriesId].concat(series.values));
	            chartData.columns.push([axisName].concat(series.times));
	            chartData.names[seriesId] = _this3.getName(series);
	            chartData.colors[seriesId] = _this3.getColor(series);
	            chartData.types[seriesId] = _this3.getTypeOfChart(series);
	        });
	
	        if (updates.length > 0) {
	            chart.load(chartData);
	        } else {
	            this.chart.unload();
	        }
	    };
	
	    TimeSeriesPlugin.prototype.updateAxis = function updateAxis(seriesArray) {
	        var _getAxisMinMax = this.getAxisMinMax(seriesArray),
	            min = _getAxisMinMax.min,
	            max = _getAxisMinMax.max;
	
	        if (min != Number.MAX_VALUE && max > 0 && (this.chart.axis.min().y != min || this.chart.axis.max().y != max)) {
	            this.chart.axis.min({ y: min });
	            this.chart.axis.max({ y: max });
	        }
	        //See: https://inovum-dev.de/jira/browse/FLIWAS-788
	        //return { min: min, max: max };
	    };
	
	    //See: https://inovum-dev.de/jira/browse/FLIWAS-788
	
	
	    TimeSeriesPlugin.prototype.updateGrid = function updateGrid(referenceValueSeriesArray /*, yAxisRange*/) {
	        //let i = 0;
	        var lines = referenceValueSeriesArray.map(function (rvS) {
	            if (rvS.values && rvS.values.length > 0) {
	                var rv = rvS.values[rvS.values.length - 1];
	                return {
	                    value: rv,
	                    text: rvS.meta.title,
	                    class: 'color-' + rvS.meta.color
	                };
	            } else {
	                console.warn('Empty ReferenceValueSeries', rvS);
	            }
	        }).filter(function (rvS) {
	            return !!rvS;
	        });
	
	        //See: https://inovum-dev.de/jira/browse/FLIWAS-788
	        /*for (i = yAxisRange.min; i <= yAxisRange.max; i += 20) {
	            lines.push({
	                value: i,
	                class: 'dashed-line'
	            });
	        }*/
	
	        var current = this.chart.ygrids();
	        if (!equalArray(current, lines, function (a, b) {
	            return a.value === b.value && a.text === b.text && a.class === b.class;
	        })) {
	            this.chart.ygrids(lines);
	        }
	    };
	
	    TimeSeriesPlugin.prototype.updateRegions = function updateRegions(chart, seriesArray) {
	        var regions = this.getChartRegions(seriesArray);
	        if (regions && Array.isArray(regions)) {
	            var current = this.chart.regions();
	            if (!equalArray(current, regions, function (a, b) {
	                return a.start === b.start && a.end === b.end;
	            })) {
	                chart.regions(regions);
	            }
	        }
	    };
	
	    /**
	     *  Check type of the series update, returns:
	     *      -1  a 'full' update needed
	     *      0  no update data is equal
	     *      n number of values that needs to be appended
	     */
	
	
	    TimeSeriesPlugin.prototype.checkUpdateType = function checkUpdateType(chart, seriesId, newSeries) {
	        var data = chart.data(seriesId),
	            newLen = newSeries.values.length;
	        data = data.length == 0 ? null : data[0];
	
	        if (!data || newLen < data.values.length) {
	            return -1;
	        }
	
	        if (this.endsWith(data.values, newSeries)) {
	
	            if (data.values.length == newLen) {
	                return 0;
	            }
	
	            if (data.values[data.values.length - 1].x.getTime() > newSeries.times[newSeries.times.length - 1]) {
	                console.error('Invalid update found! ', data, newSeries);
	                return -1;
	            }
	
	            return newLen - data.values.length;
	        }
	
	        return -1;
	    };
	
	    TimeSeriesPlugin.prototype.endsWith = function endsWith(cvalues, _ref) {
	        var values = _ref.values,
	            times = _ref.times;
	
	        if (cvalues.length > values.length) {
	            return false;
	        }
	
	        for (var i = cvalues.length - 1, v; i >= 0; i--) {
	            v = cvalues[i];
	            if (v.value !== values[i] || v.x.getTime() !== times[i]) {
	                return false;
	            }
	        }
	        return true;
	    };
	
	    TimeSeriesPlugin.prototype.getTypeOfChart = function getTypeOfChart(series) {
	        switch (series.type) {
	            case _timeseriesUtil.METRIC_TYPE.DATA_POINTS:
	                return 'scatter';
	            case _timeseriesUtil.METRIC_TYPE.SERIES:
	                return 'line';
	            default:
	                console.warn('Unknown series type: ' + series.type);
	                return 'line';
	        }
	    };
	
	    TimeSeriesPlugin.prototype.getChartRegions = function getChartRegions(seriesArray) {
	        var min = Number.MAX_VALUE,
	            max = 0,
	            regions = [];
	
	        seriesArray.forEach(function (series) {
	            min = Math.min(min, series.times[0]);
	            max = Math.max(max, series.times[series.times.length - 1]);
	        });
	
	        if (min > 0 && max > 0 && min < max) {
	            if (max - 1000 * 60 * 60 * 24 /* 1 DAY */ > min) {
	                var i = 0;
	                var minDate = new Date(min);
	                var maxDate = new Date(max);
	
	                var midnight = new Date(minDate.setHours(0, 0, 0, 0));
	                var midnightNextDay = new Date(new Date(midnight.getTime()).setHours(24, 0, 0, 0));
	
	                regions.push({
	                    start: minDate.getTime(),
	                    end: midnightNextDay.getTime()
	                });
	                i++;
	
	                midnight = new Date(midnightNextDay.getTime());
	                midnightNextDay = new Date(new Date(midnight.getTime()).setHours(24, 0, 0, 0));
	
	                while (midnightNextDay.getTime() < maxDate.getTime()) {
	                    if (i % 2 == 0) {
	                        regions.push({
	                            start: midnight.getTime(),
	                            end: midnightNextDay.getTime()
	                        });
	                    }
	
	                    midnight = new Date(midnightNextDay.getTime());
	                    midnightNextDay = new Date(new Date(midnight.getTime()).setHours(24, 0, 0, 0));
	                    i++;
	                }
	
	                if (i % 2 == 0) {
	                    regions.push({
	                        start: midnight.getTime(),
	                        end: maxDate.getTime()
	                    });
	                }
	            }
	        }
	        return regions;
	    };
	
	    TimeSeriesPlugin.prototype.getName = function getName(series) {
	        return series.metric;
	    };
	
	    TimeSeriesPlugin.prototype.getColor = function getColor(series) {};
	
	    TimeSeriesPlugin.prototype.getMinMaxValues = function getMinMaxValues(series) {
	        var min = Number.MAX_VALUE,
	            max = 0;
	        if (Array.isArray(series)) {
	            series.forEach(function (s) {
	                max = Math.max(max, Math.max.apply(Math, s.values));
	                min = Math.min(min, Math.min.apply(Math, s.values));
	            });
	        } else {
	            max = Math.max.apply(Math, series.values);
	            min = Math.min.apply(Math, series.values);
	        }
	        return { min: min, max: max };
	    };
	
	    TimeSeriesPlugin.prototype.getAxisMinMax = function getAxisMinMax(seriesArray) {
	        var _getMinMaxValues = this.getMinMaxValues(seriesArray),
	            min = _getMinMaxValues.min,
	            max = _getMinMaxValues.max;
	
	        min = Math.floor(min / 100) * 100;
	        if (max > 0) {
	            max = Math.ceil(max / 100) * 100;
	        }
	        return { min: min, max: max };
	    };
	
	    //TODO CURRENTLY UNUSED
	
	
	    TimeSeriesPlugin.prototype.getRegionFromSet = function getRegionFromSet(seriesArray) {};
	
	    return TimeSeriesPlugin;
	}();
	
	exports.default = TimeSeriesPlugin;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                   * User: CBuehler on 25.09.2015
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	__webpack_require__(97);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleChange = function handleChange(_ref) {
	    var date = _ref.date,
	        onChange = _ref.onChange;
	
	    onChange && onChange({ date: date });
	};
	
	var DateTimeFormComponent = function DateTimeFormComponent(props) {
	    var _props = props,
	        minDate = _props.minDate,
	        maxDate = _props.maxDate,
	        startDate = _props.startDate,
	        _onChange = _props.onChange,
	        inline = _props.inline,
	        label = _props.label,
	        _props$popperPlacemen = _props.popperPlacement,
	        popperPlacement = _props$popperPlacemen === undefined ? 'auto' : _props$popperPlacemen;
	
	
	    startDate = startDate ? new Date(startDate) : new Date();
	    minDate = minDate ? new Date(minDate) : null;
	    maxDate = maxDate ? new Date(maxDate) : null;
	
	    props = _extends({}, props, {
	        inline: props.inlineCal, /* inline is used by React Bootstrap and DatePicker */
	        minDate: minDate,
	        maxDate: maxDate,
	        startDate: startDate
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: inline ? 'react-datepicker-inline' : '' },
	        _react2.default.createElement(
	            'span',
	            { className: 'datepicker-date' },
	            label && _react2.default.createElement(
	                'span',
	                { className: 'datepicker-label' },
	                label
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, _extends({}, props, {
	                selected: startDate,
	                popperPlacement: popperPlacement,
	                selectsStart: true,
	                allowSameDay: true,
	                onChange: function onChange(date) {
	                    return handleChange({ date: date, onChange: _onChange });
	                }
	            }))
	        )
	    );
	};
	
	var DateTimePicker = function DateTimePicker(props) {
	    return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, props, { as: DateTimeFormComponent }));
	};
	
	//https://reactdatepicker.com/ & https://github.com/Hacker0x01/react-datepicker/blob/master/src/index.jsx
	DateTimePicker.propTypes = {
	    onChange: _propTypes2.default.func,
	    inline: _propTypes2.default.bool,
	    startDate: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),
	    minDate: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),
	    maxDate: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),
	    label: _propTypes2.default.node,
	    timeFormat: _propTypes2.default.string,
	    timeCaption: _propTypes2.default.string,
	    popperPlacement: _propTypes2.default.oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end'])
	};
	
	DateTimePicker.defaultProps = {
	    dateFormat: 'dd.MM.yyyy HH:mm',
	    timeFormat: 'HH:mm',
	    timeCaption: 'Uhrzeit'
	};
	
	DateTimeFormComponent.propTypes = DateTimePicker.propTypes;
	
	exports.default = DateTimePicker;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_97__;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(97);
	
	__webpack_require__(99);
	
	var _datefns = __webpack_require__(38);
	
	var _datefns2 = _interopRequireDefault(_datefns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Created by Carsten Hibbeler
	                                                                                                                                                                                                                              * Date: 11.04.2018
	                                                                                                                                                                                                                              */
	
	var handleChange = function handleChange(_ref) {
	    var startDate = _ref.startDate,
	        endDate = _ref.endDate,
	        onChange = _ref.onChange;
	
	    if (_datefns2.default.isAfter(startDate, endDate)) {
	        endDate = startDate;
	    }
	    onChange && onChange({ startDate: startDate, endDate: endDate });
	};
	
	var DateRangeFormComponent = function DateRangeFormComponent(_ref2) {
	    var minDate = _ref2.minDate,
	        maxDate = _ref2.maxDate,
	        startDate = _ref2.startDate,
	        endDate = _ref2.endDate,
	        _onChange = _ref2.onChange,
	        inline = _ref2.inline,
	        disabled = _ref2.disabled,
	        _ref2$dateFormat = _ref2.dateFormat,
	        dateFormat = _ref2$dateFormat === undefined ? 'dd.MM.yyyy HH:mm' : _ref2$dateFormat,
	        _ref2$timeFormat = _ref2.timeFormat,
	        timeFormat = _ref2$timeFormat === undefined ? 'HH:mm' : _ref2$timeFormat,
	        _ref2$timeCaption = _ref2.timeCaption,
	        timeCaption = _ref2$timeCaption === undefined ? 'Uhrzeit' : _ref2$timeCaption,
	        _ref2$startLabel = _ref2.startLabel,
	        startLabel = _ref2$startLabel === undefined ? 'Von' : _ref2$startLabel,
	        _ref2$endLabel = _ref2.endLabel,
	        endLabel = _ref2$endLabel === undefined ? 'Bis' : _ref2$endLabel,
	        rest = _objectWithoutProperties(_ref2, ['minDate', 'maxDate', 'startDate', 'endDate', 'onChange', 'inline', 'disabled', 'dateFormat', 'timeFormat', 'timeCaption', 'startLabel', 'endLabel']);
	
	    startDate = startDate ? new Date(startDate) : new Date();
	    endDate = endDate ? new Date(endDate) : new Date();
	    minDate = minDate ? new Date(minDate) : null;
	    maxDate = maxDate ? new Date(maxDate) : null;
	
	    (0, _react.useEffect)(function () {
	        if (!disabled) {
	            handleChange({ startDate: startDate, endDate: endDate, onChange: _onChange });
	        }
	    }, [disabled]);
	
	    var props = _extends({}, rest, {
	        //inline: props.inlineCal, /* inline is used by React Bootstrap and DatePicker */
	        disabled: disabled,
	        dateFormat: dateFormat,
	        timeFormat: timeFormat,
	        timeCaption: timeCaption,
	        startLabel: startLabel,
	        endLabel: endLabel,
	        minDate: minDate,
	        maxDate: maxDate,
	        startDate: startDate,
	        endDate: endDate
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'd-block date-range-picker' },
	        _react2.default.createElement(
	            'div',
	            { className: 'd-inline-block mr-auto mb-2' },
	            _react2.default.createElement(
	                'label',
	                { className: 'date-picker-start-label', htmlFor: 'date-picker-start' },
	                startLabel
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, _extends({}, props, {
	                id: 'date-picker-start',
	                selected: startDate,
	                selectsStart: true,
	                allowSameDay: true,
	                onChange: function onChange(v) {
	                    return handleChange({ startDate: v, endDate: endDate, onChange: _onChange });
	                }
	            }))
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'd-inline-block mb-2' },
	            _react2.default.createElement(
	                'label',
	                { className: 'date-picker-end-label', htmlFor: 'date-picker-end' },
	                endLabel
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, _extends({}, props, {
	                id: 'date-picker-end',
	                selected: endDate,
	                selectsEnd: true,
	                allowSameDay: true,
	                onChange: function onChange(v) {
	                    return handleChange({ startDate: startDate, endDate: v, onChange: _onChange });
	                }
	            }))
	        )
	    );
	};
	
	var DateRangePicker = function DateRangePicker(props) {
	    return _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, props, { as: DateRangeFormComponent }));
	};
	
	//https://reactdatepicker.com/ & https://github.com/Hacker0x01/react-datepicker/blob/master/src/index.jsx
	DateRangePicker.propTypes = {
	    onChange: _propTypes2.default.func,
	    inline: _propTypes2.default.bool,
	    startDate: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),
	    endDate: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),
	    minDate: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),
	    maxDate: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),
	    startLabel: _propTypes2.default.node,
	    endLabel: _propTypes2.default.node,
	    timeFormat: _propTypes2.default.string,
	    timeCaption: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool
	};
	
	DateRangeFormComponent.propTypes = DateRangePicker.propTypes;
	
	exports.default = DateRangePicker;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(100);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./date-picker.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./date-picker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".date-range-picker .date-picker-end-label,.date-range-picker .date-picker-start-label{width:30px;display:inline-block;margin:0}", ""]);
	
	// exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Hibbeler
	 * Date: 28.01.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _mapPortlet = __webpack_require__(25);
	
	var _BaseRemoteDataLayerController = __webpack_require__(24);
	
	var _BaseRemoteDataLayerController2 = _interopRequireDefault(_BaseRemoteDataLayerController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BusinessObjectSelect = function (_React$Component) {
	  _inherits(BusinessObjectSelect, _React$Component);
	
	  function BusinessObjectSelect(props) {
	    _classCallCheck(this, BusinessObjectSelect);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.layerDescription = _extends({}, props.layer, {
	      controller: new _BaseRemoteDataLayerController2.default()
	    });
	    _this.layerDescription.controller.onItemClick = function (className, id, title, typeKey) {
	      return _this.onChange({
	        id: id,
	        title: title,
	        typeKey: typeKey
	      });
	    };
	
	    _this.DATA = { LIST: _this.withCtx('BusinessObjectSelect') };
	    _this.state = {
	      searchValue: ''
	    };
	
	    _this.ListCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list'], _this.props.store);
	    _this.searchList = (0, _liferayWidgetsReactWeb.debounce)(_this.searchList.bind(_this), 300);
	    return _this;
	  }
	
	  BusinessObjectSelect.prototype.componentDidMount = function componentDidMount() {
	    this.searchList('');
	  };
	
	  BusinessObjectSelect.prototype.withCtx = function withCtx(s) {
	    return this.props.formId + '.' + s;
	  };
	
	  BusinessObjectSelect.prototype.more = function more(query) {
	    this.props.onMore(this.DATA.LIST, query);
	  };
	
	  BusinessObjectSelect.prototype.updateSearch = function updateSearch(e) {
	    this.setState({ searchValue: e.target.value });
	    this.searchList(e.target.value);
	  };
	
	  BusinessObjectSelect.prototype.searchList = function searchList(searchValue) {
	    this.props.onSearch(this.DATA.LIST, {
	      start: 0,
	      end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE,
	      searchValue: searchValue || ''
	    });
	  };
	
	  BusinessObjectSelect.prototype.change = function change(o) {
	    this.props.onChange(_extends({}, this.props.formData, o));
	  };
	
	  BusinessObjectSelect.prototype.onChange = function onChange(item) {
	    var _change;
	
	    var id = item.id,
	        title = item.title,
	        _item$typeKey = item.typeKey,
	        typeKey = _item$typeKey === undefined ? '' : _item$typeKey;
	    // don't remove 2nd id param!!!
	
	    this.change((_change = {}, _change[this.props.propName || 'id'] = id, _change.id = id, _change.title = title, _change.typeKey = typeKey, _change));
	    this.setState({ title: title });
	  };
	
	  BusinessObjectSelect.prototype.render = function render() {
	    var _this2 = this,
	        _ref;
	
	    var searchValue = this.state.searchValue;
	    var _props = this.props,
	        noPadding = _props.noPadding,
	        formData = _props.formData,
	        propName = _props.propName,
	        _props$showMap = _props.showMap,
	        showMap = _props$showMap === undefined ? true : _props$showMap;
	
	    var id = formData && propName ? formData[propName] : formData.id;
	    var selectedItems = id && [{ className: this.props.className, id: id }];
	
	    return _react2.default.createElement(
	      _reactBootstrap.Container,
	      { className: noPadding ? 'p-0 ' : 'py-3' },
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        { noGutters: true },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, sm: 12, md: showMap ? 5 : 12 },
	          _react2.default.createElement(_reactBootstrap.FormControl, {
	            className: 'mb-3',
	            type: 'text',
	            value: searchValue,
	            onChange: this.updateSearch.bind(this),
	            placeholder: 'Suchen'
	          }),
	          _react2.default.createElement(this.ListCHOC, {
	            className: 'business-object-select-list',
	            list: this.DATA.LIST,
	            ListItem: this.props.CustomMapLinkListItem || _mapPortlet.MapLinkListItem,
	            activeIds: { id: id },
	            onClick: function onClick(item) {
	              return _this2.onChange(item);
	            },
	            onClickMore: this.more.bind(this)
	          })
	        ),
	        showMap && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, sm: 12, md: 7 },
	          _react2.default.createElement(
	            'h3',
	            { className: 'mb-3 pl-3' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.state && this.state.title ? this.state.title : 'Kein Eintrag ausgewählt'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'area-select pl-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'map', style: { height: '365px' } },
	              _react2.default.createElement(_mapPortlet.Map, {
	                selectedItems: selectedItems,
	                defaultFallbackMapConfigType: 'static',
	                layerDescriptions: [this.layerDescription],
	                activeUuids: (_ref = {}, _ref[this.props.layer.uuid] = true, _ref),
	                style: { height: '365px' },
	                zoom: 12
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return BusinessObjectSelect;
	}(_react2.default.Component);
	
	BusinessObjectSelect.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  formId: _propTypes2.default.string.isRequired,
	  formData: _propTypes2.default.object,
	
	  layer: _propTypes2.default.object.isRequired,
	  className: _propTypes2.default.string.isRequired,
	  propName: _propTypes2.default.string,
	  onMore: _propTypes2.default.func.isRequired,
	  onSearch: _propTypes2.default.func.isRequired,
	  store: _propTypes2.default.object.isRequired,
	  CustomMapLinkListItem: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  noPadding: _propTypes2.default.bool,
	  showMap: _propTypes2.default.bool
	};
	
	exports.default = BusinessObjectSelect;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 21.11.2018
	 * Copyright: xdot GmbH 2018
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OPTIONS = [{ key: 'Group', label: 'Alarmstufe (Mandant)' }, { key: 'DikeBreak', label: 'Deichbruchszenario' }, { key: 'ManualBooleanState', label: 'Ereignis' }, { key: 'FloodRetentionBasin', label: 'Hochwasserrückhaltebecken' }, { key: 'CriticalObject', label: 'Kritisches Objekt' }, { key: 'NewsMessage', label: 'Lagemeldung' }, { key: 'Task', label: 'Maßnahmen in Ausführung' }, { key: 'RealPrecipitationStation', label: 'Niederschlagsmessstation' }, { key: 'PrecipitationStation', label: 'Radar Niederschlagsmessung' }, { key: 'GaugingStation', label: 'Pegel' }, { key: 'Quarter', label: 'Teilgebiet' }];
	
	var AssetLinkChooser = function (_React$Component) {
	  _inherits(AssetLinkChooser, _React$Component);
	
	  function AssetLinkChooser(props) {
	    _classCallCheck(this, AssetLinkChooser);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onObjectTypeChange = _this.onObjectTypeChange.bind(_this);
	    _this.onAssetSelected = _this.onAssetSelected.bind(_this);
	    _this.state = {
	      objectType: _this.props.objectType
	    };
	    _this.props.onChange(_this.props.formData, _this.validate(_this.props.formData));
	    return _this;
	  }
	
	  AssetLinkChooser.prototype.onObjectTypeChange = function onObjectTypeChange(event) {
	    this.setState({
	      objectType: event.target.value
	    });
	  };
	
	  AssetLinkChooser.prototype.onAssetSelected = function onAssetSelected(formData) {
	    this.props.onChange(formData, this.validate(formData));
	  };
	
	  AssetLinkChooser.prototype.validate = function validate(formData) {
	    var idValid = void 0;
	
	    if (!(formData.id > 0) || !formData.className) {
	      idValid = 'Bitte Asset auswählen';
	    }
	
	    return {
	      id: idValid
	    };
	  };
	
	  AssetLinkChooser.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        filterTypes = _props.filterTypes,
	        hideTypes = _props.hideTypes;
	
	    return _react2.default.createElement(
	      'fieldset',
	      { className: 'padding-box' },
	      _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Welches Objekt soll verkn\xFCpft werden?' }),
	      _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        { controlId: 'AssetLinChooserObjectTypeChooser' },
	        _react2.default.createElement(
	          _reactBootstrap.FormLabel,
	          null,
	          'Objekttyp'
	        ),
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.FormControl,
	          {
	            as: 'select',
	            required: true,
	            value: this.state.objectType,
	            onChange: this.onObjectTypeChange
	          },
	          _react2.default.createElement(
	            'option',
	            { value: '' },
	            'Bitte w\xE4hlen'
	          ),
	          OPTIONS.filter(function (o) {
	            if (filterTypes) {
	              return filterTypes.includes(o.key);
	            } else if (hideTypes) {
	              return !hideTypes.includes(o.key);
	            }
	            return true;
	          }).map(function (o) {
	            return _react2.default.createElement(
	              'option',
	              { key: o.key, value: o.key },
	              o.label
	            );
	          })
	        ),
	        _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: this.props.formValidation, propName: 'id' })
	      ),
	      this.state.objectType && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _liferayWidgetsReactWeb.AmdRequireComponent,
	          { dependencies: ['FliwasObjectChooser/' + this.state.objectType] },
	          function (Renderer) {
	            return _react2.default.createElement(Renderer, { formData: _this2.props.formData, onChange: _this2.onAssetSelected });
	          }
	        ),
	        _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: this.props.formValidation, propName: 'id' })
	      )
	    );
	  };
	
	  return AssetLinkChooser;
	}(_react2.default.Component);
	
	AssetLinkChooser.propTypes = {
	  onChange: _propTypes2.default.func,
	  formData: _propTypes2.default.object,
	  formValidation: _propTypes2.default.object,
	  objectType: _propTypes2.default.string,
	  filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  hideTypes: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	exports.default = AssetLinkChooser;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Carsten Bühler
	 * Date: 12.02.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _AssetTagActions = __webpack_require__(104);
	
	var _AssetTagActions2 = _interopRequireDefault(_AssetTagActions);
	
	var _DlFileEntryActions = __webpack_require__(106);
	
	var _DlFileEntryActions2 = _interopRequireDefault(_DlFileEntryActions);
	
	var _AttachedDocumentList = __webpack_require__(63);
	
	var _AttachedDocumentList2 = _interopRequireDefault(_AttachedDocumentList);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssetTagStore = (0, _StoreFactory.getAssetTagStore)(_liferayWidgetsReactWeb.AppContext);
	
	var AttachedDocumentListLink = _liferayWidgetsReactWeb.DataLinkContainer.link(_AttachedDocumentList2.default, 'list', (0, _StoreFactory.getDLFileEntryStore)(_liferayWidgetsReactWeb.AppContext));
	
	var AttachedDocumentsByTagForm = function (_React$Component) {
	    _inherits(AttachedDocumentsByTagForm, _React$Component);
	
	    function AttachedDocumentsByTagForm(props) {
	        _classCallCheck(this, AttachedDocumentsByTagForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            ASSET_TAGS: _this.withCtx('ASSET_TAGS'),
	            DOCUMENTS_BY_TAGS: _this.withCtx('DOCUMENT_BY_TAG')
	        };
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onSubmit = _this.onSubmit.bind(_this);
	        return _this;
	    }
	
	    AttachedDocumentsByTagForm.prototype.componentDidMount = function componentDidMount() {
	        _AssetTagActions2.default.getAssetTagsByGroupId(this.DATA.ASSET_TAGS, {
	            groupId: _liferayWidgetsReactWeb.AppContext.getScopeGroupId()
	        });
	    };
	
	    AttachedDocumentsByTagForm.getStores = function getStores() {
	        return [AssetTagStore];
	    };
	
	    AttachedDocumentsByTagForm.calculateState = function calculateState(prevState, prevProps, DATA) {
	        return {
	            tagDataList: AssetTagStore.getRemoteData(DATA.ASSET_TAGS)
	        };
	    };
	
	    AttachedDocumentsByTagForm.prototype.withCtx = function withCtx(s) {
	        return this.props.formId + '.' + s;
	    };
	
	    AttachedDocumentsByTagForm.prototype.onChange = function onChange(e) {
	        var tagId = parseInt(e.target.value);
	        var formData = _extends({}, this.props.formData, { tagId: tagId });
	        this.props.onChange(formData, this.validate(formData));
	        _DlFileEntryActions2.default.getGroupFileEntriesByTag(this.DATA.DOCUMENTS_BY_TAGS, { tagId: tagId });
	    };
	
	    AttachedDocumentsByTagForm.prototype.onSubmit = function onSubmit() {
	        // eslint-disable-next-line react/prop-types
	        this.props.submit();
	    };
	
	    AttachedDocumentsByTagForm.prototype.validate = function validate(formData) {
	        var tagIdValid = void 0;
	
	        if (formData.tagId <= 0) {
	            tagIdValid = 'Bitte Tag auswählen.';
	        }
	
	        return {
	            tagId: tagIdValid
	        };
	    };
	
	    AttachedDocumentsByTagForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation,
	            formValid = _props.formValid;
	
	
	        var tagOptions = [];
	        tagOptions.push(_react2.default.createElement(
	            'option',
	            { key: 'Asset_Tag_' + -1, value: -1 },
	            'Bitte Tag ausw\xE4hlen!'
	        ));
	
	        var tagDataList = this.state.tagDataList;
	
	
	        if (tagDataList && _liferayWidgetsReactWeb.DataUtil.asArray(tagDataList)) {
	            var assetTags = _liferayWidgetsReactWeb.DataUtil.asArray(tagDataList);
	            assetTags.forEach(function (assetTag) {
	                tagOptions.push(_react2.default.createElement(
	                    'option',
	                    { key: 'Asset_Tag_' + assetTag.id, value: assetTag.id },
	                    assetTag.name
	                ));
	            });
	        }
	
	        var buttonOptions = formValid ? {} : { disabled: 'disabled' };
	
	        return _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { controlId: 'WebcamWidgetImageUrl' },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormLabel,
	                            null,
	                            'Dokumenten-Tag'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.FormControl,
	                            { as: 'select',
	                                required: true,
	                                value: formData.tagId,
	                                onChange: this.onChange },
	                            tagOptions
	                        ),
	                        _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'tagId' })
	                    )
	                )
	            ),
	            formData.tagId > 0 && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement('hr', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Folgende Dokumente werden mit dem Objekt verbunden:'
	                        ),
	                        _react2.default.createElement(AttachedDocumentListLink, { list: this.DATA.DOCUMENTS_BY_TAGS,
	                            renderStyle: _AttachedDocumentList2.default.RENDER_STYLE.FLAT })
	                    )
	                )
	            )
	        );
	    };
	
	    return AttachedDocumentsByTagForm;
	}(_react2.default.Component);
	
	AttachedDocumentsByTagForm.propTypes = {
	    onChange: _propTypes2.default.func,
	    formValid: _propTypes2.default.bool,
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object
	};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(AttachedDocumentsByTagForm);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _AssetTagWebApi = __webpack_require__(105);
	
	var _AssetTagWebApi2 = _interopRequireDefault(_AssetTagWebApi);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.AssetTag; /**
	                                                 * Created by Carsten Bühler
	                                                 * User: c.buehler on 01.09.2016
	                                                 * Copyright: xdot GmbH 2015
	                                                 */
	
	exports.default = {
	  getAssetTagsByGroupId: function getAssetTagsByGroupId(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _AssetTagWebApi2.default.getAssetTagsByGroupId);
	  }
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _lwrClient = __webpack_require__(20);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 09.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var serviceWithContext = function serviceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/base.fliwasassettagapi/' + m, o, c);
	};
	var dervice = function dervice(m, o, c) {
	    return _lwrClient.Client.invoke('/base.fliwasassettagapi/' + m, o, c);
	};
	
	var api = {
	    getAssetTagsByGroupId: function getAssetTagsByGroupId(query) {
	        return dervice('get-asset-tags-by-group-id.1', {
	            groupId: query.groupId
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('AssetTagWebApi', api);
	
	exports.default = api;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _FliwasFileEntryWebApi = __webpack_require__(107);
	
	var _FliwasFileEntryWebApi2 = _interopRequireDefault(_FliwasFileEntryWebApi);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.DLFileEntry; /**
	                                                    * Created by Carsten Bühler
	                                                    * User: c.buehler on 01.09.2016
	                                                    * Copyright: xdot GmbH 2015
	                                                    */
	
	exports.default = {
	  moreDLFileEntries: function moreDLFileEntries(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, className, query);
	  },
	  getGroupFileEntriesByTag: function getGroupFileEntriesByTag(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasFileEntryWebApi2.default.getGroupFileEntriesByTag);
	  }
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _lwrClient = __webpack_require__(20);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 09.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var serviceWithContext = function serviceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/base.fliwasfileentryapi/' + m, o, c);
	};
	var service = function service(m, o, c) {
	    return _lwrClient.Client.invoke('/base.fliwasfileentryapi/' + m, o, c);
	};
	
	var api = {
	    getGroupFileEntriesByTag: function getGroupFileEntriesByTag(query) {
	        return service('get-group-file-entries-by-tag.1', {
	            tagId: query.tagId
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('FliwasFileEntryWebApi', api);
	
	exports.default = api;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2019 xdot GmbH
	 * Author: Carsten Bühler
	 * Date: 07.02.2019
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _mapPortlet = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BusinessObjectMultiSelect = function (_React$Component) {
	    _inherits(BusinessObjectMultiSelect, _React$Component);
	
	    function BusinessObjectMultiSelect(props) {
	        _classCallCheck(this, BusinessObjectMultiSelect);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            FLIWAS_OBJECT_ALL_LIST: _this.withCtx('FLIWAS_OBJECT_ALL_LIST'),
	            FLIWAS_OBJECT_ACTIVE_LIST: _this.withCtx('FLIWAS_OBJECT_ACTIVE_LIST')
	        };
	
	        _this.state = {
	            searchValue: ''
	        };
	
	        _this.AllListCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list'], _this.props.store);
	        _this.ActiveListCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list'], _this.props.store);
	        _this.searchList = (0, _liferayWidgetsReactWeb.debounce)(_this.searchList.bind(_this), 300);
	        return _this;
	    }
	
	    BusinessObjectMultiSelect.prototype.componentDidMount = function componentDidMount() {
	        this.searchList('');
	        this.listActive(this.props.formData && this.props.formData[this.props.propName]);
	    };
	
	    BusinessObjectMultiSelect.prototype.withCtx = function withCtx(s) {
	        return this.props.formId + '.' + s;
	    };
	
	    BusinessObjectMultiSelect.prototype.searchList = function searchList(searchValue) {
	        this.props.onSearch(this.DATA.FLIWAS_OBJECT_ALL_LIST, {
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE,
	            searchValue: searchValue || ''
	        });
	    };
	
	    BusinessObjectMultiSelect.prototype.listActive = function listActive(activeIds) {
	        this.props.onListActive(this.DATA.FLIWAS_OBJECT_ACTIVE_LIST, {
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE,
	            activeIds: activeIds || ''
	        });
	    };
	
	    BusinessObjectMultiSelect.prototype.setActive = function setActive(item) {
	        var _this2 = this,
	            _extends2;
	
	        var activeItemIds = this.getActiveOrganizationIdsFromFormData();
	        var idx = activeItemIds.findIndex(function (id) {
	            return item[_this2.props.idPropName] === id;
	        });
	        var newActiveItemIds = [].concat(activeItemIds);
	        if (idx === -1) {
	            newActiveItemIds.push(item[this.props.idPropName]);
	        } else {
	            newActiveItemIds.splice(idx, 1);
	        }
	
	        this.props.onChange(_extends({}, this.props.formData, (_extends2 = {}, _extends2[this.props.propName] = newActiveItemIds, _extends2)));
	        this.listActive(newActiveItemIds);
	    };
	
	    BusinessObjectMultiSelect.prototype.getActiveOrganizationIdsFromFormData = function getActiveOrganizationIdsFromFormData() {
	        var activeItemIds = this.props.formData[this.props.propName];
	        if (typeof activeItemIds == 'string') {
	            activeItemIds = JSON.parse(activeItemIds);
	        }
	        if (!activeItemIds) {
	            activeItemIds = [];
	        }
	        return activeItemIds;
	    };
	
	    BusinessObjectMultiSelect.prototype.deleteSelected = function deleteSelected(deleteId) {
	        var _extends3;
	
	        this.props.onChange(_extends({}, this.props.formData, (_extends3 = {}, _extends3[this.props.propName] = this.getActiveOrganizationIdsFromFormData().filter(function (id) {
	            return deleteId !== id;
	        }), _extends3)));
	    };
	
	    BusinessObjectMultiSelect.prototype.updateSearchValue = function updateSearchValue(e) {
	        this.setState({ searchValue: e.target.value });
	        this.searchList(e.target.value);
	    };
	
	    BusinessObjectMultiSelect.prototype.more = function more(query) {
	        this.props.onMore(this.DATA.FLIWAS_OBJECT_ALL_LIST, query);
	    };
	
	    BusinessObjectMultiSelect.prototype.render = function render() {
	        var _this3 = this;
	
	        var searchValue = this.state.searchValue;
	        var selectedListTitle = this.props.selectedListTitle;
	
	        var activeOrganizationIds = this.getActiveOrganizationIdsFromFormData();
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { className: 'py-3' },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                { noGutters: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12, sm: 12, md: 6, className: 'col-left' },
	                    _react2.default.createElement(_reactBootstrap.FormControl, {
	                        className: 'mb-3',
	                        type: 'text',
	                        value: searchValue,
	                        placeholder: 'Nach Namen suchen',
	                        onChange: this.updateSearchValue.bind(this)
	                    }),
	                    _react2.default.createElement(this.AllListCHOC, {
	                        className: 'fliwas-organizations-config-list',
	                        list: this.DATA.FLIWAS_OBJECT_ALL_LIST,
	                        size: 'medium',
	                        ListItem: this.props.CustomAllListMapLinkListItem || _mapPortlet.MapLinkListItem,
	                        propName: this.props.idPropName,
	                        onClick: function onClick(i) {
	                            return _this3.setActive(i);
	                        },
	                        activeIds: activeOrganizationIds,
	                        onClickMore: this.more.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12, sm: 12, md: 6, className: 'col-right nopadding nomargin' },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'mb-3 pl-3' },
	                        selectedListTitle ? selectedListTitle : 'Aktive ' + _liferayWidgetsReactWeb.translation.trans(this.props.className)
	                    ),
	                    _react2.default.createElement(this.ActiveListCHOC, {
	                        className: 'fliwas-organizations-config-list pl-3',
	                        list: this.DATA.FLIWAS_OBJECT_ACTIVE_LIST,
	                        size: 'medium',
	                        ListItem: this.props.CustomActiveListMapLinkListItem || _mapPortlet.MapLinkListItem,
	                        propName: this.props.idPropName,
	                        onClick: function onClick(i) {
	                            return _this3.setActive(i);
	                        },
	                        activeIds: activeOrganizationIds,
	                        onClickMore: this.more.bind(this)
	                    })
	                )
	            )
	        );
	    };
	
	    return BusinessObjectMultiSelect;
	}(_react2.default.Component);
	
	BusinessObjectMultiSelect.propTypes = {
	    onChange: _propTypes2.default.func.isRequired,
	    formId: _propTypes2.default.string.isRequired,
	    formData: _propTypes2.default.object,
	
	    className: _propTypes2.default.string.isRequired,
	    idPropName: _propTypes2.default.string,
	    selectedListTitle: _propTypes2.default.string,
	    propName: _propTypes2.default.string.isRequired,
	    onMore: _propTypes2.default.func.isRequired,
	    onSearch: _propTypes2.default.func.isRequired,
	    onListActive: _propTypes2.default.func.isRequired,
	    store: _propTypes2.default.object.isRequired,
	    CustomActiveListMapLinkListItem: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	    CustomAllListMapLinkListItem: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
	};
	
	BusinessObjectMultiSelect.defaultProps = {
	    idPropName: 'id'
	};
	
	exports.default = BusinessObjectMultiSelect;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PDFExportButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PDFExportButton = function PDFExportButton(_ref) {
	  var baseUrl = _ref.baseUrl,
	      namespace = _ref.namespace,
	      params = _ref.params,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Exportieren' : _ref$title,
	      _ref$fileName = _ref.fileName,
	      fileName = _ref$fileName === undefined ? 'Export' : _ref$fileName,
	      allowExport = _ref.allowExport,
	      label = _ref.label,
	      rest = _objectWithoutProperties(_ref, ['baseUrl', 'namespace', 'params', 'title', 'fileName', 'allowExport', 'label']);
	
	  var _useState = (0, _react.useState)(false),
	      loading = _useState[0],
	      setLoading = _useState[1];
	
	  var download = function download(url, fileName) {
	    return function () {
	      if (allowExport === undefined || allowExport()) {
	        setLoading(true);
	        fetch(url).then(function (res) {
	          if (!res.ok) {
	            throw new Error('Download fehlgeschlagen! Status: ' + res.status);
	          }
	          return res.blob();
	        }).then(function (blob) {
	          if (navigator.msSaveBlob) {
	            navigator.msSaveBlob(blob, fileName + '.pdf');
	          } else {
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = fileName;
	            link.click();
	          }
	        }).catch(function (err) {
	          window.alert(err);
	        }).finally(function () {
	          setLoading(false);
	        });
	      }
	    };
	  };
	
	  var exportUrl = baseUrl;
	  if (params) {
	    Object.keys(params).forEach(function (key) {
	      var value = params[key];
	      if (value) {
	        exportUrl += '&_' + namespace + '_' + key + '=' + value;
	      }
	    });
	  }
	
	  var downloadUrl = '/o/pdf-renderer?url=' + encodeURIComponent(exportUrl) + '&download=true';
	  fileName = fileName.replace(/ /g, '_') + '.pdf';
	
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    _extends({
	      title: title,
	      download: fileName,
	      onClick: download(downloadUrl, fileName),
	      disabled: loading
	    }, rest),
	    !loading && _react2.default.createElement(_Icon2.default, { name: 'download', title: title }),
	    loading && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	    label && label.length > 0 && _react2.default.createElement(
	      'span',
	      { className: 'ml-3' },
	      label
	    )
	  );
	};
	
	exports.PDFExportButton = PDFExportButton;
	PDFExportButton.propTypes = {
	  baseUrl: _propTypes2.default.string.isRequired,
	  namespace: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  fileName: _propTypes2.default.string,
	  params: _propTypes2.default.object,
	  allowExport: _propTypes2.default.func
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Valeria Nazarova
	 * Date: 07.03.2023
	 */
	
	var SituationStatusIcons = function SituationStatusIcons(_ref) {
	    var isActive = _ref.isActive,
	        isShared = _ref.isShared;
	
	    console.log('isActive, isShared', isActive, isShared);
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_Icon2.default, {
	            name: isActive ? 'active ic-active' : 'inactive ic-inactive',
	            title: isActive ? 'Aktiv' : 'Inaktiv',
	            className: 'icon-active-size mr-3'
	        }),
	        _react2.default.createElement(_Icon2.default, {
	            name: isShared ? 'share ic-active' : 'not-shared ic-inactive',
	            title: isShared ? 'Geteilt' : 'Nicht geteilt',
	            className: 'icon-shared-size mr-3'
	        })
	    );
	};
	
	SituationStatusIcons.propTypes = {
	    isActive: _propTypes2.default.bool.isRequired,
	    isShared: _propTypes2.default.bool.isRequired
	};
	
	exports.default = SituationStatusIcons;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(112);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./situation-status-icons.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./situation-status-icons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".icon-active-size{font-size:1.8rem;vertical-align:middle}.icon-shared-size{font-size:1.5rem;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InlineView = exports.wrapWithInlineFormComponent = exports.InlineFormControlGroup = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(114);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 04.05.2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var wrapWithInlineFormComponent = function wrapWithInlineFormComponent(FormComponent, ViewComponent) {
	  var WrapWithInlineFormComponent = function (_React$Component) {
	    _inherits(WrapWithInlineFormComponent, _React$Component);
	
	    function WrapWithInlineFormComponent(props) {
	      _classCallCheck(this, WrapWithInlineFormComponent);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.state = {
	        isEdit: props.initialIsEdit || false,
	        isEditable: props.startEdit !== undefined
	      };
	      _this.editElement = undefined;
	      _this.startEdit = _this.startEdit.bind(_this);
	      _this.stopEdit = _this.stopEdit.bind(_this);
	      _this.submit = _this.submit.bind(_this);
	      return _this;
	    }
	
	    WrapWithInlineFormComponent.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (this.props.isSaving && this.props.formValid && !nextProps.isSaving && this.state.isEdit && !this.props.disableCloseOnSuccessfullSubmit === true) {
	        //submit successful
	        this.setState({ isEdit: false });
	      }
	    };
	
	    WrapWithInlineFormComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	      if (this.state.isEdit && !prevState.isEdit && this.focusInput) {
	        // eslint-disable-next-line react/no-find-dom-node
	        _reactDom2.default.findDOMNode(this.focusInput).focus(); //C.Bühler: findDOMNode is not deprecated. ReactBootstrap-FormComponents does not support focus as function.
	      }
	    };
	
	    WrapWithInlineFormComponent.prototype.stopEdit = function stopEdit() {
	      var _this2 = this;
	
	      this.setState({ isEdit: false }, function () {
	        return _this2.props.cancel && _this2.props.cancel();
	      });
	    };
	
	    WrapWithInlineFormComponent.prototype.startEdit = function startEdit() {
	      if (this.props.formValid) {
	        this.setState({ isEdit: true });
	        this.props.startEdit && this.props.startEdit();
	      }
	    };
	
	    WrapWithInlineFormComponent.prototype.submit = function submit() {
	      var _this3 = this;
	
	      if (this.props.formValid) {
	        this.setState({ isEdit: false }, function () {
	          return _this3.props.submit && _this3.props.submit();
	        });
	      }
	    };
	
	    WrapWithInlineFormComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.props.cancel && this.props.cancel();
	    };
	
	    WrapWithInlineFormComponent.prototype.render = function render() {
	      var _this4 = this;
	
	      return this.state.isEdit ? _react2.default.createElement(FormComponent, _extends({}, this.props, {
	        stopEdit: this.stopEdit,
	        focusRef: function focusRef(el) {
	          return _this4.focusInput = el;
	        },
	        submit: this.submit
	      })) : _react2.default.createElement(ViewComponent, _extends({}, this.props, {
	        startEdit: this.startEdit,
	        isEditable: this.state.isEditable
	      }));
	    };
	
	    return WrapWithInlineFormComponent;
	  }(_react2.default.Component);
	
	  WrapWithInlineFormComponent.displayName = 'WrapWithInlineFormComponent(' + getDisplayName(FormComponent) + ')';
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return WrapWithInlineFormComponent;
	};
	
	/*
	InlineFormControl.propTypes = {
	    children: PropTypes.func.isRequired,
	    onChange: PropTypes.func.isRequired,
	
	    startEdit: PropTypes.func,
	    cancel: PropTypes.func,
	    value: PropTypes.node,
	    initialIsEdit: PropTypes.bool,
	    hideSaveButton: PropTypes.bool,
	    hideCancelButton: PropTypes.bool,
	    isEditing: PropTypes.bool
	};
	*/
	
	var InlineFormControlGroup = function InlineFormControlGroup(props) {
	  var controlLabel = props.controlLabel,
	      propName = props.propName,
	      item = props.item,
	      isSaving = props.isSaving,
	      isEdited = props.isEdited,
	      onChange = props.onChange,
	      stopEdit = props.stopEdit,
	      startEdit = props.startEdit,
	      focusRef = props.focusRef,
	      cancel = props.cancel,
	      submit = props.submit,
	      reset = props.reset,
	      formError = props.formError,
	      formValidation = props.formValidation,
	      formValid = props.formValid,
	      children = props.children,
	      _props$hideSaveButton = props.hideSaveButton,
	      hideSaveButton = _props$hideSaveButton === undefined ? false : _props$hideSaveButton,
	      _props$hideCancelButt = props.hideCancelButton,
	      hideCancelButton = _props$hideCancelButt === undefined ? false : _props$hideCancelButt,
	      otherProps = _objectWithoutProperties(props, ['controlLabel', 'propName', 'item', 'isSaving', 'isEdited', 'onChange', 'stopEdit', 'startEdit', 'focusRef', 'cancel', 'submit', 'reset', 'formError', 'formValidation', 'formValid', 'children', 'hideSaveButton', 'hideCancelButton']);
	
	  var value = props.value || item[propName];
	
	  var propError = formValidation[propName];
	
	  var validateProps = formValidation ? { validationState: propError ? 'error' : null } : {};
	
	  var onKeyDown = function onKeyDown(e) {
	    if (e.keyCode === 27) {
	      stopEdit();
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  };
	
	  return _react2.default.createElement(
	    _reactBootstrap.FormGroup,
	    validateProps,
	    _react2.default.createElement(
	      _reactBootstrap.InputGroup,
	      null,
	      controlLabel && _react2.default.createElement(
	        _reactBootstrap.FormLabel,
	        null,
	        controlLabel
	      ),
	      _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, otherProps, {
	        ref: focusRef,
	        value: value,
	        onChange: onChange,
	        onKeyDown: onKeyDown,
	        submit: submit,
	        cancel: cancel,
	        reset: reset
	      })),
	      _react2.default.createElement(
	        _reactBootstrap.InputGroup.Append,
	        null,
	        hideSaveButton !== true && _react2.default.createElement(
	          InlineControlBtn,
	          { valid: formValid, onClick: submit },
	          'Speichern'
	        ),
	        hideCancelButton !== true && _react2.default.createElement(
	          InlineControlBtn,
	          { onClick: stopEdit },
	          'Abbrechen'
	        )
	      )
	    ),
	    formValidation && propError ? _react2.default.createElement(
	      _reactBootstrap.HelpBlock,
	      null,
	      propError
	    ) : null
	  );
	};
	
	// eslint-disable-next-line react/prop-types
	var InlineView = function InlineView(_ref) {
	  var value = _ref.value,
	      item = _ref.item,
	      propName = _ref.propName,
	      children = _ref.children,
	      startEdit = _ref.startEdit,
	      _ref$showEditIcon = _ref.showEditIcon,
	      showEditIcon = _ref$showEditIcon === undefined ? true : _ref$showEditIcon;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'd-flex align-items-center',
	      onClick: startEdit,
	      title: 'Klicken zum Editieren'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'w-100' },
	      children ? children(startEdit) : _react2.default.createElement(
	        'span',
	        null,
	        value || item[propName]
	      )
	    ),
	    showEditIcon && _react2.default.createElement(
	      'div',
	      { className: 'px-3 py-2 d-flex align-items-center' },
	      _react2.default.createElement('span', { className: 'icon icon-fliwas-pencil h3 m-0' })
	    )
	  );
	};
	
	// eslint-disable-next-line react/prop-types
	var InlineControlBtn = function InlineControlBtn(_ref2) {
	  var _ref2$valid = _ref2.valid,
	      valid = _ref2$valid === undefined ? true : _ref2$valid,
	      children = _ref2.children,
	      onClick = _ref2.onClick;
	
	  var options = !valid ? { disabled: 'disabled' } : {};
	
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    _extends({}, options, { variant: 'primary', onClick: onClick }),
	    children
	  );
	};
	InlineControlBtn.displayName = 'InlineControlBtn';
	
	exports.InlineFormControlGroup = InlineFormControlGroup = wrapWithInlineFormComponent(InlineFormControlGroup, InlineView);
	
	exports.InlineFormControlGroup = InlineFormControlGroup;
	exports.wrapWithInlineFormComponent = wrapWithInlineFormComponent;
	exports.InlineView = InlineView;

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_114__;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InlineFormControl = __webpack_require__(113);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _ItemDescription = __webpack_require__(71);
	
	var _ItemDescription2 = _interopRequireDefault(_ItemDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Created by Carsten Bühler
	                                                                                                                                                                                                                              * User: c.buehler on 04.05.2018
	                                                                                                                                                                                                                              * Copyright: xdot GmbH 2018
	                                                                                                                                                                                                                              */
	
	// eslint-disable-next-line react/prop-types
	var DescriptionDisplay = function DescriptionDisplay(_ref) {
	  var item = _ref.item,
	      formValid = _ref.formValid,
	      startEdit = _ref.startEdit,
	      rest = _objectWithoutProperties(_ref, ['item', 'formValid', 'startEdit']);
	
	  var i = _liferayWidgetsReactWeb.DataUtil.asItem(item);
	  return _react2.default.createElement(
	    _InlineFormControl.InlineView,
	    _extends({ startEdit: startEdit ? startEdit : undefined }, rest),
	    function () {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_ItemDescription2.default, { item: i })
	      );
	    }
	  );
	};
	
	// eslint-disable-next-line react/prop-types
	var DescriptionEdit = function DescriptionEdit(_ref2) {
	  var value = _ref2.value,
	      type = _ref2.type,
	      propName = _ref2.propName,
	      item = _ref2.item,
	      isSaving = _ref2.isSaving,
	      isEdited = _ref2.isEdited,
	      onChange = _ref2.onChange,
	      stopEdit = _ref2.stopEdit,
	      startEdit = _ref2.startEdit,
	      cancel = _ref2.cancel,
	      submit = _ref2.submit,
	      reset = _ref2.reset,
	      formError = _ref2.formError,
	      formValidation = _ref2.formValidation,
	      formValid = _ref2.formValid,
	      children = _ref2.children,
	      formData = _ref2.formData,
	      otherProps = _objectWithoutProperties(_ref2, ['value', 'type', 'propName', 'item', 'isSaving', 'isEdited', 'onChange', 'stopEdit', 'startEdit', 'cancel', 'submit', 'reset', 'formError', 'formValidation', 'formValid', 'children', 'formData']);
	
	  var validateProps = formValidation ? { validationState: formValidation[propName] ? 'error' : null } : {};
	
	  return _react2.default.createElement(
	    _reactBootstrap.FormGroup,
	    validateProps,
	    _react2.default.createElement(_liferayWidgetsReactWeb.WYSIWYGEditor, {
	      placeholder: 'Beschreibung',
	      value: formData.description,
	      onChange: onChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'button-box-v' },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { variant: 'primary', onClick: stopEdit },
	        'Abbrechen'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { variant: 'primary', onClick: submit },
	        'Speichern'
	      )
	    ),
	    formValidation && formValidation[propName] ? _react2.default.createElement(
	      _reactBootstrap.HelpBlock,
	      null,
	      formValidation[propName]
	    ) : null
	  );
	};
	
	var InlineDescriptionFormControl = (0, _InlineFormControl.wrapWithInlineFormComponent)(DescriptionEdit, DescriptionDisplay);
	
	exports.default = InlineDescriptionFormControl;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InlineFormControl = __webpack_require__(113);
	
	var _mapPortlet = __webpack_require__(25);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Created by Carsten Bühler
	                                                                                                                                                                                                                              * User: c.buehler on 04.05.2018
	                                                                                                                                                                                                                              * Copyright: xdot GmbH 2018
	                                                                                                                                                                                                                              */
	
	var MapConfigStore = (0, _mapPortlet.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext);
	
	// eslint-disable-next-line react/prop-types
	var PositionDisplay = function PositionDisplay(_ref) {
	    var dataItem = _ref.item,
	        isEditable = _ref.isEditable,
	        startEdit = _ref.startEdit;
	
	
	    var item = _liferayWidgetsReactWeb.DataUtil.asItem(dataItem);
	    var features = item && item.geometry ? (0, _mapPortlet.transformGeometryToFeatures)(dataItem) : [];
	
	    return _react2.default.createElement(
	        _InlineFormControl.InlineView,
	        { showEditIcon: false },
	        function () {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_mapPortlet.Map, {
	                    defaultFallbackMapConfigType: 'static',
	                    plugins: [_mapPortlet.FeatureDisplayPlugin],
	                    features: features,
	                    zoom: 12
	                }),
	                isEditable && _react2.default.createElement(
	                    'div',
	                    { className: 'button-box-v' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            variant: 'primary',
	                            onClick: startEdit
	                        },
	                        'Bearbeiten'
	                    )
	                )
	            );
	        }
	    );
	};
	
	// eslint-disable-next-line react/prop-types
	var PositionEdit = function PositionEdit(_ref2) {
	    var value = _ref2.value,
	        type = _ref2.type,
	        propName = _ref2.propName,
	        item = _ref2.item,
	        isSaving = _ref2.isSaving,
	        isEdited = _ref2.isEdited,
	        onChange = _ref2.onChange,
	        stopEdit = _ref2.stopEdit,
	        startEdit = _ref2.startEdit,
	        cancel = _ref2.cancel,
	        submit = _ref2.submit,
	        reset = _ref2.reset,
	        formError = _ref2.formError,
	        formValidation = _ref2.formValidation,
	        formValid = _ref2.formValid,
	        children = _ref2.children,
	        formData = _ref2.formData,
	        otherProps = _objectWithoutProperties(_ref2, ['value', 'type', 'propName', 'item', 'isSaving', 'isEdited', 'onChange', 'stopEdit', 'startEdit', 'cancel', 'submit', 'reset', 'formError', 'formValidation', 'formValid', 'children', 'formData']);
	
	    value = value || item[propName];
	    var validateProps = formValidation ? { validationState: formValidation[propName] ? 'error' : null } : {};
	
	    var defaultMapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(MapConfigStore.getDefaultMapConfig());
	
	    return _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        null,
	        _react2.default.createElement(_mapPortlet.GeometryInput, {
	            geometry: formData.geometry,
	            type: type,
	            handleGeometryChange: onChange,
	            drawOptions: {
	                circle: false,
	                circlemarker: false,
	                polyline: true,
	                polygon: true,
	                rectangle: true
	            },
	            allowMultipleGeometries: true,
	            layerDescriptions: defaultMapConfig && defaultMapConfig.children
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: 'button-box-v' },
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { variant: 'primary', onClick: stopEdit },
	                'Abbrechen'
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { variant: 'primary', onClick: submit },
	                'Speichern'
	            )
	        ),
	        formValidation && formValidation[propName] ? _react2.default.createElement(
	            _reactBootstrap.HelpBlock,
	            null,
	            formValidation[propName]
	        ) : null
	    );
	};
	
	var InlinePositionFormControl = (0, _InlineFormControl.wrapWithInlineFormComponent)(PositionEdit, PositionDisplay);
	
	exports.default = InlinePositionFormControl;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//external
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * List for the left-hand side master-detail-widget
	 * @param children
	 * @param searchFunc function
	 * @param createClick function
	 * @param refreshClick function
	 * @param searchValue Passed from state of parent component
	 */
	var FliwasObjectMasterDetailList = function FliwasObjectMasterDetailList(_ref) {
	    var children = _ref.children,
	        searchFunc = _ref.searchFunc,
	        createClick = _ref.createClick,
	        searchValue = _ref.searchValue,
	        refreshClick = _ref.refreshClick;
	
	
	    return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { lg: 3, md: 12, sm: 12, xs: 12, className: 'nopadding' },
	        _react2.default.createElement(
	            'div',
	            { className: 'padding-box' },
	            _react2.default.createElement(
	                'div',
	                { className: 'd-flex' },
	                createClick && _react2.default.createElement(
	                    'div',
	                    { className: 'margin-bottom' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { title: 'Erstellen',
	                            variant: 'primary',
	                            onClick: createClick },
	                        'Erstellen'
	                    )
	                ),
	                refreshClick && _react2.default.createElement(
	                    'div',
	                    { className: 'margin-bottom ml-1' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { title: 'Neu laden',
	                            variant: 'primary icon-small',
	                            onClick: refreshClick },
	                        _react2.default.createElement(_Icon2.default, { name: 'loader' })
	                    )
	                )
	            ),
	            searchFunc && _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                { controlId: 'formControlsFrbSearch' },
	                _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text',
	                    value: searchValue,
	                    placeholder: 'Nach Namen suchen',
	                    onChange: searchFunc })
	            ),
	            children
	        )
	    );
	};
	
	FliwasObjectMasterDetailList.propTypes = {
	    children: _propTypes2.default.object.isRequired,
	    createClick: _propTypes2.default.func,
	    searchFunc: _propTypes2.default.func,
	    searchValue: _propTypes2.default.string,
	    refreshClick: _propTypes2.default.func
	};
	
	exports.default = FliwasObjectMasterDetailList;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//external
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ObjectDates = __webpack_require__(50);
	
	var _ObjectDates2 = _interopRequireDefault(_ObjectDates);
	
	var _mapPortlet = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Position right column in master-detail view
	 * @param selectedItem
	 * @param selectedDataItem
	 */
	
	//base
	var FliwasObjectMasterDetailPosition = function FliwasObjectMasterDetailPosition(_ref) {
	    var selectedItem = _ref.selectedItem,
	        selectedDataItem = _ref.selectedDataItem;
	
	
	    return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { lg: 4, md: 4, sm: 12, xs: 12, className: 'nopadding' },
	        _react2.default.createElement(
	            'div',
	            { className: 'padding-box' },
	            _react2.default.createElement(
	                _liferayWidgetsReactWeb.FlagComponent,
	                { item: selectedItem },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Position'
	                ),
	                _react2.default.createElement(_mapPortlet.Map, {
	                    defaultFallbackMapConfigType: 'static',
	                    plugins: [_mapPortlet.FeatureDisplayPlugin, _mapPortlet.PrintPlugin],
	                    features: [selectedDataItem],
	                    zoom: 12
	                }),
	                _react2.default.createElement(_ObjectDates2.default, { dataItem: selectedItem })
	            )
	        )
	    );
	};
	//plugins
	
	
	//react web
	
	
	FliwasObjectMasterDetailPosition.propTypes = {
	    selectedItem: _propTypes2.default.object.isRequired,
	    selectedDataItem: _propTypes2.default.object.isRequired
	};
	
	exports.default = FliwasObjectMasterDetailPosition;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//external
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generic Errormessage to choose an object
	 * @param element
	 */
	var SelectObjectErrorMessage = function SelectObjectErrorMessage(_ref) {
	    var content = _ref.content;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'error-message' },
	        content
	    );
	};
	
	SelectObjectErrorMessage.propTypes = {
	    content: _propTypes2.default.string.isRequired
	};
	
	exports.default = SelectObjectErrorMessage;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _DetailsRenderer = __webpack_require__(59);
	
	var _ItemDescription = __webpack_require__(71);
	
	var _ItemDescription2 = _interopRequireDefault(_ItemDescription);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FliwasDetailsBox = function FliwasDetailsBox(_ref) {
	    var item = _ref.item,
	        propertyDescriptions = _ref.propertyDescriptions,
	        _ref$boxGridSize = _ref.boxGridSize,
	        boxGridSize = _ref$boxGridSize === undefined ? 4 : _ref$boxGridSize,
	        children = _ref.children;
	
	    item = item && (item.item || item);
	
	    if (!item) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'Kein Element gew\xE4hlt'
	        );
	    }
	
	    var elements = void 0;
	
	    var chunks = function chunks(arr, size) {
	        var result = [];
	
	        for (var i = 0; i < arr.length; i += size) {
	            result.push(arr.slice(i, size + i));
	        }
	
	        return result;
	    };
	
	    elements = _react2.default.Children.map(children, function (child) {
	        if (child !== null && child.props && child.props.elementType === _Constants.ElementTypes.PropertyBox) {
	            return child;
	        }
	    }) || [];
	
	    var reducer = function reducer(accumulator, currentValue, currentIndex) {
	        return accumulator.concat(_react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'border-box', key: currentIndex },
	            currentValue
	        ));
	    };
	
	    var rows = chunks(elements, 12 / boxGridSize);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        item && item.title && _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: item.title }),
	        item.description && item.description.length > 0 && _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'border-box' },
	            _react2.default.createElement(
	                _DetailsRenderer.PropertyBox,
	                { title: 'Beschreibung', boxGridSize: 12 },
	                _react2.default.createElement(_ItemDescription2.default, { item: item })
	            )
	        ),
	        rows.reduce(reducer, [])
	    );
	};
	
	FliwasDetailsBox.propTypes = {
	    item: _propTypes2.default.object,
	    propertyDescriptions: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    boxGridSize: _propTypes2.default.number
	};
	
	exports.default = FliwasDetailsBox;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FliwasActionButtons = function FliwasActionButtons(_ref) {
	    var _ref$classNames = _ref.classNames,
	        classNames = _ref$classNames === undefined ? '' : _ref$classNames,
	        _ref$pullRight = _ref.pullRight,
	        pullRight = _ref$pullRight === undefined ? true : _ref$pullRight,
	        _ref$dropup = _ref.dropup,
	        dropup = _ref$dropup === undefined ? false : _ref$dropup,
	        children = _ref.children;
	
	
	    var elems = _react2.default.Children.toArray(children);
	    var filteredChildren = elems.slice(1);
	    var onClick = elems[0].props.onClick || elems[0].props.onSelect;
	    var eventKey = elems[0].props.eventKey;
	
	    var title = elems[0].props.title;
	    return _react2.default.createElement(
	        _reactBootstrap.Dropdown,
	        {
	            className: classNames,
	            as: _reactBootstrap.ButtonGroup,
	            drop: dropup ? 'up' : 'down',
	            alignRight: pullRight
	        },
	        _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	                variant: 'primary',
	                onClick: eventKey ? onClick.bind(null, eventKey) : onClick
	            },
	            title
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Dropdown.Toggle,
	            {
	                split: true,
	                variant: 'primary',
	                id: 'dropdown-' + title
	            },
	            _react2.default.createElement('i', { className: 'fa fa-caret-down' })
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Dropdown.Menu,
	            null,
	            filteredChildren
	        )
	    );
	}; /**
	    * Created by Lasse Einfeldt
	    * User: LEinfeldt on 15.05.2018
	    * Copyright: xdot GmbH 2018
	    */
	
	FliwasActionButtons.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]),
	    pullRight: _propTypes2.default.bool,
	    dropup: _propTypes2.default.bool,
	    classNames: _propTypes2.default.string
	};
	
	exports.default = FliwasActionButtons;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 02.03.2021
	 * Copyright: xdot GmbH 2021
	 */
	
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _FliwasPermissionActions = __webpack_require__(32);
	
	var _FliwasPermissionActions2 = _interopRequireDefault(_FliwasPermissionActions);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Stores
	var FliwasPermissionStore = (0, _StoreFactory.getFliwasPermissionStore)(_liferayWidgetsReactWeb.AppContext);
	
	var JournalAddEntryButton = function (_React$Component) {
	    _inherits(JournalAddEntryButton, _React$Component);
	
	    function JournalAddEntryButton(props) {
	        _classCallCheck(this, JournalAddEntryButton);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = _extends({}, _this.state, {
	            dialogRemoveDocumentAssetLinkOpened: false,
	            searchValue: ''
	        });
	
	        _this.DATA = {
	            JOURNAL_CREATE_PERMISSION: _this.withCtx('JournalCreatePermission'),
	            USER_ROLES: _this.withCtx('UserRoles')
	        };
	        return _this;
	    }
	
	    JournalAddEntryButton.getStores = function getStores() {
	        return [FliwasPermissionStore];
	    };
	
	    JournalAddEntryButton.calculateState = function calculateState(prevState, undefined, DATA) {
	        return {
	            userRolesDataItem: FliwasPermissionStore.getRemoteData(DATA.USER_ROLES),
	            documentPermissionDataItem: FliwasPermissionStore.getRemoteData(DATA.JOURNAL_CREATE_PERMISSION)
	        };
	    };
	
	    JournalAddEntryButton.prototype.componentDidMount = function componentDidMount() {
	        _FliwasPermissionActions2.default.getPermissionState(this.DATA.JOURNAL_CREATE_PERMISSION, {
	            nameSpace: 'journal',
	            fliwasPermission: 'create'
	        });
	
	        _FliwasPermissionActions2.default.getUserRoles(this.DATA.USER_ROLES, {
	            userId: _liferayWidgetsReactWeb.AppContext.getUserId()
	        });
	    };
	
	    JournalAddEntryButton.prototype.render = function render() {
	        var _state = this.state,
	            userRolesDataItem = _state.userRolesDataItem,
	            documentPermissionDataItem = _state.documentPermissionDataItem;
	
	        var userRoles = _liferayWidgetsReactWeb.DataUtil.asObject(userRolesDataItem),
	            documentPermission = _liferayWidgetsReactWeb.DataUtil.asItem(documentPermissionDataItem),
	            isAdmin = _liferayWidgetsReactWeb.RoleUtil.isOrganizationAdmin(userRoles);
	
	        var hasPermission = documentPermission && documentPermission.state && documentPermission.state.toLowerCase() === 'set' || isAdmin;
	        if (hasPermission) {
	            return _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    className: 'mini-widget__journal_entry_button',
	                    variant: 'outline-primary',
	                    title: 'Journaleintrag erstellen',
	                    onClick: this.props.onClick,
	                    size: 'lg'
	                },
	                _react2.default.createElement(_Icon2.default, { name: 'journal_add' })
	            );
	        }
	
	        return null;
	    };
	
	    return JournalAddEntryButton;
	}(_react2.default.Component);
	
	JournalAddEntryButton.propTypes = {
	    onClick: _propTypes2.default.func
	};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(JournalAddEntryButton);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DefaultChangeRecordListItem = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimeLineItem = __webpack_require__(44);
	
	var _TimeLineItem2 = _interopRequireDefault(_TimeLineItem);
	
	var _DefaultTimeLineItemMessageHeader = __webpack_require__(124);
	
	var _DefaultChangeRecordTable = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultChangeRecordListItem = exports.DefaultChangeRecordListItem = function DefaultChangeRecordListItem(_ref) {
	    var changeRecord = _ref.changeRecord,
	        userMeta = _ref.userMeta,
	        children = _ref.children,
	        headerRenderer = _ref.headerRenderer;
	
	    var Header = headerRenderer || _DefaultTimeLineItemMessageHeader.DefaultTimeLineItemMessageHeader;
	
	    return _react2.default.createElement(
	        _TimeLineItem2.default,
	        { userMeta: userMeta, timestamp: changeRecord.timestamp },
	        _react2.default.createElement(Header, { changeRecord: changeRecord, userMeta: userMeta }),
	        _react2.default.createElement(
	            'div',
	            { className: 'my-3' },
	            children && _react2.default.createElement(
	                _DefaultChangeRecordTable.DefaultChangeRecordTable,
	                { changeRecord: changeRecord },
	                children
	            )
	        )
	    );
	}; /**
	    * User: n.gorte
	    * Date: 17.09.2020
	    * Time: 14:38
	    */
	
	DefaultChangeRecordListItem.propTypes = {
	    userMeta: _propTypes2.default.object,
	    changeRecord: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    headerRenderer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.node])
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DefaultTimeLineItemMessageHeader = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimeLineItemMessageHeader = __webpack_require__(45);
	
	var _TimeLineItemMessageHeader2 = _interopRequireDefault(_TimeLineItemMessageHeader);
	
	var _BusinessObjectLink = __webpack_require__(51);
	
	var _BusinessObjectLink2 = _interopRequireDefault(_BusinessObjectLink);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultTimeLineItemMessageHeader = exports.DefaultTimeLineItemMessageHeader = function DefaultTimeLineItemMessageHeader(_ref) {
	    var changeRecord = _ref.changeRecord;
	    var className = changeRecord.className,
	        classPK = changeRecord.classPK;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	
	    var classNameTranslation = _liferayWidgetsReactWeb.translation.trans(className);
	    return _react2.default.createElement(
	        _TimeLineItemMessageHeader2.default,
	        null,
	        _react2.default.createElement(
	            'strong',
	            null,
	            (eventType === _Constants.EVENT_TYPE_DELETE || eventType === _Constants.EVENT_TYPE_CREATE) && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                classNameTranslation + ' ',
	                _react2.default.createElement(_BusinessObjectLink2.default, { className: className, classPK: classPK }),
	                ' wurde ' + (eventType === _Constants.EVENT_TYPE_CREATE ? 'hinzugefügt' : 'gelöscht') + '.'
	            ),
	            eventType === _Constants.EVENT_TYPE_UPDATE && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                'Daten\xE4nderung f\xFCr ' + classNameTranslation + ' ',
	                _react2.default.createElement(_BusinessObjectLink2.default, { className: className, classPK: classPK })
	            )
	        )
	    );
	}; /**
	    * User: n.gorte
	    * Date: 17.09.2020
	    * Time: 14:50
	    */
	
	DefaultTimeLineItemMessageHeader.propTypes = {
	    changeRecord: _propTypes2.default.object
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getEventType = undefined;
	
	var _Constants = __webpack_require__(5);
	
	var getEventType = exports.getEventType = function getEventType(changeRecord) {
	    var eventType = changeRecord.eventType,
	        op = changeRecord.op;
	
	    var actionType = (eventType + op).toLowerCase();
	
	    if (actionType.indexOf('post') > -1 || actionType.indexOf('create') > -1) {
	        return _Constants.EVENT_TYPE_CREATE;
	    } else if (actionType.indexOf('delete') > -1) {
	        return _Constants.EVENT_TYPE_DELETE;
	    } else {
	        return _Constants.EVENT_TYPE_UPDATE;
	    }
	}; /**
	    * User: n.gorte
	    * Date: 18.09.2020
	    * Time: 09:16
	    */

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DefaultChangeRecordTable = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultChangeRecordTable = exports.DefaultChangeRecordTable = function DefaultChangeRecordTable(_ref) {
	    var changeRecord = _ref.changeRecord,
	        children = _ref.children;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	
	    return _react2.default.createElement(
	        _reactBootstrap.Table,
	        {
	            className: 'change-records-table',
	            responsive: true, bordered: true, size: 'sm'
	        },
	        _react2.default.createElement(
	            'thead',
	            { className: 'change-records-table__head' },
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: 'change-records-table__first-col' },
	                    'Eigenschaft'
	                ),
	                eventType === _Constants.EVENT_TYPE_UPDATE && _react2.default.createElement(
	                    'th',
	                    { className: 'change-records-table__old-value' },
	                    'Alt'
	                ),
	                eventType === _Constants.EVENT_TYPE_DELETE && _react2.default.createElement(
	                    'th',
	                    { className: 'change-records-table__old-value' },
	                    'Gel\xF6scht'
	                ),
	                eventType !== _Constants.EVENT_TYPE_DELETE && _react2.default.createElement(
	                    'th',
	                    { className: 'change-records-table__new-value' },
	                    eventType === _Constants.EVENT_TYPE_CREATE ? 'Erstellt' : 'Neu'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	}; /**
	    * User: n.gorte
	    * Date: 17.09.2020
	    * Time: 16:49
	    */
	
	DefaultChangeRecordTable.propTypes = {
	    changeRecord: _propTypes2.default.object
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChangeRecordTextRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	var _Constants = __webpack_require__(5);
	
	var _NamedProp = __webpack_require__(49);
	
	var _NamedProp2 = _interopRequireDefault(_NamedProp);
	
	var _TableElems = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultTextRenderer = function DefaultTextRenderer(_ref) {
	    var value = _ref.value;
	    return value || '---';
	}; /**
	    * User: n.gorte
	    * Date: 18.09.2020
	    * Time: 09:44
	    */
	
	var ChangeRecordTextRenderer = exports.ChangeRecordTextRenderer = function ChangeRecordTextRenderer(_ref2) {
	    var changeRecord = _ref2.changeRecord,
	        propName = _ref2.propName,
	        label = _ref2.label,
	        newValueRenderer = _ref2.newValueRenderer,
	        oldValueRenderer = _ref2.oldValueRenderer;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	    var changes = changeRecord.changes,
	        className = changeRecord.className;
	
	    var change = changes[propName];
	
	    if (!change) {
	        return null;
	    }
	
	    var oldValue = change.oldValue,
	        newValue = change.newValue;
	
	    if (propName.endsWith('Key')) {
	        var type = className + '.' + propName;
	        oldValue = _react2.default.createElement(_NamedProp2.default, { type: type, typeKey: oldValue });
	        newValue = _react2.default.createElement(_NamedProp2.default, { type: type, typeKey: newValue });
	    }
	
	    var OldValueRenderer = oldValueRenderer || DefaultTextRenderer;
	    var NewValueRenderer = newValueRenderer || DefaultTextRenderer;
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            _TableElems.PropertyTd,
	            null,
	            label || _liferayWidgetsReactWeb.translation.trans(propName)
	        ),
	        (eventType === _Constants.EVENT_TYPE_UPDATE || eventType === _Constants.EVENT_TYPE_DELETE) && _react2.default.createElement(
	            _TableElems.OldValueTd,
	            null,
	            _react2.default.createElement(OldValueRenderer, { value: oldValue })
	        ),
	        newValue && _react2.default.createElement(
	            _TableElems.NewValueTd,
	            null,
	            _react2.default.createElement(NewValueRenderer, { value: newValue })
	        )
	    );
	};
	
	ChangeRecordTextRenderer.propTypes = {
	    changeRecord: _propTypes2.default.object,
	    propName: _propTypes2.default.string,
	    label: _propTypes2.default.string,
	    newValueRenderer: _propTypes2.default.func,
	    oldValueRenderer: _propTypes2.default.func
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChangeRecordDateRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	var _Constants = __webpack_require__(5);
	
	var _TableElems = __webpack_require__(22);
	
	var _dateFormat = __webpack_require__(37);
	
	var DateFormat = _interopRequireWildcard(_dateFormat);
	
	var _DateTimeDisplay = __webpack_require__(36);
	
	var _DateTimeDisplay2 = _interopRequireDefault(_DateTimeDisplay);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User: n.gorte
	 * Date: 18.09.2020
	 * Time: 09:44
	 */
	
	var ChangeRecordDateRenderer = exports.ChangeRecordDateRenderer = function ChangeRecordDateRenderer(_ref) {
	    var changeRecord = _ref.changeRecord,
	        propName = _ref.propName,
	        label = _ref.label;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	    var changes = changeRecord.changes;
	
	    var change = changes[propName];
	
	    if (!change) {
	        return null;
	    }
	
	    var oldValue = change.oldValue,
	        newValue = change.newValue;
	
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            _TableElems.PropertyTd,
	            null,
	            label || _liferayWidgetsReactWeb.translation.trans(propName)
	        ),
	        (eventType === _Constants.EVENT_TYPE_UPDATE || eventType === _Constants.EVENT_TYPE_DELETE) && _react2.default.createElement(
	            _TableElems.OldValueTd,
	            null,
	            _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: oldValue, dateFormat: DateFormat.formatDateTimeNoSeconds }),
	            ' Uhr'
	        ),
	        newValue && _react2.default.createElement(
	            _TableElems.NewValueTd,
	            null,
	            _react2.default.createElement(_DateTimeDisplay2.default, { timestamp: newValue, dateFormat: DateFormat.formatDateTimeNoSeconds }),
	            ' Uhr'
	        )
	    );
	};
	
	ChangeRecordDateRenderer.propTypes = {
	    changeRecord: _propTypes2.default.object,
	    propName: _propTypes2.default.string,
	    label: _propTypes2.default.string
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChangeRecordBooleanRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	var _Constants = __webpack_require__(5);
	
	var _TableElems = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User: n.gorte
	 * Date: 18.09.2020
	 * Time: 09:44
	 */
	
	var ChangeRecordBooleanRenderer = exports.ChangeRecordBooleanRenderer = function ChangeRecordBooleanRenderer(_ref) {
	    var changeRecord = _ref.changeRecord,
	        propName = _ref.propName;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	    var changes = changeRecord.changes;
	
	    var change = changes[propName];
	
	    if (!change) {
	        return null;
	    }
	
	    var oldValue = change.oldValue,
	        newValue = change.newValue;
	
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            _TableElems.PropertyTd,
	            null,
	            _liferayWidgetsReactWeb.translation.trans(propName)
	        ),
	        eventType === _Constants.EVENT_TYPE_UPDATE && _react2.default.createElement(
	            _TableElems.OldValueTd,
	            null,
	            typeof oldValue === 'boolean' && _liferayWidgetsReactWeb.translation.trans(oldValue) || '---'
	        ),
	        _react2.default.createElement(
	            _TableElems.NewValueTd,
	            null,
	            typeof newValue === 'boolean' && _liferayWidgetsReactWeb.translation.trans(newValue) || '---'
	        )
	    );
	};
	
	ChangeRecordBooleanRenderer.propTypes = {
	    changeRecord: _propTypes2.default.object,
	    propName: _propTypes2.default.string
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChangeRecordDescriptionRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	var _Constants = __webpack_require__(5);
	
	var _HtmlTextRenderer = __webpack_require__(131);
	
	var _TableElems = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_PROPNAME = 'description'; /**
	                                       * User: n.gorte
	                                       * Date: 18.09.2020
	                                       * Time: 09:44
	                                       */
	
	var ChangeRecordDescriptionRenderer = exports.ChangeRecordDescriptionRenderer = function ChangeRecordDescriptionRenderer(_ref) {
	    var _ref$propName = _ref.propName,
	        propName = _ref$propName === undefined ? DEFAULT_PROPNAME : _ref$propName,
	        changeRecord = _ref.changeRecord;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	    var changes = changeRecord.changes;
	
	    var change = changes[propName];
	    if (!change) {
	        return null;
	    }
	
	    var oldValue = change.oldValue,
	        newValue = change.newValue;
	
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            _TableElems.PropertyTd,
	            null,
	            _liferayWidgetsReactWeb.translation.trans(propName)
	        ),
	        eventType === _Constants.EVENT_TYPE_UPDATE && _react2.default.createElement(
	            _TableElems.OldValueTd,
	            null,
	            _react2.default.createElement(_HtmlTextRenderer.HtmlTextRenderer, { text: oldValue })
	        ),
	        _react2.default.createElement(
	            _TableElems.NewValueTd,
	            null,
	            _react2.default.createElement(_HtmlTextRenderer.HtmlTextRenderer, { text: newValue })
	        )
	    );
	};
	
	ChangeRecordDescriptionRenderer.propTypes = {
	    changeRecord: _propTypes2.default.object,
	    propName: _propTypes2.default.string
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HtmlTextRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HtmlTextRenderer = exports.HtmlTextRenderer = function HtmlTextRenderer(_ref) {
	    var text = _ref.text;
	
	
	    if (text === '<p><br></p>') {
	        text = undefined;
	    }
	
	    return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: text || '---' } });
	}; /**
	    * User: n.gorte
	    * Date: 06.11.2020
	    * Time: 12:30
	    */

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChangeRecordGeometryRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	var _Constants = __webpack_require__(5);
	
	var _TableElems = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User: n.gorte
	 * Date: 18.09.2020
	 * Time: 09:44
	 */
	
	var DEFAULT_PROPNAME = 'geometry';
	
	var GeometryValue = function GeometryValue(props) {
	    if (props.preview) {
	        return _react2.default.createElement('img', { src: props.preview, style: { height: '256px' }, loading: 'lazy' });
	    } else {
	        var value = props.value;
	
	        value = typeof value === 'string' ? JSON.parse(value) : value;
	        return value ? _liferayWidgetsReactWeb.translation.trans(value.type) : '---';
	    }
	};
	
	var ChangeRecordGeometryRenderer = exports.ChangeRecordGeometryRenderer = function ChangeRecordGeometryRenderer(_ref) {
	    var _ref$propName = _ref.propName,
	        propName = _ref$propName === undefined ? DEFAULT_PROPNAME : _ref$propName,
	        changeRecord = _ref.changeRecord;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	    var changes = changeRecord.changes;
	
	    var change = changes[propName];
	
	    if (!change) {
	        return null;
	    }
	
	    var oldValue = change.oldValue,
	        newValue = change.newValue,
	        oldValue_PREVIEW = change.oldValue_PREVIEW,
	        newValue_PREVIEW = change.newValue_PREVIEW;
	
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            _TableElems.PropertyTd,
	            null,
	            _liferayWidgetsReactWeb.translation.trans(propName)
	        ),
	        eventType === _Constants.EVENT_TYPE_UPDATE && _react2.default.createElement(
	            _TableElems.OldValueTd,
	            null,
	            _react2.default.createElement(GeometryValue, { preview: oldValue_PREVIEW, value: oldValue })
	        ),
	        _react2.default.createElement(
	            _TableElems.NewValueTd,
	            null,
	            _react2.default.createElement(GeometryValue, { preview: newValue_PREVIEW, value: newValue })
	        )
	    );
	};
	
	ChangeRecordGeometryRenderer.propTypes = {
	    changeRecord: _propTypes2.default.object,
	    propName: _propTypes2.default.string
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChangeRecordBusinessObjectRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	var _Constants = __webpack_require__(5);
	
	var _BusinessObjectLink = __webpack_require__(51);
	
	var _BusinessObjectLink2 = _interopRequireDefault(_BusinessObjectLink);
	
	var _TableElems = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangeRecordBusinessObjectRenderer = exports.ChangeRecordBusinessObjectRenderer = function ChangeRecordBusinessObjectRenderer(_ref) {
	    var propName = _ref.propName,
	        changeRecord = _ref.changeRecord,
	        className = _ref.className;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	    var changes = changeRecord.changes;
	
	    var change = changes[propName];
	
	    if (!change) {
	        return null;
	    }
	
	    var oldValue = change.oldValue,
	        newValue = change.newValue;
	
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            _TableElems.PropertyTd,
	            null,
	            _liferayWidgetsReactWeb.translation.trans(propName)
	        ),
	        eventType === _Constants.EVENT_TYPE_UPDATE && _react2.default.createElement(
	            _TableElems.OldValueTd,
	            null,
	            Number.isInteger(oldValue) && oldValue > 0 && _react2.default.createElement(_BusinessObjectLink2.default, {
	                className: className,
	                classPK: oldValue
	            }),
	            (!Number.isInteger(oldValue) || oldValue === 0) && '---'
	        ),
	        _react2.default.createElement(
	            _TableElems.NewValueTd,
	            null,
	            _react2.default.createElement(_BusinessObjectLink2.default, {
	                className: className,
	                classPK: newValue
	            })
	        )
	    );
	}; /**
	    * User: n.gorte
	    * Date: 18.09.2020
	    * Time: 09:44
	    */
	
	ChangeRecordBusinessObjectRenderer.propTypes = {
	    propName: _propTypes2.default.string,
	    changeRecord: _propTypes2.default.object,
	    className: _propTypes2.default.string
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChangeRecordSiteTeamRenderer = undefined;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _TableElems = __webpack_require__(22);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _TitleActions = __webpack_require__(52);
	
	var _TitleActions2 = _interopRequireDefault(_TitleActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User: v.nazarova
	 * Date: 13.02.2025
	 */
	
	var TitleStore = (0, _StoreFactory.getTitleStore)(_liferayWidgetsReactWeb.AppContext);
	// import { getEventType } from '../../utils/event-type-util';
	
	
	var SiteTeamRenderer = function SiteTeamRenderer(teamId) {
	    var _useState = (0, _react.useState)(),
	        team = _useState[0],
	        setTeam = _useState[1];
	
	    var titleKey = 'Team-' + teamId;
	
	    if (!teamId) {
	        return '---';
	    }
	
	    var requestTitle = function requestTitle() {
	        _TitleActions2.default.missingTitles([titleKey]);
	    };
	
	    (0, _react.useEffect)(function () {
	        var titleKey = 'Team-' + teamId;
	        var subscription = TitleStore.addListener(function () {
	            setTeam(TitleStore.getTitleFromKey(titleKey));
	        });
	
	        if (!team) {
	            requestTitle();
	        }
	
	        return function () {
	            if (subscription) {
	                subscription.remove();
	            }
	        };
	    }, [teamId]);
	
	    return team;
	};
	
	var DEFAULT_PROPNAME = 'teamId';
	var DEFAULT_LABEL = 'Team';
	var DefaultTextRenderer = function DefaultTextRenderer(_ref) {
	    var value = _ref.value;
	    return value || '---';
	};
	
	var ChangeRecordSiteTeamRenderer = exports.ChangeRecordSiteTeamRenderer = function ChangeRecordSiteTeamRenderer(_ref2) {
	    var changeRecord = _ref2.changeRecord,
	        _ref2$propName = _ref2.propName,
	        propName = _ref2$propName === undefined ? DEFAULT_PROPNAME : _ref2$propName,
	        _ref2$label = _ref2.label,
	        label = _ref2$label === undefined ? DEFAULT_LABEL : _ref2$label;
	    var changes = changeRecord.changes;
	
	    var change = changes[propName];
	
	    if (!change) {
	        return null;
	    }
	
	    var oldValue = change.oldValue,
	        newValue = change.newValue;
	
	    var teamOld = SiteTeamRenderer(oldValue);
	    var teamNew = SiteTeamRenderer(newValue);
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            _TableElems.PropertyTd,
	            null,
	            label || _liferayWidgetsReactWeb.translation.trans(propName)
	        ),
	        _react2.default.createElement(
	            _TableElems.OldValueTd,
	            null,
	            _react2.default.createElement(DefaultTextRenderer, { value: teamOld })
	        ),
	        _react2.default.createElement(
	            _TableElems.NewValueTd,
	            null,
	            _react2.default.createElement(DefaultTextRenderer, { value: teamNew })
	        )
	    );
	};
	
	ChangeRecordSiteTeamRenderer.propTypes = {
	    changeRecord: _propTypes2.default.object,
	    propName: _propTypes2.default.string,
	    label: _propTypes2.default.string
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Item = Item;
	exports.Accordion = Accordion;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAccessibleAccordion = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Item(_ref) {
	  var title = _ref.title,
	      children = _ref.children,
	      uuid = _ref.uuid;
	
	  return _react2.default.createElement(
	    _reactAccessibleAccordion.AccordionItem,
	    { uuid: uuid },
	    _react2.default.createElement(
	      _reactAccessibleAccordion.AccordionItemHeading,
	      null,
	      _react2.default.createElement(
	        _reactAccessibleAccordion.AccordionItemButton,
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      _reactAccessibleAccordion.AccordionItemPanel,
	      null,
	      children
	    )
	  );
	}
	
	Item.propTypes = {
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  uuid: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	function Accordion(_ref2) {
	  var _ref2$allowMultipleEx = _ref2.allowMultipleExpanded,
	      allowMultipleExpanded = _ref2$allowMultipleEx === undefined ? true : _ref2$allowMultipleEx,
	      _ref2$allowZeroExpand = _ref2.allowZeroExpanded,
	      allowZeroExpanded = _ref2$allowZeroExpand === undefined ? true : _ref2$allowZeroExpand,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? '' : _ref2$className,
	      children = _ref2.children,
	      preExpanded = _ref2.preExpanded;
	
	  return _react2.default.createElement(
	    _reactAccessibleAccordion.Accordion,
	    {
	      className: 'fliwas-accordion ' + className,
	      allowMultipleExpanded: allowMultipleExpanded,
	      allowZeroExpanded: allowZeroExpanded,
	      preExpanded: preExpanded
	    },
	    children
	  );
	}
	
	Accordion.Item = Item;
	Accordion.ItemState = _reactAccessibleAccordion.AccordionItemState;
	
	Accordion.propTypes = {
	  allowMultipleExpanded: _propTypes2.default.bool,
	  allowZeroExpanded: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  preExpanded: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(81)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
	  (global = global || self, factory(global.reactAccessibleAccordion = {}, global.React));
	}(this, (function (exports, React) { 'use strict';
	
	  function ownKeys(object, enumerableOnly) {
	    var keys = Object.keys(object);
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(object);
	      enumerableOnly && (symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      })), keys.push.apply(keys, symbols);
	    }
	
	    return keys;
	  }
	
	  function _objectSpread2(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = null != arguments[i] ? arguments[i] : {};
	      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    Object.defineProperty(Constructor, "prototype", {
	      writable: false
	    });
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    Object.defineProperty(subClass, "prototype", {
	      writable: false
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _isNativeReflectConstruct() {
	    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	    if (Reflect.construct.sham) return false;
	    if (typeof Proxy === "function") return true;
	
	    try {
	      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    } else if (call !== void 0) {
	      throw new TypeError("Derived constructors may only return object or undefined");
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _createSuper(Derived) {
	    var hasNativeReflectConstruct = _isNativeReflectConstruct();
	
	    return function _createSuperInternal() {
	      var Super = _getPrototypeOf(Derived),
	          result;
	
	      if (hasNativeReflectConstruct) {
	        var NewTarget = _getPrototypeOf(this).constructor;
	
	        result = Reflect.construct(Super, arguments, NewTarget);
	      } else {
	        result = Super.apply(this, arguments);
	      }
	
	      return _possibleConstructorReturn(this, result);
	    };
	  }
	
	  function _slicedToArray(arr, i) {
	    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	  }
	
	  function _arrayWithHoles(arr) {
	    if (Array.isArray(arr)) return arr;
	  }
	
	  function _iterableToArray(iter) {
	    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	  }
	
	  function _iterableToArrayLimit(arr, i) {
	    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	
	    if (_i == null) return;
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	
	    var _s, _e;
	
	    try {
	      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"] != null) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(o);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	  }
	
	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;
	
	    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	
	  function _nonIterableRest() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	
	  var AccordionStore = /*#__PURE__*/_createClass(function AccordionStore(_ref) {
	    var _this = this;
	
	    var _ref$expanded = _ref.expanded,
	        _expanded = _ref$expanded === void 0 ? [] : _ref$expanded,
	        _ref$allowMultipleExp = _ref.allowMultipleExpanded,
	        allowMultipleExpanded = _ref$allowMultipleExp === void 0 ? false : _ref$allowMultipleExp,
	        _ref$allowZeroExpande = _ref.allowZeroExpanded,
	        allowZeroExpanded = _ref$allowZeroExpande === void 0 ? false : _ref$allowZeroExpande;
	
	    _classCallCheck(this, AccordionStore);
	
	    _defineProperty(this, "expanded", void 0);
	
	    _defineProperty(this, "allowMultipleExpanded", void 0);
	
	    _defineProperty(this, "allowZeroExpanded", void 0);
	
	    _defineProperty(this, "toggleExpanded", function (uuid) {
	      if (_this.isItemDisabled(uuid)) {
	        return _this;
	      }
	
	      var isExpanded = _this.isItemExpanded(uuid);
	
	      if (!isExpanded) {
	        return _this.augment({
	          expanded: _this.allowMultipleExpanded ? [].concat(_toConsumableArray(_this.expanded), [uuid]) : [uuid]
	        });
	      } else {
	        return _this.augment({
	          expanded: _this.expanded.filter(function (expandedUuid) {
	            return expandedUuid !== uuid;
	          })
	        });
	      }
	    });
	
	    _defineProperty(this, "isItemDisabled", function (uuid) {
	      var isExpanded = _this.isItemExpanded(uuid);
	
	      var isOnlyOneExpanded = _this.expanded.length === 1;
	      return Boolean(isExpanded && !_this.allowZeroExpanded && isOnlyOneExpanded);
	    });
	
	    _defineProperty(this, "isItemExpanded", function (uuid) {
	      return _this.expanded.indexOf(uuid) !== -1;
	    });
	
	    _defineProperty(this, "getPanelAttributes", function (uuid, dangerouslySetExpanded) {
	      var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : _this.isItemExpanded(uuid);
	      return {
	        role: _this.allowMultipleExpanded ? undefined : 'region',
	        'aria-hidden': _this.allowMultipleExpanded ? !expanded : undefined,
	        'aria-labelledby': _this.getButtonId(uuid),
	        id: _this.getPanelId(uuid),
	        hidden: expanded ? undefined : true
	      };
	    });
	
	    _defineProperty(this, "getHeadingAttributes", function () {
	      return {
	        role: 'heading'
	      };
	    });
	
	    _defineProperty(this, "getButtonAttributes", function (uuid, dangerouslySetExpanded) {
	      var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : _this.isItemExpanded(uuid);
	
	      var disabled = _this.isItemDisabled(uuid);
	
	      return {
	        id: _this.getButtonId(uuid),
	        'aria-disabled': disabled,
	        'aria-expanded': expanded,
	        'aria-controls': _this.getPanelId(uuid),
	        role: 'button',
	        tabIndex: 0
	      };
	    });
	
	    _defineProperty(this, "getPanelId", function (id) {
	      return "accordion__panel-".concat(id);
	    });
	
	    _defineProperty(this, "getButtonId", function (id) {
	      return "accordion__heading-".concat(id);
	    });
	
	    _defineProperty(this, "augment", function (args) {
	      return new AccordionStore(_objectSpread2({
	        expanded: _this.expanded,
	        allowMultipleExpanded: _this.allowMultipleExpanded,
	        allowZeroExpanded: _this.allowZeroExpanded
	      }, args));
	    });
	
	    this.expanded = _expanded;
	    this.allowMultipleExpanded = allowMultipleExpanded;
	    this.allowZeroExpanded = allowZeroExpanded;
	  });
	
	  var Context = /*#__PURE__*/React.createContext(null);
	  var Provider = /*#__PURE__*/function (_React$PureComponent) {
	    _inherits(Provider, _React$PureComponent);
	
	    var _super = _createSuper(Provider);
	
	    function Provider() {
	      var _this;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _super.call.apply(_super, [this].concat(args));
	
	      _defineProperty(_assertThisInitialized(_this), "state", new AccordionStore({
	        expanded: _this.props.preExpanded,
	        allowMultipleExpanded: _this.props.allowMultipleExpanded,
	        allowZeroExpanded: _this.props.allowZeroExpanded
	      }));
	
	      _defineProperty(_assertThisInitialized(_this), "toggleExpanded", function (key) {
	        _this.setState(function (state) {
	          return state.toggleExpanded(key);
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(_this.state.expanded);
	          }
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "isItemDisabled", function (key) {
	        return _this.state.isItemDisabled(key);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "isItemExpanded", function (key) {
	        return _this.state.isItemExpanded(key);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getPanelAttributes", function (key, dangerouslySetExpanded) {
	        return _this.state.getPanelAttributes(key, dangerouslySetExpanded);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getHeadingAttributes", function () {
	        // uuid: UUID
	        return _this.state.getHeadingAttributes();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getButtonAttributes", function (key, dangerouslySetExpanded) {
	        return _this.state.getButtonAttributes(key, dangerouslySetExpanded);
	      });
	
	      return _this;
	    }
	
	    _createClass(Provider, [{
	      key: "render",
	      value: function render() {
	        var _this$state = this.state,
	            allowZeroExpanded = _this$state.allowZeroExpanded,
	            allowMultipleExpanded = _this$state.allowMultipleExpanded;
	        return /*#__PURE__*/React.createElement(Context.Provider, {
	          value: {
	            allowMultipleExpanded: allowMultipleExpanded,
	            allowZeroExpanded: allowZeroExpanded,
	            toggleExpanded: this.toggleExpanded,
	            isItemDisabled: this.isItemDisabled,
	            isItemExpanded: this.isItemExpanded,
	            getPanelAttributes: this.getPanelAttributes,
	            getHeadingAttributes: this.getHeadingAttributes,
	            getButtonAttributes: this.getButtonAttributes
	          }
	        }, this.props.children || null);
	      }
	    }]);
	
	    return Provider;
	  }(React.PureComponent);
	
	  _defineProperty(Provider, "defaultProps", {
	    allowMultipleExpanded: false,
	    allowZeroExpanded: false
	  });
	
	  var Consumer = /*#__PURE__*/function (_React$PureComponent2) {
	    _inherits(Consumer, _React$PureComponent2);
	
	    var _super2 = _createSuper(Consumer);
	
	    function Consumer() {
	      var _this2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _this2 = _super2.call.apply(_super2, [this].concat(args));
	
	      _defineProperty(_assertThisInitialized(_this2), "renderChildren", function (container) {
	        return container ? _this2.props.children(container) : null;
	      });
	
	      return _this2;
	    }
	
	    _createClass(Consumer, [{
	      key: "render",
	      value: function render() {
	        return /*#__PURE__*/React.createElement(Context.Consumer, null, this.renderChildren);
	      }
	    }]);
	
	    return Consumer;
	  }(React.PureComponent);
	
	  var _excluded = ["className", "allowMultipleExpanded", "allowZeroExpanded", "onChange", "preExpanded"];
	
	  var Accordion = function Accordion(_ref) {
	    var _ref$className = _ref.className,
	        className = _ref$className === void 0 ? 'accordion' : _ref$className,
	        allowMultipleExpanded = _ref.allowMultipleExpanded,
	        allowZeroExpanded = _ref.allowZeroExpanded,
	        onChange = _ref.onChange,
	        preExpanded = _ref.preExpanded,
	        rest = _objectWithoutProperties(_ref, _excluded);
	
	    return /*#__PURE__*/React.createElement(Provider, {
	      preExpanded: preExpanded,
	      allowMultipleExpanded: allowMultipleExpanded,
	      allowZeroExpanded: allowZeroExpanded,
	      onChange: onChange
	    }, /*#__PURE__*/React.createElement("div", _extends({
	      "data-accordion-component": "Accordion",
	      className: className
	    }, rest)));
	  };
	
	  var DisplayName;
	
	  (function (DisplayName) {
	    DisplayName["Accordion"] = "Accordion";
	    DisplayName["AccordionItem"] = "AccordionItem";
	    DisplayName["AccordionItemButton"] = "AccordionItemButton";
	    DisplayName["AccordionItemHeading"] = "AccordionItemHeading";
	    DisplayName["AccordionItemPanel"] = "AccordionItemPanel";
	  })(DisplayName || (DisplayName = {}));
	
	  var DisplayName$1 = DisplayName;
	
	  // @ts-ignore
	  var DEFAULT = 0;
	  var counter = 0;
	  function useGlobalCounterId() {
	    var current = counter;
	    counter = counter + 1;
	    return "raa-".concat(current);
	  }
	  function resetGlobalCounterId() {
	    counter = DEFAULT;
	  }
	  var useNextId = React.useId || useGlobalCounterId; // HTML5 ids allow all unicode characters, except for ASCII whitespaces
	  // https://infra.spec.whatwg.org/#ascii-whitespace
	  // eslint-disable-next-line no-control-regex
	
	  var idRegex = /[\u0009\u000a\u000c\u000d\u0020]/g;
	  function assertValidHtmlId(htmlId) {
	    if (htmlId === '' || idRegex.test(htmlId)) {
	      console.error("uuid must be a valid HTML5 id but was given \"".concat(htmlId, "\", ASCII whitespaces are forbidden"));
	      return false;
	    }
	
	    return true;
	  }
	
	  var Context$1 = /*#__PURE__*/React.createContext(null);
	
	  var Provider$1 = function Provider(_ref) {
	    var children = _ref.children,
	        uuid = _ref.uuid,
	        accordionContext = _ref.accordionContext,
	        dangerouslySetExpanded = _ref.dangerouslySetExpanded;
	
	    var toggleExpanded = function toggleExpanded() {
	      accordionContext.toggleExpanded(uuid);
	    };
	
	    var renderChildren = function renderChildren(accordionContext) {
	      var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : accordionContext.isItemExpanded(uuid);
	      var disabled = accordionContext.isItemDisabled(uuid);
	      var panelAttributes = accordionContext.getPanelAttributes(uuid, dangerouslySetExpanded);
	      var headingAttributes = accordionContext.getHeadingAttributes(uuid);
	      var buttonAttributes = accordionContext.getButtonAttributes(uuid, dangerouslySetExpanded);
	      return /*#__PURE__*/React.createElement(Context$1.Provider, {
	        value: {
	          uuid: uuid,
	          expanded: expanded,
	          disabled: disabled,
	          toggleExpanded: toggleExpanded,
	          panelAttributes: panelAttributes,
	          headingAttributes: headingAttributes,
	          buttonAttributes: buttonAttributes
	        }
	      }, children);
	    };
	
	    return /*#__PURE__*/React.createElement(Consumer, null, renderChildren);
	  };
	
	  var ProviderWrapper = function ProviderWrapper(props) {
	    return /*#__PURE__*/React.createElement(Consumer, null, function (accordionContext) {
	      return /*#__PURE__*/React.createElement(Provider$1, _extends({}, props, {
	        accordionContext: accordionContext
	      }));
	    });
	  };
	  var Consumer$1 = function Consumer(_ref2) {
	    var children = _ref2.children;
	
	    var renderChildren = function renderChildren(container) {
	      return container ? children(container) : null;
	    };
	
	    return /*#__PURE__*/React.createElement(Context$1.Consumer, null, renderChildren);
	  };
	
	  var _excluded$1 = ["uuid", "dangerouslySetExpanded", "className", "activeClassName"];
	
	  var AccordionItem = function AccordionItem(_ref) {
	    var customUuid = _ref.uuid,
	        dangerouslySetExpanded = _ref.dangerouslySetExpanded,
	        _ref$className = _ref.className,
	        className = _ref$className === void 0 ? 'accordion__item' : _ref$className,
	        activeClassName = _ref.activeClassName,
	        rest = _objectWithoutProperties(_ref, _excluded$1);
	
	    var _useState = React.useState(useNextId()),
	        _useState2 = _slicedToArray(_useState, 1),
	        instanceUuid = _useState2[0];
	
	    var uuid = customUuid !== null && customUuid !== void 0 ? customUuid : instanceUuid;
	
	    var renderChildren = function renderChildren(itemContext) {
	      var expanded = itemContext.expanded;
	      var cx = expanded && activeClassName ? activeClassName : className;
	      return /*#__PURE__*/React.createElement("div", _extends({
	        "data-accordion-component": "AccordionItem",
	        className: cx
	      }, rest));
	    };
	
	    assertValidHtmlId(uuid.toString());
	
	    if (rest.id) {
	      assertValidHtmlId(rest.id);
	    }
	
	    return /*#__PURE__*/React.createElement(ProviderWrapper, {
	      uuid: uuid,
	      dangerouslySetExpanded: dangerouslySetExpanded
	    }, /*#__PURE__*/React.createElement(Consumer$1, null, renderChildren));
	  };
	
	  AccordionItem.displayName = DisplayName$1.AccordionItem;
	
	  function getClosestAccordion(el) {
	    return el && (el.matches('[data-accordion-component="Accordion"]') ? el : getClosestAccordion(el.parentElement));
	  }
	  function getSiblingButtons(item) {
	    var parentAccordion = getClosestAccordion(item);
	    return parentAccordion && Array.from(parentAccordion.querySelectorAll('[data-accordion-component="AccordionItemButton"]'));
	  }
	  function focusFirstSiblingOf(item) {
	    var siblings = getSiblingButtons(item) || [];
	    var first = siblings[0];
	
	    if (first) {
	      first.focus();
	    }
	  }
	  function focusLastSiblingOf(item) {
	    var siblings = getSiblingButtons(item) || [];
	    var last = siblings[siblings.length - 1];
	
	    if (last) {
	      last.focus();
	    }
	  }
	  function focusNextSiblingOf(item) {
	    var siblings = getSiblingButtons(item) || [];
	    var currentIndex = siblings.indexOf(item);
	
	    if (currentIndex !== -1) {
	      var next = siblings[currentIndex + 1];
	
	      if (next) {
	        next.focus();
	      }
	    }
	  }
	  function focusPreviousSiblingOf(item) {
	    var siblings = getSiblingButtons(item) || [];
	    var currentIndex = siblings.indexOf(item);
	
	    if (currentIndex !== -1) {
	      var previous = siblings[currentIndex - 1];
	
	      if (previous) {
	        previous.focus();
	      }
	    }
	  }
	
	  var keycodes = {
	    END: 'End',
	    ENTER: 'Enter',
	    HOME: 'Home',
	    SPACE: ' ',
	    SPACE_DEPRECATED: 'Spacebar',
	    UP: 'ArrowUp',
	    DOWN: 'ArrowDown',
	    LEFT: 'ArrowLeft',
	    RIGHT: 'ArrowRight'
	  };
	
	  var _excluded$2 = ["toggleExpanded", "className"];
	
	  var AccordionItemButton = function AccordionItemButton(_ref) {
	    var toggleExpanded = _ref.toggleExpanded,
	        _ref$className = _ref.className,
	        className = _ref$className === void 0 ? 'accordion__button' : _ref$className,
	        rest = _objectWithoutProperties(_ref, _excluded$2);
	
	    var handleKeyPress = function handleKeyPress(evt) {
	      var keyCode = evt.key;
	
	      if (keyCode === keycodes.ENTER || keyCode === keycodes.SPACE || keyCode === keycodes.SPACE_DEPRECATED) {
	        evt.preventDefault();
	        toggleExpanded();
	      }
	      /* The following block is ignored from test coverage because at time
	       * time of writing Jest/react-testing-library can not assert 'focus'
	       * functionality.
	       */
	      // istanbul ignore next
	
	
	      if (evt.target instanceof HTMLElement) {
	        switch (keyCode) {
	          case keycodes.HOME:
	            {
	              evt.preventDefault();
	              focusFirstSiblingOf(evt.target);
	              break;
	            }
	
	          case keycodes.END:
	            {
	              evt.preventDefault();
	              focusLastSiblingOf(evt.target);
	              break;
	            }
	
	          case keycodes.LEFT:
	          case keycodes.UP:
	            {
	              evt.preventDefault();
	              focusPreviousSiblingOf(evt.target);
	              break;
	            }
	
	          case keycodes.RIGHT:
	          case keycodes.DOWN:
	            {
	              evt.preventDefault();
	              focusNextSiblingOf(evt.target);
	              break;
	            }
	        }
	      }
	    };
	
	    if (rest.id) {
	      assertValidHtmlId(rest.id);
	    }
	
	    return /*#__PURE__*/React.createElement("div", _extends({
	      className: className
	    }, rest, {
	      role: "button",
	      tabIndex: 0,
	      onClick: toggleExpanded,
	      onKeyDown: handleKeyPress,
	      "data-accordion-component": "AccordionItemButton"
	    }));
	  };
	
	  var AccordionItemButtonWrapper = function AccordionItemButtonWrapper(props) {
	    return /*#__PURE__*/React.createElement(Consumer$1, null, function (itemContext) {
	      var toggleExpanded = itemContext.toggleExpanded,
	          buttonAttributes = itemContext.buttonAttributes;
	      return /*#__PURE__*/React.createElement(AccordionItemButton, _extends({
	        toggleExpanded: toggleExpanded
	      }, props, buttonAttributes));
	    });
	  };
	
	  var defaultProps = {
	    className: 'accordion__heading',
	    'aria-level': 3
	  };
	  var SPEC_ERROR = "AccordionItemButton may contain only one child element, which must be an instance of AccordionItemButton.\n\nFrom the WAI-ARIA spec (https://www.w3.org/TR/wai-aria-practices-1.1/#accordion):\n\n\u201CThe button element is the only element inside the heading element. That is, if there are other visually persistent elements, they are not included inside the heading element.\u201D\n\n";
	  var AccordionItemHeading = /*#__PURE__*/function (_React$PureComponent) {
	    _inherits(AccordionItemHeading, _React$PureComponent);
	
	    var _super = _createSuper(AccordionItemHeading);
	
	    function AccordionItemHeading() {
	      var _this;
	
	      _classCallCheck(this, AccordionItemHeading);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _super.call.apply(_super, [this].concat(args));
	
	      _defineProperty(_assertThisInitialized(_this), "ref", void 0);
	
	      _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
	        _this.ref = ref;
	      });
	
	      return _this;
	    }
	
	    _createClass(AccordionItemHeading, [{
	      key: "componentDidUpdate",
	      value: function componentDidUpdate() {
	        AccordionItemHeading.VALIDATE(this.ref);
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        AccordionItemHeading.VALIDATE(this.ref);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return /*#__PURE__*/React.createElement("div", _extends({
	          "data-accordion-component": "AccordionItemHeading"
	        }, this.props, {
	          ref: this.setRef
	        }));
	      }
	    }], [{
	      key: "VALIDATE",
	      value: function VALIDATE(ref) {
	        if (ref === undefined) {
	          throw new Error('ref is undefined');
	        }
	
	        if (!(ref.childElementCount === 1 && ref.firstElementChild && ref.firstElementChild.getAttribute('data-accordion-component') === 'AccordionItemButton')) {
	          throw new Error(SPEC_ERROR);
	        }
	      }
	    }]);
	
	    return AccordionItemHeading;
	  }(React.PureComponent);
	
	  _defineProperty(AccordionItemHeading, "defaultProps", defaultProps);
	
	  var AccordionItemHeadingWrapper = function AccordionItemHeadingWrapper(props) {
	    return /*#__PURE__*/React.createElement(Consumer$1, null, function (itemContext) {
	      var headingAttributes = itemContext.headingAttributes;
	
	      if (props.id) {
	        assertValidHtmlId(props.id);
	      }
	
	      return /*#__PURE__*/React.createElement(AccordionItemHeading, _extends({}, props, headingAttributes));
	    });
	  };
	
	  AccordionItemHeadingWrapper.displayName = DisplayName$1.AccordionItemHeading;
	
	  var _excluded$3 = ["className", "region", "id"];
	
	  var AccordionItemPanel = function AccordionItemPanel(_ref) {
	    var _ref$className = _ref.className,
	        className = _ref$className === void 0 ? 'accordion__panel' : _ref$className,
	        region = _ref.region,
	        id = _ref.id,
	        rest = _objectWithoutProperties(_ref, _excluded$3);
	
	    var renderChildren = function renderChildren(_ref2) {
	      var panelAttributes = _ref2.panelAttributes;
	
	      if (id) {
	        assertValidHtmlId(id);
	      }
	
	      var attrs = _objectSpread2(_objectSpread2({}, panelAttributes), {}, {
	        'aria-labelledby': region ? panelAttributes['aria-labelledby'] : undefined
	      });
	
	      return /*#__PURE__*/React.createElement("div", _extends({
	        "data-accordion-component": "AccordionItemPanel",
	        className: className
	      }, rest, attrs, {
	        role: region ? 'region' : undefined
	      }));
	    };
	
	    return /*#__PURE__*/React.createElement(Consumer$1, null, renderChildren);
	  };
	
	  var AccordionItemState = function AccordionItemState(_ref) {
	    var children = _ref.children;
	
	    var renderChildren = function renderChildren(itemContext) {
	      var expanded = itemContext.expanded,
	          disabled = itemContext.disabled;
	      return /*#__PURE__*/React.createElement(React.Fragment, null, children({
	        expanded: expanded,
	        disabled: disabled
	      }));
	    };
	
	    return /*#__PURE__*/React.createElement(Consumer$1, null, renderChildren);
	  };
	
	  exports.Accordion = Accordion;
	  exports.AccordionItem = AccordionItem;
	  exports.AccordionItemButton = AccordionItemButtonWrapper;
	  exports.AccordionItemHeading = AccordionItemHeadingWrapper;
	  exports.AccordionItemPanel = AccordionItemPanel;
	  exports.AccordionItemState = AccordionItemState;
	  exports.resetNextUuid = resetGlobalCounterId;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getGroupSchemaProperties;
	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 22.03.2019
	 * Copyright: xdot GmbH 2019
	 */
	
	function getGroupSchemaProperties(groupSchema) {
	    if (groupSchema && groupSchema.allOf && groupSchema.allOf.length >= 2) {
	        return groupSchema.allOf[1].properties;
	    }
	    return undefined;
	}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 01.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	exports.default = {
	    openUploadForm: function openUploadForm(assetEntryIds, tagNames, folderId) {
	        return _openUploadForm(assetEntryIds, tagNames, folderId);
	    }
	};
	
	
	function _openUploadForm(assetEntryIds, tagNames, folderId) {
	    AUI().use('aui-base', 'escape', 'liferay-search-container', 'liferay-portlet-url', function (A) {
	
	        var renderURL = Liferay.PortletURL.createURL('/group/control_panel'),
	            eventName = 'UploadFileEvent_' + new Date().getTime();
	
	        renderURL.setWindowState('pop_up');
	        renderURL.setPortletMode('view');
	        renderURL.setParameter('eventName', eventName);
	
	        renderURL.setParameter('folderId', folderId);
	        renderURL.setParameter('mvcRenderCommandName', '/document_library/edit_file_entry');
	        renderURL.setParameter('fliwasAssetEntryIds', (assetEntryIds || []).join());
	        renderURL.setParameter('fliwasCommand', 'BusinessObjectUpload');
	        renderURL.setParameter('scopeGroupId', Liferay.ThemeDisplay.getScopeGroupId());
	        renderURL.setParameter('selectedGroupIds', Liferay.ThemeDisplay.getCompanyGroupId() + ',' + Liferay.ThemeDisplay.getScopeGroupId());
	        renderURL.setParameter('fliwasTagNames', (tagNames || []).join());
	        renderURL.setParameter('groupId', Liferay.ThemeDisplay.getScopeGroupId());
	        renderURL.setPortletId('com_liferay_document_library_web_portlet_DLPortlet');
	        renderURL.setDoAsGroupId(Liferay.ThemeDisplay.getScopeGroupId());
	
	        var url = renderURL.toString();
	        var id = 'UploadDialog_' + new Date().getTime();
	        var dialog = void 0;
	
	        window.subscribeEvent('businessObjectUploadSuccessFull', document, function (e) {
	            dialog.hide();
	        });
	        window.eventDocument = document;
	
	        Liferay.Util.openWindow({
	            dialog: {
	                constrain: true,
	                modal: true,
	                on: {}
	            },
	
	            eventName: eventName,
	            id: id,
	            title: 'Dokument hochladen',
	            uri: url
	        }, function (d) {
	            dialog = d;
	        });
	    }.bind(this));
	}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.hasEditPermissionAndGroup = hasEditPermissionAndGroup;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function hasEditPermissionAndGroup(fliwasObject, permission) {
	    var ignoreGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var permissionItem = _liferayWidgetsReactWeb.DataUtil.asItem(permission);
	
	    var hasPermission = permissionItem && permissionItem.state && permissionItem.state.toLowerCase() === 'set';
	
	    if (hasPermission && (ignoreGroup || fliwasObject && fliwasObject.groupId === window.Liferay.ThemeDisplay.getScopeGroupId())) {
	        hasPermission = true;
	    } else if (fliwasObject && fliwasObject.groupId != window.Liferay.ThemeDisplay.getScopeGroupId()) {
	        hasPermission = false;
	    }
	
	    return hasPermission;
	}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 12.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _WebCamWidgetConfigForm = __webpack_require__(141);
	
	var _WebCamWidgetConfigForm2 = _interopRequireDefault(_WebCamWidgetConfigForm);
	
	var _ImageDisplay = __webpack_require__(65);
	
	var _ImageDisplay2 = _interopRequireDefault(_ImageDisplay);
	
	var _JournalEntryAddForm = __webpack_require__(91);
	
	var _JournalAddEntryButton = __webpack_require__(122);
	
	var _JournalAddEntryButton2 = _interopRequireDefault(_JournalAddEntryButton);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebCamWidgetConfigFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_WebCamWidgetConfigForm2.default);
	var JournalEntryAddFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_JournalEntryAddForm.JournalEntryAddForm);
	
	var WebCamWidget = function (_PortletComponent) {
	    _inherits(WebCamWidget, _PortletComponent);
	
	    function WebCamWidget(props) {
	        _classCallCheck(this, WebCamWidget);
	
	        var _this = _possibleConstructorReturn(this, _PortletComponent.call(this, props));
	
	        _this.DATA = {
	            FORM_ADD_JOURNAL_ENTRY: _liferayWidgetsReactWeb.UidUtil.generateId('FormAddJournalEntry')
	        };
	
	        _this.onJournalEntryAdd = _this.onJournalEntryAdd.bind(_this);
	        _this.onJournalEntryAddFormSubmit = _this.onJournalEntryAddFormSubmit.bind(_this);
	        return _this;
	    }
	
	    WebCamWidget.prototype.renderConfigForm = function renderConfigForm(props) {
	        return _react2.default.createElement(WebCamWidgetConfigFormHoc, props);
	    };
	
	    WebCamWidget.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.timer) {
	            clearInterval(this.timer);
	        }
	    };
	
	    WebCamWidget.prototype.configWillChange = function configWillChange(prevConfig, nextConfig) {
	        this.isRefreshing = false;
	        console.log('configWillChange', prevConfig, ' ==> ', nextConfig);
	        if (this.timer) {
	            clearInterval(this.timer);
	        }
	        if (nextConfig.refreshInterval > 0) {
	            this.timer = setInterval(this.refreshWidget.bind(this, nextConfig), nextConfig.refreshInterval * 1000);
	            this.refreshWidget(nextConfig);
	        }
	    };
	
	    WebCamWidget.prototype.refreshWidget = function refreshWidget(config) {
	        var _this2 = this;
	
	        this.isRefreshing = true;
	        var imageUrl = config.imageUrl,
	            portletSetupTitle_de_DE = config.portletSetupTitle_de_DE;
	        var time = this.state.time;
	
	        var url = imageUrl;
	
	        if (imageUrl.indexOf('?') < 0) {
	            url += '?cct=' + time;
	        } else if (imageUrl.indexOf('cct') < 0) {
	            url += '&cct=' + time;
	        } else {
	            url = imageUrl.split('cct')[0] + 'cct=' + time;
	        }
	
	        if (config.username && config.username.length > 0 && config.password && config.password.length > 0) {
	
	            this.getImageBlob(url, config).then(function (resp) {
	                _this2.setState({ url: window.URL.createObjectURL(resp) });
	            }).catch(function (e) {
	                console.error(e);
	                _this2.setState({ url: url });
	            });
	
	            this.setState({
	                time: new Date().getTime(),
	                imgData: new Date().getTime(),
	                portletTitle: portletSetupTitle_de_DE,
	                url: undefined
	            });
	        } else {
	            this.setState({
	                time: new Date().getTime(),
	                imgData: new Date().getTime(),
	                portletTitle: portletSetupTitle_de_DE,
	                url: url
	            });
	        }
	    };
	
	    WebCamWidget.prototype.imageToBlob = function imageToBlob() {
	        var _this3 = this;
	
	        return new Promise(function (resolve, reject) {
	            var img = new Image();
	            var canvas = document.createElement('canvas');
	            var ctx = canvas.getContext('2d');
	            img.onload = function () {
	                canvas.width = img.naturalWidth;
	                canvas.height = img.naturalHeight;
	                ctx.drawImage(img, 0, 0);
	                canvas.toBlob(function (blob) {
	                    resolve(blob);
	                }, 'image/jpeg', 0.85);
	            };
	            img.onerror = reject;
	            img.crossOrigin = 'Anonymous';
	            img.src = _this3.state.url;
	        });
	    };
	
	    WebCamWidget.prototype.getImageBlob = function getImageBlob(url, config) {
	        return new Promise(function (resolve, reject) {
	            try {
	                var xhr = new XMLHttpRequest();
	                xhr.responseType = 'blob';
	                if (config.username && config.username.length > 0 && config.password && config.password.length > 0) {
	                    xhr.withCredentials = true;
	                }
	                xhr.open('GET', url, true, config.username, config.password);
	                xhr.onload = function (oEvent) {
	                    if (xhr.status === 200) {
	                        resolve(xhr.response);
	                    } else {
	                        reject('Loading error:' + xhr.statusText);
	                    }
	                };
	                xhr.onerror = function () {
	                    reject(xhr.response);
	                };
	                xhr.send();
	            } catch (err) {
	                reject(err.message);
	            }
	        });
	    };
	
	    WebCamWidget.prototype.onJournalEntryAdd = function onJournalEntryAdd() {
	        var portletTitle = this.state.portletTitle;
	
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_ADD_JOURNAL_ENTRY, {
	            title: ''
	        });
	    };
	
	    WebCamWidget.prototype.onJournalEntryAddFormSubmit = function onJournalEntryAddFormSubmit(formData) {
	        var _this4 = this;
	
	        //  this.imageToBlob().then(resp => {
	        var entryData = {
	            url: this.state.url,
	            type: _Constants.JournalTypeNames.Webcam,
	            message: _extends({}, formData, { url: this.state.url }),
	            //attachments: { image: resp },
	            attachments: { image__URL__UPLOAD: this.state.url },
	            groupId: Liferay.ThemeDisplay.getScopeGroupId()
	        };
	        (0, _liferayWidgetsReactWeb.amdRequire)(['journal-portlet/js/journal-portlet'], function (J) {
	            J.JournalActions.addEntry(entryData, _this4.DATA.FORM_ADD_JOURNAL_ENTRY, true);
	        });
	        // }).catch(e => console.error(e));
	    };
	
	    WebCamWidget.prototype.isConfigurationNeeded = function isConfigurationNeeded(config) {
	        return !config || config && !config.imageUrl;
	    };
	
	    WebCamWidget.prototype.renderPortlet = function renderPortlet(config) {
	        var url = this.state.url;
	
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(JournalEntryAddFormHoc, {
	                formId: this.DATA.FORM_ADD_JOURNAL_ENTRY,
	                showReset: true,
	                onFormSubmit: this.onJournalEntryAddFormSubmit,
	                editTitle: true,
	                modalProps: {
	                    aboveLiferayDialog: true,
	                    size: 'md'
	                }
	            }),
	            _react2.default.createElement(_JournalAddEntryButton2.default, { onClick: this.onJournalEntryAdd }),
	            url && _react2.default.createElement(_ImageDisplay2.default, {
	                thumbnailUrl: url,
	                previewUrl: url
	            }),
	            !url && _react2.default.createElement(
	                'div',
	                null,
	                'Bild wird geladen...'
	            )
	        );
	    };
	
	    return WebCamWidget;
	}(_liferayWidgetsReactWeb.PortletComponent);
	
	WebCamWidget.propTypes = {};
	
	exports.default = WebCamWidget;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Carsten Bühler
	 * Date: 12.02.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _BasicFormComponents = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var optionsMinSec = [],
	    optionsHours = [];
	for (var i = 0; i < 60; i++) {
	    optionsMinSec.push(_react2.default.createElement(
	        'option',
	        { key: i, value: i },
	        i
	    ));
	    if (i < 24) {
	        optionsHours.push(_react2.default.createElement(
	            'option',
	            { key: i, value: i },
	            i
	        ));
	    }
	}
	
	var WebCamWidgetConfigForm = function (_React$Component) {
	    _inherits(WebCamWidgetConfigForm, _React$Component);
	
	    function WebCamWidgetConfigForm(props) {
	        _classCallCheck(this, WebCamWidgetConfigForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        var refreshInterval = props.formData.refreshInterval;
	
	
	        _this.state = {
	            seconds: refreshInterval ? refreshInterval % 3600 % 60 : 0,
	            minutes: refreshInterval ? parseInt(refreshInterval % 3600 / 60, 10) : 1,
	            hours: refreshInterval ? parseInt(refreshInterval / 3600, 10) : 0
	        };
	
	        _this.change({
	            refreshInterval: refreshInterval || 60 // initial refresh interval
	        });
	        return _this;
	    }
	
	    WebCamWidgetConfigForm.prototype.onChangeImageUrl = function onChangeImageUrl(e) {
	        this.change({ imageUrl: e.target.value });
	    };
	
	    WebCamWidgetConfigForm.prototype.onChangePassword = function onChangePassword(e) {
	        this.change({ password: e.target.value });
	    };
	
	    WebCamWidgetConfigForm.prototype.onChangeUsername = function onChangeUsername(e) {
	        this.change({ username: e.target.value });
	    };
	
	    WebCamWidgetConfigForm.prototype.onChangeRefreshInterval = function onChangeRefreshInterval(unit, e) {
	        var _setState;
	
	        var _state = this.state,
	            seconds = _state.seconds,
	            minutes = _state.minutes,
	            hours = _state.hours;
	
	        var val = parseInt(e.target.value);
	        var refreshInterval = void 0;
	        this.setState((_setState = {}, _setState[unit] = val, _setState));
	
	        switch (unit) {
	            case 'seconds':
	                refreshInterval = val + minutes * 60 + hours * 60 * 60;
	                break;
	            case 'minutes':
	                refreshInterval = seconds + val * 60 + hours * 60 * 60;
	                break;
	            case 'hours':
	                refreshInterval = seconds + minutes * 60 + val * 60 * 60;
	                break;
	        }
	
	        this.change({
	            refreshInterval: refreshInterval
	        });
	    };
	
	    WebCamWidgetConfigForm.prototype.change = function change(o) {
	        var formData = _extends({}, this.props.formData, o);
	        this.props.onChange(formData, this.validate(formData));
	    };
	
	    WebCamWidgetConfigForm.prototype.validate = function validate(formData) {
	        var imageUrlValid = void 0,
	            refreshIntervalValid = void 0,
	            usernameValid = void 0,
	            passwordValid = void 0;
	
	        if (!(formData.imageUrl && formData.imageUrl.length > 0)) {
	            imageUrlValid = 'Bitte URL eingeben';
	        }
	
	        if (formData.imageUrl && formData.imageUrl.length > 0) {
	            if (formData.imageUrl === 'Sid' || formData.imageUrl === '/base-portlet/images/SID.jpg') {
	                formData.imageUrl = '/base-portlet/images/SID.jpg';
	            }
	            // eslint-disable-next-line no-useless-escape
	            else if (!/^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(formData.imageUrl)) {
	                    imageUrlValid = 'Bitte gültige URL eingeben!';
	                }
	        }
	
	        if (!(formData.refreshInterval && formData.refreshInterval >= 60)) {
	            refreshIntervalValid = 'Aktualisierungsinterval muss mindestens 1 Minute betragen!';
	        }
	
	        if (formData.username && formData.username.length > 0 && formData.username.length > 75) {
	            usernameValid = 'Benutzername darf nicht länger als 75 Zeichen sein!';
	        }
	
	        if (formData.password && formData.password.length > 0 && formData.password.length > 75) {
	            passwordValid = 'Passwort darf nicht länger als 75 Zeichen sein!';
	        }
	
	        return {
	            imageUrl: imageUrlValid,
	            refreshInterval: refreshIntervalValid,
	            username: usernameValid,
	            password: passwordValid
	        };
	    };
	
	    WebCamWidgetConfigForm.prototype.render = function render() {
	        var _state2 = this.state,
	            seconds = _state2.seconds,
	            minutes = _state2.minutes,
	            hours = _state2.hours;
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation;
	
	
	        return _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: _liferayWidgetsReactWeb.translation.trans('image-widget-config-form-legend') }),
	            _react2.default.createElement(
	                _reactBootstrap.Container,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            _BasicFormComponents.FliwasFormGroup,
	                            { title: _liferayWidgetsReactWeb.translation.trans('url'),
	                                formValidation: formValidation,
	                                propName: 'imageUrl',
	                                required: true },
	                            _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text',
	                                required: true,
	                                value: formData.imageUrl,
	                                onChange: this.onChangeImageUrl.bind(this),
	                                placeholder: 'http://www.abc.de/exampleImage.jpg' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            _BasicFormComponents.FliwasFormGroup,
	                            { title: _liferayWidgetsReactWeb.translation.trans('user'),
	                                formValidation: formValidation,
	                                propName: 'user' },
	                            _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text',
	                                value: formData.username,
	                                onChange: this.onChangeUsername.bind(this),
	                                placeholder: 'Benutzer' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            _BasicFormComponents.FliwasFormGroup,
	                            { title: _liferayWidgetsReactWeb.translation.trans('password'),
	                                formValidation: formValidation,
	                                propName: 'user' },
	                            _react2.default.createElement(_reactBootstrap.FormControl, { type: 'password',
	                                value: formData.password,
	                                onChange: this.onChangePassword.bind(this),
	                                placeholder: 'Passwort' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormLabel,
	                            null,
	                            _liferayWidgetsReactWeb.translation.trans('refresh-interval')
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Form,
	                            { inline: true },
	                            _react2.default.createElement(
	                                _BasicFormComponents.FliwasFormGroup,
	                                {
	                                    title: _liferayWidgetsReactWeb.translation.trans('hours'),
	                                    formValidation: formValidation,
	                                    propName: 'refreshInterval',
	                                    required: true
	                                },
	                                _react2.default.createElement(
	                                    _reactBootstrap.FormControl,
	                                    {
	                                        className: 'mx-2',
	                                        as: 'select',
	                                        required: true,
	                                        value: hours,
	                                        onChange: this.onChangeRefreshInterval.bind(this, 'hours')
	                                    },
	                                    optionsHours
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _BasicFormComponents.FliwasFormGroup,
	                                {
	                                    title: _liferayWidgetsReactWeb.translation.trans('minutes'),
	                                    formValidation: formValidation,
	                                    required: true
	                                },
	                                _react2.default.createElement(
	                                    _reactBootstrap.FormControl,
	                                    {
	                                        className: 'mx-2',
	                                        as: 'select',
	                                        required: true,
	                                        value: minutes,
	                                        onChange: this.onChangeRefreshInterval.bind(this, 'minutes')
	                                    },
	                                    optionsMinSec
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _BasicFormComponents.FliwasFormGroup,
	                                {
	                                    title: _liferayWidgetsReactWeb.translation.trans('seconds'),
	                                    formValidation: formValidation,
	                                    required: true
	                                },
	                                _react2.default.createElement(
	                                    _reactBootstrap.FormControl,
	                                    {
	                                        className: 'mx-2',
	                                        as: 'select',
	                                        required: true,
	                                        value: seconds,
	                                        onChange: this.onChangeRefreshInterval.bind(this, 'seconds')
	                                    },
	                                    optionsMinSec
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return WebCamWidgetConfigForm;
	}(_react2.default.Component);
	
	WebCamWidgetConfigForm.propTypes = {
	    onChange: _propTypes2.default.func,
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object
	};
	
	exports.default = WebCamWidgetConfigForm;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Hibbeler
	 * Date: 23.02.2016
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*function DebugOut(props) {
	    return <pre>{JSON.stringify(props.item, null, 3)}</pre>;
	}*/
	
	// eslint-disable-next-line react/prop-types
	var MultiTypeRenderer = function MultiTypeRenderer(_ref) {
	    var item = _ref.item,
	        portletId = _ref.portletId;
	
	    // eslint-disable-next-line react/prop-types
	    if (Array.isArray(item) && item.length) {
	        item = item[0];
	    }
	
	    return !item ? _react2.default.createElement(
	        'div',
	        { className: 'padding-box' },
	        _liferayWidgetsReactWeb.translation.trans('details-widget-help-1'),
	        _react2.default.createElement('br', null),
	        _liferayWidgetsReactWeb.translation.trans('details-widget-help-2')
	    ) : _react2.default.createElement(
	        _liferayWidgetsReactWeb.AmdRequireComponent,
	        { dependencies: ['DetailsRenderer/' + item.className] },
	        function (Renderer) {
	            return _react2.default.createElement(Renderer, { item: item, portletId: portletId });
	        }
	    );
	};
	
	var SelectedDetails = _liferayWidgetsReactWeb.DataLinkContainer.link(MultiTypeRenderer, ['item'], (0, _StoreFactory.getPageSelectedStore)(_liferayWidgetsReactWeb.AppContext));
	
	var DetailsWidget = function (_PortletComponent) {
	    _inherits(DetailsWidget, _PortletComponent);
	
	    function DetailsWidget(props) {
	        _classCallCheck(this, DetailsWidget);
	
	        return _possibleConstructorReturn(this, _PortletComponent.call(this, props));
	    }
	
	    DetailsWidget.prototype.isConfigurationNeeded = function isConfigurationNeeded(config) {
	        return false;
	    };
	
	    DetailsWidget.prototype.renderPortlet = function renderPortlet(config) {
	        return _react2.default.createElement(SelectedDetails, { item: _liferayWidgetsReactWeb.DataNames.PAGE_SELECTED, portletId: this.portletId });
	    };
	
	    return DetailsWidget;
	}(_liferayWidgetsReactWeb.PortletComponent);
	
	exports.default = DetailsWidget;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Carsten Hibbeler
	 * Date: 28.01.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _mapPortlet = __webpack_require__(25);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapC = _liferayWidgetsReactWeb.DataLinkContainer.link(_mapPortlet.Map, {
	    selectedItems: (0, _StoreFactory.getPageSelectedStore)(_liferayWidgetsReactWeb.AppContext),
	    mapConfig: (0, _mapPortlet.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext)
	});
	
	var FliwasMapWidget = function (_MapWidget) {
	    _inherits(FliwasMapWidget, _MapWidget);
	
	    function FliwasMapWidget() {
	        _classCallCheck(this, FliwasMapWidget);
	
	        return _possibleConstructorReturn(this, _MapWidget.apply(this, arguments));
	    }
	
	    FliwasMapWidget.prototype.renderPortlet = function renderPortlet(config) {
	        return _react2.default.createElement(MapC, {
	            style: { height: config.height + 'px' },
	            selectedItems: _liferayWidgetsReactWeb.DataNames.PAGE_SELECTED,
	            mapConfig: this.DATA.SELECTED_MAP_CONFIG,
	            portletConfig: config,
	            mapKey: this.MAP_ID
	        });
	    };
	
	    return FliwasMapWidget;
	}(_mapPortlet.MapWidget);
	
	exports.default = FliwasMapWidget;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 26.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _FliwasObjectMasterDetailList = __webpack_require__(117);
	
	var _FliwasObjectMasterDetailList2 = _interopRequireDefault(_FliwasObjectMasterDetailList);
	
	var _SelectObjectErrorMessage = __webpack_require__(119);
	
	var _SelectObjectErrorMessage2 = _interopRequireDefault(_SelectObjectErrorMessage);
	
	var _NamedListListItem = __webpack_require__(145);
	
	var _NamedListListItem2 = _interopRequireDefault(_NamedListListItem);
	
	var _NamedListEditForm = __webpack_require__(146);
	
	var _NamedListEditForm2 = _interopRequireDefault(_NamedListEditForm);
	
	var _FliwasDetailsBox = __webpack_require__(120);
	
	var _FliwasDetailsBox2 = _interopRequireDefault(_FliwasDetailsBox);
	
	var _FliwasActionButtons = __webpack_require__(121);
	
	var _FliwasActionButtons2 = _interopRequireDefault(_FliwasActionButtons);
	
	var _FliwasObjectListItem = __webpack_require__(147);
	
	var _FliwasObjectListItem2 = _interopRequireDefault(_FliwasObjectListItem);
	
	var _AssetLinkChooser = __webpack_require__(102);
	
	var _AssetLinkChooser2 = _interopRequireDefault(_AssetLinkChooser);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _Constants = __webpack_require__(5);
	
	var _NamedListActions = __webpack_require__(148);
	
	var _NamedListActions2 = _interopRequireDefault(_NamedListActions);
	
	var _BomListActions = __webpack_require__(149);
	
	var _BomListActions2 = _interopRequireDefault(_BomListActions);
	
	var _NamedListWebApi = __webpack_require__(69);
	
	var _NamedListWebApi2 = _interopRequireDefault(_NamedListWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Current Module
	
	
	//Stores
	var NamedListStore = (0, _StoreFactory.getNamedListStore)(_liferayWidgetsReactWeb.AppContext);
	var BomListStore = (0, _StoreFactory.getBomListStore)(_liferayWidgetsReactWeb.AppContext);
	
	//DataLinks
	var NamedListListLinkCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list'], NamedListStore);
	var NamedListEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_NamedListEditForm2.default);
	
	var AssetLinkChooserHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_AssetLinkChooser2.default);
	
	var NamedListMasterDetailsWidget = function (_PortletComponent) {
	    _inherits(NamedListMasterDetailsWidget, _PortletComponent);
	
	    function NamedListMasterDetailsWidget(props) {
	        _classCallCheck(this, NamedListMasterDetailsWidget);
	
	        var _this = _possibleConstructorReturn(this, _PortletComponent.call(this, props));
	
	        _this.DATA = {
	            SELECTED_NAMED_LIST: _this.withCtx('_SelectedNamedList'),
	            SELECT_OBJECT_LIST: _this.withCtx('_SelectedObjectList'),
	
	            FORM_DELETE_OBJECT: _this.withCtx('_DeleteNamedList'),
	            FORM_EDIT_NAMED_LIST: _this.withCtx('_EditNamedList'),
	
	            FORM_ADD_OBJECT: _this.withCtx('_AddObject')
	        };
	
	        _this.onNamedListFormSubmit = _this.onNamedListFormSubmit.bind(_this);
	        _this.newNamedList = _this.newNamedList.bind(_this);
	        _this.selectNamedList = _this.selectNamedList.bind(_this);
	        return _this;
	    }
	
	    NamedListMasterDetailsWidget.getStores = function getStores() {
	        return [NamedListStore, BomListStore];
	    };
	
	    NamedListMasterDetailsWidget.calculateState = function calculateState(prevState, undefined, DATA) {
	        return {
	            selectedNamedList: NamedListStore.getRemoteData(DATA.SELECTED_NAMED_LIST),
	            selectedObjectList: BomListStore.getRemoteData(DATA.SELECT_OBJECT_LIST)
	        };
	    };
	
	    NamedListMasterDetailsWidget.prototype.componentDidMount = function componentDidMount() {
	        var linkedQuery = {
	            $byEntries: _Constants.ClassNames.AssetCategory + '/' + this.DATA.SELECTED_NAMED_LIST + '/entries',
	            byClassName: _Constants.ClassNames.AssetCategory
	        };
	        _BomListActions2.default.bomList(this.DATA.SELECT_OBJECT_LIST, _extends({}, linkedQuery));
	    };
	
	    NamedListMasterDetailsWidget.prototype.selectNamedList = function selectNamedList(namedList) {
	        //Current Object
	        _NamedListActions2.default.item(this.DATA.SELECTED_NAMED_LIST, { id: namedList.id });
	    };
	
	    NamedListMasterDetailsWidget.prototype.newNamedList = function newNamedList() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_EDIT_NAMED_LIST, {});
	    };
	
	    NamedListMasterDetailsWidget.prototype.editNamedList = function editNamedList() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_EDIT_NAMED_LIST, _liferayWidgetsReactWeb.DataUtil.asItem(this.state.selectedNamedList));
	    };
	
	    NamedListMasterDetailsWidget.prototype.onNamedListFormSubmit = function onNamedListFormSubmit(data) {
	        if (data.id) {
	            _NamedListActions2.default.update(data, this.DATA.FORM_EDIT_NAMED_LIST, true);
	        } else {
	            _NamedListActions2.default.add(data, this.DATA.FORM_EDIT_NAMED_LIST, true);
	        }
	    };
	
	    NamedListMasterDetailsWidget.prototype.onClickNamedList = function onClickNamedList() {
	        var object = _liferayWidgetsReactWeb.DataUtil.asItem(this.state.selectedNamedList);
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_DELETE_OBJECT, object);
	    };
	
	    NamedListMasterDetailsWidget.prototype.deleteObject = function deleteObject(object) {
	        _NamedListActions2.default.delete(object, this.DATA.FORM_DELETE_OBJECT, true);
	        _liferayWidgetsReactWeb.RemoteDataActions.remove(this.DATA.SELECTED_NAMED_LIST, _Constants.ClassNames.AssetCategory);
	        //RemoteDataActions.remove(this.DATA.SELECT_OBJECT_LIST, undefined);
	    };
	
	    NamedListMasterDetailsWidget.prototype.onObjectAdd = function onObjectAdd() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_ADD_OBJECT, {});
	    };
	
	    NamedListMasterDetailsWidget.prototype.onObjectAddSubmit = function onObjectAddSubmit(data) {
	        var selectedList = _liferayWidgetsReactWeb.DataUtil.asItem(this.state.selectedNamedList);
	        _NamedListWebApi2.default.update(_extends({}, selectedList, {
	            entries: [].concat(selectedList.entries, [{ className: data.className, classPK: data.id }])
	        }));
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.FORM_ADD_OBJECT);
	    };
	
	    NamedListMasterDetailsWidget.prototype.isConfigurationNeeded = function isConfigurationNeeded(config) {
	        return false;
	    };
	
	    NamedListMasterDetailsWidget.prototype.renderPortlet = function renderPortlet(config) {
	        var selectedNamedListDataItem = this.state.selectedNamedList && this.state.selectedNamedList,
	            selectedNamedList = _liferayWidgetsReactWeb.DataUtil.asItem(selectedNamedListDataItem),
	            selectedObjectListDataItem = this.state.selectedObjectList && this.state.selectedObjectList;
	        //selectedObjectList = DataUtil.asItem(selectedObjectListDataItem);
	
	        /*eslint react/jsx-no-bind: 0*/
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { fluid: true },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _FliwasObjectMasterDetailList2.default,
	                    { createClick: this.newNamedList },
	                    _react2.default.createElement(NamedListListLinkCHOC, { list: _Constants.GROUP_NAMED_LISTS,
	                        activeIds: selectedNamedList,
	                        size: 'large',
	                        ListItem: _NamedListListItem2.default,
	                        onClick: this.selectNamedList })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 9, md: 12, sm: 12, xs: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(NamedListEditFormHoc, { formId: this.DATA.FORM_EDIT_NAMED_LIST,
	                            onFormSubmit: this.onNamedListFormSubmit }),
	                        !selectedNamedList && selectedObjectListDataItem && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { lg: 12, md: 12, sm: 12, xs: 12 },
	                            _react2.default.createElement(_SelectObjectErrorMessage2.default, { content: 'Bitte Benannte Liste ausw\xE4hlen' })
	                        ),
	                        _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, {
	                            formId: this.DATA.FORM_DELETE_OBJECT,
	                            title: 'L\xF6schen',
	                            Content: function Content(_ref) {
	                                var formData = _ref.formData;
	                                return 'Wollen Sie Liste \'' + formData.title + '\' wirklich löschen?';
	                            },
	                            editRequired: false,
	                            onFormSubmit: this.deleteObject.bind(this)
	                        }),
	                        selectedNamedList && selectedObjectListDataItem && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, className: 'nopadding' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'padding-box' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'margin-bottom' },
	                                    _react2.default.createElement(
	                                        _FliwasActionButtons2.default,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Dropdown.Item,
	                                            { title: 'Neues Objekt hinzuf\xFCgen',
	                                                onClick: this.onObjectAdd.bind(this) },
	                                            'Neues Objekt hinzuf\xFCgen'
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Dropdown.Item,
	                                            { title: 'Bearbeiten',
	                                                onClick: this.editNamedList.bind(this) },
	                                            'Bearbeiten'
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Dropdown.Item,
	                                            { title: 'L\xF6schen',
	                                                onClick: this.onClickNamedList.bind(this) },
	                                            'Gesamte Liste L\xF6schen'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_FliwasDetailsBox2.default, { item: selectedNamedList }),
	                                _react2.default.createElement(_liferayWidgetsReactWeb.ScrollableDataListRV, { list: selectedObjectListDataItem,
	                                    size: 'large',
	                                    rowHeight: 80,
	                                    selectedNamedList: selectedNamedList,
	                                    onClickDelete: true,
	                                    ListItem: _FliwasObjectListItem2.default }),
	                                _react2.default.createElement(AssetLinkChooserHoc, { formId: this.DATA.FORM_ADD_OBJECT,
	                                    onFormSubmit: this.onObjectAddSubmit.bind(this) })
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return NamedListMasterDetailsWidget;
	}(_liferayWidgetsReactWeb.PortletComponent);
	
	NamedListMasterDetailsWidget.propTypes = {};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(NamedListMasterDetailsWidget);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NamedListListItem = function (_React$Component) {
	    _inherits(NamedListListItem, _React$Component);
	
	    function NamedListListItem() {
	        _classCallCheck(this, NamedListListItem);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    NamedListListItem.prototype.onClick = function onClick(e) {
	        this.props.onClick(this.props.item, e);
	    };
	
	    NamedListListItem.prototype.render = function render() {
	        var _props = this.props,
	            item = _props.item,
	            otherProps = _objectWithoutProperties(_props, ['item']);
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            _extends({}, otherProps, { onClick: this.onClick }),
	            item.title
	        );
	    };
	
	    return NamedListListItem;
	}(_react2.default.Component);
	
	NamedListListItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = NamedListListItem;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _BasicFormComponents = __webpack_require__(70);
	
	var _formValidationUtil = __webpack_require__(92);
	
	var FormValidationUtil = _interopRequireWildcard(_formValidationUtil);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validate = function validate(formData) {
	    var titleValid = void 0;
	
	    titleValid = FormValidationUtil.validateStringMinLengthMaxLength(formData.title, 1, 75, 'Titel');
	
	    return {
	        title: titleValid
	    };
	};
	
	var CriticalObjectEditForm = function (_React$Component) {
	    _inherits(CriticalObjectEditForm, _React$Component);
	
	    function CriticalObjectEditForm(props) {
	        _classCallCheck(this, CriticalObjectEditForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.props.onChange(_this.props.formData, validate(_this.props.formData));
	        return _this;
	    }
	
	    CriticalObjectEditForm.prototype.handleChange = function handleChange(field, e) {
	        this.change(field, e.target.value);
	    };
	
	    CriticalObjectEditForm.prototype.change = function change(field, value) {
	        var _extends2;
	
	        var formData = this.props.formData,
	            item = formData.item || formData;
	
	        var newData = _extends({}, item, (_extends2 = {}, _extends2[field] = value, _extends2));
	
	        this.props.onChange(newData, validate(newData));
	    };
	
	    CriticalObjectEditForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation;
	
	
	        return _react2.default.createElement(
	            _BasicFormComponents.FliwasFormGrid,
	            null,
	            _react2.default.createElement(_BasicFormComponents.FliwasFormHeading, { title: 'Benannte Liste bearbeiten' }),
	            _react2.default.createElement(
	                _BasicFormComponents.FliwasFormGroup,
	                { title: _liferayWidgetsReactWeb.translation.trans('title'),
	                    formValidation: formValidation,
	                    propName: 'title',
	                    required: true },
	                _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text',
	                    required: true,
	                    placeholder: _liferayWidgetsReactWeb.translation.trans('title'),
	                    value: formData && formData.title ? formData.title : '',
	                    onChange: this.handleChange.bind(this, 'title') })
	            )
	        );
	    };
	
	    return CriticalObjectEditForm;
	}(_react2.default.Component);
	
	CriticalObjectEditForm.propTypes = {
	    formData: _propTypes2.default.object,
	    drawOptions: _propTypes2.default.object,
	    handleGeometryChange: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    formValidation: _propTypes2.default.object
	};
	
	exports.default = CriticalObjectEditForm;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 18.04.2019
	 * Copyright: xdot GmbH 2019
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _DetailsListItemComponents = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FliwasObjectListItem = function FliwasObjectListItem(_ref) {
	    var item = _ref.item,
	        selectedNamedList = _ref.selectedNamedList,
	        onLoad = _ref.onLoad,
	        _ref$onClickDelete = _ref.onClickDelete,
	        onClickDelete = _ref$onClickDelete === undefined ? false : _ref$onClickDelete;
	
	
	    if (!item) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'Kein Objekt!'
	        );
	    }
	
	    if (item.active === false) {
	        return _react2.default.createElement(
	            _DetailsListItemComponents.DetailsListItem,
	            { item: item, onClickDelete: onClickDelete, list: selectedNamedList },
	            _react2.default.createElement(
	                _DetailsListItemComponents.DetailsListItemNameBox,
	                null,
	                _react2.default.createElement(
	                    _DetailsListItemComponents.DetailsListItemTitle,
	                    null,
	                    item.className + '+' + item.classPK
	                )
	            ),
	            _react2.default.createElement(_DetailsListItemComponents.DetailsListItemStatusBox, null),
	            _react2.default.createElement(_DetailsListItemComponents.DetailsListItemMeasurementBox, null)
	        );
	    }
	
	    return _react2.default.createElement(
	        _liferayWidgetsReactWeb.AmdRequireComponent,
	        {
	            key: 'FliwasObjectListItem' + item.__type + item.id,
	            onDependenciesLoaded: onLoad,
	            dependencies: ['DetailsListItem/' + item.__type]
	        },
	        function (DetailsListItem) {
	            return _react2.default.createElement(DetailsListItem, {
	                item: item,
	                list: selectedNamedList,
	                onClickDelete: onClickDelete,
	                onLoad: onLoad
	            });
	        }
	    );
	};
	
	FliwasObjectListItem.propTypes = {
	    item: _propTypes2.default.object,
	    selectedNamedList: _propTypes2.default.object,
	    onClickDelete: _propTypes2.default.bool,
	    onLoad: _propTypes2.default.func
	};
	
	exports.default = FliwasObjectListItem;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _NamedListWebApi = __webpack_require__(69);
	
	var _NamedListWebApi2 = _interopRequireDefault(_NamedListWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.AssetCategory; /**
	                                                      * Created by Carsten Bühler
	                                                      * User: CBuehler on 22.10.2015
	                                                      * Copyright: xdot GmbH 2015
	                                                      */
	
	exports.default = {
	    initialNamedLists: function initialNamedLists(query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(_Constants.GROUP_NAMED_LISTS, className, {}, _NamedListWebApi2.default.listViewableByGroupScope);
	    },
	    list: function list(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _NamedListWebApi2.default.listViewableByGroupScope);
	    },
	    item: function item(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query, _NamedListWebApi2.default.get);
	    },
	
	    add: function add(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_NamedListWebApi2.default.add, item, formId, closeForm);
	    },
	    update: function update(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_NamedListWebApi2.default.update, item, formId, closeForm);
	    },
	    delete: function _delete(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_NamedListWebApi2.default.delete, item, formId, closeForm);
	    }
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _BomListWebApi = __webpack_require__(150);
	
	var _BomListWebApi2 = _interopRequireDefault(_BomListWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	exports.default = {
	  bomList: function bomList(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, undefined, query, _BomListWebApi2.default.bomList);
	  }
	};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                   * User: CBuehler on 09.11.2015
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                   */
	
	var _lwrClient = __webpack_require__(20);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var asTypedItem = function asTypedItem(dataList, entries) {
	    dataList.item = dataList.item.map(function (item, idx) {
	        return _extends({}, item, {
	            __type: entries[idx].className
	        });
	    });
	    return dataList;
	};
	
	var sortByOverallState = function sortByOverallState(dataList) {
	    dataList.item.sort(function (item1, item2) {
	        var weight1 = item1.overallState ? item1.overallState.state.weight : -1,
	            weight2 = item2.overallState ? item2.overallState.state.weight : -1;
	        if (weight1 > weight2) {
	            return -1;
	        } else if (weight1 < weight2) {
	            return 1;
	        } else {
	            return (item1.title ? item1.title : '').localeCompare(item2.title ? item2.title : '');
	        }
	    });
	};
	
	var reWriteData = function reWriteData(promise, entries) {
	    return new Promise(function (resolve, reject) {
	        promise.then(function (dataList) {
	            dataList = asTypedItem(dataList, entries);
	            sortByOverallState(dataList);
	            resolve(dataList);
	        }).catch(function (error) {
	            reject(error);
	        });
	    });
	};
	
	//const objectFetcherService = (m, o) => Client.invoke('/administration.objectfetcher/' + m, o);
	var objectFetcherServiceWithContext = function objectFetcherServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/administration.objectfetcher/' + m, o, c);
	};
	
	var api = {
	    bomList: function bomList(query) {
	        return reWriteData(objectFetcherServiceWithContext('list.3', {
	            entries: query.byEntries,
	            expand: 'SRI_10,SRI_30,SRI_60,PrecipitationAggregation_10,PrecipitationAggregation_30,PrecipitationAggregation_60,NewestAlarmlevel,NewestStatus,NewestOperationStatus,NewestBasinFillLevel,NewestBasinFillDegree,NewestWaterFlow,NewestWaterLevel,NewestPrecipitationValue, OldestPrecipitationDate'
	        }, {}), query.byEntries);
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('BomListWebApi', api);
	
	exports.default = api;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 12.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _BomListWidgetConfigForm = __webpack_require__(152);
	
	var _BomListWidgetConfigForm2 = _interopRequireDefault(_BomListWidgetConfigForm);
	
	var _Constants = __webpack_require__(5);
	
	var _BomListActions = __webpack_require__(149);
	
	var _BomListActions2 = _interopRequireDefault(_BomListActions);
	
	var _NamedListActions = __webpack_require__(148);
	
	var _NamedListActions2 = _interopRequireDefault(_NamedListActions);
	
	var _FliwasObjectListItem = __webpack_require__(147);
	
	var _FliwasObjectListItem2 = _interopRequireDefault(_FliwasObjectListItem);
	
	var _AssetLinkChooser = __webpack_require__(102);
	
	var _AssetLinkChooser2 = _interopRequireDefault(_AssetLinkChooser);
	
	var _NamedListWebApi = __webpack_require__(69);
	
	var _NamedListWebApi2 = _interopRequireDefault(_NamedListWebApi);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _editPermissionUtil = __webpack_require__(139);
	
	var _FliwasPermissionActions = __webpack_require__(32);
	
	var _FliwasPermissionActions2 = _interopRequireDefault(_FliwasPermissionActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BomListStore = (0, _StoreFactory.getBomListStore)(_liferayWidgetsReactWeb.AppContext);
	var NamedListStore = (0, _StoreFactory.getNamedListStore)(_liferayWidgetsReactWeb.AppContext);
	var fliwasPermissionStore = (0, _StoreFactory.getFliwasPermissionStore)(_liferayWidgetsReactWeb.AppContext);
	
	var BomListWidgetConfigFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_BomListWidgetConfigForm2.default);
	var AssetLinkChooserHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_AssetLinkChooser2.default);
	
	var BomListWidget = function (_PortletComponent) {
	    _inherits(BomListWidget, _PortletComponent);
	
	    function BomListWidget(props) {
	        _classCallCheck(this, BomListWidget);
	
	        var _this = _possibleConstructorReturn(this, _PortletComponent.call(this, props));
	
	        _this.DATA = {
	            SELECTED_NAMED_LIST: _this.withCtx('_SelectedNamedList'),
	            SELECT_OBJECT_LIST: _this.withCtx('_SelectedObjectList'),
	            FORM_ADD_OBJECT: _this.withCtx('_FormAddObject'),
	            NAMED_LIST_PERMISSION: _this.withCtx('_NamedListPermission')
	        };
	
	        _this.selectNamedList = _this.selectNamedList.bind(_this);
	        return _this;
	    }
	
	    BomListWidget.prototype.componentDidMount = function componentDidMount() {
	        _PortletComponent.prototype.componentDidMount.call(this);
	        var linkedQuery = {
	            $byEntries: _Constants.ClassNames.AssetCategory + '/' + this.DATA.SELECTED_NAMED_LIST + '/entries',
	            byClassName: _Constants.ClassNames.AssetCategory
	        };
	        var assetCategoryId = this.props.initialConfig && this.props.initialConfig.assetCategoryId || -1;
	        if (assetCategoryId > 0) {
	            this.selectNamedList({ id: assetCategoryId });
	        }
	
	        _FliwasPermissionActions2.default.getPermissionState(this.DATA.NAMED_LIST_PERMISSION, {
	            nameSpace: 'named-lists',
	            fliwasPermission: 'manage-named-lists'
	        });
	
	        _BomListActions2.default.bomList(this.DATA.SELECT_OBJECT_LIST, _extends({}, linkedQuery));
	    };
	
	    BomListWidget.getStores = function getStores() {
	        return [NamedListStore, BomListStore, fliwasPermissionStore];
	    };
	
	    BomListWidget.calculateState = function calculateState(prevState, undefined, DATA) {
	        return {
	            config: prevState.config,
	            selectedNamedList: NamedListStore.getRemoteData(DATA.SELECTED_NAMED_LIST),
	            selectedObjectList: BomListStore.getRemoteData(DATA.SELECT_OBJECT_LIST),
	            NAMED_LIST_PERMISSION: fliwasPermissionStore.getRemoteData(DATA.NAMED_LIST_PERMISSION)
	        };
	    };
	
	    BomListWidget.prototype.selectNamedList = function selectNamedList(namedList) {
	        //Current Object
	        _NamedListActions2.default.item(this.DATA.SELECTED_NAMED_LIST, { id: namedList.id });
	    };
	
	    BomListWidget.prototype.renderConfigForm = function renderConfigForm(props) {
	        return _react2.default.createElement(BomListWidgetConfigFormHoc, props);
	    };
	
	    BomListWidget.prototype.configWillChange = function configWillChange(prevConfig, nextConfig) {
	        this.isRefreshing = false;
	        console.log('configWillChange', prevConfig, ' ==> ', nextConfig);
	
	        if (prevConfig.assetCategoryId !== nextConfig.assetCategoryId) {
	            this.selectNamedList({ id: nextConfig.assetCategoryId });
	        }
	    };
	
	    BomListWidget.prototype.onObjectAdd = function onObjectAdd() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_ADD_OBJECT, {});
	    };
	
	    BomListWidget.prototype.onObjectAddSubmit = function onObjectAddSubmit(data) {
	        var selectedList = _liferayWidgetsReactWeb.DataUtil.asItem(this.state.selectedNamedList);
	        _NamedListWebApi2.default.update(_extends({}, selectedList, {
	            entries: [].concat(selectedList.entries, [{ className: data.className, classPK: data.id }])
	        }));
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.FORM_ADD_OBJECT);
	    };
	
	    BomListWidget.prototype.isConfigurationNeeded = function isConfigurationNeeded(config) {
	        return !(config && config.assetCategoryId);
	    };
	
	    BomListWidget.prototype.renderPortlet = function renderPortlet(config) {
	        var selectedObjectListDataItem = this.state.selectedObjectList && this.state.selectedObjectList;
	        var namedListPermission = this.state && this.state.NAMED_LIST_PERMISSION;
	        var isEditable = (0, _editPermissionUtil.hasEditPermissionAndGroup)(this.state.selectedObjectList, namedListPermission, true);
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { fluid: true },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                selectedObjectListDataItem && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12, className: 'nopadding' },
	                    isEditable && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: this.onObjectAdd.bind(this), className: 'm-1' },
	                        _react2.default.createElement(_Icon2.default, { name: 'plus' })
	                    ),
	                    _react2.default.createElement(_liferayWidgetsReactWeb.ScrollableDataListRV, {
	                        list: selectedObjectListDataItem,
	                        rowHeight: 80,
	                        size: config.height,
	                        ListItem: _FliwasObjectListItem2.default
	                    }),
	                    _react2.default.createElement(AssetLinkChooserHoc, {
	                        formId: this.DATA.FORM_ADD_OBJECT,
	                        onFormSubmit: this.onObjectAddSubmit.bind(this)
	                    })
	                )
	            )
	        );
	    };
	
	    return BomListWidget;
	}(_liferayWidgetsReactWeb.PortletComponent);
	
	BomListWidget.propTypes = {};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(BomListWidget);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Carsten Bühler
	 * Date: 12.02.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _NamedListListItem = __webpack_require__(145);
	
	var _NamedListListItem2 = _interopRequireDefault(_NamedListListItem);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NamedListStore = (0, _StoreFactory.getNamedListStore)(_liferayWidgetsReactWeb.AppContext);
	var NamedListListLinkCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list'], NamedListStore);
	
	var BomListWidgetConfigForm = function (_React$Component) {
	    _inherits(BomListWidgetConfigForm, _React$Component);
	
	    function BomListWidgetConfigForm(props) {
	        _classCallCheck(this, BomListWidgetConfigForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            namedList: undefined
	        };
	
	        _this.selectNamedList = _this.selectNamedList.bind(_this);
	        _this.onChangeHeight = _this.onChangeHeight.bind(_this);
	        return _this;
	    }
	
	    BomListWidgetConfigForm.prototype.componentDidMount = function componentDidMount() {
	        var assetCategoryId = this.props.formData && this.props.formData.assetCategoryId || -1;
	        if (assetCategoryId > 0) {
	            var namedListsDataItem = NamedListStore.getRemoteData(_Constants.GROUP_NAMED_LISTS);
	            var namedLists = _liferayWidgetsReactWeb.DataUtil.asArray(namedListsDataItem);
	            var namedList = namedLists && namedLists.filter(function (list) {
	                return list.id == assetCategoryId;
	            })[0];
	            this.setState({
	                namedList: namedList
	            });
	        }
	    };
	
	    BomListWidgetConfigForm.prototype.selectNamedList = function selectNamedList(namedList) {
	        this.change({ assetCategoryId: namedList.id });
	        this.setState({ namedList: namedList });
	    };
	
	    BomListWidgetConfigForm.prototype.onChangeHeight = function onChangeHeight(e) {
	        this.change({ height: e.target.value });
	    };
	
	    BomListWidgetConfigForm.prototype.change = function change(o) {
	        var formData = _extends({}, this.props.formData, o);
	        this.props.onChange(formData);
	    };
	
	    BomListWidgetConfigForm.prototype.render = function render() {
	        var formData = this.props.formData;
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { fluid: true },
	            _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Liste auswählen' }),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, sm: 4 },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { controlId: 'formControlsGaugingStationheight' },
	                            _react2.default.createElement(
	                                _reactBootstrap.FormLabel,
	                                null,
	                                'H\xF6he (in Pixel)'
	                            ),
	                            _react2.default.createElement(_reactBootstrap.FormControl, {
	                                type: 'number',
	                                step: '10.0',
	                                value: formData.height,
	                                onChange: this.onChangeHeight
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(NamedListListLinkCHOC, {
	                            list: _Constants.GROUP_NAMED_LISTS,
	                            activeIds: this.state.namedList,
	                            size: 'large',
	                            ListItem: _NamedListListItem2.default,
	                            onClick: this.selectNamedList
	                        })
	                    )
	                )
	            )
	        );
	    };
	
	    return BomListWidgetConfigForm;
	}(_react2.default.Component);
	
	BomListWidgetConfigForm.propTypes = {
	    onChange: _propTypes2.default.func,
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object
	};
	
	exports.default = BomListWidgetConfigForm;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var className = _Constants.ClassNames.NamedProp;
	
	var api = 'NamedPropWebApi';
	var listApiMethod = 'loadNamedPropsFromService';
	
	exports.default = {
	
	  list: function list(query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list('namedprops', className, query, api + '.' + listApiMethod);
	  }
	
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _GroupSchemaWebApi = __webpack_require__(155);
	
	var _GroupSchemaWebApi2 = _interopRequireDefault(_GroupSchemaWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.GroupSchema; /**
	                                                    * Created by Carsten Bühler
	                                                    * User: c.buehler on 01.09.2016
	                                                    * Copyright: xdot GmbH 2015
	                                                    */
	
	var api = 'GroupSchemaWebApi';
	var listApiMethod = 'listGroupSchemas';
	
	exports.default = {
	  listDefaultGroupSchemas: function listDefaultGroupSchemas(query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list('group-schemas', className, query, api + '.' + listApiMethod);
	  },
	  addManualBooleanState: function addManualBooleanState(query, formId, closeForm) {
	    return _liferayWidgetsReactWeb.FormActions.submitForm(_GroupSchemaWebApi2.default.addManualBooleanState, query, formId, closeForm);
	  }
	};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _lwrClient = __webpack_require__(20);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 09.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var baseServiceWithContext = function baseServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/base.groupschema/' + m, o, c);
	};
	var adminServiceWithContext = function adminServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/administration.administrationapi/' + m, o, c);
	};
	//const baseService = (m, o) => Client.invoke('/base.groupschema/' + m, o);
	//const adminService = (m, o) => Client.invoke('/administration.administrationapi/' + m, o);
	
	var api = {
	    listGroupSchemas: function listGroupSchemas(query) {
	        return baseServiceWithContext('list-group-schemas.1', {});
	    },
	    addManualBooleanState: function addManualBooleanState(query) {
	        return adminServiceWithContext('add-manual-boolean-state.3', {
	            title: query.title,
	            groupId: query.groupId
	        }, {});
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('GroupSchemaWebApi', api);
	
	exports.default = api;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 01.04.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _TimeLineItem = __webpack_require__(44);
	
	var _TimeLineItem2 = _interopRequireDefault(_TimeLineItem);
	
	var _TimeLineItemMessageHeader = __webpack_require__(45);
	
	var _TimeLineItemMessageHeader2 = _interopRequireDefault(_TimeLineItemMessageHeader);
	
	var _BusinessObjectLink = __webpack_require__(51);
	
	var _BusinessObjectLink2 = _interopRequireDefault(_BusinessObjectLink);
	
	var _Constants = __webpack_require__(5);
	
	var _eventTypeUtil = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assetEntryFromChange = function assetEntryFromChange(changes, nr, isDelete) {
	    var p = isDelete ? 'oldValue' : 'newValue';
	    return ['title', 'className', 'classPK', 'description', 'groupId', 'url'].reduce(function (o, prop) {
	        var v = changes[prop + nr];
	        if (v && (v = v[p])) {
	            o[prop] = prop === 'classPK' || prop === 'groupId' ? parseInt(v) : v;
	        }
	        return o;
	    }, {});
	};
	
	var DocElement = function DocElement(_ref) {
	    var asset = _ref.asset;
	    return _react2.default.createElement(
	        'span',
	        null,
	        'Dokument',
	        ' ',
	        _react2.default.createElement(
	            'a',
	            {
	                className: 'btn btn-outline-info btn-sm',
	                href: asset.url,
	                target: '_blank',
	                rel: 'noopener noreferrer'
	            },
	            asset.title
	        ),
	        ' '
	    );
	};
	var BomElement = function BomElement(_ref2) {
	    var asset = _ref2.asset;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _liferayWidgetsReactWeb.translation.trans(asset.className) + ' ',
	        _react2.default.createElement(_BusinessObjectLink2.default, {
	            className: asset.className,
	            classPK: asset.classPK, title: asset.title
	        })
	    );
	};
	
	var AssetLinkChangeRecordRenderer = function AssetLinkChangeRecordRenderer(_ref3) {
	    var changeRecord = _ref3.changeRecord,
	        userMeta = _ref3.userMeta;
	    var changes = changeRecord.changes,
	        attachedClassName = changeRecord.attachedClassName,
	        attachedClassPK = changeRecord.attachedClassPK;
	
	    var eventType = (0, _eventTypeUtil.getEventType)(changeRecord);
	    var isDelete = eventType === _Constants.EVENT_TYPE_DELETE;
	    if (!isDelete && eventType !== _Constants.EVENT_TYPE_CREATE) {
	        console.error('Unknown AssetLink eventType ', changeRecord);
	    }
	
	    var asset1 = assetEntryFromChange(changes, 1, isDelete);
	    var asset2 = assetEntryFromChange(changes, 2, isDelete);
	    var FromElem = asset1.className === _Constants.ClassNames.DLFileEntry ? DocElement : BomElement;
	    var ToElem = asset2.className === _Constants.ClassNames.DLFileEntry ? DocElement : BomElement;
	
	    return _react2.default.createElement(
	        _TimeLineItem2.default,
	        { userMeta: userMeta, timestamp: changeRecord.timestamp },
	        _react2.default.createElement(
	            _TimeLineItemMessageHeader2.default,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                'Verlinkung f\xFCr',
	                ' ' + _liferayWidgetsReactWeb.translation.trans(attachedClassName) + ' ',
	                _react2.default.createElement(_BusinessObjectLink2.default, { className: attachedClassName, classPK: attachedClassPK }),
	                ' '
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'my-3' },
	            _react2.default.createElement(
	                'span',
	                null,
	                'Verlinkung von ',
	                _react2.default.createElement(FromElem, { asset: asset1 }),
	                ' mit ',
	                _react2.default.createElement(ToElem, {
	                    asset: asset2 }),
	                ' ',
	                isDelete ? 'entfernt' : 'erstellt',
	                ' '
	            )
	        )
	    );
	};
	
	AssetLinkChangeRecordRenderer.propTypes = {
	    changeRecord: _propTypes2.default.object,
	    userMeta: _propTypes2.default.object
	};
	
	exports.default = AssetLinkChangeRecordRenderer;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 01.04.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _TimeLineItem = __webpack_require__(44);
	
	var _TimeLineItem2 = _interopRequireDefault(_TimeLineItem);
	
	var _TimeLineItemMessageHeader = __webpack_require__(45);
	
	var _TimeLineItemMessageHeader2 = _interopRequireDefault(_TimeLineItemMessageHeader);
	
	var _BusinessObjectLink = __webpack_require__(51);
	
	var _BusinessObjectLink2 = _interopRequireDefault(_BusinessObjectLink);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeoFeatureChangeRecordRenderer = function GeoFeatureChangeRecordRenderer(_ref) {
	    var changeRecord = _ref.changeRecord,
	        userMeta = _ref.userMeta;
	
	
	    return _react2.default.createElement(
	        _TimeLineItem2.default,
	        { userMeta: userMeta, timestamp: changeRecord.timestamp },
	        _react2.default.createElement(
	            _TimeLineItemMessageHeader2.default,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                'Positions\xE4nderung f\xFCr',
	                ' ',
	                _liferayWidgetsReactWeb.translation.trans(changeRecord.className) + ' ',
	                _react2.default.createElement(_BusinessObjectLink2.default, { className: changeRecord.attachedClassName,
	                    classPK: changeRecord.attachedClassPK }),
	                ' '
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                changeRecord.changes.geometry && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        /*Position-Alt: { changeRecord.changes.geometry.oldValue }<br/>
	                        Position-Neu: { changeRecord.changes.geometry.newValue }<br/>*/
	                        changeRecord.changes.geometry.newValue ? 'Position wurde geändert!' : ''
	                    )
	                ),
	                changeRecord.changes.properties && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Eigenschaften-Alt: ',
	                        changeRecord.changes.properties.oldValue,
	                        _react2.default.createElement('br', null),
	                        'Eigenschaften-Neu: ',
	                        changeRecord.changes.properties.newValue,
	                        _react2.default.createElement('br', null)
	                    )
	                ),
	                changeRecord.changes.geometryType && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Typ-Alt: ',
	                        changeRecord.changes.geometryType.oldValue,
	                        _react2.default.createElement('br', null),
	                        'Typ-Neu: ',
	                        changeRecord.changes.geometryType.newValue,
	                        _react2.default.createElement('br', null)
	                    )
	                )
	            )
	        )
	    );
	};
	
	GeoFeatureChangeRecordRenderer.propTypes = {
	    item: _propTypes2.default.object,
	    changeRecord: _propTypes2.default.object,
	    userMeta: _propTypes2.default.object
	};
	
	exports.default = GeoFeatureChangeRecordRenderer;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(20);
	
	//const baseService = (m, o) => Client.invoke('/base.namedprop/' + m, o);
	var baseServiceWithContext = function baseServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/base.namedprop/' + m, o, c);
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 09.11.2015
	    * Copyright: xdot GmbH 2015
	    */
	
	exports.default = {
	    loadNamedPropsFromService: function loadNamedPropsFromService() {
	        return baseServiceWithContext('list-all.1', {});
	    }
	};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_159__;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 29.04.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ModalActions = __webpack_require__(26);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _StoreFactory = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalStore = (0, _StoreFactory.getModalStore)(_liferayWidgetsReactWeb.AppContext);
	
	var DetailsModal = function DetailsModal(props) {
	    var store = props.store,
	        className = props.className,
	        context = props.context,
	        dataName = props.dataName,
	        onClose = props.onClose,
	        size = props.size;
	
	    var RendererHoc = (0, _react.useRef)();
	
	    return _react2.default.createElement(
	        _liferayWidgetsReactWeb.CustomModal,
	        {
	            show: true,
	            onHide: onClose,
	            context: context,
	            size: size
	        },
	        _react2.default.createElement(
	            _liferayWidgetsReactWeb.CustomModalBody,
	            null,
	            _react2.default.createElement(
	                _liferayWidgetsReactWeb.AmdRequireComponent,
	                { dependencies: ['DetailsRenderer/' + className] },
	                function (Renderer) {
	                    var R_Hoc = RendererHoc.current;
	                    if (!R_Hoc || R_Hoc.store !== store || R_Hoc.Renderer !== Renderer) {
	                        if (R_Hoc) {
	                            console.warn('ReCreate RendererHoc! ', R_Hoc.store, R_Hoc.Renderer, store, Renderer);
	                        }
	                        RendererHoc.current = R_Hoc = _liferayWidgetsReactWeb.DataLinkContainer.link(Renderer, 'item', store);
	                        R_Hoc.store = store;
	                        R_Hoc.Renderer = Renderer;
	                    }
	
	                    return _react2.default.createElement(R_Hoc, _extends({}, props, { dataName: null, item: dataName }));
	                }
	            )
	        )
	    );
	};
	
	var ModalRenderer = function (_React$Component) {
	    _inherits(ModalRenderer, _React$Component);
	
	    function ModalRenderer(props) {
	        _classCallCheck(this, ModalRenderer);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { activeTabKey: 'tabAttachedChangeRecords' };
	        return _this;
	    }
	
	    ModalRenderer.getStores = function getStores() {
	        return [ModalStore];
	    };
	
	    ModalRenderer.calculateState = function calculateState() {
	        return {
	            modals: ModalStore.getModals()
	        };
	    };
	
	    ModalRenderer.prototype.closeModal = function closeModal(modal) {
	        _ModalActions2.default.hideModal(modal.className, modal.dataName);
	    };
	
	    ModalRenderer.prototype.render = function render() {
	        var _this2 = this;
	
	        return this.state.modals.map(function (modal) {
	            return _react2.default.createElement(DetailsModal, _extends({}, _extends({}, _this2.props, modal.props), {
	                className: modal.className,
	                context: modal.context,
	                dataName: modal.dataName,
	                store: modal.store,
	                key: modal.key,
	                onClose: _this2.closeModal.bind(_this2, modal)
	            }));
	        });
	    };
	
	    return ModalRenderer;
	}(_react2.default.Component);
	
	exports.default = _liferayWidgetsReactWeb.FluxContainer.create(ModalRenderer);

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_161__;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_162__;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(35);
	
	var _TimeLineItem = __webpack_require__(44);
	
	var _TimeLineItem2 = _interopRequireDefault(_TimeLineItem);
	
	var _TimeLineItemMessageHeader = __webpack_require__(45);
	
	var _TimeLineItemMessageHeader2 = _interopRequireDefault(_TimeLineItemMessageHeader);
	
	var _HtmlTextRenderer = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebcamJournalRenderer = function WebcamJournalRenderer(_ref) {
	    var message = _ref.message,
	        entry = _ref.entry;
	    var userMeta = entry.userMeta,
	        timestamp = entry.timestamp;
	    var description = message.description,
	        title = message.title,
	        url = message.url;
	
	    var image = entry.attachments.image;
	
	    return _react2.default.createElement(
	        _TimeLineItem2.default,
	        { userMeta: userMeta, timestamp: timestamp },
	        _react2.default.createElement(
	            _TimeLineItemMessageHeader2.default,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                title
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'my-3' },
	            _react2.default.createElement(
	                _reactBootstrap.Table,
	                {
	                    className: 'journal-entry-records-table',
	                    responsive: true,
	                    borderless: true,
	                    size: 'sm'
	                },
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Kommentar'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(_HtmlTextRenderer.HtmlTextRenderer, { text: description })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Quelle'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            url
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement('img', { src: image, loading: 'lazy' })
	        )
	    );
	};
	
	WebcamJournalRenderer.propTypes = {
	    message: _propTypes2.default.object.isRequired,
	    entry: _propTypes2.default.object.isRequired
	};
	
	exports.default = WebcamJournalRenderer;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// base-portlet.js